export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * A catchall field if we don't have anything more specific.
   * This is provided by GQLGen: https://gqlgen.com/reference/scalars/#any
   */
  Any: { input: unknown; output: unknown; }
  /** Hundredths of a dollar. */
  Cents: { input: unknown; output: unknown; }
  /**
   * A Date string without time. ISO 8601 style (YYYY-MM-DD) is preferred.
   * See .models/type.go for how it's (un)marshalled.
   */
  Date: { input: unknown; output: unknown; }
  /** Dollar values backed by high-precision floats (ie. Decimal) */
  Dollars: { input: unknown; output: unknown; }
  /**
   * A Key-Value store (ie.  an object).
   * This is provided by GQLGen: https://gqlgen.com/reference/scalars/#map
   */
  Map: { input: unknown; output: unknown; }
  NCPDPAmount: { input: unknown; output: unknown; }
  /** A phone number string. */
  PhoneNumber: { input: unknown; output: unknown; }
  /**
   * A timestamp with nanos.
   * This is provided by GQLGen: https://gqlgen.com/reference/scalars/#time
   */
  Time: { input: unknown; output: unknown; }
  /** A URL pointing to a web resource. */
  URL: { input: unknown; output: unknown; }
  /**
   * A Universally Unique Identifier.
   * This is provided by GQLGen: https://gqlgen.com/reference/scalars/#universally-unique-identifier-uuid
   */
  UUID: { input: unknown; output: unknown; }
  /**
   * A multipart file upload.
   * This is provided by GQLGen:
   *  - https://gqlgen.com/reference/scalars/#upload
   *  - https://gqlgen.com/reference/file-upload/
   */
  Upload: { input: unknown; output: unknown; }
  timeOnly: { input: unknown; output: unknown; }
};

export type AccessToPhi = {
  __typename?: 'AccessToPhi';
  /**
   * 'Consent Status' column. Status of the latest consent between the viewer and this member.
   * Null when consent doesn't apply or none has been requested, and null with an error
   * without Portal.Consent.Read.
   */
  consentStatus?: Maybe<ConsentStatus>;
  /**
   * Which consent rule applies, from this member's age: automatic under 13, teen consent 13-17,
   * adult 18+. Null when no consent rule applies to the viewer.
   */
  consentType?: Maybe<ConsentType>;
  /** Overall result shown in the 'Access to PHI' column (Yes/No). */
  hasAccess: Scalars['Boolean']['output'];
  /**
   * 'Primary PHI Access Revoked' checkbox. True when an active restriction exists.
   * Null with an error without Portal.MemberAccessRestriction.Read.
   */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
};

export type Account = {
  __typename?: 'Account';
  code: Scalars['String']['output'];
  entry_date: Scalars['Time']['output'];
  go_live?: Maybe<Scalars['Time']['output']>;
  groups?: Maybe<GroupList>;
  id: Scalars['ID']['output'];
  insurance_type: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partners?: Maybe<AccountPartnerList>;
  status: AccountStatusEnum;
};


export type AccountGroupsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type AccountPartnersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type AccountFilters = {
  code?: InputMaybe<StringFilter>;
  go_live?: InputMaybe<TimeFilter>;
  id?: InputMaybe<IdFilter>;
  insurance_type?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type AccountList = {
  __typename?: 'AccountList';
  pagination: Pagination;
  results?: Maybe<Array<Account>>;
};

export type AccountOrder = {
  code?: InputMaybe<OrderDirectionEnum>;
  go_live?: InputMaybe<OrderDirectionEnum>;
  insurance_type?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  status?: InputMaybe<OrderDirectionEnum>;
};

export type AccountPartner = {
  __typename?: 'AccountPartner';
  partner: Partner;
  relationship: Scalars['String']['output'];
};

export type AccountPartnerList = {
  __typename?: 'AccountPartnerList';
  pagination: Pagination;
  results?: Maybe<Array<AccountPartner>>;
};

export enum AccountStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Setup = 'SETUP',
  Testing = 'TESTING'
}

export enum AccumFileType {
  FullReplacement = 'FULL_REPLACEMENT',
  FullTransactional = 'FULL_TRANSACTIONAL',
  MedReplacement = 'MED_REPLACEMENT',
  MedTransactional = 'MED_TRANSACTIONAL'
}

export type Accumulator = {
  __typename?: 'Accumulator';
  accumulate: Scalars['String']['output'];
  /**
   * Provenance for the fields an AI extractor wrote on this accumulator. See AiOverlay
   * in ai_overlay.graphql for what null means and why it is the common case.
   *
   * fieldPath on each entry is an Accumulator field name in this type's own snake_case
   * — in_network_individual, not inNetworkIndividual.
   *
   * Resolved from the artifact the plan was drafted from, once per plan per request,
   * so asking for it on every accumulator of a plan costs one read rather than one per
   * row.
   */
  aiOverlay?: Maybe<AiOverlay>;
  channel: ChannelEnum;
  created_at?: Maybe<Scalars['Time']['output']>;
  cross_accumulator?: Maybe<Scalars['Boolean']['output']>;
  drug_category: Scalars['String']['output'];
  drug_lists?: Maybe<Array<MatchRule>>;
  effective_from?: Maybe<Scalars['Time']['output']>;
  effective_to?: Maybe<Scalars['Time']['output']>;
  family_dependents?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  in_network_family?: Maybe<Scalars['Int']['output']>;
  in_network_individual?: Maybe<Scalars['Int']['output']>;
  individual_dependents?: Maybe<Scalars['Int']['output']>;
  logic: Scalars['String']['output'];
  out_of_network_family?: Maybe<Scalars['Int']['output']>;
  out_of_network_individual?: Maybe<Scalars['Int']['output']>;
  period: Period;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Time']['output']>;
};

export enum AccumulatorActionEnum {
  Add = 'ADD',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type AccumulatorFilters = {
  id?: InputMaybe<IdFilter>;
  recordStatus?: InputMaybe<StringFilter>;
};

export type AccumulatorInput = {
  accumulate: Scalars['String']['input'];
  channel: ChannelEnum;
  cross_accumulator?: InputMaybe<Scalars['Boolean']['input']>;
  drug_category: Scalars['String']['input'];
  drug_lists?: InputMaybe<Array<Scalars['ID']['input']>>;
  family_dependents?: InputMaybe<Scalars['Int']['input']>;
  /**
   * id is optional on the input but if known should be sent so the accumulator can be correctly updated
   * rather than a new one being created
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  in_network_family?: InputMaybe<Scalars['Int']['input']>;
  in_network_individual?: InputMaybe<Scalars['Int']['input']>;
  individual_dependents?: InputMaybe<Scalars['Int']['input']>;
  logic: Scalars['String']['input'];
  out_of_network_family?: InputMaybe<Scalars['Int']['input']>;
  out_of_network_individual?: InputMaybe<Scalars['Int']['input']>;
  period: Period;
  type: Scalars['String']['input'];
};

export type Accumulators = {
  __typename?: 'Accumulators';
  deductible_to_date?: Maybe<Scalars['Cents']['output']>;
  familyMedicalDeductible?: Maybe<Scalars['Cents']['output']>;
  familyMedicalOutOfPocket?: Maybe<Scalars['Cents']['output']>;
  familyPrescriptionsDeductible?: Maybe<Scalars['Cents']['output']>;
  familyPrescriptionsOutOfPocket?: Maybe<Scalars['Cents']['output']>;
  family_deductible_to_date?: Maybe<Scalars['Cents']['output']>;
  family_out_of_pocket_to_date?: Maybe<Scalars['Cents']['output']>;
  medicalDeductible?: Maybe<Scalars['Cents']['output']>;
  medicalOutOfPocket?: Maybe<Scalars['Cents']['output']>;
  out_of_pocket_to_date?: Maybe<Scalars['Cents']['output']>;
  prescriptionsDeductible?: Maybe<Scalars['Cents']['output']>;
  prescriptionsOutOfPocket?: Maybe<Scalars['Cents']['output']>;
};

export type Activity = {
  __typename?: 'Activity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ActorS3FileFilters = {
  actor_id?: InputMaybe<IdFilter>;
  created_at?: InputMaybe<TimeFilter>;
  deleted_at?: InputMaybe<TimeFilter>;
  direction?: InputMaybe<StringFilter>;
  file_type?: InputMaybe<StringFilter>;
  group_name?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  size?: InputMaybe<IntFilter>;
  status?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<TimeFilter>;
};

/** AddAccumsTransactionInput is the input type for UpsertAccumulatorTransaction mutation */
export type AddAccumsTransactionInput = {
  /** @deprecated temporarily marked deprecated to avoid breaking FE. Should be reverted after FE changes are merged. */
  deductible?: InputMaybe<Scalars['Int']['input']>;
  effectiveAt: Scalars['Time']['input'];
  /** @deprecated User deductible with transactionalType instead */
  medDeductible?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated User oop with transactionalType instead */
  medOop?: InputMaybe<Scalars['Int']['input']>;
  membershipId: Scalars['UUID']['input'];
  notes: Scalars['String']['input'];
  /** @deprecated temporarily marked deprecated to avoid breaking FE. Should be reverted after FE changes are merged. */
  oop?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated temporarily marked deprecated to avoid breaking FE. Should be reverted after FE changes are merged. */
  transactionalType?: InputMaybe<Scalars['String']['input']>;
};

export type AddDrugListItemInputV2 = {
  customDrugListId: Scalars['ID']['input'];
  deaClass?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveAt?: InputMaybe<Scalars['Time']['input']>;
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  gpi?: InputMaybe<Scalars['String']['input']>;
  mony?: InputMaybe<Scalars['String']['input']>;
  ndc?: InputMaybe<Scalars['String']['input']>;
};

/** AddSDCTransactionInput is the input type for AddSDCTransaction mutation */
export type AddSdcTransactionInput = {
  sdcAmount: Scalars['Float']['input'];
  sdcId: Scalars['String']['input'];
  transactionFilters: AddTransactionFilters;
};

export type AddTransactionFilters = {
  effectiveAt: Scalars['Time']['input'];
  membershipUUID: Scalars['UUID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionTypeEnum>;
};

/** Supported Adjudicated By types */
export enum AdjudicatedBy {
  Cervey = 'CERVEY',
  Claimshx = 'CLAIMSHX',
  Laker = 'LAKER',
  Other = 'OTHER',
  Rxnxt = 'RXNXT',
  Rxpartner = 'RXPARTNER',
  Zebra = 'ZEBRA'
}

export type AdjudicatedByFilter = {
  /** Equal */
  eq?: InputMaybe<AdjudicatedBy>;
  /** In */
  in?: InputMaybe<Array<AdjudicatedBy>>;
  /** Not equal */
  ne?: InputMaybe<AdjudicatedBy>;
  /** Not in */
  nin?: InputMaybe<Array<AdjudicatedBy>>;
};

export enum AdjudicationStatus {
  AdjCompleted = 'ADJ_COMPLETED',
  AdjFailed = 'ADJ_FAILED',
  AdjProcessing = 'ADJ_PROCESSING',
  AdjQueued = 'ADJ_QUEUED'
}

export type AdjustClaimInput = {
  benefitAmount: Scalars['Dollars']['input'];
  claimID: Scalars['UUID']['input'];
  claimSource?: InputMaybe<Scalars['String']['input']>;
  deductible: Scalars['Dollars']['input'];
  markup: Scalars['Dollars']['input'];
  outOfPocketAccum: Scalars['Dollars']['input'];
  payDispenseFee: Scalars['Dollars']['input'];
  payIngredientCost: Scalars['Dollars']['input'];
  payTax: Scalars['Dollars']['input'];
  sdcHistories?: InputMaybe<Array<ClaimSdcHistoryInput>>;
  totalPatientPayAmount: Scalars['Dollars']['input'];
};

export type AdjustClaimOutput = {
  __typename?: 'AdjustClaimOutput';
  adjustedClaim: ClaimV2;
  originalClaim: ClaimV2;
};

export type AgeHandler = {
  __typename?: 'AgeHandler';
  ageHandlerDetails?: Maybe<Array<AgeHandlerDetail>>;
  created: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['Time']['output'];
};

export type AgeHandlerConnection = {
  __typename?: 'AgeHandlerConnection';
  edges: Array<AgeHandlerEdge>;
  pageInfo: PageInfo;
};

export type AgeHandlerDetail = {
  __typename?: 'AgeHandlerDetail';
  ageHandlerUUID: Scalars['ID']['output'];
  created: Scalars['Time']['output'];
  femaleMax: Scalars['Int']['output'];
  femaleMin: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  maleMax: Scalars['Int']['output'];
  maleMin: Scalars['Int']['output'];
  type: HandlerDetailType;
  updated?: Maybe<Scalars['Time']['output']>;
};

export type AgeHandlerDetailOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
};

export type AgeHandlerDetailUpsertInput = {
  ageHandlerUUID: Scalars['ID']['input'];
  femaleMax?: InputMaybe<Scalars['Int']['input']>;
  femaleMin?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maleMax?: InputMaybe<Scalars['Int']['input']>;
  maleMin?: InputMaybe<Scalars['Int']['input']>;
  type: HandlerDetailType;
};

export type AgeHandlerEdge = {
  __typename?: 'AgeHandlerEdge';
  cursor: Scalars['String']['output'];
  node: AgeHandler;
};

export type AgeHandlerFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type AgeHandlerOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export enum AggregateAdjudicationStatus {
  AggAdjCompleted = 'AGG_ADJ_COMPLETED',
  AggAdjFailed = 'AGG_ADJ_FAILED',
  AggAdjProcessing = 'AGG_ADJ_PROCESSING',
  AggAdjQueued = 'AGG_ADJ_QUEUED'
}

/**
 * How sure an AI extractor was about a value it wrote.
 *
 * These are forge's words, not the artifact's. The artifact reports lowercase strings
 * and forge maps them, so that a rename on the extractor's side is not a breaking
 * change to this API. A value forge cannot map is null rather than a member of this
 * enum.
 */
export enum AiConfidence {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  /**
   * The extractor reported no confidence in the value. Distinct from a null
   * confidence, which means it reported one forge could not interpret.
   */
  None = 'NONE'
}

/** The provenance of one field an AI extractor wrote. */
export type AiFieldOverlay = {
  __typename?: 'AiFieldOverlay';
  /**
   * The value as the human wrote it in the workbook: "$10 N/A to Deduct", not the 10
   * forge stores. Showing it beside the stored value is the point of provenance, since
   * it is what lets a reviewer compare the workbook's own words against what forge
   * made of them.
   *
   * Empty means the extractor read a blank cell. That is not the same as the extractor
   * having written nothing: a field it did not write has no AiFieldOverlay at all.
   */
  aiValue?: Maybe<Scalars['String']['output']>;
  /**
   * The extractor's self-report about this field.
   *
   * Not a quality signal and not forge's assessment: a HIGH field can still be wrong,
   * and LOW is a prompt to look rather than evidence of an error. In the sample
   * artifact HIGH correlates perfectly with the extractor having skipped review of the
   * cell, so it records "nobody checked this" at least as much as "this was checked
   * and trusted".
   *
   * Null when the artifact reported a confidence forge does not recognise, which forge
   * records as a parser anomaly. Null is not NONE.
   */
  confidence?: Maybe<AiConfidence>;
  /**
   * How far the source cell sits from where the template puts it, as a signed row
   * offset. Zero means it was found where it was expected, and negative means it was
   * found above. Show the magnitude, or show it beside sourceCell and templateCell;
   * a raw "-1" on a row means nothing to a reviewer.
   *
   * A whole block usually drifts together rather than one field of it: every
   * accumulator in the sample workbook reports -1, because that sheet's rows sit one
   * above the template's. So a uniform offset across a row is the ordinary reading,
   * and a single field disagreeing with its neighbours is the interesting one.
   *
   * An artifact that reports no drift at all also reads as zero, so this under-reports
   * drift rather than inventing it.
   *
   * Unrelated to userOverridden: drift is the extractor saying the workbook was laid
   * out unexpectedly, userOverridden is forge saying its own value has since changed.
   * A field can be both.
   */
  drift: Scalars['Int']['output'];
  /**
   * The field this provenance belongs to, spelled as its own type spells it:
   * in_network_individual on Accumulator, which is snake_case by era, and lowerCamel
   * on a type that is. Match it against your query's field names, not against a
   * camelCased or snake_cased version of it.
   */
  fieldPath: Scalars['String']['output'];
  /**
   * The extractor's explanation, naming the source and template cell in prose. This is
   * the reviewer-facing evidence, and it is prose rather than structured fields
   * because that is how the extractor emits it.
   *
   * Long — a median of about 280 characters — so it belongs in a detail view rather
   * than a table cell.
   */
  reason?: Maybe<Scalars['String']['output']>;
  /**
   * The workbook cell the value was read from, as the artifact names it. Null when the
   * artifact did not say.
   */
  sourceCell?: Maybe<Scalars['String']['output']>;
  /**
   * The cell the template expected the value at, as the artifact names it. Compare it
   * against sourceCell to see what drift is a drift between. Null when the artifact
   * did not say.
   */
  templateCell?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the row no longer holds the value the AI proposed. Computed per request by
   * comparing the live row against the artifact, so it reflects forge right now rather
   * than at extraction time.
   *
   * Null means nobody diffed this field, not false. It is the answer when the field has
   * no counterpart on the row forge stores, and treating it as false would claim a
   * human looked at the AI's value and agreed with it.
   */
  userOverridden?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The extractor's own caveat about this field, null when it raised none — which is
   * 325 of the 336 extracted values in the sample workbook. A warning is worth
   * surfacing on the row itself; its absence is not reassurance.
   */
  warning?: Maybe<Scalars['String']['output']>;
};

/**
 * The provenance of one forge row: which of its fields an AI extractor wrote, and the
 * evidence for each.
 *
 * This is display-only. There is no accept or reject, and this file declares no
 * mutations: the value on the row beside an overlay is already forge's value, and a
 * reviewer who disagrees edits the row like any other field of the plan. What
 * provenance adds is the evidence needed to make that judgement — which workbook cell
 * the number came from, how sure the extractor was, and whether the number has since
 * been changed.
 *
 * An AiOverlay is nullable everywhere it appears, and null is the common case. Render
 * the plan exactly as it renders today when it is null: without provenance, not as an
 * error and not as a plan nobody has reviewed.
 *
 * Null does not mean a human wrote the row. It is also the answer when forge cannot
 * tell which row the artifact described — the match is by the row's own values, not by
 * an identifier the artifact carries, so two rows a workbook cannot tell apart resolve
 * null on both — and when the extractor's claims for a row were mutually
 * contradictory. Under-reporting is deliberate: no provenance is better than
 * provenance belonging to the row above.
 */
export type AiOverlay = {
  __typename?: 'AiOverlay';
  /**
   * Whether the caller may discard this AI-proposed row.
   *
   * Always null today: nothing in forge computes it yet. Read null as "forge has not
   * determined this" and do not offer deletion — it is deliberately not defaulted to
   * false, because false would be a claim forge is not in a position to make.
   */
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  /**
   * One entry per field of this row that has provenance, ordered by fieldPath so a
   * response is stable between requests.
   *
   * Provenance is deltas, not a complete account of the row, so this is normally much
   * shorter than the row has fields: most fields of an AI-drafted plan were never
   * touched by the extractor and have no entry here. It is never empty — a row with
   * nothing to show resolves the whole AiOverlay to null instead, because an empty
   * list reads as "AI-authored, no detail".
   */
  fields?: Maybe<Array<AiFieldOverlay>>;
  /**
   * How much of the workbook block this row came from was laid out the way the
   * template expects, as a fraction from 0 to 1.
   *
   * It is the extractor's structural finding about the spreadsheet, not a judgement
   * about this row's values: a block scoring 0.4 means most of its cells were
   * somewhere unexpected, which is a reason to read the fields below more carefully,
   * not evidence that any one of them is wrong.
   *
   * Null when the artifact's score for the block was missing or outside 0..1. Read
   * null as "layout unknown", not as 0: forge does not publish a score it could not
   * validate.
   *
   * The artifact's own structural_score is an object with several keys. This is one
   * number out of it — the cells-on-template fraction — chosen because it is the one
   * that says how much to trust the layout. Ask if a UI needs the others; they are
   * parsed and kept, just not published yet.
   */
  structuralScore?: Maybe<Scalars['Float']['output']>;
};

/**
 * How much of a plan an AI drafted, and how much of that wants a human's attention.
 *
 * Not resolved yet — it is always null today, and filling it is E3-S6. The shape is
 * published now so the review UI can be built against it rather than against a guess.
 */
export type AiOverlaySummary = {
  __typename?: 'AiOverlaySummary';
  /**
   * How many fields across the plan have provenance. This counts fields, not rows: one
   * accumulator with four extracted values contributes four.
   */
  aiGeneratedValues: Scalars['Int']['output'];
  /**
   * How many of those the reviewer should look at: anything the extractor did not
   * report HIGH confidence for, warned about, or found drifted. Always a subset of
   * aiGeneratedValues.
   */
  needsAttention: Scalars['Int']['output'];
  /**
   * The same two counts broken down by the workbook tab the values came from, which is
   * how a reviewer navigates — the plan page's tabs are the workbook's.
   */
  tabs?: Maybe<Array<AiOverlayTabCount>>;
};

/** One workbook tab's slice of an AiOverlaySummary. */
export type AiOverlayTabCount = {
  __typename?: 'AiOverlayTabCount';
  aiGeneratedValues: Scalars['Int']['output'];
  needsAttention: Scalars['Int']['output'];
  /**
   * The artifact's own name for the tab, passed through unchanged. forge has no
   * vocabulary of its own for workbook tabs, so there is nothing to map it to and the
   * string is the extractor's.
   */
  tab: Scalars['String']['output'];
};

export type AltCardId = {
  __typename?: 'AltCardID';
  altCardID: Scalars['String']['output'];
  /** Opaque cache identifier. Unique for this member/card context. */
  id: Scalars['ID']['output'];
  /** True if altCardID exists in both Portal and Zebra; otherwise false. */
  searchable: Scalars['Boolean']['output'];
};

export type AppleWalletPass = {
  __typename?: 'AppleWalletPass';
  /** Base64 encoded signed pass bundle */
  pass: Scalars['String']['output'];
};

export type ApplyClaimInstructionTemplateInput = {
  /** The originating claim context, when the flow has one. */
  claimContext?: InputMaybe<ClaimContextInput>;
  /** NCPDP reject code(s) from the originating claim. The in-code registry matches these to a template. */
  rejectCodes: Array<Scalars['String']['input']>;
};

/**
 * The result of resolving a template for a claim: the proposed instruction set,
 * the MPA core fields the template sets, and the validations for live Save-gating.
 * Persists nothing.
 */
export type ApplyClaimInstructionTemplateResult = {
  __typename?: 'ApplyClaimInstructionTemplateResult';
  /** Whether applying the template backs out (clears) the claim's NDC. */
  backOutNDC: Scalars['Boolean']['output'];
  /** Effective date the template sets, normalized to a date with no time-of-day. */
  effectiveDate: Scalars['Time']['output'];
  /** GPI match granularity the template matches at. */
  gpiLevel: MpagpiLevel;
  /**
   * Proposed instructions: static values are filled; claim- and user-sourced
   * fields are returned marked (isEmpty) for the client to fill.
   */
  instructions: Array<ClaimInstruction>;
  /** Stable registry key of the matched template, echoed on create for provenance. */
  templateKey: Scalars['String']['output'];
  /** Display name of the matched template. */
  templateName: Scalars['String']['output'];
  /** Version of the matched template. */
  templateVersion: Scalars['String']['output'];
  /** Termination date the template sets, normalized to a date with no time-of-day. */
  terminationDate: Scalars['Time']['output'];
  /** Prefill notices (INFO), warnings (WARNING), and blocking failures (BLOCKING) for live Save-gating. */
  validations: Array<ClaimInstructionValidation>;
};

export type ApproveSent835sInput = {
  /** Array of IDs of the Sent835s to be approved. */
  ids: Array<Scalars['ID']['input']>;
};

export type AssociatedDrugList = {
  __typename?: 'AssociatedDrugList';
  comment?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AuditCorrelationGroup = Node & {
  __typename?: 'AuditCorrelationGroup';
  correlationId: Scalars['String']['output'];
  endTime: Scalars['Time']['output'];
  eventCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  primaryActorId?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['Time']['output'];
};

export type AuditCorrelationGroupConnection = {
  __typename?: 'AuditCorrelationGroupConnection';
  edges: Array<AuditCorrelationGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuditCorrelationGroupEdge = {
  __typename?: 'AuditCorrelationGroupEdge';
  cursor: Scalars['String']['output'];
  node: AuditCorrelationGroup;
};

export enum AuditEventType {
  ConfigurationChanged = 'CONFIGURATION_CHANGED',
  ConfigurationDeleted = 'CONFIGURATION_DELETED',
  Export = 'EXPORT',
  Import = 'IMPORT',
  PhiDeleted = 'PHI_DELETED',
  PhiQueried = 'PHI_QUERIED',
  PhiViewed = 'PHI_VIEWED',
  PhiWritten = 'PHI_WRITTEN'
}

export type AuditLogEvent = Node & {
  __typename?: 'AuditLogEvent';
  action?: Maybe<Scalars['String']['output']>;
  actorDepartment?: Maybe<Scalars['String']['output']>;
  actorFirstname?: Maybe<Scalars['String']['output']>;
  actorId?: Maybe<Scalars['String']['output']>;
  actorLastname?: Maybe<Scalars['String']['output']>;
  actorRole?: Maybe<Scalars['String']['output']>;
  changes?: Maybe<Scalars['String']['output']>;
  correlationId?: Maybe<Scalars['String']['output']>;
  dataType?: Maybe<Scalars['String']['output']>;
  disclosedDataDescription?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  entityIds?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['ID']['output'];
  eventLabel?: Maybe<Scalars['String']['output']>;
  eventTime: Scalars['Time']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idsTruncated?: Maybe<Scalars['Boolean']['output']>;
  impersonatedUserId?: Maybe<Scalars['String']['output']>;
  initiatorType?: Maybe<Scalars['String']['output']>;
  networkAddress?: Maybe<Scalars['String']['output']>;
  outcome: Scalars['String']['output'];
  outcomeDetail?: Maybe<Scalars['String']['output']>;
  purposeOfUse?: Maybe<Scalars['String']['output']>;
  recipientId?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  recipientType?: Maybe<Scalars['String']['output']>;
  resultsCount?: Maybe<Scalars['Int']['output']>;
  searchCriteria?: Maybe<Scalars['String']['output']>;
  searchType?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type AuditLogEventConnection = {
  __typename?: 'AuditLogEventConnection';
  edges: Array<AuditLogEventEdge>;
  pageInfo: PageInfo;
};

export type AuditLogEventEdge = {
  __typename?: 'AuditLogEventEdge';
  cursor: Scalars['String']['output'];
  node: AuditLogEvent;
};

export type AuditLogFilterOptions = {
  __typename?: 'AuditLogFilterOptions';
  eventTypes: Array<Scalars['String']['output']>;
  initiatorTypes: Array<Scalars['String']['output']>;
  outcomes: Array<Scalars['String']['output']>;
  sourceSystems: Array<Scalars['String']['output']>;
};

export type AuditLogFilters = {
  actorId?: InputMaybe<StringFilter>;
  correlationId?: InputMaybe<StringFilter>;
  entityId?: InputMaybe<StringFilter>;
  eventTime?: InputMaybe<TimeFilter>;
  eventType?: InputMaybe<StringFilter>;
  initiatorType?: InputMaybe<StringFilter>;
  outcome?: InputMaybe<StringFilter>;
  sourceSystem?: InputMaybe<StringFilter>;
};

export type AuditLogOrder = {
  eventTime?: InputMaybe<OrderDirectionEnum>;
};

export type AuditReport = Node & {
  __typename?: 'AuditReport';
  createdAt: Scalars['Time']['output'];
  expired: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  reportType: Scalars['String']['output'];
  requestedBy: Scalars['String']['output'];
};

export type AuditReportConnection = {
  __typename?: 'AuditReportConnection';
  edges: Array<AuditReportEdge>;
  pageInfo: PageInfo;
};

export type AuditReportEdge = {
  __typename?: 'AuditReportEdge';
  cursor: Scalars['String']['output'];
  node: AuditReport;
};

/**
 * Filters the OCR Investigation report to one member's events over a date
 * range. name/cardId are the member identity as entered by the requester.
 */
export type AuditReportOcrInvestigationRequest = {
  actorId?: InputMaybe<StringFilter>;
  cardId?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<StringFilter>;
  entityId: StringFilter;
  eventTime: TimeFilter;
  eventType?: InputMaybe<StringFilter>;
  initiatorType?: InputMaybe<StringFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<StringFilter>;
  sourceSystem?: InputMaybe<StringFilter>;
};

export enum AuditSurface {
  Administration = 'ADMINISTRATION',
  Claims = 'CLAIMS',
  ClinicalLookup = 'CLINICAL_LOOKUP',
  Consent = 'CONSENT',
  Export = 'EXPORT',
  Financial = 'FINANCIAL',
  MemberSelfService = 'MEMBER_SELF_SERVICE'
}

export enum AuditTeam {
  Accums = 'ACCUMS',
  Claims = 'CLAIMS',
  Eligibility = 'ELIGIBILITY',
  Plans = 'PLANS',
  Unspecified = 'UNSPECIFIED'
}

export type AuthEvent = {
  __typename?: 'AuthEvent';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  timestamp: Scalars['Time']['output'];
  type: Scalars['String']['output'];
};

export type AuthEventsList = {
  __typename?: 'AuthEventsList';
  pagination: Pagination;
  results: Array<AuthEvent>;
};

export type Authorization = {
  __typename?: 'Authorization';
  id: Scalars['ID']['output'];
  resources: AuthorizedResourceList;
};


export type AuthorizationResourcesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type AuthorizedResource = {
  __typename?: 'AuthorizedResource';
  created_at: Scalars['Time']['output'];
  deleted_at?: Maybe<Scalars['Time']['output']>;
  group?: Maybe<Group>;
  id: Scalars['ID']['output'];
  partner?: Maybe<Partner>;
  pharmacy?: Maybe<PharmacyV2>;
  resource_id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['Time']['output'];
};

export type AuthorizedResourceFilters = {
  credential_id?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
};

export type AuthorizedResourceInput = {
  credential_id: Scalars['Int']['input'];
  resource_id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type AuthorizedResourceList = {
  __typename?: 'AuthorizedResourceList';
  pagination: Pagination;
  results: Array<AuthorizedResource>;
};

export type AuthorizedResourceOrder = {
  created_at?: InputMaybe<OrderDirectionEnum>;
  deleted_at?: InputMaybe<OrderDirectionEnum>;
  resource_type?: InputMaybe<OrderDirectionEnum>;
};

export enum AuxCode {
  /** 2 */
  Maintenance = 'MAINTENANCE',
  /** 1 */
  Preferred = 'PREFERRED',
  /** 0 */
  Standard = 'STANDARD'
}

export type BaseError = Error & {
  __typename?: 'BaseError';
  message: Scalars['String']['output'];
};

export enum BatchDataSyncJobOrderField {
  Id = 'ID',
  RequestedBy = 'REQUESTED_BY',
  RequestDate = 'REQUEST_DATE',
  RequestMethod = 'REQUEST_METHOD'
}

export type BatchDataSyncJobParameters = {
  __typename?: 'BatchDataSyncJobParameters';
  cardID?: Maybe<Scalars['String']['output']>;
  destinations?: Maybe<Array<SyncDestination>>;
  groupUUID?: Maybe<Scalars['String']['output']>;
  memberKey?: Maybe<Scalars['String']['output']>;
  membersCSV?: Maybe<Scalars['String']['output']>;
  priority: SyncJobPriority;
  requestedMembersNumber?: Maybe<Scalars['Int']['output']>;
  subscriptionUUID?: Maybe<Scalars['String']['output']>;
};

export type BatchDataSyncJobParametersWithDetails = {
  __typename?: 'BatchDataSyncJobParametersWithDetails';
  metadataDetails?: Maybe<InputParametersMetadataDetails>;
  parameters?: Maybe<BatchDataSyncJobParameters>;
};

export enum BatchDataSyncJobRequestMethod {
  CardId = 'CARD_ID',
  GroupCode = 'GROUP_CODE',
  GroupUuid = 'GROUP_UUID',
  MembershipUuids = 'MEMBERSHIP_UUIDS',
  MembersCsv = 'MEMBERS_CSV',
  MemberKeys = 'MEMBER_KEYS',
  SubscriptionUuid = 'SUBSCRIPTION_UUID',
  Unknown = 'UNKNOWN'
}

export enum BatchDataSyncJobStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export type BatchSettings = {
  __typename?: 'BatchSettings';
  allowOtcForScript: Scalars['Boolean']['output'];
  holdGroupConstant: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ignoreAgeHandler: Scalars['Boolean']['output'];
  ignoreDiscontinuedNdcs: Scalars['Boolean']['output'];
  ignoreDispenseLimitHandler: Scalars['Boolean']['output'];
  ignoreMemberEligibilityEndDate: Scalars['Boolean']['output'];
  ignoreMiscHandler: Scalars['Boolean']['output'];
  isHoldingCostConstant: Scalars['Boolean']['output'];
  keepMonyCodeTheSame: Scalars['Boolean']['output'];
  overrideRefillTooSoon: Scalars['Boolean']['output'];
  skipReporting: Scalars['Boolean']['output'];
  treatAsIncludePr: Scalars['Boolean']['output'];
};

export type BatchSyncJobStatus = {
  __typename?: 'BatchSyncJobStatus';
  failures?: Maybe<Array<SyncFailure>>;
  finishedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  requestMethod: BatchDataSyncJobRequestMethod;
  requestedBy: Scalars['String']['output'];
  requestedParametersWithDetails: BatchDataSyncJobParametersWithDetails;
  startedAt: Scalars['Time']['output'];
  stats: BatchSyncStats;
  status: BatchDataSyncJobStatus;
};

export type BatchSyncJobStatusConnection = {
  __typename?: 'BatchSyncJobStatusConnection';
  edges?: Maybe<Array<BatchSyncJobStatusEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BatchSyncJobStatusEdge = {
  __typename?: 'BatchSyncJobStatusEdge';
  cursor: Scalars['String']['output'];
  node: BatchSyncJobStatus;
};

export type BatchSyncStats = {
  __typename?: 'BatchSyncStats';
  failure: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  running: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  success: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BenefitPeriod = {
  __typename?: 'BenefitPeriod';
  /** The end date of the benefit period */
  end: Scalars['Time']['output'];
  /** The start date of the benefit period */
  start: Scalars['Time']['output'];
};

export type BenefitPlan = {
  __typename?: 'BenefitPlan';
  SDCCrossAccumConfigs?: Maybe<Array<SdcCrossAccumConfig>>;
  accumulators?: Maybe<Array<Accumulator>>;
  /**
   * Provenance for the fields an AI extractor wrote on the plan itself — the values that
   * sit on this row rather than on one of its accumulators or rules. See AiOverlay in
   * ai_overlay.graphql.
   *
   * Distinct from aiOverlaySummary below: this is the per-field provenance for this one
   * row, that is the tally for the whole plan.
   *
   * Always null today, for the same reason as the other embedded overlays: the artifact
   * carries no forge identifier, so a row is matched by its own values, and the natural
   * key for a plan is not yet decided (E3-S5). The bindings themselves are ready —
   * pkg/v2/aioverlay/gqlmap scores name and code from benefit_plan/CreateBenefitPlan.
   *
   * Read name's provenance with care when it arrives. Across the sample artifact its
   * values come off five different columns, including a TPA plan code and a company name,
   * so a confident name is the field most worth checking against sourceCell rather than
   * trusting.
   *
   * formulary is the notable absence, and it is not a decision forge can take alone. The
   * workbook does carry it — the sample reads "Pareto Medium (Essential Formulary)" from
   * two cells at high confidence — but the extractor files those values as unmapped,
   * bound to no field of any type, so nothing reaches forge to attribute. It will also
   * arrive as a name to look a formulary up by rather than a value to write: formulary is
   * a relation and formulary_id is a forge identifier the artifact cannot supply. When the
   * AI stack maps those cells, the provenance lands here with fieldPath naming the
   * relation, and no schema change is needed to carry it.
   */
  aiOverlay?: Maybe<AiOverlay>;
  /**
   * How much of this plan an AI drafted, for the plan header.
   *
   * Always null today; filling it is E3-S6. Null already has a correct reading —
   * "forge has no provenance tally for this plan" — so a header that handles null
   * needs no change when the resolver lands.
   *
   * Do not derive this by walking every row's aiOverlay. The counts include tabs and
   * values that no forge row received, so a walk of the rows would under-report, and it
   * would cost one artifact read per row type rather than one per plan.
   */
  aiOverlaySummary?: Maybe<AiOverlaySummary>;
  /**
   * When the AI stack provisioned this plan, or null if it was not AI-provisioned. Read through
   * implementation_manual_plan_candidate rather than a column on benefit_plan, so the fact lives
   * in one table. Retained after the plan is deployed.
   */
  aiProvisionedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * All groups associated with this benefit plan via plan_code, regardless of termination status.
   * Use this instead of querying planCodesV2 when you need to navigate to a group even after
   * its plan code has expired.
   */
  associatedGroups: Array<Group>;
  base_plan?: Maybe<BenefitPlan>;
  benefitPlanType?: Maybe<BenefitPlanType>;
  changelog: BenefitPlanChangelogList;
  code?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Time']['output']>;
  drug_lookup_link?: Maybe<Scalars['String']['output']>;
  formulary: Formulary;
  id: Scalars['ID']['output'];
  included_networks?: Maybe<Array<IncludedSuperNetwork>>;
  /**
   * Whether the plan is under review and may not be attached to any group. False for every
   * plan a human created.
   */
  isDraft: Scalars['Boolean']['output'];
  member_drug_lookup_link_option: Scalars['String']['output'];
  name: Scalars['String']['output'];
  otc_document?: Maybe<Scalars['String']['output']>;
  plan_id: Scalars['ID']['output'];
  plan_rules?: Maybe<Array<PlanRule>>;
  /** Mail order providers */
  providers: Array<Maybe<Provider>>;
  run_status?: Maybe<Scalars['String']['output']>;
  /**
   * Whether state-based restrictions should be shown for this plan.
   * Returns true for MEWA plans or UnitedAg UAL plans.
   */
  stateRestrictionsEnabled: Scalars['Boolean']['output'];
  updated_at?: Maybe<Scalars['Time']['output']>;
  zebraPlan?: Maybe<Plan>;
  zebraSDCs?: Maybe<Array<ZebraSdc>>;
  zebra_plan_id?: Maybe<Scalars['ID']['output']>;
};


export type BenefitPlanSdcCrossAccumConfigsArgs = {
  where?: InputMaybe<SdcCrossAccumConfigFilters>;
};


export type BenefitPlanAccumulatorsArgs = {
  where?: InputMaybe<AccumulatorFilters>;
};


export type BenefitPlanChangelogArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type BenefitPlanPlanRulesArgs = {
  where?: InputMaybe<PlanRuleFilters>;
};

export type BenefitPlanChangelog = {
  __typename?: 'BenefitPlanChangelog';
  changes?: Maybe<Scalars['Map']['output']>;
  created_at?: Maybe<Scalars['Time']['output']>;
  credential?: Maybe<Credential>;
  id: Scalars['ID']['output'];
};

export type BenefitPlanChangelogList = {
  __typename?: 'BenefitPlanChangelogList';
  pagination: Pagination;
  results?: Maybe<Array<BenefitPlanChangelog>>;
};

export type BenefitPlanDrugCoverageCopay = {
  __typename?: 'BenefitPlanDrugCoverageCopay';
  associatedAllowances: Array<CalculatedAllowance>;
  associated_drug_lists: Array<Scalars['String']['output']>;
  associated_drug_programs: Array<Scalars['String']['output']>;
  benefit_plan?: Maybe<BenefitPlan>;
  category?: Maybe<Scalars['String']['output']>;
  coinsurance?: Maybe<Scalars['String']['output']>;
  copay?: Maybe<Scalars['String']['output']>;
  copay_coinsurance_logic?: Maybe<Scalars['String']['output']>;
  coverage?: Maybe<Scalars['String']['output']>;
  coverageChecks: Array<Scalars['String']['output']>;
  coverage_notes?: Maybe<Scalars['String']['output']>;
  drug: Drug;
  formulary?: Maybe<Formulary>;
  formulary_drug?: Maybe<FormularyDrug>;
  hasCopayIncentive: Scalars['Boolean']['output'];
  hasDesignatedPharmacy: Scalars['Boolean']['output'];
  hasFirstRightOfRefusal: Scalars['Boolean']['output'];
  list_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use coverageChecks instead */
  logic_path: Array<Scalars['String']['output']>;
  related_drug_programs?: Maybe<Array<RelatedDrugProgram>>;
};

export type BenefitPlanDrugCoverageCopayList = {
  __typename?: 'BenefitPlanDrugCoverageCopayList';
  pagination: Pagination;
  results: Array<BenefitPlanDrugCoverageCopay>;
};

export type BenefitPlanFilters = {
  code?: InputMaybe<StringFilter>;
  group?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  /**
   * Omit (or pass null) to return draft and non-draft plans alike. Drafts are kept out of
   * group-to-plan and plan code creation by those mutations, not by this list.
   */
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<StringFilter>;
  plan_id?: InputMaybe<IdFilter>;
};

export type BenefitPlanInput = {
  base_plan_id?: InputMaybe<Scalars['ID']['input']>;
  benefitPlanTypeID?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  formulary_id: Scalars['ID']['input'];
  /**
   * Only the AI Orchestrator service account may set this. Ignored, not errored, from any other
   * caller, so an existing client that sends the field wholesale keeps working.
   */
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  is_zebra_plan?: InputMaybe<Scalars['Boolean']['input']>;
  member_drug_lookup_link_option: Scalars['String']['input'];
  name: Scalars['String']['input'];
  papn?: InputMaybe<Scalars['ID']['input']>;
  papn2?: InputMaybe<Scalars['ID']['input']>;
  papn3?: InputMaybe<Scalars['ID']['input']>;
};

export type BenefitPlanList = {
  __typename?: 'BenefitPlanList';
  pagination: Pagination;
  results?: Maybe<Array<BenefitPlan>>;
};

export type BenefitPlanNetworkType = {
  __typename?: 'BenefitPlanNetworkType';
  benefitPlan: BenefitPlan;
  groupName: Scalars['String']['output'];
  networkType: DesignatedPharmacyNetworkType;
};

export type BenefitPlanOrder = {
  code?: InputMaybe<OrderDirectionEnum>;
  created_at?: InputMaybe<OrderDirectionEnum>;
  last_modified_at?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export type BenefitPlanType = {
  __typename?: 'BenefitPlanType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type BillCostHandler = {
  __typename?: 'BillCostHandler';
  billCostHandlerDetails?: Maybe<Array<BillCostHandlerDetail>>;
  created: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated?: Maybe<Scalars['Time']['output']>;
};

export type BillCostHandlerConnection = {
  __typename?: 'BillCostHandlerConnection';
  edges: Array<BillCostHandlerEdge>;
  pageInfo: PageInfo;
};

export type BillCostHandlerDetail = {
  __typename?: 'BillCostHandlerDetail';
  billCostHandlerUUID: Scalars['ID']['output'];
  calculation?: Maybe<Scalars['Int']['output']>;
  created: Scalars['Time']['output'];
  dispFeeMargin: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  limitUC: Scalars['Boolean']['output'];
  type: HandlerDetailType;
  updated?: Maybe<Scalars['Time']['output']>;
};

export type BillCostHandlerDetailOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
};

export type BillCostHandlerDetailUpsertInput = {
  billCostHandlerUUID: Scalars['ID']['input'];
  calculation?: InputMaybe<Scalars['Int']['input']>;
  dispFeeMargin?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  limitUC?: InputMaybe<Scalars['Boolean']['input']>;
  type: HandlerDetailType;
  updated?: InputMaybe<Scalars['Time']['input']>;
};

export type BillCostHandlerEdge = {
  __typename?: 'BillCostHandlerEdge';
  cursor: Scalars['String']['output'];
  node: BillCostHandler;
};

export type BillCostHandlerFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type BillCostHandlerOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export type BodyPartCode = {
  __typename?: 'BodyPartCode';
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  compensability?: Maybe<Scalars['String']['output']>;
  compensability_comment?: Maybe<Scalars['String']['output']>;
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  primary_injured_body_part?: Maybe<Scalars['Boolean']['output']>;
};

export type BodyPartCodeFilters = {
  code?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type BodyPartCodeInput = {
  code: Scalars['String']['input'];
  compensability?: InputMaybe<Scalars['String']['input']>;
  compensability_comment?: InputMaybe<Scalars['String']['input']>;
  primary_injured_body_part?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BodyPartCodeList = {
  __typename?: 'BodyPartCodeList';
  pagination: Pagination;
  results?: Maybe<Array<BodyPartCode>>;
};

export type BodyPartCodeOrder = {
  code?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export type BooleanClaimInstruction = ClaimInstruction & {
  __typename?: 'BooleanClaimInstruction';
  boolValue: Scalars['Boolean']['output'];
  field: MpaClaimInstructionField;
  id: Scalars['ID']['output'];
  isEmpty: Scalars['Boolean']['output'];
};

export type BooleanFilter = {
  /** Equal */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal */
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BrandCode {
  /** B */
  Brand = 'Brand',
  /** G */
  Generic = 'Generic',
  /** T */
  Trademark = 'Trademark'
}

export type BuildMpaFromTemplateInput = {
  /** The originating claim. */
  claimId: Scalars['UUID']['input'];
};

export type BulkDeleteDepartmentError = {
  __typename?: 'BulkDeleteDepartmentError';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type BulkDeleteDepartmentsInput = {
  dryRun: Scalars['Boolean']['input'];
  ids: Array<Scalars['ID']['input']>;
};

export type BulkDeleteDepartmentsOutput = {
  __typename?: 'BulkDeleteDepartmentsOutput';
  deletionErrors: Array<BulkDeleteDepartmentError>;
  ids: Array<Scalars['ID']['output']>;
};

export type BulkDeletePlanCodeError = {
  __typename?: 'BulkDeletePlanCodeError';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type BulkDeletePlanCodesInput = {
  dryRun: Scalars['Boolean']['input'];
  ids: Array<Scalars['ID']['input']>;
};

export type BulkDeletePlanCodesOutput = {
  __typename?: 'BulkDeletePlanCodesOutput';
  deletionErrors: Array<BulkDeletePlanCodeError>;
  ids: Array<Scalars['ID']['output']>;
};

export type BulkDeleteSubgroupDetailError = {
  __typename?: 'BulkDeleteSubgroupDetailError';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type BulkDeleteSubgroupDetailsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type BulkDeleteSubgroupDetailsOutput = {
  __typename?: 'BulkDeleteSubgroupDetailsOutput';
  deletionErrors: Array<BulkDeleteSubgroupDetailError>;
  ids: Array<Scalars['ID']['output']>;
};

export type BulkEditSubgroupError = {
  __typename?: 'BulkEditSubgroupError';
  message: Scalars['String']['output'];
};

export type BulkEditSubgroupsInput = {
  create: Array<CreateSubgroupInput>;
  delete: Array<Scalars['ID']['input']>;
  update: Array<UpdateSubgroupInput>;
};

export type BulkEditSubgroupsOutput = {
  __typename?: 'BulkEditSubgroupsOutput';
  bulkEditSubgroupErrors: Array<BulkEditSubgroupError>;
  deletedSubgroupIds: Array<Scalars['ID']['output']>;
  subgroups: Array<Subgroup>;
};

export type BulkSaveCostListDetailInput = {
  costListID: Scalars['ID']['input'];
  deleteCostGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deleteDetailIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details: Array<CostListDetailInput>;
  function: CostListGroupFunctionType;
  groupFunctions?: InputMaybe<Array<CostListGroupFunctionInput>>;
};

export type BulkTerminatePrescribersInput = {
  expirationDate: Scalars['Date']['input'];
  ids: Array<Scalars['ID']['input']>;
};

export type BulkUpdateProcessRuleLinesInput = {
  action?: InputMaybe<ProcessRuleLineInclusion>;
  copayHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  matchScriptTag?: InputMaybe<ReplaceOrAppendOperation>;
  processRuleLineIds: Array<Scalars['ID']['input']>;
  setScriptTag?: InputMaybe<ReplaceOrAppendOperation>;
};

export type BulkUpdateProcessRuleLinesResponse = {
  __typename?: 'BulkUpdateProcessRuleLinesResponse';
  generalErrors?: Maybe<Array<Scalars['String']['output']>>;
  processRuleLineErrors?: Maybe<Array<ProcessRuleLineError>>;
  processRuleLines?: Maybe<Array<ProcessRuleLine>>;
  success: Scalars['Boolean']['output'];
};

export type BulkUpdateSubgroupDetailError = {
  __typename?: 'BulkUpdateSubgroupDetailError';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type BulkUpdateSubgroupDetailsInput = {
  benCapSatisfactionType?: InputMaybe<SatisfactionType>;
  benefitStartDate?: InputMaybe<Scalars['Date']['input']>;
  dedSatisfactionType?: InputMaybe<SatisfactionType>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  familyBenCap?: InputMaybe<Scalars['Cents']['input']>;
  familyDed?: InputMaybe<Scalars['Cents']['input']>;
  familyOop?: InputMaybe<Scalars['Cents']['input']>;
  ids: Array<Scalars['ID']['input']>;
  individualBenCap?: InputMaybe<Scalars['Cents']['input']>;
  individualDed?: InputMaybe<Scalars['Cents']['input']>;
  individualOop?: InputMaybe<Scalars['Cents']['input']>;
  naToDed?: InputMaybe<Scalars['Boolean']['input']>;
  oopSatisfactionType?: InputMaybe<SatisfactionType>;
};

export type BulkUpdateSubgroupDetailsOutput = {
  __typename?: 'BulkUpdateSubgroupDetailsOutput';
  errors: Array<BulkUpdateSubgroupDetailError>;
  ids: Array<Scalars['ID']['output']>;
};

/** Input for bulk updating test case results */
export type BulkUpdateTestCaseResultsInput = {
  /** Optional: Diff notes to apply */
  diffNotes?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Issue category to apply */
  issueCategory?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Test result/status to apply */
  result?: InputMaybe<Scalars['String']['input']>;
  /** IDs of test case results to update */
  testCaseResultIds: Array<Scalars['Int']['input']>;
};

/** Response from bulk update operation */
export type BulkUpdateTestCaseResultsResponse = {
  __typename?: 'BulkUpdateTestCaseResultsResponse';
  /** Success message */
  message: Scalars['String']['output'];
  /** Number of records updated */
  updatedCount: Scalars['Int']['output'];
};

export type BulkUpsertDesignatedPharmacyInput = {
  deleteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  details?: InputMaybe<Array<DesignatedPharmacyDetailInput>>;
};

export type BulkUpsertProcessRuleAttachmentsInput = {
  deletedIDs: Array<Scalars['ID']['input']>;
  processRuleAttachments: Array<ProcessRuleAttachmentInput>;
};

export type BulkUpsertProcessRuleAttachmentsPayload = {
  __typename?: 'BulkUpsertProcessRuleAttachmentsPayload';
  processRuleAttachments: Array<ProcessRuleAttachment>;
};

export type BusinessRelationship = {
  __typename?: 'BusinessRelationship';
  connections: ConnectionList;
  group: Group;
  partner: Partner;
  relationship?: Maybe<Scalars['String']['output']>;
};

export type BusinessRelationshipList = {
  __typename?: 'BusinessRelationshipList';
  pagination: Pagination;
  results?: Maybe<Array<BusinessRelationship>>;
};

export type BusinessRelationshipOrder = {
  group?: InputMaybe<OrderDirectionEnum>;
  partner?: InputMaybe<OrderDirectionEnum>;
  relationship?: InputMaybe<OrderDirectionEnum>;
};

export type Cob = {
  __typename?: 'COB';
  cobLines?: Maybe<Array<CobObjectLine>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CobConnection = {
  __typename?: 'COBConnection';
  edges: Array<CobEdge>;
  pageInfo: PageInfo;
};

export type CobEdge = {
  __typename?: 'COBEdge';
  cursor: Scalars['String']['output'];
  node: Cob;
};

export type CobFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CobObjectLine = {
  __typename?: 'COBObjectLine';
  calculation?: Maybe<CalculationType>;
  cobObjectID?: Maybe<Scalars['ID']['output']>;
  condition?: Maybe<Condition>;
  created: Scalars['Time']['output'];
  effectiveDate: Scalars['Date']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  occCode?: Maybe<OccCode>;
  rejectWithCode?: Maybe<Scalars['String']['output']>;
  rejectWithMessage?: Maybe<Scalars['String']['output']>;
  updated: Scalars['Time']['output'];
};

export type CobOrder = {
  id?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export type CsvExecutionInput = {
  groupId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
  subgroupId: Scalars['ID']['input'];
  suiteId: Scalars['ID']['input'];
};

export type CalculatedAllowance = {
  __typename?: 'CalculatedAllowance';
  allowance: PlanRule;
  coinsurance?: Maybe<Scalars['String']['output']>;
  copay?: Maybe<Scalars['String']['output']>;
  copayCoinsuranceLogic?: Maybe<Scalars['String']['output']>;
  copayIncentive?: Maybe<Scalars['Boolean']['output']>;
  coverageNotes: Scalars['String']['output'];
  frorDrugLists: Array<MatchRule>;
};

export enum CalculationType {
  BillForCopay = 'BILL_FOR_COPAY',
  Reject = 'REJECT',
  Standard = 'STANDARD'
}

export type CardholderKey = {
  cardID: Scalars['String']['input'];
  groupNumber: Scalars['String']['input'];
};

export type CardholderToGroupTimelineRecord = TimelineRecord & {
  __typename?: 'CardholderToGroupTimelineRecord';
  /**
   * The altCardID is specific to Portal data source.
   * Zebra stores this data in a separate table and the value won't be populated.
   */
  altCardID?: Maybe<Scalars['String']['output']>;
  cardId: Scalars['String']['output'];
  coverageType: MemberCoverageLevelEnum;
  createdAt?: Maybe<Scalars['Time']['output']>;
  effectiveDate: Scalars['Date']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  group: Group;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type CardholderToGroupTimelineRecordInput = {
  altCardID?: InputMaybe<Scalars['String']['input']>;
  coverageType: MemberCoverageLevelEnum;
  timelineRecordKey: Scalars['Int']['input'];
};

export type Carrier = Node & {
  __typename?: 'Carrier';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type CarrierCode = {
  __typename?: 'CarrierCode';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CaseRequest = {
  /** Group */
  group: Group;
  /** The case's unique identifier, caseID */
  id: Scalars['ID']['output'];
  /** Member read the latest message or not */
  isUnread: Scalars['Boolean']['output'];
  /** Member */
  member: Member;
};

export type CaseRequestConnection = {
  __typename?: 'CaseRequestConnection';
  csvDownloadURL?: Maybe<Scalars['String']['output']>;
  edges?: Maybe<Array<Maybe<CaseRequestEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseRequestEdge = {
  __typename?: 'CaseRequestEdge';
  node?: Maybe<CaseRequest>;
};

export type CaseRequestFilters = {
  ID?: InputMaybe<IdFilter>;
  /** Filtering by status+category combinations, multiple objects are joined by OR */
  combinedStatuses?: InputMaybe<Array<InputMaybe<CombinedStatusFilters>>>;
  connectProgramName?: InputMaybe<Scalars['String']['input']>;
  drugName?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<IdFilter>;
  initiatedAt?: InputMaybe<TimeFilter>;
  memberComposite?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<IdFilter>;
  referenceNumber?: InputMaybe<IdFilter>;
  status?: InputMaybe<StringFilter>;
  type?: InputMaybe<Array<CaseRequestType>>;
  /** Use response based on native histories and combinedStatuses filtering */
  useNativeHistories?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use updated PA status mapping: some existing filters refined and support for new statuses */
  usePAStatusMappingV2?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CaseRequestOrder = {
  initiatedAt?: InputMaybe<OrderDirectionEnum>;
  memberName?: InputMaybe<OrderDirectionEnum>;
};

export enum CaseRequestType {
  Connect = 'CONNECT',
  MailOrder = 'MAIL_ORDER',
  Mss = 'MSS',
  PriorAuthorization = 'PRIOR_AUTHORIZATION'
}

export type ChainCode = Node & {
  __typename?: 'ChainCode';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ChainCodeConnection = {
  __typename?: 'ChainCodeConnection';
  edges: Array<ChainCodeEdge>;
  pageInfo: PageInfo;
};

export type ChainCodeEdge = {
  __typename?: 'ChainCodeEdge';
  cursor: Scalars['String']['output'];
  node: ChainCode;
};

export type ChainCodeFilters = {
  code?: InputMaybe<StringFilter>;
};

export type ChainInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  contactName?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type ChainUpsertResult = BaseError | ChainCode | ValidationError;

/**
 * # ChangelogEntry
 * GraphQL schema capturing a change of a resource's single field and its context.
 * Denormalized for exportability.
 *
 * Captures information at 3 levels:
 * 1. Transaction level - multiple operations are grouped into a single transaction
 * * `transactionId`: Opaque identifier for the transaction
 * * `changedAt`: Timestamp of when the operation occurred
 * * `changedBy`: Actor who made the operation
 * 1. Resource level - multiple fields can be operated on a single resource
 * * `resourceType`: Type of the resource (e.g., `custom_drug_list`)
 * * `resourceId`: Opaque identifier for the resource (unique to resource)
 * * `operation`: `CREATE`, `UPDATE`, `DELETE`
 * 1. Field level - captures changes made to specific fields of the resource
 * * `id`: Opaque identifier for the field change
 * * `field`: Name of the field of the resource that was changed
 * * `before`: Value of the field before the change (empty when create)
 * * `after`: Value of the field after the change (empty when delete)
 *
 * [View tech plan for more information](https://docs.google.com/document/d/1RXVlofk-ucOFEyOmjNVB7sG2gW9T2jPUBcVqhazq5Xo/edit?tab=t.0).
 */
export type ChangelogEntry = Node & {
  __typename?: 'ChangelogEntry';
  after?: Maybe<Scalars['Any']['output']>;
  before?: Maybe<Scalars['Any']['output']>;
  changedAt: Scalars['Time']['output'];
  changedBy?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  operation: ChangelogOperation;
  resourceId: Scalars['ID']['output'];
  resourceType: Scalars['String']['output'];
  transactionId: Scalars['ID']['output'];
};

/**
 * # Relay-style pagination for Changelog entries.
 *
 * [Relay documentation](https://www.apollographql.com/docs/graphos/schema-design/guides/relay-style-connections)
 */
export type ChangelogEntryConnection = {
  __typename?: 'ChangelogEntryConnection';
  count: Scalars['Int']['output'];
  edges: Array<ChangelogEntryEdge>;
  pageInfo: PageInfo;
};

export type ChangelogEntryEdge = {
  __typename?: 'ChangelogEntryEdge';
  cursor: Scalars['String']['output'];
  node: ChangelogEntry;
};

export type ChangelogEntryFilterOptions = {
  __typename?: 'ChangelogEntryFilterOptions';
  /**
   * # List of users who have changed the resource.
   * Requires `resourceType`, and is further refined when providing `resourceId`.
   */
  changedBy?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * # List of fields that can be filtered for.
   * Requires `resourceType`.
   */
  fields: Array<Scalars['String']['output']>;
  /**
   * # List of `resourceType` that can be filtered for.
   * Only returned if no inputs are provided.
   */
  resourceTypes?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * # Earliest start and latest end time for filtering changelog entries.
   * Requires `resourceType`, and is further refined when providing `resourceId`.
   */
  timeRange?: Maybe<TimeRange>;
};

/**
 * # Input type for filtering options based on resource type and ID.
 * If no inputs are provided, only `resourceTypes` will be returned.
 * If `resourceType` is provided, other fields are returned.
 */
export type ChangelogEntryFilterOptionsInput = {
  resourceId?: InputMaybe<Scalars['ID']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
};

/** # Filter Changelog entries by various criteria. */
export type ChangelogEntryFilters = {
  beforeOrAfter?: InputMaybe<StringFilter>;
  changedAt?: InputMaybe<TimeFilter>;
  changedBy?: InputMaybe<StringFilter>;
  field?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  operation?: InputMaybe<StringFilter>;
  resourceId?: InputMaybe<IdFilter>;
  resourceType?: InputMaybe<StringFilter>;
  transactionId?: InputMaybe<IdFilter>;
};

export type ChangelogEntryOrder = {
  changedAt?: InputMaybe<OrderDirectionEnum>;
  field?: InputMaybe<OrderDirectionEnum>;
  operation?: InputMaybe<OrderDirectionEnum>;
  resourceId?: InputMaybe<OrderDirectionEnum>;
  resourceType?: InputMaybe<OrderDirectionEnum>;
};

export enum ChangelogOperation {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export enum ChannelEnum {
  All = 'ALL',
  Mail = 'MAIL',
  Retail = 'RETAIL',
  Specialty = 'SPECIALTY'
}

export type CheckNameIsUniqueInput = {
  name: Scalars['String']['input'];
};

export type Claim = {
  __typename?: 'Claim';
  authorization_number: Scalars['String']['output'];
  billed_to_group: Scalars['Float']['output'];
  compound_code: Scalars['String']['output'];
  copay: Scalars['Float']['output'];
  cost_basis: Scalars['String']['output'];
  days_supply: Scalars['Int']['output'];
  deductible: Scalars['Float']['output'];
  dispense_as_written: Scalars['String']['output'];
  dispense_as_written_diff: Scalars['Float']['output'];
  dispensing_fee: Scalars['Float']['output'];
  doctor?: Maybe<Doctor>;
  drug: Drug;
  fill_number: Scalars['Int']['output'];
  fill_processed_at: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  ingredient_cost: Scalars['Float']['output'];
  number_of_refills: Scalars['Int']['output'];
  out_of_network: Scalars['Boolean']['output'];
  out_of_pocket: Scalars['Float']['output'];
  pharmacy: Pharmacy;
  prior_auth: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  rx_date: Scalars['Time']['output'];
  rx_number: Scalars['String']['output'];
  sales_tax: Scalars['Float']['output'];
  self_pay: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  strength: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Filter by composition of claim objects fields, using AND / OR logical operator */
export type ClaimCompositeFilterV2 = {
  filters: Array<ClaimFilterV2>;
  operator: FilterOperatorV2;
};

/** Relay-style connection of Claims */
export type ClaimConnectionV2 = {
  __typename?: 'ClaimConnectionV2';
  /** Number of claims that satisfy filters (or total number of claims when filters are omitted) */
  count: Scalars['Int']['output'];
  edges: Array<ClaimEdgeV2>;
  pageInfo: ClaimPageInfoV2;
};

export type ClaimContextInput = {
  /** The originating claim. Reserved for claim-derived fills; the P0 dates use the server clock. */
  claimId: Scalars['UUID']['input'];
};

/** Sort direction to be used with claims API */
export enum ClaimDirectionV2 {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

/** Relay-style edge associated with a Claim object */
export type ClaimEdgeV2 = {
  __typename?: 'ClaimEdgeV2';
  cursor: Scalars['String']['output'];
  node: ClaimV2;
};

/** Filter by given claim objects field */
export type ClaimFieldFilterV2 = {
  comparator: FilterComparatorV2;
  field: ClaimFieldV2;
  value: Scalars['Any']['input'];
};

/** Claim object fields to filter and sort list of claim objects */
export enum ClaimFieldV2 {
  AdjudicatedBy = 'ADJUDICATED_BY',
  AuthorizationNumber = 'AUTHORIZATION_NUMBER',
  BatchUuid = 'BATCH_UUID',
  Copay = 'COPAY',
  Created = 'CREATED',
  DateOfService = 'DATE_OF_SERVICE',
  Gpi = 'GPI',
  GroupBilledAmount = 'GROUP_BILLED_AMOUNT',
  GroupCode = 'GROUP_CODE',
  Id = 'ID',
  MemberCardId = 'MEMBER_CARD_ID',
  MemberDob = 'MEMBER_DOB',
  MemberPersonCode = 'MEMBER_PERSON_CODE',
  MemberUuid = 'MEMBER_UUID',
  Ndc = 'NDC',
  PharmacyNpi = 'PHARMACY_NPI',
  PlanCode = 'PLAN_CODE',
  PrescriptionDate = 'PRESCRIPTION_DATE',
  PrescriptionNumber = 'PRESCRIPTION_NUMBER',
  QuantityDispensed = 'QUANTITY_DISPENSED',
  Type = 'TYPE'
}

/**
 * Filter claims using either single field filter or a combination of filters, both `filter` and `compose` should not
 * be provided at the same time. We cannot enforce this rule until @oneOf directive is part of the GraphQL specification
 */
export type ClaimFilterV2 = {
  compose?: InputMaybe<ClaimCompositeFilterV2>;
  filter?: InputMaybe<ClaimFieldFilterV2>;
};

export type ClaimFilters = {
  dateInterval?: InputMaybe<ClaimsDateIntervalFilterEnum>;
  rx_number?: InputMaybe<StringFilter>;
};

export type ClaimInstruction = {
  /** MPA field key, e.g. "ALLOW_OTC", "FORCE_THIS_COPAY_HANDLER_ID". Unique per MPA. */
  field: MpaClaimInstructionField;
  /** Opaque, stable across refetches. Not a Relay global id; clients must not parse it. */
  id: Scalars['ID']['output'];
  /** True if the instruction has no value (e.g. a boolean false, or a nil reference). */
  isEmpty: Scalars['Boolean']['output'];
};

/** One validation entry from the shared evaluator, consumed for live Save-gating and re-enforced at write. */
export type ClaimInstructionValidation = {
  __typename?: 'ClaimInstructionValidation';
  code: ClaimInstructionValidationCode;
  /** The field this relates to. Null for form-level entries such as the effective/termination dates. */
  field?: Maybe<MpaClaimInstructionField>;
  message: Scalars['String']['output'];
  severity: ClaimInstructionValidationSeverity;
};

/** Category a claim-instruction validation falls into. The FE switches on this for messaging but gates on severity. */
export enum ClaimInstructionValidationCode {
  /** The same field appears more than once in the input. BLOCKING. */
  DuplicateField = 'DUPLICATE_FIELD',
  /** The template needs claim context but none was provided. BLOCKING. */
  MissingRequiredContext = 'MISSING_REQUIRED_CONTEXT',
  /** A value is outside the allowed bounds. BLOCKING. */
  OutOfRange = 'OUT_OF_RANGE',
  /** The template prefilled this field. INFO. */
  Prefilled = 'PREFILLED',
  /** A required field has no value yet. BLOCKING. */
  Required = 'REQUIRED',
  /** The termination date is on or before the effective date. BLOCKING. */
  TermBeforeEffective = 'TERM_BEFORE_EFFECTIVE',
  /** The populated value does not match the field's datatype. BLOCKING. */
  TypeMismatch = 'TYPE_MISMATCH',
  /** The field is not in the server's field-to-datatype map. BLOCKING. */
  UnknownField = 'UNKNOWN_FIELD'
}

/**
 * Severity of a claim-instruction validation. BLOCKING gates Save and is
 * re-enforced server-side; WARNING is advisory; INFO feeds the prefill banner.
 * Read severity to gate, not code.
 */
export enum ClaimInstructionValidationSeverity {
  Blocking = 'BLOCKING',
  Info = 'INFO',
  Warning = 'WARNING'
}

/**
 * Write-side mirror of ClaimInstruction. GraphQL has no input unions, so the
 * datatype is inferred from field and exactly one value field must be set and
 * match the inferred datatype. id is not sent on write; instructions are
 * identified by field.
 */
export type ClaimInstructionValueInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** For single enum fields. */
  code?: InputMaybe<Scalars['String']['input']>;
  dollarsValue?: InputMaybe<Scalars['Dollars']['input']>;
  field: MpaClaimInstructionField;
  floatValue?: InputMaybe<Scalars['Float']['input']>;
  intValue?: InputMaybe<Scalars['Int']['input']>;
  /** For reference fields (UUID entities or multi-value code refs). */
  refIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export type ClaimList = {
  __typename?: 'ClaimList';
  pagination: Pagination;
  results?: Maybe<Array<Claim>>;
};

export type ClaimLookup = {
  __typename?: 'ClaimLookup';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ClaimLookups = {
  __typename?: 'ClaimLookups';
  cobPayorQualifiers: Array<ClaimLookup>;
  compoundCodes: Array<ClaimLookup>;
  coverageTypes: Array<ClaimLookup>;
  dawCodes: Array<ClaimLookup>;
  dosageForms: Array<ClaimLookup>;
  id: Scalars['ID']['output'];
  ingredientCostBases: Array<ClaimLookup>;
  levelsOfEffort: Array<ClaimLookup>;
  levelsOfService: Array<ClaimLookup>;
  otherCoverageCodes: Array<ClaimLookup>;
  pACodeTypes: Array<ClaimLookup>;
  pharmacyServices: Array<ClaimLookup>;
  professionalServices: Array<ClaimLookup>;
  reasonsForService: Array<ClaimLookup>;
  resultsOfService: Array<ClaimLookup>;
  submissionClarifications: Array<ClaimLookup>;
};

export type ClaimOrder = {
  billed_to_group?: InputMaybe<OrderDirectionEnum>;
  copay?: InputMaybe<OrderDirectionEnum>;
  days_supply?: InputMaybe<OrderDirectionEnum>;
  fill_processed_at?: InputMaybe<OrderDirectionEnum>;
  quantity?: InputMaybe<OrderDirectionEnum>;
  rx_date?: InputMaybe<OrderDirectionEnum>;
  rx_number?: InputMaybe<OrderDirectionEnum>;
};

/** Sort claims by available field in given direction */
export type ClaimOrderV2 = {
  direction: ClaimDirectionV2;
  field: ClaimFieldV2;
};

/** Relay-style page info */
export type ClaimPageInfoV2 = {
  __typename?: 'ClaimPageInfoV2';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ClaimSdc = {
  __typename?: 'ClaimSDC';
  amount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  sdcId: Scalars['String']['output'];
};

export type ClaimSdcHistoryInput = {
  amount: Scalars['Dollars']['input'];
  sdcId: Scalars['String']['input'];
};

export type ClaimSet = {
  __typename?: 'ClaimSet';
  associatedClaims: ClaimConnectionV2;
  createdAt: Scalars['Time']['output'];
  createdBy: Credential;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  totalClaims: Scalars['Int']['output'];
  totalPaid: Scalars['Int']['output'];
  totalProcessed: Scalars['Int']['output'];
  totalRejected: Scalars['Int']['output'];
  totalReversed: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** The upload and processing status of a ClaimSet IFP file associated with a reprocessor batch. */
export type ClaimSetUploadProgress = {
  __typename?: 'ClaimSetUploadProgress';
  /** Error details if the file is in ERROR status. Null otherwise. */
  errorInfo?: Maybe<IfpFileErrorInfo>;
  /** The ID of the associated IFP file. */
  fileId: Scalars['UUID']['output'];
  /** The S3 key of the uploaded file. */
  s3Key: Scalars['String']['output'];
  /** The current processing status of the IFP file. */
  status: IfpFileStatus;
};

export type ClaimTransaction = {
  __typename?: 'ClaimTransaction';
  PrimaryMemberPersonCode?: Maybe<Scalars['String']['output']>;
  RandomUUID?: Maybe<Scalars['String']['output']>;
  accumResetDayOfMonth?: Maybe<Scalars['Int']['output']>;
  accumResetMonth?: Maybe<Scalars['Int']['output']>;
  adjudicatedBy: AdjudicatedBy;
  adjustedAuthNumber?: Maybe<Scalars['String']['output']>;
  adjustedCopay?: Maybe<Scalars['Cents']['output']>;
  adjustedFromAuthNumber?: Maybe<Scalars['String']['output']>;
  awpIngredientCost?: Maybe<Scalars['Float']['output']>;
  batchID?: Maybe<Scalars['String']['output']>;
  benefitEndDate?: Maybe<Scalars['Time']['output']>;
  benefitPlan?: Maybe<BenefitPlan>;
  benefitPlanCode?: Maybe<Scalars['String']['output']>;
  benefitPlanID?: Maybe<Scalars['String']['output']>;
  benefitPlanName?: Maybe<Scalars['String']['output']>;
  benefitPlanUUID?: Maybe<Scalars['String']['output']>;
  benefitStartDate?: Maybe<Scalars['Time']['output']>;
  billedIngredientCostPerQuantity?: Maybe<Scalars['Cents']['output']>;
  billedIngredientCostPlusDispensingFee?: Maybe<Scalars['Cents']['output']>;
  billedIngredientCostPlusTax?: Maybe<Scalars['Cents']['output']>;
  chainCode?: Maybe<Scalars['String']['output']>;
  chainName?: Maybe<Scalars['String']['output']>;
  claimAdminFee?: Maybe<Scalars['Cents']['output']>;
  claimAuthorizationNumber?: Maybe<Scalars['String']['output']>;
  claimAwpUnitPrice?: Maybe<Scalars['Float']['output']>;
  claimBasisOfReimbursement?: Maybe<Scalars['Int']['output']>;
  claimBilledDispensingFee?: Maybe<Scalars['Cents']['output']>;
  /** @deprecated Use claimUsedIncentiveFee instead */
  claimBilledIncentiveFee?: Maybe<Scalars['Cents']['output']>;
  claimBilledIngredientCost?: Maybe<Scalars['Cents']['output']>;
  claimBilledTax?: Maybe<Scalars['Cents']['output']>;
  claimBillsAdminFee?: Maybe<Scalars['Boolean']['output']>;
  claimChannelFee?: Maybe<Scalars['Cents']['output']>;
  claimClaimantCardID?: Maybe<Scalars['String']['output']>;
  claimCompoundCode?: Maybe<Scalars['String']['output']>;
  claimCopay?: Maybe<Scalars['Cents']['output']>;
  claimCostBasisTerm?: Maybe<Scalars['String']['output']>;
  claimDaysSupply?: Maybe<Scalars['Int']['output']>;
  claimDeaCode?: Maybe<Scalars['String']['output']>;
  claimDeductible?: Maybe<Scalars['Cents']['output']>;
  claimDispenseAsWritten?: Maybe<Scalars['String']['output']>;
  claimDispenseAsWrittenDiff?: Maybe<Scalars['String']['output']>;
  claimEndServiceAt?: Maybe<Scalars['Time']['output']>;
  claimFillProcessedAt?: Maybe<Scalars['Time']['output']>;
  claimFillStartedAt?: Maybe<Scalars['Time']['output']>;
  claimGrossAmountDue?: Maybe<Scalars['Cents']['output']>;
  claimGrossCopay?: Maybe<Scalars['Cents']['output']>;
  claimIndemnity?: Maybe<Scalars['Cents']['output']>;
  claimMACName?: Maybe<Scalars['String']['output']>;
  claimMacUnitPrice?: Maybe<Scalars['Float']['output']>;
  claimMpaNumber?: Maybe<Scalars['String']['output']>;
  claimMpaUUID?: Maybe<Scalars['String']['output']>;
  claimNdc?: Maybe<Scalars['String']['output']>;
  claimNetCopay?: Maybe<Scalars['Cents']['output']>;
  claimNetworkName?: Maybe<Scalars['String']['output']>;
  claimNewRefillCode?: Maybe<Scalars['Int']['output']>;
  claimNumRefills?: Maybe<Scalars['Int']['output']>;
  claimNumber?: Maybe<Scalars['String']['output']>;
  claimOutOfNetwork?: Maybe<Scalars['Boolean']['output']>;
  claimOutOfPocket?: Maybe<Scalars['Cents']['output']>;
  claimPaidIngredientCost?: Maybe<Scalars['Cents']['output']>;
  claimPrescriptionID?: Maybe<Scalars['String']['output']>;
  claimPrescriptionWrittenAt?: Maybe<Scalars['Time']['output']>;
  claimPriorAuthCode?: Maybe<Scalars['String']['output']>;
  claimProfessionalServiceFee?: Maybe<Scalars['Cents']['output']>;
  claimQuantity?: Maybe<Scalars['Float']['output']>;
  claimRouteOfAdministration?: Maybe<Scalars['String']['output']>;
  claimRxNumber?: Maybe<Scalars['String']['output']>;
  claimSelfPay?: Maybe<Scalars['Boolean']['output']>;
  claimSource?: Maybe<Scalars['String']['output']>;
  claimStrength?: Maybe<Scalars['String']['output']>;
  claimSubmittedFee?: Maybe<Scalars['Cents']['output']>;
  claimSubmittedIncentiveFee?: Maybe<Scalars['Cents']['output']>;
  claimSubmittedIngredientCost?: Maybe<Scalars['Cents']['output']>;
  claimTotalBilled?: Maybe<Scalars['Cents']['output']>;
  claimTotalCharge?: Maybe<Scalars['Cents']['output']>;
  claimTotalPaid?: Maybe<Scalars['Cents']['output']>;
  claimType?: Maybe<Scalars['String']['output']>;
  claimUMAC2UnitPrice?: Maybe<Scalars['Float']['output']>;
  claimUMAC3UnitPrice?: Maybe<Scalars['Float']['output']>;
  claimUMACUnitPrice?: Maybe<Scalars['Float']['output']>;
  claimUsedIncentiveFee?: Maybe<Scalars['Cents']['output']>;
  claimUsualCost?: Maybe<Scalars['Cents']['output']>;
  claimWacUnitPrice?: Maybe<Scalars['Float']['output']>;
  claimWhoPaidDawDiff?: Maybe<Scalars['String']['output']>;
  coInsurance?: Maybe<Scalars['Cents']['output']>;
  /** Compound ingredients for compound claims. Returns null for non-compound claims. */
  compoundIngredients?: Maybe<Array<CompoundIngredient>>;
  contentEndDate?: Maybe<Scalars['Time']['output']>;
  contentStartDate?: Maybe<Scalars['Time']['output']>;
  current_date?: Maybe<Scalars['Time']['output']>;
  /**
   * Which store served this claim. Distinct from adjudicatedBy: a
   * Laker-adjudicated claim belonging to a group that has cut over to Zebra is
   * served from ZEBRA, and only those claims can resolve a Zebra member.
   */
  dataSource: DataSource;
  deductibleOrOutOfPocket?: Maybe<Scalars['Cents']['output']>;
  departmentCode?: Maybe<Scalars['String']['output']>;
  discountAdjustedCopay?: Maybe<Scalars['Cents']['output']>;
  discountDeductible?: Maybe<Scalars['Cents']['output']>;
  discountOutOfPocket?: Maybe<Scalars['Cents']['output']>;
  doctorAddress1?: Maybe<Scalars['String']['output']>;
  doctorAddress2?: Maybe<Scalars['String']['output']>;
  doctorCity?: Maybe<Scalars['String']['output']>;
  doctorFirstName?: Maybe<Scalars['String']['output']>;
  doctorId?: Maybe<Scalars['String']['output']>;
  doctorLastName?: Maybe<Scalars['String']['output']>;
  doctorName?: Maybe<Scalars['String']['output']>;
  doctorNpi?: Maybe<Scalars['String']['output']>;
  doctorState?: Maybe<Scalars['String']['output']>;
  doctorZip?: Maybe<Scalars['String']['output']>;
  drugBgt?: Maybe<Scalars['String']['output']>;
  drugDdID?: Maybe<Scalars['String']['output']>;
  drugDeaClassCode?: Maybe<Scalars['String']['output']>;
  drugDesi?: Maybe<Scalars['String']['output']>;
  drugGcn?: Maybe<Scalars['String']['output']>;
  drugGenericName?: Maybe<Scalars['String']['output']>;
  drugGpi?: Maybe<Scalars['String']['output']>;
  drugHic3?: Maybe<Scalars['String']['output']>;
  drugLabelNameMddb?: Maybe<Scalars['String']['output']>;
  drugMaintenanceMddb?: Maybe<Scalars['String']['output']>;
  drugMony?: Maybe<Scalars['String']['output']>;
  drugPackageSizeUnitOfMeasure?: Maybe<Scalars['String']['output']>;
  drugRxOtcMddb?: Maybe<Scalars['String']['output']>;
  drugThirdPartyRestriction?: Maybe<Scalars['String']['output']>;
  emiDrugType?: Maybe<Scalars['String']['output']>;
  /**
   * Estimated net amount the coupon covers (after the program minimum copay),
   * in cents. Null when the estimate is not applicable.
   *
   * Example: member owes $200, drug requires $25 minimum → returns 17500
   * (the coupon covers $200 - $25 = $175 instead of the full $200).
   */
  estNetCouponPayAmt?: Maybe<Scalars['Cents']['output']>;
  /**
   * Estimated net amount the member pays (includes the program minimum copay),
   * in cents. Null for claims outside the CPM-S / CPM-T / CASLDD coupon programs
   * and when the estimate cannot be computed.
   *
   * Example: member owes $200, drug requires $25 minimum → returns 2500
   * (without the minimum the member would have paid 0 because the coupon
   * covers the full $200).
   */
  estNetMemberPayAmt?: Maybe<Scalars['Cents']['output']>;
  firstFillStatus?: Maybe<Scalars['String']['output']>;
  formularyDrugCoverageCode?: Maybe<Scalars['String']['output']>;
  formularyDrugIsPreferredSpecialty?: Maybe<Scalars['Boolean']['output']>;
  formularyDrugIsPriorAuthorization?: Maybe<Scalars['Boolean']['output']>;
  formularyDrugIsSpecialty?: Maybe<Scalars['Boolean']['output']>;
  formularyDrugIsStepTherapy?: Maybe<Scalars['Boolean']['output']>;
  formularyDrugQuantityLimit?: Maybe<Scalars['String']['output']>;
  formularyDrugTier?: Maybe<Scalars['String']['output']>;
  formularyDrugTierDesc?: Maybe<Scalars['String']['output']>;
  formularyDrugsIsHealthCareReform?: Maybe<Scalars['Boolean']['output']>;
  formularyName?: Maybe<Scalars['String']['output']>;
  formularyType?: Maybe<Scalars['String']['output']>;
  formularyVersion?: Maybe<Scalars['String']['output']>;
  handlers?: Maybe<Array<Maybe<Handler>>>;
  hasSameDayReversal?: Maybe<Scalars['Boolean']['output']>;
  ingredientCostDifference?: Maybe<Scalars['Cents']['output']>;
  invoiceBatchDate?: Maybe<Scalars['Time']['output']>;
  isClaimDiscounted?: Maybe<Scalars['Boolean']['output']>;
  isClaimDrugOnDiscountList?: Maybe<Scalars['Boolean']['output']>;
  isClaimSap?: Maybe<Scalars['Boolean']['output']>;
  isDrugDiscountEligible?: Maybe<Scalars['Boolean']['output']>;
  isDrugOnFormulary?: Maybe<Scalars['Boolean']['output']>;
  isDrugSapEligible?: Maybe<Scalars['Boolean']['output']>;
  isSap?: Maybe<Scalars['Boolean']['output']>;
  isTest: Scalars['Boolean']['output'];
  lakerUserUUID?: Maybe<Scalars['String']['output']>;
  member?: Maybe<Member>;
  memberAddress1?: Maybe<Scalars['String']['output']>;
  memberAddress2?: Maybe<Scalars['String']['output']>;
  memberAge?: Maybe<Scalars['Float']['output']>;
  memberCity?: Maybe<Scalars['String']['output']>;
  memberCoverageEndDate?: Maybe<Scalars['Time']['output']>;
  memberCoverageStartDate?: Maybe<Scalars['Time']['output']>;
  memberDateOfBirth?: Maybe<Scalars['Time']['output']>;
  memberFirstName?: Maybe<Scalars['String']['output']>;
  memberGender?: Maybe<Scalars['String']['output']>;
  memberLakerPersonCode?: Maybe<Scalars['String']['output']>;
  memberLastName?: Maybe<Scalars['String']['output']>;
  memberMiddleName?: Maybe<Scalars['String']['output']>;
  memberPersonCode?: Maybe<Scalars['String']['output']>;
  memberRelationship?: Maybe<Scalars['String']['output']>;
  memberSsn?: Maybe<Scalars['String']['output']>;
  memberState?: Maybe<Scalars['String']['output']>;
  memberSuffix?: Maybe<Scalars['String']['output']>;
  memberZip?: Maybe<Scalars['String']['output']>;
  ncpdpRejections?: Maybe<Array<Maybe<NcpdpRejection>>>;
  /**
   * Timestamp the estimate was calculated. Null when no estimate was applied
   * (estNetMemberPayAmt and estNetCouponPayAmt are also null in that case).
   */
  netCopayCalculatedAt?: Maybe<Scalars['Time']['output']>;
  outOfPocketOrDeductible?: Maybe<Scalars['Cents']['output']>;
  parsedRequest?: Maybe<NcpdpTransaction>;
  parsedResponse?: Maybe<NcpdpTransactionResponse>;
  partnerGroup?: Maybe<Group>;
  partnerGroupCarrierCode?: Maybe<Scalars['String']['output']>;
  partnerGroupDivisionName?: Maybe<Scalars['String']['output']>;
  partnerGroupDivisionNameNormalized?: Maybe<Scalars['String']['output']>;
  partnerGroupName?: Maybe<Scalars['String']['output']>;
  partnerGroupNumber?: Maybe<Scalars['String']['output']>;
  partnerGroupUUID?: Maybe<Scalars['String']['output']>;
  payeeName?: Maybe<Scalars['String']['output']>;
  payeeTaxID?: Maybe<Scalars['String']['output']>;
  payeeType?: Maybe<Scalars['String']['output']>;
  pharmacy?: Maybe<PharmacyV2>;
  /** @deprecated Use pharmacy.nabp instead */
  pharmacyNabp?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use pharmacy.name instead */
  pharmacyName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use pharmacy.npi instead */
  pharmacyNpi?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use pharmacy.locationPhoneNumber instead */
  pharmacyPhone?: Maybe<Scalars['String']['output']>;
  pharmacyType?: Maybe<Scalars['String']['output']>;
  pharmacyTypeCode?: Maybe<Scalars['Int']['output']>;
  planCodeName?: Maybe<Scalars['String']['output']>;
  primaryAddress1?: Maybe<Scalars['String']['output']>;
  primaryAddress2?: Maybe<Scalars['String']['output']>;
  primaryCity?: Maybe<Scalars['String']['output']>;
  primaryDateOfBirth?: Maybe<Scalars['Time']['output']>;
  primaryFirstName?: Maybe<Scalars['String']['output']>;
  primaryGender?: Maybe<Scalars['String']['output']>;
  primaryLastName?: Maybe<Scalars['String']['output']>;
  primaryMiddleName?: Maybe<Scalars['String']['output']>;
  primaryPersonCode?: Maybe<Scalars['String']['output']>;
  primarySsn?: Maybe<Scalars['String']['output']>;
  primaryState?: Maybe<Scalars['String']['output']>;
  primarySuffix?: Maybe<Scalars['String']['output']>;
  primaryZip?: Maybe<Scalars['String']['output']>;
  rawRequest?: Maybe<Scalars['String']['output']>;
  rawResponse?: Maybe<Scalars['String']['output']>;
  rejectCode?: Maybe<Scalars['String']['output']>;
  /** Holds all the reject code related information along with the handler type and process rule name */
  rejects?: Maybe<Array<Maybe<Rejects>>>;
  reversalAuthNumber?: Maybe<Scalars['String']['output']>;
  reversedAuthNumber?: Maybe<Scalars['String']['output']>;
  reversedOrAuth?: Maybe<Scalars['String']['output']>;
  reversedProcessedAt?: Maybe<Scalars['Time']['output']>;
  reversedStartedAt?: Maybe<Scalars['Time']['output']>;
  salesAccountCode?: Maybe<Scalars['String']['output']>;
  salesAccountName?: Maybe<Scalars['String']['output']>;
  sapDeductible?: Maybe<Scalars['Cents']['output']>;
  sapOutOfPocket?: Maybe<Scalars['Cents']['output']>;
  scriptTagsMulti?: Maybe<Scalars['String']['output']>;
  shareClaimID: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
};

export type ClaimTransactionContext = {
  __typename?: 'ClaimTransactionContext';
  costCalcSummary: Array<CostCalcSummary>;
  eventLogs: Array<EventLog>;
};

export type ClaimTransactionFilters = {
  adjudicationPersonCode?: InputMaybe<StringFilter>;
  authorizationNumber?: InputMaybe<StringFilter>;
  benefitPlanID?: InputMaybe<StringFilter>;
  benefitPlanName?: InputMaybe<StringFilter>;
  carrierCode?: InputMaybe<StringFilter>;
  /** Filter by raw claim type, use status if you want to filter by computed status instead of raw claim type */
  claimType?: InputMaybe<StringFilter>;
  dateOfBirth?: InputMaybe<TimeFilter>;
  dateProcessedEnd?: InputMaybe<TimeFilter>;
  dateProcessedStart?: InputMaybe<TimeFilter>;
  drugComposite?: InputMaybe<StringFilter>;
  drugLabelNameMddb?: InputMaybe<StringFilter>;
  firstFillStatus?: InputMaybe<StringFilter>;
  gpi?: InputMaybe<StringFilter>;
  groupCode?: InputMaybe<StringFilter>;
  groupComposite?: InputMaybe<StringFilter>;
  groupID?: InputMaybe<IdFilter>;
  groupName?: InputMaybe<StringFilter>;
  memberComposite?: InputMaybe<StringFilter>;
  memberFirstName?: InputMaybe<StringFilter>;
  memberID?: InputMaybe<IdFilter>;
  memberLastName?: InputMaybe<StringFilter>;
  mpaNumber?: InputMaybe<StringFilter>;
  ndc?: InputMaybe<StringFilter>;
  pharmacyComposite?: InputMaybe<StringFilter>;
  pharmacyNabp?: InputMaybe<StringFilter>;
  pharmacyNpi?: InputMaybe<StringFilter>;
  planComposite?: InputMaybe<StringFilter>;
  priorAuthCode?: InputMaybe<StringFilter>;
  rejectCode?: InputMaybe<StringFilter>;
  rxNumber?: InputMaybe<StringFilter>;
  salesAccountCode?: InputMaybe<StringFilter>;
  salesAccountName?: InputMaybe<StringFilter>;
  shareClaimID?: InputMaybe<IdFilter>;
  /** Filter by computed claim status, this will result in "reversed" even for some paid claims if they are later reversed by another claim. Possible options are "paid", "reversed", "rejected". However using rejected is technically the same as claimType rejected. Paid is similar to claimType disbursement but removes claims that are later reversed. */
  status?: InputMaybe<StringFilter>;
};

export type ClaimTransactionFiltersV2 = {
  adjudicatedBy?: InputMaybe<AdjudicatedByFilter>;
  adjudicationPersonCode?: InputMaybe<StringFilter>;
  authorizationNumber?: InputMaybe<StringFilter>;
  batchID?: InputMaybe<IdFilter>;
  benefitPlanID?: InputMaybe<StringFilter>;
  benefitPlanName?: InputMaybe<StringFilter>;
  carrierCode?: InputMaybe<StringFilter>;
  dateOfBirth?: InputMaybe<TimeFilter>;
  dateOfServiceEnd?: InputMaybe<TimeFilter>;
  dateOfServiceStart?: InputMaybe<TimeFilter>;
  dateProcessedEnd?: InputMaybe<TimeFilter>;
  dateProcessedStart?: InputMaybe<TimeFilter>;
  drugComposite?: InputMaybe<StringFilter>;
  drugLabelNameMddb?: InputMaybe<StringFilter>;
  /** Does not work, not implemented in V2 yet */
  firstFillStatus?: InputMaybe<StringFilter>;
  gpi?: InputMaybe<StringFilter>;
  groupCode?: InputMaybe<StringFilter>;
  groupComposite?: InputMaybe<StringFilter>;
  groupID?: InputMaybe<IdFilter>;
  groupName?: InputMaybe<StringFilter>;
  memberComposite?: InputMaybe<StringFilter>;
  memberFirstName?: InputMaybe<StringFilter>;
  memberID?: InputMaybe<IdFilter>;
  memberLastName?: InputMaybe<StringFilter>;
  mpaNumber?: InputMaybe<StringFilter>;
  ndc?: InputMaybe<StringFilter>;
  pharmacyComposite?: InputMaybe<StringFilter>;
  pharmacyNabp?: InputMaybe<StringFilter>;
  pharmacyNpi?: InputMaybe<StringFilter>;
  planComposite?: InputMaybe<StringFilter>;
  priorAuthCode?: InputMaybe<StringFilter>;
  rejectCode?: InputMaybe<StringFilter>;
  rxNumber?: InputMaybe<StringFilter>;
  salesAccountCode?: InputMaybe<StringFilter>;
  salesAccountName?: InputMaybe<StringFilter>;
  shareClaimID?: InputMaybe<IdFilter>;
  /** Does not work, not implemented in V2 yet */
  status?: InputMaybe<StringFilter>;
};

export type ClaimTransactionList = {
  __typename?: 'ClaimTransactionList';
  pagination: Pagination;
  results: Array<ClaimTransaction>;
};

export type ClaimTransactionListV2 = {
  __typename?: 'ClaimTransactionListV2';
  count: Scalars['Int']['output'];
  pageInfo: ClaimPageInfoV2;
  results: Array<ClaimTransaction>;
};

export type ClaimTransactionOrder = {
  claimFillProcessedAt?: InputMaybe<OrderDirectionEnum>;
  claimType?: InputMaybe<OrderDirectionEnum>;
  shareClaimID?: InputMaybe<OrderDirectionEnum>;
};

export type ClaimTransactionOrderV2 = {
  claimFillProcessedAt?: InputMaybe<OrderDirectionEnum>;
  claimType?: InputMaybe<OrderDirectionEnum>;
  createdAt?: InputMaybe<OrderDirectionEnum>;
  drugGpi?: InputMaybe<OrderDirectionEnum>;
};

/** Supported claim types */
export enum ClaimTypeV2 {
  Duplicate = 'DUPLICATE',
  Paid = 'PAID',
  Rejected = 'REJECTED',
  Reversal = 'REVERSAL'
}

/** Claim object */
export type ClaimV2 = {
  __typename?: 'ClaimV2';
  adjudicatedBy: AdjudicatedBy;
  adjustedAuthNumber?: Maybe<Scalars['String']['output']>;
  adjustedFromAuthNumber?: Maybe<Scalars['String']['output']>;
  altMemberCardId?: Maybe<Scalars['ID']['output']>;
  authorizationNumber?: Maybe<Scalars['String']['output']>;
  awpUnitPrice: Scalars['Float']['output'];
  basisOfCostReimbursement: Scalars['Int']['output'];
  benCapAmount: Scalars['Float']['output'];
  billDispensingFee: Scalars['Float']['output'];
  billIngredientCost: Scalars['Float']['output'];
  billTax: Scalars['Float']['output'];
  carrierCode?: Maybe<Scalars['String']['output']>;
  carrierId: Scalars['UUID']['output'];
  claimSource?: Maybe<Scalars['String']['output']>;
  cobAmount: Scalars['Float']['output'];
  compound?: Maybe<Scalars['String']['output']>;
  compoundCode: Scalars['Int']['output'];
  copay: Scalars['Float']['output'];
  created: Scalars['Time']['output'];
  dateOfService: Scalars['Time']['output'];
  dawCode: Scalars['Int']['output'];
  dawPenalty: Scalars['Float']['output'];
  dawWhoPays: Scalars['Int']['output'];
  daysSupply: Scalars['Int']['output'];
  deductibleAmount: Scalars['Float']['output'];
  drugId: Scalars['UUID']['output'];
  employerName?: Maybe<Scalars['String']['output']>;
  fillNumber: Scalars['Int']['output'];
  gpi?: Maybe<Scalars['String']['output']>;
  groupBilledAmount: Scalars['Float']['output'];
  groupCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ingredientCost: Scalars['Float']['output'];
  injuryDate?: Maybe<Scalars['Time']['output']>;
  isTest: Scalars['Boolean']['output'];
  macId?: Maybe<Scalars['UUID']['output']>;
  maintenanceFlag?: Maybe<Scalars['Boolean']['output']>;
  markup: Scalars['Float']['output'];
  member?: Maybe<MemberV2>;
  memberCardId?: Maybe<Scalars['ID']['output']>;
  memberId: Scalars['UUID']['output'];
  memberPersonCode?: Maybe<Scalars['String']['output']>;
  mony?: Maybe<Scalars['String']['output']>;
  mpaId?: Maybe<Scalars['UUID']['output']>;
  mpaNumber?: Maybe<Scalars['String']['output']>;
  ndc: Scalars['String']['output'];
  networkName?: Maybe<Scalars['String']['output']>;
  networkRealName?: Maybe<Scalars['String']['output']>;
  oopAmount: Scalars['Float']['output'];
  otherAmountPaid: Scalars['Float']['output'];
  otherCoverageCode?: Maybe<Scalars['Int']['output']>;
  otherPayerAmount: Scalars['Float']['output'];
  parsedRequest?: Maybe<NcpdpTransaction>;
  parsedResponse?: Maybe<NcpdpTransactionResponse>;
  payDispensingFee: Scalars['Float']['output'];
  payIngredientCost: Scalars['Float']['output'];
  payTax: Scalars['Float']['output'];
  personCode?: Maybe<Scalars['String']['output']>;
  pharmacy?: Maybe<PharmacyV2>;
  pharmacyFee: Scalars['Float']['output'];
  pharmacyId?: Maybe<Scalars['ID']['output']>;
  pharmacyNPI: Scalars['String']['output'];
  planCode?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['ID']['output']>;
  prescriberId?: Maybe<Scalars['String']['output']>;
  prescriberNPI?: Maybe<Scalars['String']['output']>;
  prescriberName?: Maybe<Scalars['String']['output']>;
  prescriptionDate: Scalars['Time']['output'];
  prescriptionNumber?: Maybe<Scalars['String']['output']>;
  priorAuthCode?: Maybe<Scalars['Int']['output']>;
  professionalServiceFee: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  quantityDispensed?: Maybe<Scalars['Float']['output']>;
  rawRequest?: Maybe<Scalars['String']['output']>;
  rawResponse?: Maybe<Scalars['String']['output']>;
  rejects: Array<Rejects>;
  reversalClaimId?: Maybe<Scalars['UUID']['output']>;
  reversedAuthNumber?: Maybe<Scalars['String']['output']>;
  reversedClaimId?: Maybe<Scalars['UUID']['output']>;
  sdc?: Maybe<Array<ClaimSdc>>;
  subGroupCode?: Maybe<Scalars['String']['output']>;
  subGroupId?: Maybe<Scalars['String']['output']>;
  submissionClarificationCode?: Maybe<Scalars['String']['output']>;
  submittedFee: Scalars['Float']['output'];
  submittedGrossAmountDue: Scalars['Float']['output'];
  submittedIncentiveFee: Scalars['Float']['output'];
  submittedPrescriberId?: Maybe<Scalars['ID']['output']>;
  totalPaidToPharmacy: Scalars['Float']['output'];
  transactionId?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<ClaimTypeV2>;
  umac2UnitPrice: Scalars['Float']['output'];
  umac3UnitPrice: Scalars['Float']['output'];
  umacUnitPrice: Scalars['Float']['output'];
  usedIncentiveFee: Scalars['Float']['output'];
  usualCustomaryCost?: Maybe<Scalars['Float']['output']>;
  wacUnitPrice: Scalars['Float']['output'];
};

/**
 * Embedded claims measures aggregated by GPI over the latest six-month reporting
 * window. This value object has no identity independent of its drug alternative.
 * Individual fields are null when that measure is unavailable.
 */
export type ClaimsAnalytics = {
  __typename?: 'ClaimsAnalytics';
  /** Average total price per claim, as an exact decimal string. */
  averagePrice?: Maybe<Scalars['String']['output']>;
  /** Average ingredient cost per dispensed unit, as an exact decimal string. */
  averageUnitIngredientCost?: Maybe<Scalars['String']['output']>;
  claimVolume?: Maybe<Scalars['Int']['output']>;
  modalQuantity?: Maybe<Scalars['Float']['output']>;
};

export enum ClaimsDateIntervalFilterEnum {
  /** 6 Month */
  HalfYear = 'HALF_YEAR',
  /** Lifetime */
  Lifetime = 'LIFETIME',
  /** 2 Years */
  TwoYears = 'TWO_YEARS',
  /** Year */
  Year = 'YEAR'
}

export type ClientDocumentation = {
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ClientDocumentationConnection = {
  __typename?: 'ClientDocumentationConnection';
  edges: Array<ClientDocumentationEdge>;
  pageInfo: PageInfo;
};

export type ClientDocumentationEdge = {
  __typename?: 'ClientDocumentationEdge';
  cursor: Scalars['String']['output'];
  node: ClientDocumentation;
};

export type ClientDocumentationFilters = {
  groupId?: InputMaybe<IdFilter>;
  groupOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdFilter>;
  type?: InputMaybe<StringFilter>;
};

export type ClientDocumentationOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  type?: InputMaybe<OrderDirectionEnum>;
};

export type CombinedStatusFilters = {
  category?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type CommentedId = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** One plan per call: Deploy is a reviewer's judgement; a half-failed batch has no honest response. */
export type CommitDraftPlanInput =
  /** The Implementation Manual plan candidate to deploy. Must be in DRAFT_CREATED status. */
  { planCandidateId: Scalars['ID']['input']; planId?: never; }
  |  /** The draft benefit plan to deploy, resolved to the plan candidate that owns it. */
  { planCandidateId?: never; planId: Scalars['ID']['input']; };

export type ComparisonResult = {
  __typename?: 'ComparisonResult';
  mail_success: Scalars['Boolean']['output'];
  results?: Maybe<Array<DrugComparison>>;
  retail_success: Scalars['Boolean']['output'];
  specialty_success: Scalars['Boolean']['output'];
};

export enum CompoundCode {
  /** 2 */
  Compound = 'COMPOUND',
  /** 1 */
  NonCompound = 'NON_COMPOUND'
}

/**
 * CompoundIngredient represents an individual ingredient in a compound claim adjudication.
 * Each ingredient has its own adjudicated costs and handler assignments.
 */
export type CompoundIngredient = Node & {
  __typename?: 'CompoundIngredient';
  awpPrice?: Maybe<Scalars['Float']['output']>;
  billCostHandler?: Maybe<Handler>;
  billCostHandlerFull?: Maybe<BillCostHandler>;
  calcBillCost: Scalars['Float']['output'];
  calcPayCost: Scalars['Float']['output'];
  costHandler?: Maybe<Handler>;
  costHandlerFull?: Maybe<CostHandler>;
  daysSupply: Scalars['Int']['output'];
  drugMony: Scalars['String']['output'];
  /** Drug name looked up from drug table by NDC */
  drugName?: Maybe<Scalars['String']['output']>;
  gad: Scalars['Float']['output'];
  gpi: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ingredientNumber: Scalars['Int']['output'];
  /** MAC list name looked up by MAC UUID */
  macName?: Maybe<Scalars['String']['output']>;
  macPrice?: Maybe<Scalars['Float']['output']>;
  maintenanceFlag: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  miscHandler?: Maybe<Handler>;
  miscHandlerFull?: Maybe<MiscHandler>;
  mony: Scalars['String']['output'];
  ndc: Scalars['String']['output'];
  preferredFlag: Scalars['Boolean']['output'];
  quantity: Scalars['Float']['output'];
  /** Reject codes for this ingredient (only populated when status is R) */
  rejects?: Maybe<Array<Rejects>>;
  scriptTag: Scalars['String']['output'];
  sic: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  submittedCost: Scalars['Float']['output'];
  submittedCostBasis: Scalars['Int']['output'];
  usualCustomary: Scalars['Float']['output'];
  wacPrice?: Maybe<Scalars['Float']['output']>;
};

export enum Condition {
  AllConditions = 'ALL_CONDITIONS',
  OtherPayerAmtGreaterThanZero = 'OTHER_PAYER_AMT_GREATER_THAN_ZERO',
  OtherPayerAmtLessOrEqualZero = 'OTHER_PAYER_AMT_LESS_OR_EQUAL_ZERO',
  OtherPayerAmtZero = 'OTHER_PAYER_AMT_ZERO'
}

export type ConnectProgramRestrictions = {
  __typename?: 'ConnectProgramRestrictions';
  /** Connect program code which is actually connect_program_txt, e.g. 'CPM-T' */
  connectProgramCode: Scalars['String']['output'];
  restrictions: Array<Restriction>;
};

export type ConnectRequest = CaseRequest & {
  __typename?: 'ConnectRequest';
  /** annual savings */
  annualSavings?: Maybe<Scalars['Cents']['output']>;
  /** The associated document requests of the Connect request */
  documentRequests: Array<DocumentRequest>;
  /** drug name */
  drugName: Scalars['String']['output'];
  /** duration */
  duration?: Maybe<Scalars['String']['output']>;
  /** Group */
  group: Group;
  /** The case's unique identifier, caseID */
  id: Scalars['ID']['output'];
  /** The date that Connect Request was created */
  initiatedAt: Scalars['Time']['output'];
  /** Member read the latest message or not */
  isUnread: Scalars['Boolean']['output'];
  /** Member */
  member: Member;
  /** connect program name */
  programName: Scalars['String']['output'];
  /** provider name */
  provider: Scalars['String']['output'];
  /** quantity */
  quantity?: Maybe<Scalars['String']['output']>;
  /** The case's member-friendly identifier, caseNumber in SF */
  referenceNumber: Scalars['ID']['output'];
  /** The status history of the Connect request. Has separated Status and Category when flag is enabled */
  statusLog: Array<StatusLogEntry>;
};

export type Connection = {
  __typename?: 'Connection';
  activation_date?: Maybe<Scalars['Time']['output']>;
  /** Person or organization tied to this connection. */
  actor: Partner;
  /**
   * Variable format configuration.
   * Wiki: https://smithrx.atlassian.net/wiki/spaces/EN/pages/530055376/Automated+Claims+Reporting
   * Outgoing+paid_claim: transmission/reports.PaidClaimConnectionParams
   */
  config: Scalars['Map']['output'];
  /** group list */
  connection_related_group_list?: Maybe<ConnectionRelatedGroupList>;
  credential?: Maybe<Credential>;
  /** When set cron_schedule describes when the next report should be generated. */
  cron_schedule: Scalars['String']['output'];
  deactivation_date?: Maybe<Scalars['Time']['output']>;
  /** From enum_deliverable_response_method */
  deliverable_response_method?: Maybe<Scalars['String']['output']>;
  /** From enum_deliverable_type */
  deliverable_type?: Maybe<Scalars['String']['output']>;
  /** Inbound connections are for data ingestion. Outbound connections are for report transmission. */
  direction: ConnectionDirection;
  /** Date first version of the connection entered our system */
  entry_date?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  /** Implementation Project UUID */
  implementation_project_uuid?: Maybe<Scalars['String']['output']>;
  /** Jobs performed for this connection */
  jobs: TransmissionJobList;
  /** Last modified - first half of a connection's validity */
  last_modified?: Maybe<Scalars['Time']['output']>;
  /**
   * Target or source location for file handling. Includes protocol, path, and filename.
   * i.e. s3://srx-staging-partner-sftp-hrzn.s3.us-west-2.amazonaws.com/paid_claim_report.csv
   */
  location: Scalars['String']['output'];
  /** Duration (in seconds) that a transmission can be blocked before alerts should be generated. */
  max_latency: Scalars['Int']['output'];
  /** Human readable name for this connection. */
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** Email notification configuration */
  notification_config?: Maybe<ConnectionNotificationConfig>;
  /** A JSON string indicating custom options for this connection. */
  options?: Maybe<Scalars['Map']['output']>;
  review_status?: Maybe<Scalars['String']['output']>;
  /** Status from enum_task_status */
  status?: Maybe<Scalars['String']['output']>;
  /** transmission_format record used to parse inbound or compose outbound file content. */
  transmission_format: TransmissionFormat;
  /** Connection types describe how this connection record should be handled and edited. */
  type: ConnectionType;
};


export type ConnectionJobsArgs = {
  order?: InputMaybe<Array<TransmissionJobOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<TransmissionJobFilters>;
};

export enum ConnectionDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type ConnectionFilters = {
  /** Filter by actor (partner) UUID. */
  actorUuid?: InputMaybe<IdFilter>;
  /** Exact filter. */
  direction?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  /** Partial match filter (substring). */
  name?: InputMaybe<StringFilter>;
  /** Partial match filter (substring). */
  type?: InputMaybe<StringFilter>;
};

export type ConnectionForGroup = {
  __typename?: 'ConnectionForGroup';
  /** Jobs performed for this connection */
  JobsConnectionForGroup: TransmissionJobList;
  /** Activation date */
  activation_date?: Maybe<Scalars['Time']['output']>;
  /** Activity status */
  activity_status: Scalars['String']['output'];
  /** Integration vendor code */
  actor_code?: Maybe<Scalars['String']['output']>;
  /** Integration vendor name */
  actor_name?: Maybe<Scalars['String']['output']>;
  /** Integration vendor uuid */
  actor_uuid?: Maybe<Scalars['String']['output']>;
  /** connection list */
  connection_list?: Maybe<ConnectionList>;
  /** Human readable name for this connection. */
  connection_name: Scalars['String']['output'];
  /** Current live date */
  current_live_date?: Maybe<Scalars['Time']['output']>;
  /** Deactivation date */
  deactivation_date?: Maybe<Scalars['Time']['output']>;
  /** Response type */
  deliverable_response_method?: Maybe<Scalars['String']['output']>;
  /** Deliverable type */
  deliverable_type?: Maybe<Scalars['String']['output']>;
  /** When set cron_schedule describes when the next report should be generated. */
  delivery_schedule: Scalars['String']['output'];
  /** Entry Date for this connection. */
  entry_date?: Maybe<Scalars['Time']['output']>;
  /** Format standard */
  format_standard?: Maybe<Scalars['String']['output']>;
  /** Format type */
  format_type?: Maybe<Scalars['String']['output']>;
  /** Group code */
  group_code?: Maybe<Scalars['String']['output']>;
  /** Group name */
  group_name?: Maybe<Scalars['String']['output']>;
  /** Group uuid */
  group_uuid?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Implementation Project code */
  implementation_project_code?: Maybe<Scalars['String']['output']>;
  /** Integration set */
  integration_set?: Maybe<Scalars['String']['output']>;
  /** When connection was last modified */
  last_modified?: Maybe<Scalars['Time']['output']>;
  /**
   * Target or source location for file handling. Includes protocol, path, and filename.
   * i.e. s3://srx-staging-partner-sftp-hrzn.s3.us-west-2.amazonaws.com/paid_claim_report.csv
   */
  location: Scalars['String']['output'];
  /** Master Account Code associated with this connection. */
  master_account_code?: Maybe<Scalars['String']['output']>;
  /** Login email for who was the last to make a modification */
  modified_by?: Maybe<Scalars['String']['output']>;
  /** Any notes that have been attached to the connection */
  note?: Maybe<Scalars['String']['output']>;
  /** Original live date */
  original_live_date?: Maybe<Scalars['Time']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** Inbound connections are for data ingestion. Outbound connections are for report transmission. */
  transfer_direction: ConnectionDirection;
  /** transmission_format record used to parse inbound or compose outbound file content. */
  transmission_format: TransmissionFormat;
  /** Connection types describe how this connection record should be handled and edited. */
  type: ConnectionType;
};


export type ConnectionForGroupJobsConnectionForGroupArgs = {
  order?: InputMaybe<Array<TransmissionJobOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<TransmissionJobFilters>;
};

export type ConnectionForGroupFilters = {
  account_uuid?: InputMaybe<IdFilter>;
  /** Activity status filter. */
  activity_status?: InputMaybe<StringFilter>;
  /** Partial match filter (substring). */
  connection_name?: InputMaybe<StringFilter>;
  credentials_id?: InputMaybe<IdFilter>;
  /** Exact filter. */
  current_live_date?: InputMaybe<TimeFilter>;
  group_code?: InputMaybe<StringFilter>;
  group_name?: InputMaybe<StringFilter>;
  /** Exact filter. */
  group_uuid?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  /** Partial match filter (substring). */
  master_account_code?: InputMaybe<StringFilter>;
  /** Exact filter. */
  original_live_date?: InputMaybe<TimeFilter>;
  partner_code?: InputMaybe<StringFilter>;
  partner_name?: InputMaybe<StringFilter>;
  partner_uuid?: InputMaybe<IdFilter>;
  /** Exact filter. */
  transfer_direction?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type ConnectionForGroupList = {
  __typename?: 'ConnectionForGroupList';
  pagination: Pagination;
  results: Array<ConnectionForGroup>;
};

export type ConnectionForGroupOrder = {
  activation_date?: InputMaybe<OrderDirectionEnum>;
  activity_status?: InputMaybe<OrderDirectionEnum>;
  actor_code?: InputMaybe<OrderDirectionEnum>;
  actor_name?: InputMaybe<OrderDirectionEnum>;
  connection_name?: InputMaybe<OrderDirectionEnum>;
  current_live_date?: InputMaybe<OrderDirectionEnum>;
  deactivation_date?: InputMaybe<OrderDirectionEnum>;
  delivery_schedule?: InputMaybe<OrderDirectionEnum>;
  entry_date?: InputMaybe<OrderDirectionEnum>;
  group_code?: InputMaybe<OrderDirectionEnum>;
  group_name?: InputMaybe<OrderDirectionEnum>;
  id?: InputMaybe<OrderDirectionEnum>;
  implementation_project_code?: InputMaybe<OrderDirectionEnum>;
  last_modified?: InputMaybe<OrderDirectionEnum>;
  location?: InputMaybe<OrderDirectionEnum>;
  master_account_code?: InputMaybe<OrderDirectionEnum>;
  modified_by?: InputMaybe<OrderDirectionEnum>;
  original_live_date?: InputMaybe<OrderDirectionEnum>;
  status?: InputMaybe<OrderDirectionEnum>;
  transfer_direction?: InputMaybe<OrderDirectionEnum>;
  type?: InputMaybe<OrderDirectionEnum>;
};

export type ConnectionList = {
  __typename?: 'ConnectionList';
  pagination: Pagination;
  results: Array<Connection>;
};

export type ConnectionNotificationConfig = {
  __typename?: 'ConnectionNotificationConfig';
  recipient: NotificationRecipient;
  template_id: Scalars['String']['output'];
};

export type ConnectionNotificationConfigInput = {
  recipient: NotificationRecipientInput;
  template_id: Scalars['String']['input'];
};

export type ConnectionRelatedGroupFilters = {
  direction: StringFilter;
  id: IdFilter;
  type: StringFilter;
};

export type ConnectionRelatedGroupList = {
  __typename?: 'ConnectionRelatedGroupList';
  results?: Maybe<Array<Group>>;
};

export enum ConnectionType {
  Accum = 'ACCUM',
  AcknowledgementReceipt = 'ACKNOWLEDGEMENT_RECEIPT',
  Card = 'CARD',
  ClaimReport = 'CLAIM_REPORT',
  Elig = 'ELIG',
  EligFlag = 'ELIG_FLAG',
  EligReport = 'ELIG_REPORT',
  Invoice = 'INVOICE',
  Lock = 'LOCK',
  ReconReport = 'RECON_REPORT',
  RejectionReport = 'REJECTION_REPORT'
}

export type ConnectionVersionFilters = {
  /** Filter by actor (partner) UUID. */
  actorUuid?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
};

export type ConnectionVersionOrder = {
  last_modified?: InputMaybe<OrderDirectionEnum>;
};

export type Consent = Node & {
  __typename?: 'Consent';
  auditLog: ConsentAuditLogConnection;
  consentType: ConsentType;
  createdAt: Scalars['Time']['output'];
  dependentPerson: Member;
  expiresAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  parentPerson: Member;
  requestExpiresAt?: Maybe<Scalars['Time']['output']>;
  requesterPerson: Member;
  signedAt?: Maybe<Scalars['Time']['output']>;
  status: ConsentStatus;
  terminatedAt?: Maybe<Scalars['Time']['output']>;
  terminatedBy?: Maybe<Member>;
  updatedAt: Scalars['Time']['output'];
};


export type ConsentAuditLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ConsentAuditLogOrder>;
  where?: InputMaybe<ConsentAuditLogFilters>;
};

export enum ConsentAuditAction {
  ConsentCancelled = 'CONSENT_CANCELLED',
  ConsentRejected = 'CONSENT_REJECTED',
  ConsentRequested = 'CONSENT_REQUESTED',
  ConsentResendRequested = 'CONSENT_RESEND_REQUESTED',
  ConsentRevoked = 'CONSENT_REVOKED',
  ConsentSigned = 'CONSENT_SIGNED',
  NotificationSent = 'NOTIFICATION_SENT'
}

export type ConsentAuditLogConnection = {
  __typename?: 'ConsentAuditLogConnection';
  edges: Array<ConsentAuditLogEdge>;
  pageInfo: PageInfo;
};

export type ConsentAuditLogEdge = {
  __typename?: 'ConsentAuditLogEdge';
  cursor: Scalars['String']['output'];
  node: ConsentAuditLogEntry;
};

export type ConsentAuditLogEntry = Node & {
  __typename?: 'ConsentAuditLogEntry';
  action: ConsentAuditAction;
  actorPerson?: Maybe<Member>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['Map']['output']>;
  newState?: Maybe<Scalars['String']['output']>;
  previousState?: Maybe<Scalars['String']['output']>;
  targetPerson?: Maybe<Member>;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type ConsentAuditLogFilters = {
  action?: InputMaybe<StringFilter>;
  actorPersonId?: InputMaybe<IdFilter>;
};

export type ConsentAuditLogOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
};

export type ConsentConnection = {
  __typename?: 'ConsentConnection';
  edges: Array<ConsentEdge>;
  pageInfo: PageInfo;
};

export type ConsentEdge = {
  __typename?: 'ConsentEdge';
  cursor: Scalars['String']['output'];
  node: Consent;
};

export type ConsentFilters = {
  dependentPersonId?: InputMaybe<IdFilter>;
  parentPersonId?: InputMaybe<IdFilter>;
  status?: InputMaybe<StringFilter>;
};

export type ConsentOrder = {
  dependentPersonId?: InputMaybe<OrderDirectionEnum>;
  id?: InputMaybe<OrderDirectionEnum>;
  parentPersonId?: InputMaybe<OrderDirectionEnum>;
};

export enum ConsentStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Revoked = 'REVOKED'
}

export enum ConsentType {
  AdultConsent = 'ADULT_CONSENT',
  AutomaticUnder_13 = 'AUTOMATIC_UNDER_13',
  TeenConsent = 'TEEN_CONSENT'
}

export type Contact = {
  __typename?: 'Contact';
  cell_phone?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entity_id: Scalars['ID']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContactFilters = {
  entity_id?: InputMaybe<IdFilter>;
  first_name?: InputMaybe<StringFilter>;
  last_name?: InputMaybe<StringFilter>;
};

export type ContactInformation = {
  __typename?: 'ContactInformation';
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<LocationInformation>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  workPhoneNumber?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type ContactInformationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<LocationInformationInput>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  workPhoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type ContactInformationPartialInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<LocationInformationPartialInput>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  workPhoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type ContactInput = {
  cell_phone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entity_id: Scalars['ID']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContactList = {
  __typename?: 'ContactList';
  pagination?: Maybe<Pagination>;
  result?: Maybe<Array<Maybe<Contact>>>;
};

export type ContactOrder = {
  first_name?: InputMaybe<OrderDirectionEnum>;
  last_name?: InputMaybe<OrderDirectionEnum>;
};

export enum CopayCalculationType {
  /** 6 */
  CostDiffPercentWithMinDollar = 'COST_DIFF_PERCENT_WITH_MIN_DOLLAR',
  /** 9 */
  CostDiffPercentWithMinDollarIfCostLessThanMaxDollar = 'COST_DIFF_PERCENT_WITH_MIN_DOLLAR_IF_COST_LESS_THAN_MAX_DOLLAR',
  /** 16 */
  CostMinDollarPlusPercentUpToMaxDollar = 'COST_MIN_DOLLAR_PLUS_PERCENT_UP_TO_MAX_DOLLAR',
  /** 2 */
  CostPercent = 'COST_PERCENT',
  /** 19 */
  CostPercentIfCostGreaterThanMaxDollar = 'COST_PERCENT_IF_COST_GREATER_THAN_MAX_DOLLAR',
  /** 8 */
  CostPercentIfCostLessThanMaxDollar = 'COST_PERCENT_IF_COST_LESS_THAN_MAX_DOLLAR',
  /** 3 */
  CostPercentWithMinDollar = 'COST_PERCENT_WITH_MIN_DOLLAR',
  /** 5 */
  MaxOfMinDollarAndCostPercent = 'MAX_OF_MIN_DOLLAR_AND_COST_PERCENT',
  /** 1 */
  MinDollar = 'MIN_DOLLAR',
  /** 4 */
  MinOfMaxDollarAndCostPercent = 'MIN_OF_MAX_DOLLAR_AND_COST_PERCENT',
  /** 7 */
  ValueInRangeMinAndMaxDollar = 'VALUE_IN_RANGE_MIN_AND_MAX_DOLLAR'
}

export enum CopayCoverageEnum {
  Covered = 'COVERED',
  NotCovered = 'NOT_COVERED'
}

export type CopayHandler = {
  __typename?: 'CopayHandler';
  copayHandlerDetails?: Maybe<Array<CopayHandlerDetail>>;
  created: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated?: Maybe<Scalars['Time']['output']>;
};

export type CopayHandlerConnection = {
  __typename?: 'CopayHandlerConnection';
  edges: Array<CopayHandlerEdge>;
  pageInfo: PageInfo;
};

export type CopayHandlerDetail = {
  __typename?: 'CopayHandlerDetail';
  auxCode?: Maybe<AuxCode>;
  calculation?: Maybe<CopayCalculationType>;
  copayHandlerTiers?: Maybe<Array<CopayHandlerTier>>;
  copayHandlerUuid: Scalars['ID']['output'];
  created: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  tierBasis?: Maybe<TierBasis>;
  type?: Maybe<HandlerDetailType>;
  updated?: Maybe<Scalars['String']['output']>;
};

export type CopayHandlerDetailOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
};

export type CopayHandlerDetailUpsertInput = {
  auxCode?: InputMaybe<AuxCode>;
  calculation?: InputMaybe<CopayCalculationType>;
  copayHandlerTiers?: InputMaybe<Array<CopayHandlerTierInput>>;
  copayHandlerTiersToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  copayHandlerUuid: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  tierBasis?: InputMaybe<TierBasis>;
  type?: InputMaybe<HandlerDetailType>;
};

export type CopayHandlerEdge = {
  __typename?: 'CopayHandlerEdge';
  cursor: Scalars['String']['output'];
  node: CopayHandler;
};

export type CopayHandlerFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CopayHandlerOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export type CopayHandlerTier = {
  __typename?: 'CopayHandlerTier';
  copayHandlerDetailUuid: Scalars['ID']['output'];
  created: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maxDollar?: Maybe<Scalars['Float']['output']>;
  minDollar?: Maybe<Scalars['Float']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
  tierMax?: Maybe<Scalars['Int']['output']>;
  tierMin?: Maybe<Scalars['Int']['output']>;
  updated: Scalars['String']['output'];
};

export type CopayHandlerTierInput = {
  copayHandlerDetailUuid?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maxDollar?: InputMaybe<Scalars['Float']['input']>;
  minDollar?: InputMaybe<Scalars['Float']['input']>;
  percent?: InputMaybe<Scalars['Float']['input']>;
  tierMax?: InputMaybe<Scalars['Int']['input']>;
  tierMin?: InputMaybe<Scalars['Int']['input']>;
};

export enum CostBasisDescriptionType {
  Aawp = 'AAWP',
  Awp = 'AWP',
  Calc = 'CALC',
  Clist = 'CLIST',
  Cnote = 'CNOTE',
  Floor = 'FLOOR',
  Gad = 'GAD',
  Geap = 'GEAP',
  Gen = 'GEN',
  Hcfa = 'HCFA',
  Mac = 'MAC',
  Sic = 'SIC',
  Umac = 'UMAC',
  Umac2 = 'UMAC2',
  Umac3 = 'UMAC3',
  UC = 'U_C',
  Wac = 'WAC'
}

export enum CostBasisType {
  /** AWP Average Wholesale Price basis type - 2 */
  Awp = 'AWP',
  Cnote = 'CNOTE',
  /** CostList Cost List basis type */
  CostList = 'CostList',
  /** GAD Gross Amount Due basis type */
  Gad = 'GAD',
  /** GENCostBasisType Generic - 1 */
  Gen = 'GEN',
  /** HCFA Health Care Financing Administration basis type */
  Hcfa = 'HCFA',
  /** MAC Maximum Allowed Cost basis type */
  Mac = 'MAC',
  /** SIC Submitted Ingredient Cost basis type */
  Sic = 'SIC',
  /** UC Usual Customary basis type */
  Uc = 'UC',
  /** UMAC User Defined Maximum Allowed Cost basis type */
  Umac = 'UMAC',
  /** UMAC2 User Defined Maximum Allowed Cost 2 basis type */
  Umac2 = 'UMAC2',
  /** UMAC3 User Defined Maximum Allowed Cost 3 basis type */
  Umac3 = 'UMAC3',
  /** Unknown cost basis type - 0 */
  Unknown = 'UNKNOWN',
  /** WAC Wholesale Acquisition Cost basis type */
  Wac = 'WAC'
}

export type CostCalcSummary = {
  __typename?: 'CostCalcSummary';
  formula1: FormulaResultSummary;
  formula2: FormulaResultSummary;
  lesserCalcs: Array<LesserCostCalcSummary>;
  ndc?: Maybe<Scalars['String']['output']>;
};

export type CostGroupSummary = {
  __typename?: 'CostGroupSummary';
  costDetailSummaries: Array<FormulaResultSummary>;
  costGroupCalcType: Scalars['String']['output'];
  costGroupCost?: Maybe<Scalars['Float']['output']>;
  costGroupName: Scalars['String']['output'];
};

export type CostHandler = {
  __typename?: 'CostHandler';
  costHandlerDetails?: Maybe<Array<CostHandlerDetail>>;
  created: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['Time']['output'];
};

export type CostHandlerConnection = {
  __typename?: 'CostHandlerConnection';
  edges: Array<CostHandlerEdge>;
  pageInfo: PageInfo;
};

export type CostHandlerDetail = {
  __typename?: 'CostHandlerDetail';
  auxCode: AuxCode;
  compoundCostFloor?: Maybe<Scalars['Float']['output']>;
  costFloor: Scalars['Float']['output'];
  costHandlerUUID: Scalars['ID']['output'];
  created: Scalars['Time']['output'];
  flatCost: Scalars['Float']['output'];
  formula1Basis?: Maybe<CostBasisType>;
  formula1CostList?: Maybe<CostList>;
  formula1Percent: Scalars['Float']['output'];
  formula2Basis?: Maybe<CostBasisType>;
  formula2CostList?: Maybe<CostList>;
  formula2Percent: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  lesserCalc: Scalars['Boolean']['output'];
  lesserGAD: Scalars['Boolean']['output'];
  lesserSIC: Scalars['Boolean']['output'];
  lesserUC: Scalars['Boolean']['output'];
  type: HandlerDetailType;
  updated?: Maybe<Scalars['Time']['output']>;
  useGreaterFormula: Scalars['Boolean']['output'];
};

export type CostHandlerDetailUpsertInput = {
  auxCode?: InputMaybe<AuxCode>;
  compoundCostFloor?: InputMaybe<Scalars['Float']['input']>;
  costFloor?: InputMaybe<Scalars['Float']['input']>;
  costHandlerID: Scalars['ID']['input'];
  flatCost?: InputMaybe<Scalars['Float']['input']>;
  formula1Basis?: InputMaybe<CostBasisType>;
  formula1CostListID?: InputMaybe<Scalars['ID']['input']>;
  formula1Percent?: InputMaybe<Scalars['Float']['input']>;
  formula2Basis?: InputMaybe<CostBasisType>;
  formula2CostListID?: InputMaybe<Scalars['ID']['input']>;
  formula2Percent?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lesserCalc: Scalars['Boolean']['input'];
  lesserGAD: Scalars['Boolean']['input'];
  lesserSIC: Scalars['Boolean']['input'];
  lesserUC: Scalars['Boolean']['input'];
  type: HandlerDetailType;
  useGreaterFormula: Scalars['Boolean']['input'];
};

export type CostHandlerEdge = {
  __typename?: 'CostHandlerEdge';
  cursor: Scalars['String']['output'];
  node: CostHandler;
};

export type CostHandlerFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CostHandlerOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export type CostList = {
  __typename?: 'CostList';
  costListGroups: Array<CostListGroup>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CostListConnection = {
  __typename?: 'CostListConnection';
  edges: Array<CostListEdge>;
  pageInfo: PageInfo;
};

export type CostListDetail = {
  __typename?: 'CostListDetail';
  allowZeroDollar?: Maybe<Scalars['Boolean']['output']>;
  basisType?: Maybe<CostBasisType>;
  costGroupID?: Maybe<Scalars['String']['output']>;
  dispenseFee?: Maybe<Scalars['Float']['output']>;
  flatFee?: Maybe<Scalars['Float']['output']>;
  guaranteedMinimum?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  mac?: Maybe<MacList>;
  macID?: Maybe<Scalars['ID']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  referencedCostGroup?: Maybe<CostListGroup>;
  referencedCostGroupID?: Maybe<Scalars['String']['output']>;
  useSimpleValue?: Maybe<Scalars['Boolean']['output']>;
};

export enum CostListDetailFunctionType {
  Firstfound = 'FIRSTFOUND',
  Greatest = 'GREATEST',
  Least = 'LEAST',
  Unknown = 'UNKNOWN'
}

export type CostListDetailInput = {
  allowZeroDollar?: InputMaybe<Scalars['Boolean']['input']>;
  basisType?: InputMaybe<CostBasisType>;
  costGroupID?: InputMaybe<Scalars['ID']['input']>;
  dispenseFee?: InputMaybe<Scalars['Float']['input']>;
  final?: InputMaybe<Scalars['Boolean']['input']>;
  flatFee?: InputMaybe<Scalars['Float']['input']>;
  functionType?: InputMaybe<CostListGroupFunctionType>;
  guaranteedMinimum?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  macID?: InputMaybe<Scalars['ID']['input']>;
  newGroupID?: InputMaybe<Scalars['Int']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  useSimpleValue?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CostListEdge = {
  __typename?: 'CostListEdge';
  cursor: Scalars['String']['output'];
  node: CostList;
};

export type CostListFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CostListGroup = {
  __typename?: 'CostListGroup';
  costGroupID: Scalars['Int']['output'];
  costListID: Scalars['ID']['output'];
  details: Array<CostListDetail>;
  displayValue: Scalars['String']['output'];
  final?: Maybe<Scalars['Boolean']['output']>;
  function?: Maybe<CostListGroupFunctionType>;
  id: Scalars['ID']['output'];
};

export type CostListGroupFunctionInput = {
  costGroupID: Scalars['UUID']['input'];
  function: CostListGroupFunctionType;
};

export enum CostListGroupFunctionType {
  Firstfound = 'FIRSTFOUND',
  Greatest = 'GREATEST',
  Least = 'LEAST',
  Unknown = 'UNKNOWN'
}

export type CostListOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export type CostListSummary = {
  __typename?: 'CostListSummary';
  costGroupSummaries: Array<CostGroupSummary>;
  costListName: Scalars['String']['output'];
  finalCalcType: Scalars['String']['output'];
  finalCost: Scalars['Float']['output'];
  finalCostGroupName: Scalars['String']['output'];
};

export enum CoverageEnum {
  Covered = 'COVERED',
  NotCovered = 'NOT_COVERED'
}

export type CreateAltCardIdInput = {
  altCardID: Scalars['String']['input'];
  cardholderKey: CardholderKey;
};

/**
 * Input for creating a new IFPFile and uploading the associated file.
 * This is a "discriminated union" where the 'jobType' dictates
 * which other field is required.
 */
export type CreateAndUploadIfpFileInput = {
  /** REQUIRED if jobType is BATCH_REPROCESSING_CLAIMSET_CREATE */
  claimSetEntityDetails?: InputMaybe<CreateIfpFileClaimSetEntityDetailsInput>;
  file: Scalars['Upload']['input'];
  /**
   * REQUIRED if jobType is PLAN_TEST_CASES_IMPORT
   * Contains plan targets: { targets: [{ groupId, planId, subgroupId }] }
   *
   * REQUIRED if jobType is CUSTOM_DRUG_LIST_IMPORTER_V2
   * Contains: { name, updateType, customDrugListUploadID }
   * Omit 'updateType' to create new lists; set it to create_update or
   * create_update_delete to modify an existing one.
   * 'name' scopes the upload to the selected list: rows naming a different list are
   * rejected. Omit it only for a multi-list upload.
   */
  fileContext?: InputMaybe<Scalars['Map']['input']>;
  jobType: IfpFileJobTypes;
  /** REQUIRED if jobType is PHARMACY_NETWORK_ENTITY_UPSERT or PHARMACY_NETWORK_ENTITY_FULL_REPLACEMENT */
  pharmacyNetworkEntityDetails?: InputMaybe<CreateIfpFilePharmacyNetworkEntityDetailsInput>;
};

export type CreateBatchDataSyncJobRequest = {
  cardID?: InputMaybe<Scalars['String']['input']>;
  destinations?: InputMaybe<Array<InputMaybe<SyncDestination>>>;
  groupUUID?: InputMaybe<Scalars['ID']['input']>;
  memberCSV?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Array<InputMaybe<MemberKey>>>;
  membershipUUIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  priority: SyncJobPriority;
  subscriptionUUID?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateBatchDataSyncJobResponse = {
  __typename?: 'CreateBatchDataSyncJobResponse';
  id: Scalars['ID']['output'];
  membershipSyncsCreated: Scalars['Int']['output'];
  status: BatchDataSyncJobStatus;
};

export type CreateBatchSettingInput = {
  allowOtcForScript?: InputMaybe<Scalars['Boolean']['input']>;
  holdGroupConstant?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreAgeHandler?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreDiscontinuedNdcs?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreDispenseLimitHandler?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreMemberEligibilityEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreMiscHandler?: InputMaybe<Scalars['Boolean']['input']>;
  isHoldingCostConstant?: InputMaybe<Scalars['Boolean']['input']>;
  keepMonyCodeTheSame?: InputMaybe<Scalars['Boolean']['input']>;
  overrideRefillTooSoon?: InputMaybe<Scalars['Boolean']['input']>;
  skipReporting?: InputMaybe<Scalars['Boolean']['input']>;
  treatAsIncludePr?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCobObjectInput = {
  copyFromId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCobObjectPayload = {
  __typename?: 'CreateCOBObjectPayload';
  cobObject: Cob;
};

export type CreateClaimSetInput = {
  file: Scalars['Upload']['input'];
  reprocessorBatchId: Scalars['ID']['input'];
};

export type CreateConnectionInput = {
  activation_date?: InputMaybe<Scalars['Time']['input']>;
  /** Person or organization tied to this connection. */
  actor_id: Scalars['ID']['input'];
  /**
   * Variable format configuration.
   * Wiki: https://smithrx.atlassian.net/wiki/spaces/EN/pages/530055376/Automated+Claims+Reporting
   * Outgoing+paid_claim: transmission/reports.PaidClaimConnectionParams
   */
  config: Scalars['Map']['input'];
  credentials_id?: InputMaybe<Scalars['Int']['input']>;
  /** When set cron_schedule describes when the next report should be generated. */
  cron_schedule: Scalars['String']['input'];
  deactivation_date?: InputMaybe<Scalars['Time']['input']>;
  deliverable_response_method?: InputMaybe<Scalars['String']['input']>;
  deliverable_type?: InputMaybe<Scalars['String']['input']>;
  /** Inbound connections are for data ingestion. Outbound connections are for report transmission. */
  direction: ConnectionDirection;
  implementation_project_uuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target or source location for file handling. Includes protocol, path, and filename.
   * i.e. s3://srx-staging-partner-sftp-hrzn.s3.us-west-2.amazonaws.com/paid_claim_report_%s.csv
   * You MUST include "%s" in order to substitute date values correctly.
   */
  location: Scalars['String']['input'];
  /** Duration (in seconds) that a transmission can be blocked before alerts should be generated. */
  max_latency: Scalars['Int']['input'];
  /** Human readable name for this connection. */
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  /** Email notification configuration */
  notification_config?: InputMaybe<ConnectionNotificationConfigInput>;
  review_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  /** transmission_format record used to parse inbound or compose outbound file content. */
  transmission_format_id: Scalars['ID']['input'];
  /** Connection types describe how this connection record should be handled and edited. */
  type: ConnectionType;
};

export type CreateCopiedProcessRuleInput = {
  name: Scalars['String']['input'];
  processRuleID?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCostGroupInput = {
  costListID: Scalars['ID']['input'];
  functionType: CostListGroupFunctionType;
};

export type CreateCostListInput = {
  copyFromID?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCustomDrugListV2Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateDurObjectInput = {
  copyFromID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  type: DurObjectType;
};

export type CreateDefaultPlanInput = {
  benCapSatisfactionType?: InputMaybe<SatisfactionType>;
  dedSatisfactionType?: InputMaybe<SatisfactionType>;
  effectiveDate: Scalars['Date']['input'];
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  familyBenCap?: InputMaybe<Scalars['Cents']['input']>;
  familyDed?: InputMaybe<Scalars['Cents']['input']>;
  familyOop?: InputMaybe<Scalars['Cents']['input']>;
  groupID: Scalars['ID']['input'];
  individualBenCap?: InputMaybe<Scalars['Cents']['input']>;
  individualDed?: InputMaybe<Scalars['Cents']['input']>;
  individualOop?: InputMaybe<Scalars['Cents']['input']>;
  oopSatisfactionType?: InputMaybe<SatisfactionType>;
  planID: Scalars['ID']['input'];
};

export type CreateDepartmentInput = {
  code: Scalars['String']['input'];
  groupId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDependentInput = {
  /** The member's address line 1 */
  address_1?: InputMaybe<Scalars['String']['input']>;
  /** The member's address line 2 */
  address_2?: InputMaybe<Scalars['String']['input']>;
  /** The member's card ID */
  card_id: Scalars['String']['input'];
  /** The member's city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Name of carrier */
  cob_carrier_name?: InputMaybe<Scalars['String']['input']>;
  /** Has COB coverage */
  cob_coverage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of COB Coverage */
  cob_coverage_type?: InputMaybe<MemberCobCoverageTypeEnum>;
  /** Date COB ends */
  cob_end?: InputMaybe<Scalars['Time']['input']>;
  /** Date COB starts */
  cob_start?: InputMaybe<Scalars['Time']['input']>;
  /** The member's country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The member's coverage end date */
  coverage_end?: InputMaybe<Scalars['Time']['input']>;
  /** The member's coverage start date */
  coverage_start: Scalars['Time']['input'];
  /** The member's date of birth */
  date_of_birth: Scalars['Time']['input'];
  /** The member's email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The member's first name */
  first_name: Scalars['String']['input'];
  /** The member's gender */
  gender: MemberGenderEnum;
  /**
   * The group the primary member is in. This is required because card IDs are not required
   * to be unique across groups, only within a group.
   */
  group_id: Scalars['ID']['input'];
  /** The member's last name */
  last_name: Scalars['String']['input'];
  /** The member's middle name */
  middle_name?: InputMaybe<Scalars['String']['input']>;
  /** The member's person code */
  person_code: Scalars['String']['input'];
  /** The member's alternative phone number */
  phone_alt?: InputMaybe<Scalars['String']['input']>;
  /** The member's cell phone number */
  phone_cell?: InputMaybe<Scalars['String']['input']>;
  /** The member's default phone number */
  phone_default?: InputMaybe<Scalars['String']['input']>;
  /** The member's home phone number */
  phone_home?: InputMaybe<Scalars['String']['input']>;
  /** The member's work phone number */
  phone_work?: InputMaybe<Scalars['String']['input']>;
  /** The member's relationship to the subscriber */
  relationship_to_subscriber: DependentRelationshipEnum;
  /** The member's social security number */
  ssn?: InputMaybe<Scalars['String']['input']>;
  /** The member's state */
  state?: InputMaybe<Scalars['String']['input']>;
  /** The member's suffix */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The member's title if any */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The member's zip code */
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDrugListUploadInput = {
  /** The filename of the upload csv file */
  filename: Scalars['String']['input'];
  /** The upload name */
  name: Scalars['String']['input'];
  /** Update type, can be 'create_update' or 'create_update_delete' or nil */
  updateType?: InputMaybe<UpdateType>;
};

export type CreateDrugListUploadOutput = {
  __typename?: 'CreateDrugListUploadOutput';
  /** The ID of the created DrugListUpload */
  drugListUploadID: Scalars['UUID']['output'];
  /** The expiration timestamp of the presigned URL */
  expiresAt: Scalars['Time']['output'];
  /** The presigned URL for uploading the document */
  url: Scalars['String']['output'];
};

export type CreateFillRuleInput = {
  copyFromId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateFillRuleLineInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dontApplyBeforeDate?: InputMaybe<Scalars['Date']['input']>;
  drugID?: InputMaybe<Scalars['String']['input']>;
  drugValue?: InputMaybe<DrugValue>;
  effectiveDate: Scalars['Date']['input'];
  excludeMOClaims?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  fillRuleID: Scalars['ID']['input'];
  hxClaimsQuantityLessOrEqual?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  monyCode: Array<MonyCode>;
  order: Scalars['Int']['input'];
  periodType?: InputMaybe<PeriodType>;
  periodX?: InputMaybe<Scalars['Int']['input']>;
  profileMatchOn?: InputMaybe<Scalars['Int']['input']>;
  rule?: InputMaybe<FillRuleLineRuleType>;
  rxOTCCode?: InputMaybe<RxOtcInd>;
  scriptTagMatchValue?: InputMaybe<Scalars['String']['input']>;
  trueProcessRuleID?: InputMaybe<Scalars['ID']['input']>;
  trueProcessRulePriority?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateGroupInput = {
  benefit_start_date: Scalars['Time']['input'];
  bin: Scalars['String']['input'];
  carrier_code: Scalars['String']['input'];
  code: Scalars['String']['input'];
  effective_date: Scalars['Time']['input'];
  extendFirstBenefitPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  insurance_type?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  partner_id: Scalars['ID']['input'];
  pcn: Scalars['String']['input'];
  pushToSalesforce?: InputMaybe<Scalars['Boolean']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  service_notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  termination_date?: InputMaybe<Scalars['Time']['input']>;
};

export type CreateHandlerInput = {
  copyFromID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  type: HandlerType;
};

/**
 * Input for creating and uploading a custom drug list IFP file.
 * Allows specifying the upload name and optional update type for the drug list operation.
 */
export type CreateIfpDrugListUploadInput = {
  file: Scalars['Upload']['input'];
  /** The upload name */
  name: Scalars['String']['input'];
  /** Update type, can be 'create_update' or 'create_update_delete' or nil when creating a new list from the upload. */
  updateType?: InputMaybe<UpdateType>;
};

export type CreateIfpDrugListUploadPayload = {
  __typename?: 'CreateIFPDrugListUploadPayload';
  /** The ID of the created DrugListUpload */
  drugListUploadID: Scalars['UUID']['output'];
};

/** Required specifier for ClaimSet IFP files. */
export type CreateIfpFileClaimSetEntityDetailsInput = {
  reprocessorBatchID: Scalars['ID']['input'];
};

/** Required specifier for Pharmacy Network Entity IFP files. */
export type CreateIfpFilePharmacyNetworkEntityDetailsInput = {
  pharmacyNetworkID: Scalars['ID']['input'];
};

export type CreateImplementationManualUploadInput = {
  file: Scalars['Upload']['input'];
  /** Display name and extension whitelist. A label, not a key — forge chooses the S3 key. */
  filename: Scalars['String']['input'];
  /** Organisational label only. No provisioning, promotion or attachment path reads this. */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** Work-item name, e.g. 'Open Door'. */
  name: Scalars['String']['input'];
};

export type CreateInvoiceConfig = {
  config: Scalars['String']['input'];
  partner_id: Scalars['ID']['input'];
  period: Period;
};

export type CreateInvoiceOneTimeCharge = {
  amount: Scalars['Int']['input'];
  partner_id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type CreateLakerMpaRequest = {
  /** Action: Should be 'A' for Approve */
  action: Scalars['String']['input'];
  /** When the MPA starts being used in adjudication */
  effectiveAt?: InputMaybe<Scalars['String']['input']>;
  /** What GPI the MPA covers */
  gpi?: InputMaybe<Scalars['String']['input']>;
  /** Group Number: Member's group identifier; aka Group Code (group number in laker) */
  groupNumber: Scalars['String']['input'];
  /** What NDC the MPA covers */
  ndc?: InputMaybe<Scalars['String']['input']>;
  /** Notes about the MPA */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Person Code: eg '01' */
  personCode?: InputMaybe<Scalars['String']['input']>;
  /** Subscriber Number: aka cardId */
  subscriberNumber: Scalars['String']['input'];
  /** When the MPA stops being used in adjudication */
  terminatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLakerMpaResponse = {
  __typename?: 'CreateLakerMPAResponse';
  authnum: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateManualPlanCandidatesInput = {
  /**
   * Every plan the agent created, in one call - the complete set, not a delta. Delivery is
   * at-least-once, so a replay updates the matching ordinals in place. An empty list is legal: on a
   * work item not yet under review it fails the work item, since there is nothing to review.
   */
  candidates: Array<ManualPlanCandidateInput>;
  manualUploadId: Scalars['ID']['input'];
};

export type CreateMemberAccessRestrictionInput = {
  dependentPersonUUID: Scalars['ID']['input'];
  primaryPersonUUID: Scalars['ID']['input'];
};

export type CreateMpaOverrideRequest = {
  /** When the MPA starts being used in adjudication */
  effectiveAt?: InputMaybe<Scalars['String']['input']>;
  /** What GPI the MPA covers */
  gpi?: InputMaybe<Scalars['String']['input']>;
  /** Group Number: Member's group identifier; aka Group Code */
  groupNumber: Scalars['String']['input'];
  /**
   * Max script dollars: the account-manager-confirmed dollar amount applied when
   * reject code 76 (Cost Exceeds Maximum) is requested. Required when 76 is among
   * the reject codes; ignored otherwise.
   */
  maxScriptDollars?: InputMaybe<Scalars['Float']['input']>;
  /** What NDC the MPA covers */
  ndc?: InputMaybe<Scalars['String']['input']>;
  /** Notes about the MPA */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Person Code: eg '01' */
  personCode?: InputMaybe<Scalars['String']['input']>;
  /** Reject codes this override should resolve. Supported: 79, 9G, 75, 608. */
  rejectCodes: Array<Scalars['String']['input']>;
  /** Subscriber Number: aka cardId */
  subscriberNumber: Scalars['String']['input'];
  /** When the MPA stops being used in adjudication */
  terminatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMpaOverrideResponse = {
  __typename?: 'CreateMpaOverrideResponse';
  mpaId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreatePartnerInput = {
  SFTP_password?: InputMaybe<Scalars['String']['input']>;
  account_holder?: InputMaybe<Scalars['Boolean']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  bucket_type?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  contact_name?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  create_s3_bucket: Scalars['Boolean']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  s3_bucket: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  useCarrierCode?: InputMaybe<Scalars['Boolean']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Input for adding a new schedule to an existing Plan Code. */
export type CreatePlanCodeScheduleInput = {
  /**
   * Token from groupAssessCreatePlanCodeScheduleImpact. When provided, the system
   * applies subgroup detail synchronization (expansions and creations) as described
   * by the assessment. If the assessment state has drifted, the mutation fails.
   */
  assessmentToken?: InputMaybe<Scalars['String']['input']>;
  /** The benefit plan to associate with this schedule. */
  benefitPlanId: Scalars['ID']['input'];
  /** The date from which this schedule becomes effective. */
  effectiveDate: Scalars['Date']['input'];
  /** The date on which this schedule expires (inclusive). */
  expirationDate: Scalars['Date']['input'];
  /** The UUID of the existing Plan Code to add a schedule to. */
  planCodeId: Scalars['ID']['input'];
};

export type CreatePlanCodeV2Input = {
  benefitPlanId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use benefitPlanId */
  benefit_plan_id?: InputMaybe<Scalars['ID']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use displayName */
  display_name?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Use effectiveDate */
  effective_from?: InputMaybe<Scalars['Time']['input']>;
  /** @deprecated Use expirationDate */
  effective_to?: InputMaybe<Scalars['Time']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use groupId */
  group_id?: InputMaybe<Scalars['ID']['input']>;
  received: Scalars['String']['input'];
};

export type CreatePlanInput = {
  allowNegativePayments: Scalars['Boolean']['input'];
  benAfterCapCopayHandler?: InputMaybe<Scalars['ID']['input']>;
  benefitRestart?: InputMaybe<Scalars['Time']['input']>;
  defaultAgeHandler?: InputMaybe<Scalars['ID']['input']>;
  defaultBillCostHandler?: InputMaybe<Scalars['ID']['input']>;
  defaultCopayHandler?: InputMaybe<Scalars['ID']['input']>;
  defaultCostHandler?: InputMaybe<Scalars['ID']['input']>;
  defaultDispFeeHandler?: InputMaybe<Scalars['ID']['input']>;
  defaultDispLimitHandler?: InputMaybe<Scalars['ID']['input']>;
  defaultRefillHandler?: InputMaybe<Scalars['ID']['input']>;
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  oopAfterCapCopayHandler?: InputMaybe<Scalars['ID']['input']>;
  rejectRepack: Scalars['Boolean']['input'];
  umac?: InputMaybe<Scalars['UUID']['input']>;
  umac2?: InputMaybe<Scalars['UUID']['input']>;
  umac3?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreatePlanTestSuiteInput = {
  /** Create plan test suite for specified benefit plan */
  benefit_plan_id: Scalars['ID']['input'];
  /**
   * Marks the suite as created by the BenOps AI project. Honored only for the
   * orchestrator caller and ignored for everyone else. An AI suite does not count
   * against the one-suite-per-plan limit, so each AI generation is a new suite.
   */
  isAiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreatePrimaryInput = {
  /** The member's address line 1 */
  address_1?: InputMaybe<Scalars['String']['input']>;
  /** The member's address line 2 */
  address_2?: InputMaybe<Scalars['String']['input']>;
  /** The member's card ID */
  card_id: Scalars['String']['input'];
  /** The member's city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Name of carrier */
  cob_carrier_name?: InputMaybe<Scalars['String']['input']>;
  /** Has COB coverage */
  cob_coverage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of COB Coverage */
  cob_coverage_type?: InputMaybe<MemberCobCoverageTypeEnum>;
  /** Date COB ends */
  cob_end?: InputMaybe<Scalars['Time']['input']>;
  /** Date COB starts */
  cob_start?: InputMaybe<Scalars['Time']['input']>;
  /** The member's country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The member's coverage end date */
  coverage_end?: InputMaybe<Scalars['Time']['input']>;
  /** The member's coverage level */
  coverage_level: MemberCoverageLevelEnum;
  /** The member's coverage start date */
  coverage_start: Scalars['Time']['input'];
  /** The member's date of birth */
  date_of_birth: Scalars['Time']['input'];
  /** The ID of the member's department */
  department_id: Scalars['ID']['input'];
  /** The member's email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The member's first name */
  first_name: Scalars['String']['input'];
  /** The member's gender */
  gender: MemberGenderEnum;
  /** The member's last name */
  last_name: Scalars['String']['input'];
  /** The member's middle name */
  middle_name?: InputMaybe<Scalars['String']['input']>;
  /** The member's person code */
  person_code: Scalars['String']['input'];
  /** The member's alternative phone number */
  phone_alt?: InputMaybe<Scalars['String']['input']>;
  /** The member's cell phone number */
  phone_cell?: InputMaybe<Scalars['String']['input']>;
  /** The member's default phone number */
  phone_default?: InputMaybe<Scalars['String']['input']>;
  /** The member's home phone number */
  phone_home?: InputMaybe<Scalars['String']['input']>;
  /** The member's work phone number */
  phone_work?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the member's plan code */
  plan_code_id: Scalars['ID']['input'];
  /** The member's social security number */
  ssn?: InputMaybe<Scalars['String']['input']>;
  /** The member's state */
  state?: InputMaybe<Scalars['String']['input']>;
  /** The member's suffix */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The member's title if any */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The member's zip code */
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReprocessorBatchInput = {
  batchSetting: CreateBatchSettingInput;
  claimSetId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSdcInput = {
  baseSDCID?: InputMaybe<Scalars['ID']['input']>;
  oopCapInteraction?: InputMaybe<SdcOopCapInteraction>;
  sdcCode: Scalars['String']['input'];
  sdcName: Scalars['String']['input'];
};

export type CreateSent835Input = {
  /** AvoidValidRemittanceCheck flag: if set to true, we want to avoid remittance check. This flag will help to create sent_835s for missing claims in the certain time period. */
  avoidValidRemittanceCheck: Scalars['Boolean']['input'];
  /** DryRun flag: if set to true, Sent835 file is created but no database records are written. */
  dryRun: Scalars['Boolean']['input'];
  /** The end time for the requested remittance period. */
  end: Scalars['Time']['input'];
  /** String representing the `name` of the payee for which we want to generate an 835 report. */
  payeeName: Scalars['String']['input'];
  /** Array of states where pharmacies reside for which we want to generate an 835 report. If nil, all states apply. */
  pharmacyStates?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Array of plan codes for which we want to generate an 835 report. If nil or empty, all plans apply.
   * A plan code matches `claims.plan_design_id` for Laker-adjudicated claims and the plan's `number` for Zebra-adjudicated claims.
   */
  planCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The start time for the requested remittance period. */
  start: Scalars['Time']['input'];
};

export type CreateStepTherapyLineInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  drugID?: InputMaybe<Scalars['String']['input']>;
  drugValue?: InputMaybe<DrugValue>;
  effectiveDate: Scalars['Time']['input'];
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  monyCode: Array<MonyCode>;
  order: Scalars['Int']['input'];
  stepTherapyID: Scalars['ID']['input'];
};

export type CreateStepTherapyV2Input = {
  baseStepTherapyID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateSubGroupInput = {
  benefit_start_date: Scalars['Time']['input'];
  department_id: Scalars['ID']['input'];
  effective_date: Scalars['Time']['input'];
  plan_code_id: Scalars['ID']['input'];
  termination_date?: InputMaybe<Scalars['Time']['input']>;
};

export type CreateSubgroupDetailInput = {
  benCapSatisfactionType?: InputMaybe<SatisfactionType>;
  benefitStartDate?: InputMaybe<Scalars['Date']['input']>;
  dedSatisfactionType?: InputMaybe<SatisfactionType>;
  effectiveDate: Scalars['Date']['input'];
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  familyBenCap?: InputMaybe<Scalars['Cents']['input']>;
  familyDed?: InputMaybe<Scalars['Cents']['input']>;
  familyOop?: InputMaybe<Scalars['Cents']['input']>;
  individualBenCap?: InputMaybe<Scalars['Cents']['input']>;
  individualDed?: InputMaybe<Scalars['Cents']['input']>;
  individualOop?: InputMaybe<Scalars['Cents']['input']>;
  naToDed?: InputMaybe<Scalars['Boolean']['input']>;
  oopSatisfactionType?: InputMaybe<SatisfactionType>;
  subgroupId: Scalars['ID']['input'];
};

export type CreateSubgroupInput = {
  benCapSatisfactionType?: InputMaybe<SatisfactionType>;
  benefitStartDate?: InputMaybe<Scalars['Date']['input']>;
  dedSatisfactionType?: InputMaybe<SatisfactionType>;
  departmentId: Scalars['ID']['input'];
  effectiveDate: Scalars['Date']['input'];
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  familyBenCap?: InputMaybe<Scalars['Cents']['input']>;
  familyDed?: InputMaybe<Scalars['Cents']['input']>;
  familyOop?: InputMaybe<Scalars['Cents']['input']>;
  groupId: Scalars['ID']['input'];
  individualBenCap?: InputMaybe<Scalars['Cents']['input']>;
  individualDed?: InputMaybe<Scalars['Cents']['input']>;
  individualOop?: InputMaybe<Scalars['Cents']['input']>;
  naToDed?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
  oopSatisfactionType?: InputMaybe<SatisfactionType>;
  overridePlan?: InputMaybe<Scalars['ID']['input']>;
  planCodeId: Scalars['ID']['input'];
};

export type CreateTestRunCsvInput = {
  executions: Array<CsvExecutionInput>;
  flags: CreateTestRunFlagsInput;
};

export type CreateTestRunFlagsInput = {
  /**
   * Optional run-level date override, supported on a TEMPLATE run only and gated by
   * enable_bentest_template_date_override. When supplied, these dates replace the
   * template's day offsets on every claim of every plan in the run. Both must be
   * given together, and datePrescriptionWritten cannot be after dateOfService.
   */
  dateOfService?: InputMaybe<Scalars['Date']['input']>;
  datePrescriptionWritten?: InputMaybe<Scalars['Date']['input']>;
  holdUnitCostConstant: Scalars['Boolean']['input'];
  ignoreAgeHandler: Scalars['Boolean']['input'];
  ignoreDiscontinuedNdcs: Scalars['Boolean']['input'];
  ignoreDispenseLimitHandler: Scalars['Boolean']['input'];
  ignoreMemberEligibilityEndDate: Scalars['Boolean']['input'];
  overrideRefillTooSoon: Scalars['Boolean']['input'];
  reverseAllClaims: Scalars['Boolean']['input'];
};

export type CreateTestRunManualClaimInput = {
  claims: Array<ManualClaimInput>;
  executions: Array<ManualClaimExecutionInput>;
  flags: CreateTestRunFlagsInput;
};

export type CreateTestRunPayload = {
  __typename?: 'CreateTestRunPayload';
  testRun: TestRun;
};

export type CreateTestRunTemplateInput = {
  executions: Array<TemplateExecutionInput>;
  flags: CreateTestRunFlagsInput;
};

export type CreateTransmissionFormatInput = {
  /** The configuration JSON for the format. */
  config: Scalars['Map']['input'];
  /** name of sample file */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** User-facing format name. */
  name: Scalars['String']['input'];
  /** A sample file to use against the config (in the case of incoming files) */
  sampleFile?: InputMaybe<Scalars['String']['input']>;
  /** Type describes the structure/schema of config. */
  type: TransmissionFormatType;
};

export type CreateTransmissionJobInput = {
  /** The configuration JSON for the new job. */
  config: Scalars['Map']['input'];
  job_type: TransmissionJobType;
  /**
   * Target location (i.e. an S3 bucket) to write transmission (report) content to.
   * s3://bucket/folder/file
   * sftp://hitrust.org/upload
   * http://other.mplace/folder
   */
  location: Scalars['String']['input'];
};

export type CreateUpdateAccountInput = {
  code: Scalars['String']['input'];
  go_live?: InputMaybe<Scalars['Time']['input']>;
  insurance_type: Scalars['String']['input'];
  name: Scalars['String']['input'];
  status: AccountStatusEnum;
};

export type CreationStats = {
  __typename?: 'CreationStats';
  /** The total number of department entities created. */
  department_created: Scalars['Int']['output'];
  /** The total number of plan code entities created. */
  plan_code_created: Scalars['Int']['output'];
  /** The total number of subgroup entities created. */
  subgroup_created: Scalars['Int']['output'];
  /** The total number of entities created. */
  total_created: Scalars['Int']['output'];
};

export type Credential = {
  __typename?: 'Credential';
  authn_method?: Maybe<Scalars['String']['output']>;
  authorizations?: Maybe<Array<Authorization>>;
  changelog: CredentialChangelogList;
  created_at: Scalars['Time']['output'];
  deleted_at?: Maybe<Scalars['Time']['output']>;
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  invitation_sent_at?: Maybe<Scalars['Time']['output']>;
  last_name: Scalars['String']['output'];
  roles?: Maybe<Array<RoleV2>>;
  secondary_verification?: Maybe<Scalars['String']['output']>;
  third_party_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Time']['output'];
  updated_by?: Maybe<Credential>;
  username: Scalars['String']['output'];
  verified_at?: Maybe<Scalars['Time']['output']>;
};


export type CredentialChangelogArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type CredentialChangelog = {
  __typename?: 'CredentialChangelog';
  changes?: Maybe<Scalars['Map']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  modified_by?: Maybe<Credential>;
  updated_at?: Maybe<Scalars['Time']['output']>;
};

export type CredentialChangelogList = {
  __typename?: 'CredentialChangelogList';
  pagination: Pagination;
  results?: Maybe<Array<CredentialChangelog>>;
};

export type CredentialFilters = {
  group?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  include_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  partner?: InputMaybe<StringFilter>;
  /** @deprecated Use roles */
  role?: InputMaybe<IdFilter>;
  roles?: InputMaybe<StringFilter>;
  updated_by?: InputMaybe<IdFilter>;
  username?: InputMaybe<StringFilter>;
};

export type CredentialInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Replaced by roleNames */
  roleName?: InputMaybe<Scalars['String']['input']>;
  roleNames?: InputMaybe<Array<Scalars['String']['input']>>;
  username: Scalars['String']['input'];
};

export type CredentialList = {
  __typename?: 'CredentialList';
  pagination?: Maybe<Pagination>;
  results: Array<Credential>;
};

export type CredentialOrder = {
  created_at?: InputMaybe<OrderDirectionEnum>;
  deleted_at?: InputMaybe<OrderDirectionEnum>;
  username?: InputMaybe<OrderDirectionEnum>;
};

export enum CredentialsMoveOutcome {
  Moved = 'MOVED',
  NoOp = 'NO_OP'
}

export type CredentialsMoveRun = {
  __typename?: 'CredentialsMoveRun';
  author?: Maybe<Scalars['String']['output']>;
  cancelledCount: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  executedAt?: Maybe<Scalars['Time']['output']>;
  failedCount: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  runUUID: Scalars['UUID']['output'];
  runningCount: Scalars['Int']['output'];
  scheduledCount: Scalars['Int']['output'];
  scheduledFor: Scalars['Date']['output'];
  /** Earliest started_at and latest executed_at of the run's items. */
  startedAt?: Maybe<Scalars['Time']['output']>;
  /** Derived from the run's items. */
  status: CredentialsMoveRunStatus;
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type CredentialsMoveRunConnection = {
  __typename?: 'CredentialsMoveRunConnection';
  /** Number of runs that match the given filters. */
  count: Scalars['Int']['output'];
  edges: Array<CredentialsMoveRunEdge>;
  pageInfo: PageInfo;
};

export type CredentialsMoveRunEdge = {
  __typename?: 'CredentialsMoveRunEdge';
  cursor: Scalars['String']['output'];
  node: CredentialsMoveRun;
};

export type CredentialsMoveRunFilters = {
  author?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<TimeFilter>;
  /** Runs with at least one item moving from this person. */
  fromPersonUUID?: InputMaybe<Scalars['UUID']['input']>;
  runUUID?: InputMaybe<IdFilter>;
  scheduledFor?: InputMaybe<DateFilter>;
  status?: InputMaybe<Array<CredentialsMoveRunStatus>>;
  /** Runs with at least one item moving to this person. */
  toPersonUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type CredentialsMoveRunOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  scheduledFor?: InputMaybe<OrderDirectionEnum>;
  status?: InputMaybe<OrderDirectionEnum>;
};

export enum CredentialsMoveRunStatus {
  Cancelled = 'CANCELLED',
  Failure = 'FAILURE',
  InProgress = 'IN_PROGRESS',
  PartialSuccess = 'PARTIAL_SUCCESS',
  Scheduled = 'SCHEDULED',
  Success = 'SUCCESS'
}

export type CredentialsMoveSchedule = {
  __typename?: 'CredentialsMoveSchedule';
  author?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  error?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['Time']['output']>;
  fromPersonUUID: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  outcome?: Maybe<CredentialsMoveOutcome>;
  runUUID: Scalars['UUID']['output'];
  startedAt?: Maybe<Scalars['Time']['output']>;
  status: CredentialsMoveScheduleStatus;
  toPersonUUID: Scalars['UUID']['output'];
};

export type CredentialsMoveScheduleConnection = {
  __typename?: 'CredentialsMoveScheduleConnection';
  /** Number of the run's moves that match the given filters. */
  count: Scalars['Int']['output'];
  edges: Array<CredentialsMoveScheduleEdge>;
  pageInfo: PageInfo;
};

export type CredentialsMoveScheduleEdge = {
  __typename?: 'CredentialsMoveScheduleEdge';
  cursor: Scalars['String']['output'];
  node: CredentialsMoveSchedule;
};

export type CredentialsMoveScheduleFilters = {
  author?: InputMaybe<StringFilter>;
  status?: InputMaybe<Array<CredentialsMoveScheduleStatus>>;
};

export type CredentialsMoveScheduleOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  status?: InputMaybe<OrderDirectionEnum>;
};

export enum CredentialsMoveScheduleStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Scheduled = 'SCHEDULED',
  Success = 'SUCCESS'
}

export type CrossAccumulatorConfig = {
  __typename?: 'CrossAccumulatorConfig';
  benefitPlanId: Scalars['UUID']['output'];
  doesPlanAccumulateRxOnly: Scalars['Int']['output'];
  sendDeductible: Scalars['Int']['output'];
  sendOOP: Scalars['Int']['output'];
};

/** CrossAccumulatorConfigInput is the input type for crossAccumulatorConfig query */
export type CrossAccumulatorConfigInput = {
  effectiveAt: Scalars['Time']['input'];
  membershipId: Scalars['UUID']['input'];
};

/** Detected crosswalk operation type (from adaptive tool) */
export enum CrosswalkDetectedOperationType {
  InvalidInput = 'INVALID_INPUT',
  Merge = 'MERGE',
  Move = 'MOVE',
  None = 'NONE',
  TpaChange = 'TPA_CHANGE',
  Unknown = 'UNKNOWN'
}

/** Detailed information about what operations will be performed */
export type CrosswalkDetectedOperations = {
  __typename?: 'CrosswalkDetectedOperations';
  accumCarryoverRecalc: Scalars['Boolean']['output'];
  adjudicatorPCChange: Scalars['Boolean']['output'];
  cardIDChange: Scalars['Boolean']['output'];
  groupChange: Scalars['Boolean']['output'];
  mergeAccumulators: Scalars['Boolean']['output'];
  moveCredentials: Scalars['Boolean']['output'];
  providerPersonCodeChange: Scalars['Boolean']['output'];
  requiresMemberSync: Scalars['Boolean']['output'];
  setAltCardID: Scalars['Boolean']['output'];
  softDeleteOldMember: Scalars['Boolean']['output'];
  terminateOldMembership: Scalars['Boolean']['output'];
  zebraMoveMerge: Scalars['Boolean']['output'];
  zebraTPAChange: Scalars['Boolean']['output'];
};

/** Breakdown of operations by type and status */
export type CrosswalkOperationBreakdown = {
  __typename?: 'CrosswalkOperationBreakdown';
  committedCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  invalidCount: Scalars['Int']['output'];
  operationType: CrosswalkDetectedOperationType;
  totalCount: Scalars['Int']['output'];
  validCount: Scalars['Int']['output'];
};

/** Statistics for crosswalk operations in an IFP file */
export type CrosswalkOperationStats = {
  __typename?: 'CrosswalkOperationStats';
  committedCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  invalidCount: Scalars['Int']['output'];
  invalidInputCount: Scalars['Int']['output'];
  mergeCount: Scalars['Int']['output'];
  moveCount: Scalars['Int']['output'];
  noneCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  tpaChangeCount: Scalars['Int']['output'];
  unknownCount: Scalars['Int']['output'];
  validCount: Scalars['Int']['output'];
  zebraGroupCount: Scalars['Int']['output'];
  zebraMoveMergeCount: Scalars['Int']['output'];
  zebraTPAChangeCount: Scalars['Int']['output'];
};

/** Defines the type of crosswalk operation for CROSSWALK_IMPORT files. */
export enum CrosswalkOperationType {
  /** Merge operation: combine two member records into one (target member already exists) - rejected while merge is disabled */
  Merge = 'MERGE',
  /** Move operation: card ID or person code changes within the same group */
  Move = 'MOVE',
  /** TPA change: cross-group move (Third Party Administrator change) between different group codes */
  TpaChange = 'TPA_CHANGE'
}

/** Parsed metadata from IFPFileRow.targetEntitiesMeta for crosswalk rows */
export type CrosswalkRowMetadata = {
  __typename?: 'CrosswalkRowMetadata';
  detectedOperationType: CrosswalkDetectedOperationType;
  detectedOperations: CrosswalkDetectedOperations;
  isZebraGroup?: Maybe<Scalars['Boolean']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

/** Currency value using the schema's Dollars scalar. */
export type CurrencyClaimInstruction = ClaimInstruction & {
  __typename?: 'CurrencyClaimInstruction';
  dollarsValue: Scalars['Dollars']['output'];
  field: MpaClaimInstructionField;
  id: Scalars['ID']['output'];
  isEmpty: Scalars['Boolean']['output'];
};

export type CustomDrugListFiltersV2 = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CustomDrugListOrderV2 = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  id?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  status?: InputMaybe<OrderDirectionEnum>;
};

export type CustomDrugListUpload = {
  __typename?: 'CustomDrugListUpload';
  /** The time of creation of this upload */
  createdAt: Scalars['Time']['output'];
  /** The user who created this upload */
  createdBy: Scalars['String']['output'];
  /** The ID of the custom drug list associated with this upload */
  customDrugListId?: Maybe<Scalars['ID']['output']>;
  /** The unique identifier for the DrugListUpload */
  id: Scalars['ID']['output'];
  /** The IFP File associated with this CustomDrugListUpload */
  ifpFile?: Maybe<IfpFile>;
  /** The name of the custom drug list */
  name?: Maybe<Scalars['String']['output']>;
  /** The row details with the drug list items */
  rowDetails?: Maybe<RowDetails>;
  /** The status of the upload */
  status: UploadStatus;
  /** The status message for the upload */
  statusMessage?: Maybe<Scalars['String']['output']>;
  /** The update type of the upload */
  updateType?: Maybe<UpdateType>;
  /** The URL of the uploaded CSV */
  uploadedCsvUrl: Scalars['String']['output'];
};

export type CustomDrugListV2 = {
  __typename?: 'CustomDrugListV2';
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status: DrugListStatus;
  updatedAt: Scalars['Time']['output'];
};

export type CustomDrugListsV2Connection = {
  __typename?: 'CustomDrugListsV2Connection';
  edges: Array<CustomDrugListsV2Edge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CustomDrugListsV2Edge = {
  __typename?: 'CustomDrugListsV2Edge';
  cursor: Scalars['String']['output'];
  node: CustomDrugListV2;
};

/** CustomField holds claimRecord properties that should only be viewable by user with admin access */
export type CustomField = {
  __typename?: 'CustomField';
  approvedGrossDue?: Maybe<Scalars['Cents']['output']>;
  awpTotalPrice?: Maybe<Scalars['String']['output']>;
  bhsAccumBucketValue1?: Maybe<Scalars['Cents']['output']>;
  bhsAccumBucketValue1ActionCode?: Maybe<Scalars['String']['output']>;
  bhsAccumBucketValue2?: Maybe<Scalars['Cents']['output']>;
  bhsAccumBucketValue2ActionCode?: Maybe<Scalars['String']['output']>;
  bhsAmountOfCopayActionCode?: Maybe<Scalars['String']['output']>;
  bhsCopay?: Maybe<Scalars['Cents']['output']>;
  bhsFillProcessedAt?: Maybe<Scalars['Time']['output']>;
  bhsOutOfPocket?: Maybe<Scalars['Cents']['output']>;
  claimIndicator?: Maybe<Scalars['String']['output']>;
  claimMemberNumber?: Maybe<Scalars['String']['output']>;
  claimOtherCoverage?: Maybe<Scalars['Int']['output']>;
  claimPaidDispensingFee?: Maybe<Scalars['Cents']['output']>;
  claimPaidTax?: Maybe<Scalars['Cents']['output']>;
  claimPersonNumber?: Maybe<Scalars['String']['output']>;
  conBilledDispensingFee?: Maybe<Scalars['Cents']['output']>;
  conBilledIngredientCost?: Maybe<Scalars['Cents']['output']>;
  conTotalBilledPreCopay?: Maybe<Scalars['Cents']['output']>;
  deductibleOrOutOfPocketCount?: Maybe<Scalars['Int']['output']>;
  deductibleOrOutOfPocketOrSDCCount?: Maybe<Scalars['Int']['output']>;
  emiAccum1AbsoluteBalance?: Maybe<Scalars['Cents']['output']>;
  emiAccum1Balance?: Maybe<Scalars['Cents']['output']>;
  emiAccum1BalanceIsPositive?: Maybe<Scalars['String']['output']>;
  emiAccum1BenefitAccountType?: Maybe<Scalars['String']['output']>;
  emiAccum1IsOutOfNetwork?: Maybe<Scalars['String']['output']>;
  emiAccum1IsReversal?: Maybe<Scalars['String']['output']>;
  emiAccum2AbsoluteBalance?: Maybe<Scalars['Cents']['output']>;
  emiAccum2Balance?: Maybe<Scalars['Cents']['output']>;
  emiAccum2BalanceIsPositive?: Maybe<Scalars['String']['output']>;
  emiAccum2BenefitAccountType?: Maybe<Scalars['String']['output']>;
  emiAccum2IsOutOfNetwork?: Maybe<Scalars['String']['output']>;
  emiAccum2IsReversal?: Maybe<Scalars['String']['output']>;
  horizonAccum1Balance?: Maybe<Scalars['Cents']['output']>;
  horizonAccum1BenefitAccountType?: Maybe<Scalars['String']['output']>;
  horizonAccum2Balance?: Maybe<Scalars['Cents']['output']>;
  horizonAccum2BenefitAccountType?: Maybe<Scalars['String']['output']>;
  indemnityAllowance?: Maybe<Scalars['Cents']['output']>;
  indemnityMemberOwedAmount?: Maybe<Scalars['Cents']['output']>;
  indemnityPlanPay?: Maybe<Scalars['Cents']['output']>;
  kbaAllowedAmount?: Maybe<Scalars['Cents']['output']>;
  kbaIsIndemnityPlan?: Maybe<Scalars['Boolean']['output']>;
  kbaMemberID?: Maybe<Scalars['String']['output']>;
  ncpdp20DrugType?: Maybe<Scalars['String']['output']>;
  patientPayFlag?: Maybe<Scalars['String']['output']>;
  surestAccum1BenefitAccountType?: Maybe<Scalars['String']['output']>;
  surestAccum2BenefitAccountType?: Maybe<Scalars['String']['output']>;
  surestAccum3BenefitAccountType?: Maybe<Scalars['String']['output']>;
};

export type DawSetting = {
  __typename?: 'DAWSetting';
  copayTab: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  whoPays: Scalars['Int']['output'];
};

export type DawSettingInput = {
  code: Scalars['Int']['input'];
  settingID: Scalars['ID']['input'];
};

export enum DeaClass {
  /** CI */
  ClassI = 'ClassI',
  /** CII */
  ClassIi = 'ClassII',
  /** CIII */
  ClassIii = 'ClassIII',
  /** CIV */
  ClassIv = 'ClassIV',
  /** CV */
  ClassV = 'ClassV',
  Unknown = 'UNKNOWN'
}

export type DurAgeComponent = {
  __typename?: 'DURAgeComponent';
  allowPA0000000003?: Maybe<Scalars['Boolean']['output']>;
  contraindicatedMessage?: Maybe<Scalars['String']['output']>;
  contraindicatedRejectAction: DurRejectAction;
  description?: Maybe<Scalars['String']['output']>;
  extremeCautionMessage?: Maybe<Scalars['String']['output']>;
  extremeCautionRejectAction: DurRejectAction;
  id: Scalars['ID']['output'];
  informationMessage?: Maybe<Scalars['String']['output']>;
  informationRejectAction: DurRejectAction;
  name: Scalars['String']['output'];
  notRecommendedMessage?: Maybe<Scalars['String']['output']>;
  notRecommendedRejectAction: DurRejectAction;
  overrideRejectList?: Maybe<DurOverrideRejectList>;
  replaceSelectedReject88With?: Maybe<Scalars['String']['output']>;
  useCautiouslyMessage?: Maybe<Scalars['String']['output']>;
  useCautiouslyRejectAction: DurRejectAction;
};

export type DurAgeComponentConnection = {
  __typename?: 'DURAgeComponentConnection';
  edges: Array<DurAgeComponentEdge>;
  pageInfo: PageInfo;
};

export type DurAgeComponentEdge = {
  __typename?: 'DURAgeComponentEdge';
  cursor: Scalars['String']['output'];
  node: DurAgeComponent;
};

export type DurAgeMultiplier = {
  __typename?: 'DURAgeMultiplier';
  description?: Maybe<Scalars['String']['output']>;
  exactly1Message?: Maybe<Scalars['String']['output']>;
  exactly1RejectAction: DurRejectAction;
  greaterThan1UpTo2Message?: Maybe<Scalars['String']['output']>;
  greaterThan1UpTo2RejectAction: DurRejectAction;
  greaterThan2UpTo2pt5Message?: Maybe<Scalars['String']['output']>;
  greaterThan2UpTo2pt5RejectAction: DurRejectAction;
  greaterThan2pt5Message?: Maybe<Scalars['String']['output']>;
  greaterThan2pt5RejectAction: DurRejectAction;
  id: Scalars['ID']['output'];
  lessThan1Message?: Maybe<Scalars['String']['output']>;
  lessThan1RejectAction: DurRejectAction;
  name: Scalars['String']['output'];
};

export type DurComplianceComponent = {
  __typename?: 'DURComplianceComponent';
  addReject569WhenReturning88HardReject?: Maybe<Scalars['Boolean']['output']>;
  allowPA0000000003?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  includeOnlyMaintenanceMeds?: Maybe<Scalars['Boolean']['output']>;
  maxDaysBelowCompliance?: Maybe<Scalars['Int']['output']>;
  minimumDaysSupply?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  otherPharmacyMessage?: Maybe<Scalars['String']['output']>;
  otherPharmacyRejectAction: DurRejectAction;
  overrideRejectList?: Maybe<DurOverrideRejectList>;
  percentBelowCompliance?: Maybe<Scalars['Int']['output']>;
  replaceSelectedReject88With?: Maybe<Scalars['String']['output']>;
  samePharmacyMessage?: Maybe<Scalars['String']['output']>;
  samePharmacyRejectAction: DurRejectAction;
};

export type DurComplianceComponentConnection = {
  __typename?: 'DURComplianceComponentConnection';
  edges: Array<DurComplianceComponentEdge>;
  pageInfo: PageInfo;
};

export type DurComplianceComponentEdge = {
  __typename?: 'DURComplianceComponentEdge';
  cursor: Scalars['String']['output'];
  node: DurComplianceComponent;
};

export type DurComponentFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type DurComponentOrder = {
  name?: InputMaybe<OrderDirectionEnum>;
};

export type DurDoseMaintenanceComponent = {
  __typename?: 'DURDoseMaintenanceComponent';
  addReject569WhenReturning88HardReject?: Maybe<Scalars['Boolean']['output']>;
  adultAgeMultiplier?: Maybe<DurAgeMultiplier>;
  allowPA0000000003?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  durationHighPharmacyMessage?: Maybe<Scalars['String']['output']>;
  durationHighPharmacyRejectAction: DurRejectAction;
  durationLowPharmacyMessage?: Maybe<Scalars['String']['output']>;
  durationLowPharmacyRejectAction: DurRejectAction;
  geriatricAgeMultiplier?: Maybe<DurAgeMultiplier>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  overrideRejectList?: Maybe<DurOverrideRejectList>;
  pediatricAgeMultiplier?: Maybe<DurAgeMultiplier>;
  replaceSelectedReject88With?: Maybe<Scalars['String']['output']>;
};

export type DurDoseMaintenanceComponentConnection = {
  __typename?: 'DURDoseMaintenanceComponentConnection';
  count: Scalars['Int']['output'];
  edges: Array<DurDoseMaintenanceComponentEdge>;
  pageInfo: PageInfo;
};

export type DurDoseMaintenanceComponentEdge = {
  __typename?: 'DURDoseMaintenanceComponentEdge';
  cursor: Scalars['String']['output'];
  node: DurDoseMaintenanceComponent;
};

export type DurDrugToDrugComponent = {
  __typename?: 'DURDrugToDrugComponent';
  addReject569WhenReturning88HardReject?: Maybe<Scalars['Boolean']['output']>;
  allowPA0000000003?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extendDaysSupplyPercent?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  otherPharmacyMajorMessage?: Maybe<Scalars['String']['output']>;
  otherPharmacyMajorRejectAction: DurRejectAction;
  otherPharmacyMinorMessage?: Maybe<Scalars['String']['output']>;
  otherPharmacyMinorRejectAction: DurRejectAction;
  otherPharmacyModerateMessage?: Maybe<Scalars['String']['output']>;
  otherPharmacyModerateRejectAction: DurRejectAction;
  overrideRejectList?: Maybe<DurOverrideRejectList>;
  replaceSelectedReject88With?: Maybe<Scalars['String']['output']>;
  samePharmacyMajorMessage?: Maybe<Scalars['String']['output']>;
  samePharmacyMajorRejectAction: DurRejectAction;
  samePharmacyMinorMessage?: Maybe<Scalars['String']['output']>;
  samePharmacyMinorRejectAction: DurRejectAction;
  samePharmacyModerateMessage?: Maybe<Scalars['String']['output']>;
  samePharmacyModerateRejectAction: DurRejectAction;
};

export type DurDrugToDrugComponentConnection = {
  __typename?: 'DURDrugToDrugComponentConnection';
  edges: Array<DurDrugToDrugComponentEdge>;
  pageInfo: PageInfo;
};

export type DurDrugToDrugComponentEdge = {
  __typename?: 'DURDrugToDrugComponentEdge';
  cursor: Scalars['String']['output'];
  node: DurDrugToDrugComponent;
};

export type DurDupDrugComponent = {
  __typename?: 'DURDupDrugComponent';
  addReject569WhenReturning88HardReject?: Maybe<Scalars['Boolean']['output']>;
  allowPA0000000003?: Maybe<Scalars['Boolean']['output']>;
  allowedTolerance?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  doseOverride: Scalars['Boolean']['output'];
  gpiMatchDigits?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  otherPharmacyMessage?: Maybe<Scalars['String']['output']>;
  otherPharmacyRejectAction: DurRejectAction;
  overrideRejectList?: Maybe<DurOverrideRejectList>;
  replaceSelectedReject88With?: Maybe<Scalars['String']['output']>;
  samePharmacyMessage?: Maybe<Scalars['String']['output']>;
  samePharmacyRejectAction: DurRejectAction;
};

export type DurDupDrugComponentConnection = {
  __typename?: 'DURDupDrugComponentConnection';
  edges: Array<DurDupDrugComponentEdge>;
  pageInfo: PageInfo;
};

export type DurDupDrugComponentEdge = {
  __typename?: 'DURDupDrugComponentEdge';
  cursor: Scalars['String']['output'];
  node: DurDupDrugComponent;
};

export type DurDupTherapyComponent = {
  __typename?: 'DURDupTherapyComponent';
  addReject569WhenReturning88HardReject?: Maybe<Scalars['Boolean']['output']>;
  allowPA0000000003?: Maybe<Scalars['Boolean']['output']>;
  allowedTolerance?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gpiMatchDigits?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  otherPharmacyMessage?: Maybe<Scalars['String']['output']>;
  otherPharmacyRejectAction: DurRejectAction;
  overrideRejectList?: Maybe<DurOverrideRejectList>;
  replaceSelectedReject88With?: Maybe<Scalars['String']['output']>;
  samePharmacyMessage?: Maybe<Scalars['String']['output']>;
  samePharmacyRejectAction: DurRejectAction;
};

export type DurDupTherapyComponentConnection = {
  __typename?: 'DURDupTherapyComponentConnection';
  count: Scalars['Int']['output'];
  edges: Array<DurDupTherapyComponentEdge>;
  pageInfo: PageInfo;
};

export type DurDupTherapyComponentEdge = {
  __typename?: 'DURDupTherapyComponentEdge';
  cursor: Scalars['String']['output'];
  node: DurDupTherapyComponent;
};

export type DurGenderComponent = {
  __typename?: 'DURGenderComponent';
  allowPA0000000003?: Maybe<Scalars['Boolean']['output']>;
  contraindicatedMessage?: Maybe<Scalars['String']['output']>;
  contraindicatedRejectAction: DurRejectAction;
  description?: Maybe<Scalars['String']['output']>;
  extremeCautionMessage?: Maybe<Scalars['String']['output']>;
  extremeCautionRejectAction: DurRejectAction;
  id: Scalars['ID']['output'];
  informationMessage?: Maybe<Scalars['String']['output']>;
  informationRejectAction: DurRejectAction;
  name: Scalars['String']['output'];
  notRecommendedMessage?: Maybe<Scalars['String']['output']>;
  notRecommendedRejectAction: DurRejectAction;
  overrideRejectList?: Maybe<DurOverrideRejectList>;
  replaceSelectedReject88With?: Maybe<Scalars['String']['output']>;
  useCautiouslyMessage?: Maybe<Scalars['String']['output']>;
  useCautiouslyRejectAction: DurRejectAction;
};

export type DurGenderComponentConnection = {
  __typename?: 'DURGenderComponentConnection';
  edges: Array<DurGenderComponentEdge>;
  pageInfo: PageInfo;
};

export type DurGenderComponentEdge = {
  __typename?: 'DURGenderComponentEdge';
  cursor: Scalars['String']['output'];
  node: DurGenderComponent;
};

export type DurIngredientComponent = {
  __typename?: 'DURIngredientComponent';
  addReject569WhenReturning88HardReject?: Maybe<Scalars['Boolean']['output']>;
  allowPA0000000003?: Maybe<Scalars['Boolean']['output']>;
  allowedTolerance?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ingredientLines?: Maybe<Array<DurIngredientLine>>;
  name: Scalars['String']['output'];
  overrideRejectList?: Maybe<DurOverrideRejectList>;
  replaceSelectedReject88With?: Maybe<Scalars['String']['output']>;
};

export type DurIngredientComponentConnection = {
  __typename?: 'DURIngredientComponentConnection';
  count: Scalars['Int']['output'];
  edges: Array<DurIngredientComponentEdge>;
  pageInfo: PageInfo;
};

export type DurIngredientComponentEdge = {
  __typename?: 'DURIngredientComponentEdge';
  cursor: Scalars['String']['output'];
  node: DurIngredientComponent;
};

export type DurIngredientLine = {
  __typename?: 'DURIngredientLine';
  action: DurRejectAction;
  allowPA0000000003?: Maybe<Scalars['Boolean']['output']>;
  allowedTolerance?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  overrideRejectList?: Maybe<DurOverrideRejectList>;
  screeningIngredient?: Maybe<ScreeningIngredient>;
  serviceCodeReason?: Maybe<ServiceCodeReason>;
  strength?: Maybe<Scalars['Float']['output']>;
  uniquePharmacies?: Maybe<Scalars['Int']['output']>;
  uniquePrescribers?: Maybe<Scalars['Int']['output']>;
  uom?: Maybe<Scalars['String']['output']>;
};

/** DUR Program or Component */
export type DurObject = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum DurObjectType {
  Program = 'PROGRAM'
}

export type DurOverrideRejectList = {
  __typename?: 'DUROverrideRejectList';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<DurOverrideRejectListItem>>;
  name: Scalars['String']['output'];
};

export type DurOverrideRejectListItem = {
  __typename?: 'DUROverrideRejectListItem';
  durOverrideRejectListID: Scalars['ID']['output'];
  effectiveDate: Scalars['Time']['output'];
  expirationDate?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  professionalServiceCode?: Maybe<Scalars['String']['output']>;
  reasonForServiceCode?: Maybe<Scalars['String']['output']>;
  resultOfServiceCode?: Maybe<Scalars['String']['output']>;
};

export type DurProgram = DurObject & {
  __typename?: 'DURProgram';
  DURProgramDetails?: Maybe<Array<DurProgramDetail>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Relay-style connection of DUR Programs */
export type DurProgramConnection = {
  __typename?: 'DURProgramConnection';
  /** Number of DUR Programs that satisfy filters (or total number of DUR programs when filters are omitted) */
  count: Scalars['Int']['output'];
  edges: Array<DurProgramEdge>;
  pageInfo: PageInfo;
};

export type DurProgramDetail = {
  __typename?: 'DURProgramDetail';
  ageComponent?: Maybe<DurAgeComponent>;
  complianceComponent?: Maybe<DurComplianceComponent>;
  doseMaintenanceComponent?: Maybe<DurDoseMaintenanceComponent>;
  drugToDrugComponent?: Maybe<DurDrugToDrugComponent>;
  dupDrugComponent?: Maybe<DurDupDrugComponent>;
  dupTherapyComponent?: Maybe<DurDupTherapyComponent>;
  durProgramID: Scalars['ID']['output'];
  effectiveDate: Scalars['Time']['output'];
  expirationDate?: Maybe<Scalars['Time']['output']>;
  genderComponent?: Maybe<DurGenderComponent>;
  id: Scalars['ID']['output'];
  ingredientComponent?: Maybe<DurIngredientComponent>;
};

export type DurProgramDetailInput = {
  ageComponent?: InputMaybe<Scalars['ID']['input']>;
  complianceComponent?: InputMaybe<Scalars['ID']['input']>;
  doseMaintenanceComponent?: InputMaybe<Scalars['ID']['input']>;
  drugToDrugComponent?: InputMaybe<Scalars['ID']['input']>;
  dupDrugComponent?: InputMaybe<Scalars['ID']['input']>;
  dupTherapyComponent?: InputMaybe<Scalars['ID']['input']>;
  effectiveDate: Scalars['Time']['input'];
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  genderComponent?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ingredientComponent?: InputMaybe<Scalars['ID']['input']>;
};

/** Relay-style connection edge of DUR Program */
export type DurProgramEdge = {
  __typename?: 'DURProgramEdge';
  cursor: Scalars['String']['output'];
  node: DurProgram;
};

export type DurProgramFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type DurProgramOrder = {
  name?: InputMaybe<OrderDirectionEnum>;
};

export enum DurRejectAction {
  /** 3 */
  Hard = 'HARD',
  /** 1 */
  Message = 'MESSAGE',
  /** 0 */
  Off = 'OFF',
  /** 2 */
  Soft = 'SOFT'
}

/** Which store served a claim */
export enum DataSource {
  Portal = 'PORTAL',
  Zebra = 'ZEBRA'
}

export enum DataSourceEnum {
  Portal = 'PORTAL',
  Zebra = 'ZEBRA'
}

export type DateFilter = {
  /** Equal */
  eq?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than */
  gt?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than or equal */
  gte?: InputMaybe<Scalars['Date']['input']>;
  /** Matches rows where the column IS NULL (true) or IS NOT NULL (false) */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than */
  lt?: InputMaybe<Scalars['Date']['input']>;
  /** Less than or equal */
  lte?: InputMaybe<Scalars['Date']['input']>;
  /** Not equal */
  ne?: InputMaybe<Scalars['Date']['input']>;
};

export enum DaysSupplyEnum {
  Ninety = 'NINETY',
  Thirty = 'THIRTY'
}

/** Non-currency decimal: quantities and doses (maxScriptQty, maxDailyDose). */
export type DecimalClaimInstruction = ClaimInstruction & {
  __typename?: 'DecimalClaimInstruction';
  field: MpaClaimInstructionField;
  floatValue: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isEmpty: Scalars['Boolean']['output'];
};

export type DefaultPlan = {
  __typename?: 'DefaultPlan';
  benCapSatisfactionType?: Maybe<SatisfactionType>;
  dedSatisfactionType?: Maybe<SatisfactionType>;
  effectiveDate: Scalars['Date']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  familyBenCap?: Maybe<Scalars['Cents']['output']>;
  familyDed?: Maybe<Scalars['Cents']['output']>;
  familyOop?: Maybe<Scalars['Cents']['output']>;
  id: Scalars['ID']['output'];
  individualBenCap?: Maybe<Scalars['Cents']['output']>;
  individualDed?: Maybe<Scalars['Cents']['output']>;
  individualOop?: Maybe<Scalars['Cents']['output']>;
  oopSatisfactionType?: Maybe<SatisfactionType>;
  plan: Plan;
};

export type DeleteAltCardIdInput = {
  altCardID: Scalars['String']['input'];
  cardholderKey: CardholderKey;
};

export type DeleteDurProgramDetailInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDrugListItemInputV2 = {
  customDrugListId: Scalars['ID']['input'];
  drugListItemId: Scalars['ID']['input'];
};

export type DeletePlanCodeScheduleImpactAssessment = {
  __typename?: 'DeletePlanCodeScheduleImpactAssessment';
  /**
   * Opaque token encoding the assessment state. Pass to groupDeletePlanCodeSchedule
   * to confirm automated subgroup detail deletion and coverage retraction.
   */
  assessmentToken: Scalars['String']['output'];
  /** Subgroups whose details would be deleted as part of this schedule deletion. */
  impactedSubgroups: Array<DeleteSubgroupScheduleImpact>;
};

/** Input for deleting a single schedule from an existing Plan Code. */
export type DeletePlanCodeScheduleInput = {
  /**
   * Token from groupAssessDeletePlanCodeScheduleImpact. When provided, the system
   * deletes anchored subgroup details and retracts coverage as described by the
   * assessment. If the assessment state has drifted, the mutation fails.
   * Required when the schedule has associated subgroup details.
   */
  assessmentToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * The database record ID (primary key) of the specific plan code schedule to delete.
   * Corresponds to PlanCodeV2.recordID.
   */
  recordID: Scalars['ID']['input'];
};

export type DeletePlanDurProgramInput = {
  id: Scalars['ID']['input'];
};

export type DeletePlanTestCaseInput = {
  /** The plan test case's unique identifier for existing test case */
  id: Scalars['ID']['input'];
};

export type DeletePlanTestCasesInput = {
  /** The plan test case's unique identifier for existing test case */
  ids: Array<Scalars['ID']['input']>;
};

export type DeletePlanTestCasesResponse = {
  __typename?: 'DeletePlanTestCasesResponse';
  /** The list of deleted plan test cases */
  planTestCases: Array<PlanTestCase>;
};

export type DeletePlanTestSuiteInput = {
  /** Delete plan test suite for specified benefit plan */
  benefit_plan_id: Scalars['ID']['input'];
};

export type DeleteProcessRuleInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSent835sInput = {
  /** Array of IDs of the Sent835s to be deleted. */
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteSubGroupInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSubgroupScheduleImpact = {
  __typename?: 'DeleteSubgroupScheduleImpact';
  /** Details that will be deleted for this subgroup. */
  deletedDetails: Array<ZebraSubgroupDetail>;
  /** The synced subgroup impacted by the schedule deletion. */
  subgroup: SyncedSubgroup;
  /** Whether removing these details will cascade-delete the subgroup itself (zero remaining details). */
  subgroupWillBeDeleted: Scalars['Boolean']['output'];
};

export type Department = {
  __typename?: 'Department';
  code: Scalars['String']['output'];
  group: Group;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type DepartmentConnection = {
  __typename?: 'DepartmentConnection';
  count: Scalars['Int']['output'];
  edges: Array<DepartmentEdge>;
  pageInfo: PageInfo;
};

export type DepartmentEdge = {
  __typename?: 'DepartmentEdge';
  cursor: Scalars['String']['output'];
  node: Department;
};

export type DepartmentFilter = {
  code?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type DepartmentList = {
  __typename?: 'DepartmentList';
  pagination: Pagination;
  results?: Maybe<Array<Department>>;
};

export type DepartmentOrder = {
  code?: InputMaybe<OrderDirectionEnum>;
  created_at?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export type DependentAccess = Node & {
  __typename?: 'DependentAccess';
  canRequestConsent: Scalars['Boolean']['output'];
  canRevokeConsent: Scalars['Boolean']['output'];
  consentType: ConsentType;
  dependent: Member;
  id: Scalars['ID']['output'];
  status: DependentAccessStatus;
};

export type DependentAccessConnection = {
  __typename?: 'DependentAccessConnection';
  edges: Array<DependentAccessEdge>;
  pageInfo: PageInfo;
};

export type DependentAccessEdge = {
  __typename?: 'DependentAccessEdge';
  cursor: Scalars['String']['output'];
  node: DependentAccess;
};

export enum DependentAccessStatus {
  ConsentPending = 'CONSENT_PENDING',
  ConsentRequired = 'CONSENT_REQUIRED',
  FullAccess = 'FULL_ACCESS',
  NotEligible = 'NOT_ELIGIBLE'
}

/** DependentRelationshipEnum values are lowercase on purpose. */
export enum DependentRelationshipEnum {
  Child = 'child',
  Other = 'other',
  Spouse = 'spouse'
}

export type DesignatedPharmacy = {
  __typename?: 'DesignatedPharmacy';
  groupUuid: Scalars['ID']['output'];
  hierarchy: DesignatedPharmacyHierarchyType;
  id: Scalars['ID']['output'];
  networkType: DesignatedPharmacyNetworkType;
  npi: Scalars['ID']['output'];
  offer90DaySupply: Scalars['Boolean']['output'];
  pharmacy?: Maybe<PharmacyV2>;
};

export type DesignatedPharmacyDetailInput = {
  groupUuid: Scalars['ID']['input'];
  hierarchy?: InputMaybe<DesignatedPharmacyHierarchyType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  networkType?: InputMaybe<DesignatedPharmacyNetworkType>;
  npi?: InputMaybe<Scalars['ID']['input']>;
  offer90DaySupply?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DesignatedPharmacyFilter = {
  groupUuid?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  networkType?: InputMaybe<StringFilter>;
  npi?: InputMaybe<StringFilter>;
};

export enum DesignatedPharmacyFror {
  No = 'NO',
  YesCustom = 'YES_CUSTOM',
  YesSpecialtyLdd = 'YES_SPECIALTY_LDD',
  YesSpecialtyOnly = 'YES_SPECIALTY_ONLY',
  YesSpecialtyTraditional = 'YES_SPECIALTY_TRADITIONAL',
  YesSpecialtyTraditionalLdd = 'YES_SPECIALTY_TRADITIONAL_LDD',
  YesTraditionalOnly = 'YES_TRADITIONAL_ONLY'
}

export enum DesignatedPharmacyHierarchyType {
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  P4 = 'P4'
}

export enum DesignatedPharmacyNetworkType {
  Designated_340B = 'DESIGNATED_340B',
  DesignatedMail = 'DESIGNATED_MAIL',
  DesignatedMailRetail = 'DESIGNATED_MAIL_RETAIL',
  DesignatedRetail = 'DESIGNATED_RETAIL',
  DesignatedSpeciality = 'DESIGNATED_SPECIALITY'
}

export type DispenseFeeHandler = {
  __typename?: 'DispenseFeeHandler';
  created: Scalars['Time']['output'];
  dispenseFeeHandlerDetails?: Maybe<Array<DispenseFeeHandlerDetail>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Time']['output']>;
};

export type DispenseFeeHandlerConnection = {
  __typename?: 'DispenseFeeHandlerConnection';
  edges: Array<DispenseFeeHandlerEdge>;
  pageInfo: PageInfo;
};

export type DispenseFeeHandlerDetail = {
  __typename?: 'DispenseFeeHandlerDetail';
  created: Scalars['Time']['output'];
  dispenseFeeHandlerTiers?: Maybe<Array<DispenseFeeHandlerTier>>;
  dispenseFeeHandlerUUID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tierBasis?: Maybe<TierBasis>;
  type?: Maybe<HandlerDetailType>;
  updated?: Maybe<Scalars['Time']['output']>;
  useLesserSubCalc?: Maybe<Scalars['Boolean']['output']>;
  useSubmittedFee?: Maybe<Scalars['Boolean']['output']>;
};

export type DispenseFeeHandlerDetailUpsertInput = {
  dispenseFeeHandlerTiers?: InputMaybe<Array<DispenseFeeHandlerTierUpsertInput>>;
  dispenseFeeHandlerTiersToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  dispenseFeeHandlerUUID: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  tierBasis?: InputMaybe<TierBasis>;
  type?: InputMaybe<HandlerDetailType>;
  useLesserSubCalc?: InputMaybe<Scalars['Boolean']['input']>;
  useSubmittedFee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispenseFeeHandlerEdge = {
  __typename?: 'DispenseFeeHandlerEdge';
  cursor: Scalars['String']['output'];
  node: DispenseFeeHandler;
};

export type DispenseFeeHandlerFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type DispenseFeeHandlerOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export type DispenseFeeHandlerTier = {
  __typename?: 'DispenseFeeHandlerTier';
  created: Scalars['Time']['output'];
  dispenseFeeHandlerDetailUUID: Scalars['ID']['output'];
  dollars?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  macIncentive?: Maybe<Scalars['Float']['output']>;
  tierMax?: Maybe<Scalars['Int']['output']>;
  tierMin?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Time']['output']>;
};

export type DispenseFeeHandlerTierUpsertInput = {
  dispenseFeeHandlerDetailUUID?: InputMaybe<Scalars['ID']['input']>;
  dollars?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  macIncentive?: InputMaybe<Scalars['Float']['input']>;
  tierMax?: InputMaybe<Scalars['Int']['input']>;
  tierMin?: InputMaybe<Scalars['Int']['input']>;
};

export type DispenseFeeHandlerUpsertInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DispenseLimitHandler = {
  __typename?: 'DispenseLimitHandler';
  created: Scalars['Time']['output'];
  dispenseLimitHandlerDetails?: Maybe<Array<DispenseLimitHandlerDetail>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated?: Maybe<Scalars['Time']['output']>;
};

export type DispenseLimitHandlerConnection = {
  __typename?: 'DispenseLimitHandlerConnection';
  edges: Array<DispenseLimitHandlerEdge>;
  pageInfo: PageInfo;
};

export type DispenseLimitHandlerDetail = {
  __typename?: 'DispenseLimitHandlerDetail';
  auxCode: AuxCode;
  created: Scalars['Time']['output'];
  dispenseLimitHandlerUUID: Scalars['ID']['output'];
  eachMaxDaysSupply?: Maybe<Scalars['Int']['output']>;
  eachMaxQuantity?: Maybe<Scalars['Float']['output']>;
  eachMinDaysSupply?: Maybe<Scalars['Int']['output']>;
  eachMinQuantity?: Maybe<Scalars['Float']['output']>;
  gramsMaxDaysSupply?: Maybe<Scalars['Int']['output']>;
  gramsMaxQuantity?: Maybe<Scalars['Float']['output']>;
  gramsMinDaysSupply?: Maybe<Scalars['Int']['output']>;
  gramsMinQuantity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  limitType: DispenseLimitType;
  mlMaxDaysSupply?: Maybe<Scalars['Int']['output']>;
  mlMaxQuantity?: Maybe<Scalars['Float']['output']>;
  mlMinDaysSupply?: Maybe<Scalars['Int']['output']>;
  mlMinQuantity?: Maybe<Scalars['Float']['output']>;
  type: HandlerDetailType;
  updated?: Maybe<Scalars['Time']['output']>;
};

export type DispenseLimitHandlerEdge = {
  __typename?: 'DispenseLimitHandlerEdge';
  cursor: Scalars['String']['output'];
  node: DispenseLimitHandler;
};

export type DispenseLimitHandlerFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type DispenseLimitHandlerOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export enum DispenseLimitType {
  /** 1 - Both D/S and Quantity limits */
  Both = 'BOTH',
  /** 2 - Either D/S or Quantity limits */
  Either = 'EITHER',
  /** 3 - Ration Quantity to Max Days Supply */
  Ration = 'RATION',
  /** 0 - Do not enforce limits */
  Skip = 'SKIP'
}

export enum DispenserClass {
  N01IndependentPharmacy = 'N01_INDEPENDENT_PHARMACY',
  N02ChainPharmacy = 'N02_CHAIN_PHARMACY',
  N05FranchisePharmacy = 'N05_FRANCHISE_PHARMACY',
  N06GovernmentPharmacy = 'N06_GOVERNMENT_PHARMACY',
  N07AlternateDispensingSite = 'N07_ALTERNATE_DISPENSING_SITE'
}

export type Doctor = {
  __typename?: 'Doctor';
  address_1: Scalars['String']['output'];
  address_2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  dea_code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  npi: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

/**
 * Captures details of document requests.
 * See https://docs.google.com/document/d/1oEsrUZncFoYQe1T0CtrPjE0yaKkEcGgA7XHKPmUWYuk/edit
 */
export type DocumentRequest = {
  __typename?: 'DocumentRequest';
  /** The timestamp when the document request was created */
  createdAt: Scalars['Time']['output'];
  /** The description of the document request */
  description: Scalars['String']['output'];
  /** The request's unique identifier */
  id: Scalars['ID']['output'];
  /** Tracks the reference to a document uploaded by a member. Null if none has been uploaded. */
  memberUpload?: Maybe<DocumentRequestFileReference>;
  /** Tracks the reference to a document uploaded by a specialist. Null if none has been uploaded. */
  specialistUpload?: Maybe<DocumentRequestFileReference>;
  /** The status of the document request */
  status: DocumentRequestStatusEnum;
  /** The title of the document request */
  title: Scalars['String']['output'];
  /** The type of the document requested */
  type: Scalars['String']['output'];
  /** The timestamp when the document request was last updated */
  updatedAt: Scalars['Time']['output'];
};

export type DocumentRequestFileReference = {
  __typename?: 'DocumentRequestFileReference';
  /** The name of the file */
  filename: Scalars['String']['output'];
  /** The unique identifier of the file */
  id: Scalars['ID']['output'];
  /** The timestamp when the file was uploaded */
  uploadedAt: Scalars['Time']['output'];
  /** The location of the file */
  url: Scalars['String']['output'];
};

export enum DocumentRequestStatusEnum {
  PendingAutomatedReview = 'PENDING_AUTOMATED_REVIEW',
  PendingMemberUpload = 'PENDING_MEMBER_UPLOAD',
  RejectedByAutomation = 'REJECTED_BY_AUTOMATION',
  UploadedByMember = 'UPLOADED_BY_MEMBER'
}

export enum DollarAction {
  /** 2 */
  AddOverflowToBenefit = 'ADD_OVERFLOW_TO_BENEFIT',
  /** 0 */
  AddOverflowToCopay = 'ADD_OVERFLOW_TO_COPAY',
  /** 1 */
  RejectClaim = 'REJECT_CLAIM'
}

export type DosageFormOption = {
  __typename?: 'DosageFormOption';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type DreddConfig = {
  /** hasHeader, hasFooter, etc */
  options?: InputMaybe<Scalars['Map']['input']>;
  parser: DreddParserConfig;
  transform: DreddTransformConfig;
  transmissionFormatID?: InputMaybe<Scalars['ID']['input']>;
};

export type DreddParserConfig = {
  /** Parser config, format dependent */
  config?: InputMaybe<Array<Scalars['Map']['input']>>;
  /**
   * File format
   *
   * supported -
   * dsv
   * x12
   * fixed-width
   */
  name: Scalars['String']['input'];
  /**
   * Parser options
   * eg - delimiter: ','
   */
  options?: InputMaybe<Scalars['Map']['input']>;
};

export type DreddTransformConfig = {
  config: Array<DreddTransformer>;
};

/**
 * An operation chained onto a field, applied to the result of the operation
 * before it rather than to the parsed line.
 */
export type DreddTransformOperation = {
  /**
   * Arguments to pass to the transformer, after the chained value
   * (changes depending on which callback is used)
   */
  args?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
  /**
   * The transformer that will be called
   * (src/jobs/normalizer/lib/callbacks.ts in dredd)
   */
  callback: Scalars['String']['input'];
};

export type DreddTransformer = {
  /**
   * Arguments to pass to the transformer
   * (changes depending on which callback is used)
   */
  args?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
  /**
   * The transformer that will be called
   * (src/jobs/normalizer/lib/callbacks.ts in dredd)
   */
  callback: Scalars['String']['input'];
  /** The description of the field */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the field */
  name: Scalars['String']['input'];
  /**
   * Further operations applied in order, each receiving the previous
   * operation's result. Omit for a single-operation field.
   */
  then?: InputMaybe<Array<DreddTransformOperation>>;
};

export type Drug = {
  __typename?: 'Drug';
  /** Date NDC was added to the database (this identifies new NDCs). */
  add_date?: Maybe<Scalars['Time']['output']>;
  /**
   * Name type code. Another way of classifying brands vs generics
   * T = Trademarked Brand
   * B = Branded Generic
   * G = Generic
   */
  bgt?: Maybe<Scalars['String']['output']>;
  /** Drug Descriptor Id: six digit code identifying a unique combination of Drug Name, Route, Dosage Form, Strength, and Strength Unit of Measure */
  dd_id?: Maybe<Scalars['String']['output']>;
  /** Classification of scheduled drugs */
  dea_class_code?: Maybe<Scalars['String']['output']>;
  /** Identifies the stage of review for drugs pending final resolutions of efficacy by FDA */
  desi?: Maybe<Scalars['String']['output']>;
  /** Date drug is discontinued (24 months after becoming Inactive).  Note: this date may be in the future. */
  discontinued_date?: Maybe<Scalars['Time']['output']>;
  /** The form in which the drug is administered (e.g. capsule, liquid, patch) */
  dosage_form_description?: Maybe<Scalars['String']['output']>;
  /** Drug name + extension (e.g. salt form) */
  drug_name_mddb?: Maybe<Scalars['String']['output']>;
  /** Formulation ID. GCN represents the clinical formulation; it is specific to active ingredient list, route of administration, dosage form, and drug strength. Main difference is that the GCN is 5-digits and doesn't split things like different medical supplies */
  gcn?: Maybe<Scalars['String']['output']>;
  /** Identifies whether the drug is used in males or females, or is not gender specific. 0 = neutral, 1 = exclusively male, 2 = most likely male, 3 = exclusively female, 4 = most likely female */
  gender?: Maybe<Scalars['String']['output']>;
  /** Identifies the generic version of the MEDID. When the MEDID already identifies a generic product, there is no GENERIC_MEDID */
  generic_med_id?: Maybe<Scalars['String']['output']>;
  /** Generic Product Identifier: 14-character hierarchical classification system that identifies drugs */
  gpi?: Maybe<Scalars['String']['output']>;
  /** Clinical Formulation ID. A unique GSN is assigned to each different combination of ingredient(s), strength, dosage form, and route of administration for a drug formulation. Customers are encouraged to use the Clinical Formulation ID (GCN_SEQNO aka GSN) instead of the Formulation ID (GCN) because of its greater specificity and its uniqueness to ingredient(s), dosage form, route, strength, and medical supplies. */
  gsn?: Maybe<Scalars['String']['output']>;
  /** Specific Therapeutic Class Code. Identifies the specific therapeutic class of an ingredient, a Clinical Formulation ID, or each ingredient in an Ingredient List */
  hic3?: Maybe<Scalars['String']['output']>;
  /** Description of HIC3 */
  hic3_description?: Maybe<Scalars['String']['output']>;
  /** This field is mapped from `ndc`. The field `id` on the drug table does not resolve this field. */
  id: Scalars['ID']['output'];
  /** Date drug became Inactive (Status 'I'). Null if Active. */
  inactive_date?: Maybe<Scalars['Time']['output']>;
  /**
   * Knowledge Base Drug Code (KDC) is a proprietary concept that defines a drug in terms of its ingredients. Single ingredient drugs (for example, acetaminophen) are assigned a KDC. Multiple ingredient drugs (for example, acetaminophen + hydrocodone) are assigned a  KDC that represents the ingredient combination.
   * The KDC is used by some of Wolters Kluwer Clinical Drug Information’s clinical databases, including drug-drug interaction and drug allergy screening.
   */
  kdc?: Maybe<Scalars['String']['output']>;
  /** Concatenation of drug name, route of administration, dosage form, strength, strength unit of measure as defined by MediSpan */
  label_name_mddb?: Maybe<Scalars['String']['output']>;
  /** MediSpan's classification of maintenance drugs */
  maintenance_mddb?: Maybe<Scalars['String']['output']>;
  /** The manufacturer of the NDC */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /**
   * An eight-character numeric column that identifies the unique combination of product or generic name, route of administration, dosage form, strength, and strength unit-of-measure. It is the most specific name concept in MedKnowledge. This column is a stable identifier.
   * There is a separate brand MEDID and generic MEDID. the generic MEDID is usually the same as the GSN.
   */
  med_id?: Maybe<Scalars['String']['output']>;
  /** Description of MEDID */
  med_id_description?: Maybe<Scalars['String']['output']>;
  /**
   * Multisource code. Smith typically defines M/O/N as brand and Y as generic
   * M = single source, co-licensed
   * O = original product, generics available (ie the branded version of a drug product with generic equivalents available)
   * N = single source, no generics available
   * Y = considered generic, multiple sources
   */
  mony?: Maybe<Scalars['String']['output']>;
  /** National Drug Code; unique identifier for a drug */
  ndc: Scalars['String']['output'];
  /** Number of units in a package */
  package_size?: Maybe<Scalars['Float']['output']>;
  /** Unit of measure for the drug (e.g. tablets/capsules are measured in EA (each), creams/ointments are measured in GM (grams), solutions and liquids are measured in ML (milliliters) */
  package_size_unit_of_measure?: Maybe<Scalars['String']['output']>;
  /** The pricing information for this drug. */
  prices?: Maybe<DrugPriceList>;
  /** Whether the drug has been repackaged from its original packaging. We would excluded repackaged drugs from formulary */
  repackage_code?: Maybe<Scalars['String']['output']>;
  /** The way the drug is administered */
  route_of_administration_mddb?: Maybe<Scalars['String']['output']>;
  /** MediSpan's classification of Rx vs OTC. O/P = OTC, R/S = Rx */
  rx_otc_mddb?: Maybe<Scalars['String']['output']>;
  /** Indicates the top drugs by prescription volume. 0 = Not ranked, 1 = 1-100, 2 = 101-200, etc */
  rx_rank?: Maybe<Scalars['String']['output']>;
  /** Identification of single vs combination drugs: 0 = Undetermined, 1 = combination, 2 = single */
  single_combo_code?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the drug is active or inactive. We would only include active drugs on formulary.
   *
   * A|Active
   * I|Inactive
   * O|Override
   * Z|Discontinued (Inactive > 24 months)
   *
   * When a query filters on Inactive, the query returns the union of Inactive, Override, and "Super Inactive" records.
   */
  status?: Maybe<Scalars['String']['output']>;
  /** Standard Therapeutic Class Code. Classifies drugs according to the most common intended use */
  stc?: Maybe<Scalars['String']['output']>;
  /** Description of STC */
  stc_description?: Maybe<Scalars['String']['output']>;
  /** Number value of the strength of the drug */
  strength?: Maybe<Scalars['String']['output']>;
  /** Units of the strength of the drug */
  strength_unit_of_measure?: Maybe<Scalars['String']['output']>;
  /**
   * Code indicating the FDA rating of the therapeutic equivalence of a drug product with
   * other pharmaceutically equivalent drug products, as published in the Orange
   * Book. This code is used in conjunction with GPI which groups pharmaceutically equivalent drug products.
   */
  tee_code?: Maybe<Scalars['String']['output']>;
  /** Date NDC was termed */
  term_date?: Maybe<Scalars['Time']['output']>;
  /** Identifies drug classes commonly excluded by payers */
  third_party_restriction?: Maybe<Scalars['String']['output']>;
  /** Total number of units in a container (which can contain multiple packages) */
  total_package_quantity?: Maybe<Scalars['Float']['output']>;
  /** Identifies whether drug is packaged as standard, unit dose, or unit of use */
  unit_dose_flag?: Maybe<Scalars['String']['output']>;
  /** The validity period for this record. */
  validity: Scalars['String']['output'];
};

/** One row of the Drug Catalog alternatives table. */
export type DrugAlternative = {
  __typename?: 'DrugAlternative';
  /**
   * Claims measures aggregated for this alternative's GPI. Null when DAS has no
   * claims analytics for the GPI.
   */
  claimsAnalytics?: Maybe<ClaimsAnalytics>;
  /**
   * Connect Program codes active for this drug, e.g. "PAP". May be incomplete
   * when enrichment is `PARTIAL`; empty when enrichment was not requested.
   */
  connectPrograms: Array<Scalars['String']['output']>;
  /**
   * Dispensed quantity as a numeric value (e.g. 30.0, 28.5). Derived from
   * claimsAnalytics.modalQuantity. Null when no claims data is available.
   */
  dispensedQuantityValue?: Maybe<Scalars['Float']['output']>;
  drugType: DrugAlternativeTypeEnum;
  /**
   * Formulary ID this package's coverage was resolved against. May be incomplete
   * when enrichment is `PARTIAL`; empty when enrichment was not requested.
   */
  formularyId: Scalars['String']['output'];
  /**
   * Formulary module codes active for this drug (e.g. "HCG", "NEB", "NEG").
   * Empty when no formularyId was supplied or enrichment was not requested.
   */
  formularyModules: Array<Scalars['String']['output']>;
  formularyStatus: FormularyStatusEnum;
  /** Generic Product Identifier, for cross-referencing against drug lists. */
  gpi: Scalars['String']['output'];
  /** Whether the drug is therapeutically interchangeable with the source drug. */
  interchangeable: Scalars['Boolean']['output'];
  /** Drug label name — the row's display name. */
  label: Scalars['String']['output'];
  /**
   * Package NDCs for this label present on this page, in the order DAS returned
   * them. DAS returns one row per package NDC; rows sharing the same label name
   * are grouped here so each label appears once per page.
   *
   * Note: grouping is per-page — a label whose packages span multiple DAS pages
   * may appear on more than one page with a partial NDC list each time.
   * totalCount reflects the upstream NDC count before grouping.
   */
  ndcs: Array<Scalars['String']['output']>;
  /** Whether prior authorization is required. False when coverage was not resolved. */
  paRequired: Scalars['Boolean']['output'];
  routeOfAdministration: Scalars['String']['output'];
  /** Whether step therapy is required. False when coverage was not resolved. */
  stRequired: Scalars['Boolean']['output'];
  /** Therapeutic substitution group the drug belongs to, for the UI's grouping. */
  substitutionGroupNumber: Scalars['Int']['output'];
  /**
   * Formulary tier. Null when the drug is not on the formulary (render "NF") or
   * when coverage was not resolved — `formularyStatus` distinguishes the two.
   *
   * Tier 99 marks an excluded drug and is never returned: an excluded drug is not
   * an alternative anyone can be switched to, so the row is dropped entirely.
   */
  tier?: Maybe<Scalars['Int']['output']>;
};

/** Brand/generic classification of an alternative. */
export enum DrugAlternativeTypeEnum {
  Biosimilar = 'BIOSIMILAR',
  Brand = 'BRAND',
  Generic = 'GENERIC',
  /**
   * The upstream classification was absent or is newer than this build. Render as
   * unknown rather than guessing brand or generic.
   */
  Unknown = 'UNKNOWN'
}

/** Filters and pagination for the `drugAlternatives` query. */
export type DrugAlternativesInput = {
  /** Restricts results to drugs in these Connect Programs, e.g. "PAP" or "CPM-T". */
  drugPrograms?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restricts results to these classifications. Omitted means no restriction. */
  drugTypes?: InputMaybe<Array<DrugAlternativeTypeEnum>>;
  /**
   * Formulary to resolve coverage against. When omitted, no coverage enrichment is
   * performed and `enrichmentStatus` is `NONE` — every alternative comes back with
   * an unknown formulary status and no tier.
   */
  formularyId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Narrows alternatives to those treating these indications. Values are the
   * `indicationKey` of a `DrugIndication` from the `drugIndications` query, sent
   * back verbatim — do not parse or reformat them. Empty or omitted means every
   * indication for the drug.
   *
   * Replaces the numeric indication ids the contract deprecated in v0.2.0.
   */
  indicationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  interchangeable?: InputMaybe<InterchangeableFilterEnum>;
  /** Page size. Defaults to 50; values above 200 are rejected as a bad request. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The drug to find alternatives for. Must be exactly 11 digits; anything else is
   * a validation error, not a server error.
   */
  ndc: Scalars['String']['input'];
  /** Rows to skip. Defaults to 0. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Restricts results to these routes of administration, e.g. "ORAL". Matched
   * case-insensitively.
   */
  routesOfAdministration?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filters returned alternatives by formulary tier codes. Requires `formularyId`;
   * omitted or empty means no tier filter.
   */
  tiers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Sort for the `drugAlternatives` query. Defaults to `DRUG_TYPE` ascending. */
export type DrugAlternativesOrder = {
  direction?: InputMaybe<OrderDirectionEnum>;
  field?: InputMaybe<DrugAlternativesSortFieldEnum>;
};

/**
 * A page of drug alternatives.
 *
 * Offset-paginated rather than a Relay connection because that is the shape of the
 * upstream contract (limit, offset, total count, has more) and because the Drug
 * Catalog table is a numbered pager over a bounded result set rather than an
 * infinite feed.
 */
export type DrugAlternativesResponse = {
  __typename?: 'DrugAlternativesResponse';
  /**
   * Version of the alternatives resolution logic that produced this response, so a
   * support question about a surprising result can be tied to the rules behind it.
   */
  adapterVersion: Scalars['String']['output'];
  alternatives: Array<DrugAlternative>;
  /**
   * How complete the coverage enrichment is. Check this before trusting the
   * coverage columns — `PARTIAL` means fields may be incomplete, not that the drug
   * is uncovered.
   */
  enrichmentStatus: EnrichmentStatusEnum;
  /**
   * Whether another DAS page follows this one. Offset pagination, including total
   * count and has-more semantics, is preserved exactly from the upstream response;
   * the API does not group rows across pages.
   */
  hasMore: Scalars['Boolean']['output'];
  /** Page size actually applied. */
  limit: Scalars['Int']['output'];
  /** Offset actually applied. */
  offset: Scalars['Int']['output'];
  sourceDrug: SourceDrug;
  /**
   * Total package alternatives matching the filters, across all pages, exactly as
   * reported by DAS. It may include tier-99 packages that are excluded from the
   * returned page.
   */
  totalCount: Scalars['Int']['output'];
};

/** Column the alternatives list is ordered by. */
export enum DrugAlternativesSortFieldEnum {
  /**
   * Default. Orders generics ahead of brands, which is the order the Drug Catalog
   * leads with.
   */
  DrugType = 'DRUG_TYPE',
  LabelName = 'LABEL_NAME'
}

/** Represents a drug together with its availability status at a given pharmacy. */
export type DrugAvailability = {
  __typename?: 'DrugAvailability';
  /** Whether the drug is available at this pharmacy. */
  available: Scalars['Boolean']['output'];
  /** Reason why the drug is available or unavailable. */
  details?: Maybe<Scalars['String']['output']>;
  /** The drug matching the search criteria. */
  drug?: Maybe<DrugV2>;
  /**
   * Opaque, encrypted unique identifier for this drug-at-pharmacy availability.
   * It encodes the pharmacy and drug, and — when availability is resolved for a
   * specific member — that member's plan formulary (not the member), because a
   * drug's availability can differ by plan, so the pharmacy+drug alone is not
   * unique across results for different plans.
   *
   * Do NOT log this ID: it is a stable, member-resolvable identifier and is
   * treated as PHI. Services consuming this field must not write it to logs.
   */
  id: Scalars['ID']['output'];
};

/**
 * Filter for the drugAvailability query: the NDCs to check, with an optional
 * member context that scopes specialty status to a member's plan formulary.
 */
export type DrugAvailabilityFilter = {
  /**
   * The portal member (membership) UUID. When provided, a drug's specialty status
   * is resolved against that member's plan formulary instead of the global
   * formulary.
   */
  memberId?: InputMaybe<Scalars['ID']['input']>;
  /** The NDCs to check availability for. A filter selecting no NDCs checks nothing. */
  ndc?: InputMaybe<StringFilter>;
};

export type DrugComparison = {
  __typename?: 'DrugComparison';
  ndc: Scalars['String']['output'];
  new_coverage: Scalars['String']['output'];
  old_coverage: Scalars['String']['output'];
};

export type DrugConnectionV2 = {
  __typename?: 'DrugConnectionV2';
  edges: Array<DrugEdgeV2>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DrugCoverageCopayInput = {
  /** The UUID of the benefit plan for which we're looking up coverage */
  benefit_plan_id?: InputMaybe<Scalars['ID']['input']>;
  channel?: InputMaybe<ChannelEnum>;
  copay_coverage?: InputMaybe<CopayCoverageEnum>;
  days_supply?: InputMaybe<Scalars['Int']['input']>;
  /** Search Drugs by name, NDC or GPI */
  drug_composite?: InputMaybe<StringFilter>;
  /** Drug Filter for removing discontinued drugs (true removes) */
  drug_filter_discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  /** Drug Filter for removing repackaged drugs (true removes) */
  drug_filter_repackaged?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exact match on drug GPI */
  gpi?: InputMaybe<Scalars['String']['input']>;
  /** Starts with match on drug HIC3 */
  hic3?: InputMaybe<Scalars['String']['input']>;
  /** Starts with match on drug label name (FDB) */
  label_name?: InputMaybe<Scalars['String']['input']>;
  /** Exact match on drug NDC */
  ndc?: InputMaybe<Scalars['String']['input']>;
  /**
   * The unique code of the plan design
   * DEPRECATED: should only be used for old DCC, will be ignored by new benefit plan based DCC
   */
  plan_design_code?: InputMaybe<Scalars['String']['input']>;
  single_combo?: InputMaybe<SingleComboEnum>;
  /** The Super Network UUID */
  super_network_id?: InputMaybe<Scalars['ID']['input']>;
};

export type DrugCoverageCopayOrder = {
  age_lower_limit?: InputMaybe<OrderDirectionEnum>;
  age_upper_limit?: InputMaybe<OrderDirectionEnum>;
  bgt?: InputMaybe<OrderDirectionEnum>;
  category?: InputMaybe<OrderDirectionEnum>;
  copay?: InputMaybe<OrderDirectionEnum>;
  copay_exception?: InputMaybe<OrderDirectionEnum>;
  coverage?: InputMaybe<OrderDirectionEnum>;
  coverage_notes?: InputMaybe<OrderDirectionEnum>;
  gender?: InputMaybe<OrderDirectionEnum>;
  gpi?: InputMaybe<OrderDirectionEnum>;
  hic3?: InputMaybe<OrderDirectionEnum>;
  is_health_care_reform?: InputMaybe<OrderDirectionEnum>;
  is_prior_auth?: InputMaybe<OrderDirectionEnum>;
  is_specialty?: InputMaybe<OrderDirectionEnum>;
  is_step_therapy?: InputMaybe<OrderDirectionEnum>;
  label_name_mddb?: InputMaybe<OrderDirectionEnum>;
  list_name?: InputMaybe<OrderDirectionEnum>;
  maintenance_mddb?: InputMaybe<OrderDirectionEnum>;
  mandatory_mail?: InputMaybe<OrderDirectionEnum>;
  med_id?: InputMaybe<OrderDirectionEnum>;
  mony?: InputMaybe<OrderDirectionEnum>;
  ndc?: InputMaybe<OrderDirectionEnum>;
  quantity_limit_count?: InputMaybe<OrderDirectionEnum>;
  route_of_administration_mddb?: InputMaybe<OrderDirectionEnum>;
  rx_otc_mddb?: InputMaybe<OrderDirectionEnum>;
  single_combo_code?: InputMaybe<OrderDirectionEnum>;
  tier?: InputMaybe<OrderDirectionEnum>;
};

export type DrugEdgeV2 = {
  __typename?: 'DrugEdgeV2';
  cursor: Scalars['String']['output'];
  node: DrugV2;
};

export type DrugFilterV2 = {
  /** Composite search across drug name, NDC, and GPI */
  composite?: InputMaybe<StringFilter>;
  drugName?: InputMaybe<StringFilter>;
  gpi?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  ndc?: InputMaybe<StringFilter>;
};

export type DrugFilters = {
  drug_name_mddb?: InputMaybe<StringFilter>;
  filter_discontinued?: InputMaybe<BooleanFilter>;
  gcn?: InputMaybe<StringFilter>;
  gpi?: InputMaybe<StringFilter>;
  hic3?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  includeTermed?: InputMaybe<BooleanFilter>;
  label_name_mddb?: InputMaybe<StringFilter>;
  med_id?: InputMaybe<StringFilter>;
  ndc?: InputMaybe<StringFilter>;
  repackage_code?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type DrugGpi = {
  __typename?: 'DrugGpi';
  /** This field is mapped from `tc_gpi_key`. The field `id` on the drug gpi table does not resolve this field. */
  id: Scalars['ID']['output'];
  /** LastChangeDate: identifies the most recent build date where any field in the record was changed. */
  last_change_date: Scalars['Time']['output'];
  /** RecordTypeCode: indicates the level of the TC-GPI Name; discrete values of 2, 4, 6, 8, 10, 12, and 14 corresponding to the length of the GPI. */
  record_type_code: Scalars['String']['output'];
  /** TCGPIKey: The GPI denotes pharmaceutically equivalent drug products. Products having the same 14-character GPI are identical with respect to active ingredient(s), dosage form, route, and strength or concentration. */
  tc_gpi_key: Scalars['String']['output'];
  /** TCGPIName: Text description of the various levels of the classification system. */
  tc_gpi_name?: Maybe<Scalars['String']['output']>;
  /** TCLevelCode: defines the level of the therapeutic classification hierarchy based on the number of significant characters that are defined. */
  tc_level_code?: Maybe<Scalars['String']['output']>;
  /** TransactionCD: indicates the file activity that last occurred for a record. */
  transaction_cd?: Maybe<Scalars['String']['output']>;
};

export type DrugGpiFilters = {
  id?: InputMaybe<IdFilter>;
  last_change_date?: InputMaybe<StringFilter>;
  record_type_code?: InputMaybe<StringFilter>;
  tc_gpi_key?: InputMaybe<StringFilter>;
  tc_gpi_name?: InputMaybe<StringFilter>;
};

export type DrugGpiList = {
  __typename?: 'DrugGpiList';
  pagination: Pagination;
  results: Array<DrugGpi>;
};

export type DrugGpiOrder = {
  last_change_date?: InputMaybe<OrderDirectionEnum>;
  record_type_code?: InputMaybe<OrderDirectionEnum>;
  tc_gpi_key?: InputMaybe<OrderDirectionEnum>;
  tc_gpi_name?: InputMaybe<OrderDirectionEnum>;
};

/**
 * One indication a drug is prescribed for. Populates the Drug Catalog's indication
 * filter dropdown, whose selections are passed back as `indicationKeys` when the
 * alternatives query runs.
 */
export type DrugIndication = Node & {
  __typename?: 'DrugIndication';
  /**
   * GID over the NDC and the upstream indication_key. Both are part of the identity:
   * indication_key identifies the indication, not the drug-indication pairing, so
   * two drugs sharing an indication would collide in a Relay cache keyed by `id`.
   */
  id: Scalars['ID']['output'];
  /**
   * Opaque composite of the indication, restriction, microorganism and ICD-10 codes.
   * Send it back verbatim as `indicationKeys`; do not parse or reformat it. Replaces
   * the numeric indication_id, deprecated upstream in v0.2.0.
   */
  indicationKey: Scalars['String']['output'];
  /**
   * True when the indication was reached through a proxy relationship rather than
   * being stated directly for the drug.
   */
  isProxy: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/**
 * UDT's drug entity, owned by the `udt-drug` subgraph.
 *
 * `resolvable: false` declares that portal-legacy can produce this entity's key but
 * resolves none of its fields: gqlgen generates no entity resolver for it, and the
 * router fetches every selection beyond `ndc` from UDT. Code here only ever
 * populates the key.
 *
 * Router callers get all of UDT's fields without them being declared here. Declare
 * one only as `@external`, when this subgraph `@requires` it: portal-api can't
 * resolve it itself.
 */
export type DrugInfo = {
  __typename?: 'DrugInfo';
  ndc: Scalars['String']['output'];
};

export type DrugList = {
  __typename?: 'DrugList';
  pagination: Pagination;
  results: Array<Drug>;
};

export type DrugListItemConnectionV2 = {
  __typename?: 'DrugListItemConnectionV2';
  edges: Array<DrugListItemEdgeV2>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DrugListItemEdgeV2 = {
  __typename?: 'DrugListItemEdgeV2';
  cursor: Scalars['String']['output'];
  node: DrugListItemV2;
};

export type DrugListItemFiltersV2 = {
  customDrugListId?: InputMaybe<IdFilter>;
  description?: InputMaybe<StringFilter>;
  idType?: InputMaybe<StringFilter>;
  mony?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<TimeFilter>;
  value?: InputMaybe<StringFilter>;
};

export type DrugListItemOrderV2 = {
  deaClass?: InputMaybe<OrderDirectionEnum>;
  description?: InputMaybe<OrderDirectionEnum>;
  effectiveAt?: InputMaybe<OrderDirectionEnum>;
  expiresAt?: InputMaybe<OrderDirectionEnum>;
  gpi?: InputMaybe<OrderDirectionEnum>;
  mony?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  ndc?: InputMaybe<OrderDirectionEnum>;
  type?: InputMaybe<OrderDirectionEnum>;
  updatedAt?: InputMaybe<OrderDirectionEnum>;
  value?: InputMaybe<OrderDirectionEnum>;
};

export type DrugListItemV2 = {
  __typename?: 'DrugListItemV2';
  createdAt: Scalars['Time']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  customDrugListId: Scalars['ID']['output'];
  deaClass?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveAt?: Maybe<Scalars['Time']['output']>;
  expiresAt?: Maybe<Scalars['Time']['output']>;
  gpi?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mony?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ndc?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum DrugListStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export type DrugListUploadByIdInput = {
  /** The ID of the DrugListUpload */
  id: Scalars['ID']['input'];
};

export type DrugListUploadFiltersV2 = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type DrugListUploadV2Edge = {
  __typename?: 'DrugListUploadV2Edge';
  cursor: Scalars['String']['output'];
  node: CustomDrugListUpload;
};

export type DrugListUploadsV2Connection = {
  __typename?: 'DrugListUploadsV2Connection';
  edges: Array<DrugListUploadV2Edge>;
  pageInfo: PageInfo;
};

export type DrugOrder = {
  add_date?: InputMaybe<OrderDirectionEnum>;
  dosage_form_description?: InputMaybe<OrderDirectionEnum>;
  gcn?: InputMaybe<OrderDirectionEnum>;
  gender?: InputMaybe<OrderDirectionEnum>;
  gpi?: InputMaybe<OrderDirectionEnum>;
  hic3?: InputMaybe<OrderDirectionEnum>;
  hic3_description?: InputMaybe<OrderDirectionEnum>;
  label_name_mddb?: InputMaybe<OrderDirectionEnum>;
  maintenance_mddb?: InputMaybe<OrderDirectionEnum>;
  manufacturer?: InputMaybe<OrderDirectionEnum>;
  medID?: InputMaybe<OrderDirectionEnum>;
  mony?: InputMaybe<OrderDirectionEnum>;
  ndc?: InputMaybe<OrderDirectionEnum>;
  package_size?: InputMaybe<OrderDirectionEnum>;
  package_size_unit_of_measure?: InputMaybe<OrderDirectionEnum>;
  route_of_administration_mddb?: InputMaybe<OrderDirectionEnum>;
  status?: InputMaybe<OrderDirectionEnum>;
  stc?: InputMaybe<OrderDirectionEnum>;
  stc_description?: InputMaybe<OrderDirectionEnum>;
  strength?: InputMaybe<OrderDirectionEnum>;
  strength_unit_of_measure?: InputMaybe<OrderDirectionEnum>;
  term_date?: InputMaybe<OrderDirectionEnum>;
  total_package_quantity?: InputMaybe<OrderDirectionEnum>;
};

export type DrugOrderV2 = {
  drugName?: InputMaybe<OrderDirectionEnum>;
  gpi?: InputMaybe<OrderDirectionEnum>;
  ndc?: InputMaybe<OrderDirectionEnum>;
};

export type DrugPrice = {
  __typename?: 'DrugPrice';
  /** AWP Package Price: Average wholesale price per package. */
  awp_package_price: Scalars['Float']['output'];
  /** AWP Unit Price Extended: Average wholesale price per unit, multiplied by quantity to get AWP total. */
  awp_unit_price_extended: Scalars['Float']['output'];
  /** Direct Package Price: Direct price per package. */
  direct_package_price?: Maybe<Scalars['Float']['output']>;
  /** DirectUnitPriceExtended: Direct price per unit, Direct Price is the manufacturer’s list price when sold to non-wholesalers. */
  direct_unit_price_extended?: Maybe<Scalars['Float']['output']>;
  /** EffectiveDate: Date that the price is effective. */
  effective_date: Scalars['Time']['output'];
  /** FUL Package Price: Federal Upper Limit price per package, used by Medicaid. */
  ful_package_price?: Maybe<Scalars['Float']['output']>;
  /** FUL Unit Price Extended: Federal Upper Limit price per unit, used by Medicaid. */
  ful_unit_price_extended?: Maybe<Scalars['Float']['output']>;
  /** This field is mapped from `ndc`. The field `id` on the drug price table does not resolve this field. */
  id: Scalars['ID']['output'];
  /** National Drug Code; unique identifier for a drug */
  ndc: Scalars['String']['output'];
  /** PACUnitPrice: Predictive acquisition cost. This is an estimate of pharmacy acquisition cost for the drug product and is important for MAC management. */
  pac_unit_price?: Maybe<Scalars['Float']['output']>;
  /** UnitDoseFulPackagePrice: Unit dose FUL price per package, used by Medicaid. */
  unit_dose_ful_package_price?: Maybe<Scalars['Float']['output']>;
  /** UnitDoseFulUnitPriceExtended:  Unit dose FUL price per unit, used by Medicaid. */
  unit_dose_ful_unit_price_extended?: Maybe<Scalars['Float']['output']>;
  /** The validity period for this record. */
  validity: Scalars['String']['output'];
  /** WAC Package Price: Wholesale acquisition cost per package. */
  wac_package_price?: Maybe<Scalars['Float']['output']>;
  /** WAC Unit Price Extended: Wholesale acquisition cost per unit, WAC is the manufacturer's list price when sold to wholesalers. */
  wac_unit_price_extended?: Maybe<Scalars['Float']['output']>;
};

export type DrugPriceList = {
  __typename?: 'DrugPriceList';
  pagination: Pagination;
  results: Array<DrugPrice>;
};

export type DrugPricingBreakdown = {
  __typename?: 'DrugPricingBreakdown';
  dispensingFee?: Maybe<Scalars['Cents']['output']>;
  incentiveFee?: Maybe<Scalars['Cents']['output']>;
  ingredientCost?: Maybe<Scalars['Cents']['output']>;
  memberCopay?: Maybe<Scalars['Cents']['output']>;
  otherAmountPaid?: Maybe<Scalars['Cents']['output']>;
  planPays?: Maybe<Scalars['Cents']['output']>;
  tax?: Maybe<Scalars['Cents']['output']>;
  total?: Maybe<Scalars['Cents']['output']>;
};

export type DrugPricingClaim = {
  __typename?: 'DrugPricingClaim';
  additionalMessages?: Maybe<Array<Scalars['String']['output']>>;
  authorizationNumber?: Maybe<Scalars['String']['output']>;
  claimID?: Maybe<Scalars['String']['output']>;
  dateOfService?: Maybe<Scalars['Date']['output']>;
  daysSupply?: Maybe<Scalars['Int']['output']>;
  isTest: Scalars['Boolean']['output'];
  pricing?: Maybe<DrugPricingBreakdown>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rejectCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Transaction status (P = paid, R = rejected) */
  status: Scalars['String']['output'];
  transactionID?: Maybe<Scalars['String']['output']>;
};

export type DrugPricingInput = {
  /** Card ID string sent directly to the adjudicator (e.g. TEST11111111). When provided, skips member lookup and groupID is derived from cardholder enrollments. */
  cardID?: InputMaybe<Scalars['String']['input']>;
  /** Portal cardholder UUID. Required unless cardID is provided. */
  cardholderID?: InputMaybe<Scalars['String']['input']>;
  /** Optional when cardholderID is provided (derived from member record). Required when using cardID directly. */
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dawCode?: InputMaybe<Scalars['Int']['input']>;
  daysSupply: Scalars['Int']['input'];
  /** Optional. When omitted, derived from member record or cardholder enrollments based on the service date. */
  groupID?: InputMaybe<Scalars['String']['input']>;
  includeDiscontinuedNdcs?: InputMaybe<Scalars['Boolean']['input']>;
  includeDiscontinuedPharmacies?: InputMaybe<Scalars['Boolean']['input']>;
  ndcs: Array<Scalars['String']['input']>;
  personCode: Scalars['String']['input'];
  pharmacyNpis: Array<Scalars['String']['input']>;
  /** Name of the selected plan structure. Null when using a custom member. */
  planStructure?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  rxDate?: InputMaybe<Scalars['Date']['input']>;
  rxWrittenDate?: InputMaybe<Scalars['Date']['input']>;
};

export type DrugPricingOrder = {
  drugName?: InputMaybe<OrderDirectionEnum>;
  gpi?: InputMaybe<OrderDirectionEnum>;
  ingredientCostCents?: InputMaybe<OrderDirectionEnum>;
  memberCopayCents?: InputMaybe<OrderDirectionEnum>;
  ndc?: InputMaybe<OrderDirectionEnum>;
  pharmacyName?: InputMaybe<OrderDirectionEnum>;
  pharmacyNpi?: InputMaybe<OrderDirectionEnum>;
  planPaysCents?: InputMaybe<OrderDirectionEnum>;
  taxCents?: InputMaybe<OrderDirectionEnum>;
  totalCents?: InputMaybe<OrderDirectionEnum>;
  totalFeesCents?: InputMaybe<OrderDirectionEnum>;
  units?: InputMaybe<OrderDirectionEnum>;
};

export type DrugPricingResponse = {
  __typename?: 'DrugPricingResponse';
  results: Array<DrugPricingResult>;
  totalCombinations: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
};

export type DrugPricingResult = {
  __typename?: 'DrugPricingResult';
  /** Claim result from adjudicator (null if adjudication failed entirely) */
  claim?: Maybe<DrugPricingClaim>;
  /** Dispensed quantity for the submitted quantity. This is the user-entered quantity; the client pairs it with the drug's package size unit of measure for display (e.g. "5 ML"). */
  dispensedQuantity?: Maybe<Scalars['Float']['output']>;
  /** Resolved drug details (null if NDC not found in system) */
  drug?: Maybe<DrugV2>;
  /** Whether this NDC is marked as discontinued in the drug database */
  isDiscontinuedNdc: Scalars['Boolean']['output'];
  /** Whether this pharmacy is inactive based on its effective/expiration dates */
  isDiscontinuedPharmacy: Scalars['Boolean']['output'];
  /** Resolved member */
  member?: Maybe<MemberV2>;
  /** NDC submitted */
  ndc: Scalars['String']['output'];
  /** Resolved pharmacy details (null if NPI not found in system) */
  pharmacy?: Maybe<PharmacyV2>;
  /** Pharmacy NPI submitted */
  pharmacyNpi: Scalars['String']['output'];
};

export type DrugProgram = {
  __typename?: 'DrugProgram';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum DrugType {
  /** 8 */
  CompoundCode = 'COMPOUND_CODE',
  /** 13 */
  DaysSupply = 'DAYS_SUPPLY',
  /** 7 */
  DeaClassCode = 'DEA_CLASS_CODE',
  /** 20 */
  DrugList = 'DRUG_LIST',
  /** 1 */
  Gpi = 'GPI',
  /** 5 */
  Manufacturer = 'MANUFACTURER',
  /** 9 */
  MemberId = 'MEMBER_ID',
  /** 0 */
  Ndc = 'NDC',
  /** -1 */
  NoValueCheckNeeded = 'NO_VALUE_CHECK_NEEDED',
  /** 4 */
  Roa = 'ROA',
  /** 6 */
  TherapyClassCode = 'THERAPY_CLASS_CODE',
  /** 3 */
  TpRest = 'TP_REST'
}

export type DrugV2 = {
  __typename?: 'DrugV2';
  brandCode: BrandCode;
  deaClassCode: DeaClass;
  desi: Scalars['String']['output'];
  dosageForm?: Maybe<Scalars['String']['output']>;
  drugName: Scalars['String']['output'];
  gcn: Scalars['String']['output'];
  gpi: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maintenance: Scalars['Boolean']['output'];
  mony: MonyCode;
  ndc: Scalars['String']['output'];
  packageSize?: Maybe<Scalars['Float']['output']>;
  packageSizeUom?: Maybe<Scalars['String']['output']>;
  roa?: Maybe<Scalars['String']['output']>;
  rxOtcInd: RxOtcInd;
  strength?: Maybe<Scalars['String']['output']>;
  strengthUom?: Maybe<Scalars['String']['output']>;
  totalPackageQuantity?: Maybe<Scalars['Float']['output']>;
};

export enum DrugValue {
  /** A */
  All = 'All',
  /** L */
  DrugList = 'DrugList',
  /** G */
  Gpi = 'GPI',
  /** M */
  Maintenance = 'Maintenance',
  /** N */
  Ndc = 'NDC'
}

export type EligFlag = {
  __typename?: 'EligFlag';
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type EligibilityFlag = {
  __typename?: 'EligibilityFlag';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type EligibilityReport = {
  __typename?: 'EligibilityReport';
  pagination: Pagination;
  results: Array<EligibilityReportRow>;
};

export type EligibilityReportFilters = {
  coverageEnd?: InputMaybe<TimeFilter>;
  coverageStart?: InputMaybe<TimeFilter>;
  groupId?: InputMaybe<IdFilter>;
  partnerId?: InputMaybe<IdFilter>;
};

export type EligibilityReportOrder = {
  membershipUuid?: InputMaybe<OrderDirectionEnum>;
};

export type EligibilityReportRow = {
  __typename?: 'EligibilityReportRow';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  cellPhone?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  coverageEnd?: Maybe<Scalars['Time']['output']>;
  coverageLevel: Scalars['String']['output'];
  coverageStart: Scalars['Time']['output'];
  dateOfBirth: Scalars['Time']['output'];
  divisionName: Scalars['String']['output'];
  employmentStart?: Maybe<Scalars['String']['output']>;
  gender: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  groupNumber: Scalars['String']['output'];
  homePhone?: Maybe<Scalars['String']['output']>;
  memberFirstName: Scalars['String']['output'];
  memberId: Scalars['ID']['output'];
  memberLastName: Scalars['String']['output'];
  memberMiddleName?: Maybe<Scalars['String']['output']>;
  memberSuffix?: Maybe<Scalars['String']['output']>;
  memberType: Scalars['String']['output'];
  otherPhone?: Maybe<Scalars['String']['output']>;
  personCode: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ppo?: Maybe<Scalars['String']['output']>;
  relationship: Scalars['String']['output'];
  ssn?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  workPhone?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

/**
 * A member's emergency contact.
 *
 * Every field is nullable because Zebra stores the three parts independently and does
 * not require any of them; a contact with only a phone number is valid.
 */
export type EmergencyContact = {
  __typename?: 'EmergencyContact';
  /** The contact's name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The contact's phone number. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The contact's relationship to the member, as stored, e.g. "spouse". */
  relationship?: Maybe<Scalars['String']['output']>;
};

/**
 * How much of the formulary and Connect Program enrichment completed.
 *
 * `PARTIAL` is a successful response with incomplete coverage data: the
 * alternatives resolved, but one or more enrichment sidecars did not answer in
 * time. Enrichment fields may be absent or incomplete, while fields that were
 * successfully resolved may still be present. Consumers must check
 * `enrichmentStatus` before relying on coverage fields and should render the list
 * with the coverage columns marked incomplete rather than showing an error.
 */
export enum EnrichmentStatusEnum {
  Complete = 'COMPLETE',
  /**
   * No enrichment was requested, because no `formularyId` was supplied. A
   * successful outcome, not a missing one.
   */
  None = 'NONE',
  Partial = 'PARTIAL',
  Unknown = 'UNKNOWN'
}

/** Single enum value (MPATier, MONYCode). code = wire value, label = display. */
export type EnumClaimInstruction = ClaimInstruction & {
  __typename?: 'EnumClaimInstruction';
  code: Scalars['String']['output'];
  field: MpaClaimInstructionField;
  id: Scalars['ID']['output'];
  isEmpty: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

export type Error = {
  message: Scalars['String']['output'];
};

export type EventLog = {
  __typename?: 'EventLog';
  data: Scalars['Map']['output'];
  message: Scalars['String']['output'];
  /**
   * Identifier of the processing rule (e.g., "07-LoadMemberHistory", "15-ApplyAgeLimits").
   * Previously an enum; now a string to accommodate dynamic rules from the adjudicator.
   * Format: "NN-RuleName" where NN is the execution order number.
   */
  rule: Scalars['String']['output'];
  time: Scalars['Time']['output'];
};

export type Exception = {
  __typename?: 'Exception';
  classification_type?: Maybe<Scalars['String']['output']>;
  copay_exceptions?: Maybe<Scalars['String']['output']>;
  coverage?: Maybe<Scalars['String']['output']>;
  coverage_notes?: Maybe<Scalars['String']['output']>;
  exception_list_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  matching_value?: Maybe<Scalars['String']['output']>;
  mony?: Maybe<ExceptionMonyEnum>;
  name: Scalars['String']['output'];
};

export type ExceptionFilters = {
  exception_list_id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ExceptionList = {
  __typename?: 'ExceptionList';
  exceptions: Array<Maybe<Exception>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: ExceptionListTypeEnum;
};

export type ExceptionListFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type ExceptionListOrder = {
  name?: InputMaybe<OrderDirectionEnum>;
  type?: InputMaybe<OrderDirectionEnum>;
};

export enum ExceptionListTypeEnum {
  BenefitCategories = 'BENEFIT_CATEGORIES',
  CustomList = 'CUSTOM_LIST',
  PreventativeList = 'PREVENTATIVE_LIST'
}

export enum ExceptionMonyEnum {
  M = 'M',
  N = 'N',
  O = 'O',
  Y = 'Y'
}

export type ExceptionOrder = {
  classification_type?: InputMaybe<OrderDirectionEnum>;
  copay_exceptions?: InputMaybe<OrderDirectionEnum>;
  coverage?: InputMaybe<OrderDirectionEnum>;
  exception_list_id?: InputMaybe<OrderDirectionEnum>;
  matching_value?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export type FamilyMember = {
  __typename?: 'FamilyMember';
  /** The viewed member's access to this family member's PHI. */
  accessToPhi?: Maybe<AccessToPhi>;
  /** The member's card ID */
  card_id: Scalars['String']['output'];
  /** The member's coverage end date */
  coverage_end?: Maybe<Scalars['Time']['output']>;
  /** The member's coverage level */
  coverage_level: MemberCoverageLevelEnum;
  /** The member's coverage start date */
  coverage_start?: Maybe<Scalars['Time']['output']>;
  /** The member's date of birth */
  date_of_birth: Scalars['Time']['output'];
  /** The member's first name */
  first_name: Scalars['String']['output'];
  /** The member's unique identifier */
  id: Scalars['ID']['output'];
  /** The member's last name */
  last_name: Scalars['String']['output'];
  /** The member's middle name */
  middle_name?: Maybe<Scalars['String']['output']>;
  /** The member's person uuid */
  personUUID: Scalars['ID']['output'];
  /** The member's person code */
  person_code: Scalars['String']['output'];
  /** The member's relationship to the subscriber */
  relationship_to_subscriber: MemberRelationshipEnum;
  /** The member's coverage status */
  status: MemberStatusEnum;
  /** The member's suffix */
  suffix?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FillRule = {
  __typename?: 'FillRule';
  fillRuleLines: Array<FillRuleLine>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Plans this fill rule is used in, one edge per plan_to_fill_rule row. */
  usedInPlans: PlanRelatedFillRuleConnection;
};


export type FillRuleUsedInPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<PlanRelatedFillRuleOrder>;
  where?: InputMaybe<PlanRelatedFillRuleFilters>;
};

export type FillRuleConnection = {
  __typename?: 'FillRuleConnection';
  edges: Array<FillRuleEdge>;
  pageInfo: PageInfo;
};

export type FillRuleEdge = {
  __typename?: 'FillRuleEdge';
  cursor: Scalars['String']['output'];
  node: FillRule;
};

export type FillRuleLine = {
  __typename?: 'FillRuleLine';
  RxOTCCode?: Maybe<RxOtcInd>;
  customDrugList?: Maybe<CustomDrugListV2>;
  description?: Maybe<Scalars['String']['output']>;
  dontApplyBeforeDate?: Maybe<Scalars['Date']['output']>;
  drugID?: Maybe<Scalars['String']['output']>;
  drugValue?: Maybe<DrugValue>;
  effectiveDate: Scalars['Date']['output'];
  excludeMOClaims?: Maybe<Scalars['Boolean']['output']>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  hxClaimsQuantityLessOrEqual?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<Scalars['Int']['output']>;
  monyCode: Array<MonyCode>;
  order?: Maybe<Scalars['Int']['output']>;
  periodType?: Maybe<PeriodType>;
  periodX?: Maybe<Scalars['Int']['output']>;
  profileMatchOn?: Maybe<Scalars['Int']['output']>;
  rule?: Maybe<FillRuleLineRuleType>;
  scriptTagMatchValue?: Maybe<Scalars['String']['output']>;
  trueProcessRule?: Maybe<ProcessRule>;
  trueProcessRulePriority?: Maybe<Scalars['Int']['output']>;
};

export enum FillRuleLineRuleType {
  /** 999 */
  Default = 'Default',
  /** 3 */
  LastScriptDaysSupply = 'LastScriptDaysSupply',
  /** 2 */
  MaxDaysSupply = 'MaxDaysSupply',
  /** 4 */
  Quantity = 'Quantity',
  /** 1 */
  ScriptsFilled = 'ScriptsFilled',
  /** 6 */
  UniqueFillDates = 'UniqueFillDates'
}

export type FillRuleRelatedProcessRule = Node & {
  __typename?: 'FillRuleRelatedProcessRule';
  fillRule: FillRule;
  fillRuleLine: FillRuleLine;
  id: Scalars['ID']['output'];
};

export type FillRuleRelatedProcessRuleConnection = {
  __typename?: 'FillRuleRelatedProcessRuleConnection';
  count: Scalars['Int']['output'];
  edges: Array<FillRuleRelatedProcessRuleEdge>;
  groups: GroupBucketConnection;
  pageInfo: PageInfo;
};


export type FillRuleRelatedProcessRuleConnectionGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  by: FillRuleRelatedProcessRuleGroupBy;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FillRuleRelatedProcessRuleEdge = {
  __typename?: 'FillRuleRelatedProcessRuleEdge';
  cursor: Scalars['String']['output'];
  node: FillRuleRelatedProcessRule;
};

export type FillRuleRelatedProcessRuleFilters = {
  fillRuleID?: InputMaybe<IdFilter>;
  fillRuleLineDescription?: InputMaybe<StringFilter>;
  fillRuleLineDrugValue?: InputMaybe<StringFilter>;
  fillRuleLinePriority?: InputMaybe<IntFilter>;
  fillRuleLineValue?: InputMaybe<StringFilter>;
  fillRuleName?: InputMaybe<StringFilter>;
  trueProcessRuleName?: InputMaybe<StringFilter>;
};

export enum FillRuleRelatedProcessRuleGroupBy {
  FillRuleId = 'FILL_RULE_ID',
  FillRuleLineDescription = 'FILL_RULE_LINE_DESCRIPTION',
  FillRuleLineDrugValue = 'FILL_RULE_LINE_DRUG_VALUE',
  FillRuleLinePriority = 'FILL_RULE_LINE_PRIORITY',
  FillRuleLineValue = 'FILL_RULE_LINE_VALUE',
  FillRuleName = 'FILL_RULE_NAME',
  TrueProcessRuleName = 'TRUE_PROCESS_RULE_NAME'
}

export type FillRuleRelatedProcessRuleOrder = {
  fillRuleLineDescription?: InputMaybe<OrderDirectionEnum>;
  fillRuleLineDrugValue?: InputMaybe<OrderDirectionEnum>;
  fillRuleLinePriority?: InputMaybe<OrderDirectionEnum>;
  fillRuleLineValue?: InputMaybe<OrderDirectionEnum>;
  fillRuleName?: InputMaybe<OrderDirectionEnum>;
  trueProcessRuleName?: InputMaybe<OrderDirectionEnum>;
};

export enum FilterComparatorV2 {
  /** Equal to */
  Eq = 'EQ',
  /** Greater than */
  Gt = 'GT',
  /** Greater than or equal to */
  Gte = 'GTE',
  /** In one of the values */
  In = 'IN',
  /** Less than */
  Lt = 'LT',
  /** Less than or equal to */
  Lte = 'LTE',
  /** Matches string */
  Match = 'MATCH',
  /** Not equal to */
  Neq = 'NEQ',
  /** Not in one of the values */
  Nin = 'NIN'
}

export enum FilterOperatorV2 {
  And = 'AND',
  Or = 'OR'
}

export type FloatFilter = {
  /** Equal */
  eq?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than */
  gt?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than or equal */
  gte?: InputMaybe<Scalars['Float']['input']>;
  /** In */
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Less than */
  lt?: InputMaybe<Scalars['Float']['input']>;
  /** Less than or equal */
  lte?: InputMaybe<Scalars['Float']['input']>;
  /** Not equal */
  ne?: InputMaybe<Scalars['Float']['input']>;
  /** Not in */
  nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FormulaResultSummary = {
  __typename?: 'FormulaResultSummary';
  basisDescType?: Maybe<CostBasisDescriptionType>;
  basisOfReimbursement: Scalars['Int']['output'];
  cost?: Maybe<Scalars['Float']['output']>;
  costListSummary?: Maybe<CostListSummary>;
  dispenseFee?: Maybe<Scalars['Float']['output']>;
  formula1OrFormula2: Scalars['String']['output'];
  formularyPercentage?: Maybe<Scalars['Float']['output']>;
  genSummary?: Maybe<CostCalcSummary>;
  macListName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  type: Scalars['Int']['output'];
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type Formulary = {
  __typename?: 'Formulary';
  /** The formulary's document link */
  document?: Maybe<Scalars['String']['output']>;
  /** List of drugs and it's flags contained in the formulary */
  drugs?: Maybe<FormularyDrugList>;
  id: Scalars['ID']['output'];
  /** The name of the formulary */
  name: Scalars['String']['output'];
  /** The formulary's step therapy document link, if formulary is Magellan */
  step_therapy_document?: Maybe<Scalars['String']['output']>;
  /** The version name of the formulary */
  version_name: Scalars['String']['output'];
};


export type FormularyDrugsArgs = {
  order?: InputMaybe<Array<FormularyDrugOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<FormularyDrugFilters>;
};

/** A single drug in a formulary and it's flags. */
export type FormularyDrug = {
  __typename?: 'FormularyDrug';
  /** Age limit lower limit (inclusive) */
  age_lower_limit?: Maybe<Scalars['Int']['output']>;
  /** Age limit upper limit (inclusive) */
  age_upper_limit?: Maybe<Scalars['Int']['output']>;
  /** Coverage Code flag */
  coverage_code?: Maybe<Scalars['String']['output']>;
  /** This is a Magellan-defined drug classification that allows them to create their own drug categories outside of the FDB/MDDB standardized categories */
  drug_class?: Maybe<Scalars['String']['output']>;
  /** Gender restriction */
  gender?: Maybe<Scalars['String']['output']>;
  /** Healthcare Reform category */
  health_care_reform_category?: Maybe<Scalars['String']['output']>;
  /** Healthcare Reform flag */
  is_health_care_reform?: Maybe<Scalars['Boolean']['output']>;
  /** Flag to identify expensive generics */
  is_high_cost_generic?: Maybe<Scalars['Boolean']['output']>;
  /** Medical Drug flag */
  is_medical_drug?: Maybe<Scalars['Boolean']['output']>;
  /** Flag to identify branded products that have more cost-effective alternatives */
  is_minimum_value_brand?: Maybe<Scalars['Boolean']['output']>;
  /** Flag to identify generic products that have more cost-effective alternatives */
  is_minimum_value_generic?: Maybe<Scalars['Boolean']['output']>;
  /** Flag to identify drugs with a narrow therapeutic window */
  is_narrow_therapeutic?: Maybe<Scalars['Boolean']['output']>;
  /** Flag to identify Rx products with an OTC version available */
  is_otc_equivalent?: Maybe<Scalars['Boolean']['output']>;
  /** Flag to identify rebated specialty drugs */
  is_preferred_specialty?: Maybe<Scalars['Boolean']['output']>;
  /** Flag to identify preventive medications */
  is_preventative?: Maybe<Scalars['Boolean']['output']>;
  /** PA flag */
  is_prior_auth?: Maybe<Scalars['Boolean']['output']>;
  /** Rebatable Drug / Class flag */
  is_rebatable?: Maybe<Scalars['Boolean']['output']>;
  /** Specialty Drug flag */
  is_specialty?: Maybe<Scalars['Boolean']['output']>;
  /** Step Therapy flag */
  is_step_therapy?: Maybe<Scalars['Boolean']['output']>;
  /** An 11-digit drug identifier assigned by the FDA that identifies a drug by its manufacturer, strength, form, and package size */
  ndc: Scalars['String']['output'];
  /** Prior authorization type (Restrictive PA or PA Applies) */
  priorAuthType?: Maybe<PriorAuthType>;
  /** PA requirement URL (link to doc) */
  prior_auth_requirement?: Maybe<Scalars['String']['output']>;
  /** Quantity Limit rules, QL numerator */
  quantity_limit_count?: Maybe<Scalars['String']['output']>;
  /** QL denominator represented as a period of time */
  quantity_limit_duration?: Maybe<Scalars['String']['output']>;
  /** Rebatable Drug means the drug is rebated, Rebatable Class means we know the class is rebated but we don't know if the drug itself is rebated */
  rebatable_type?: Maybe<Scalars['String']['output']>;
  /** Step Therapy category */
  step_therapy_category?: Maybe<Scalars['String']['output']>;
  /** Comments to clarify exceptions to the step therapy rule represented by the ST Category, Level, and Requirements columns */
  step_therapy_comments?: Maybe<Scalars['String']['output']>;
  /** Step Therapy level - indicates Step 1, 2, 3, etc */
  step_therapy_level?: Maybe<Scalars['Int']['output']>;
  /** Step Therapy requirement - indicates how many drugs of a previous step must be tried */
  step_therapy_requirement?: Maybe<Scalars['Int']['output']>;
  /** Formulary tier of the drug */
  tier?: Maybe<Scalars['String']['output']>;
  /** Description of the tier */
  tier_desc?: Maybe<Scalars['String']['output']>;
};

export type FormularyDrugFilters = {
  ndc?: InputMaybe<StringFilter>;
};

export type FormularyDrugList = {
  __typename?: 'FormularyDrugList';
  pagination: Pagination;
  results?: Maybe<Array<FormularyDrug>>;
};

export type FormularyDrugOrder = {
  age_lower_limit?: InputMaybe<OrderDirectionEnum>;
  age_upper_limit?: InputMaybe<OrderDirectionEnum>;
  coverage_code?: InputMaybe<OrderDirectionEnum>;
  drug_class?: InputMaybe<OrderDirectionEnum>;
  formulary_id?: InputMaybe<OrderDirectionEnum>;
  gender?: InputMaybe<OrderDirectionEnum>;
  health_care_reform_category?: InputMaybe<OrderDirectionEnum>;
  is_health_care_reform?: InputMaybe<OrderDirectionEnum>;
  is_high_cost_generic?: InputMaybe<OrderDirectionEnum>;
  is_medical_drug?: InputMaybe<OrderDirectionEnum>;
  is_minimum_value_brand?: InputMaybe<OrderDirectionEnum>;
  is_minimum_value_generic?: InputMaybe<OrderDirectionEnum>;
  is_narrow_therapeutic?: InputMaybe<OrderDirectionEnum>;
  is_otc_equivalent?: InputMaybe<OrderDirectionEnum>;
  is_preferred_specialty?: InputMaybe<OrderDirectionEnum>;
  is_preventative?: InputMaybe<OrderDirectionEnum>;
  is_prior_auth?: InputMaybe<OrderDirectionEnum>;
  is_rebatable?: InputMaybe<OrderDirectionEnum>;
  is_specialty?: InputMaybe<OrderDirectionEnum>;
  is_step_therapy?: InputMaybe<OrderDirectionEnum>;
  ndc?: InputMaybe<OrderDirectionEnum>;
  prior_auth_requirement?: InputMaybe<OrderDirectionEnum>;
  prior_auth_type?: InputMaybe<OrderDirectionEnum>;
  quantity_limit_count?: InputMaybe<OrderDirectionEnum>;
  quantity_limit_duration?: InputMaybe<OrderDirectionEnum>;
  rebatable_type?: InputMaybe<OrderDirectionEnum>;
  step_therapy_category?: InputMaybe<OrderDirectionEnum>;
  step_therapy_comments?: InputMaybe<OrderDirectionEnum>;
  step_therapy_level?: InputMaybe<OrderDirectionEnum>;
  step_therapy_requirement?: InputMaybe<OrderDirectionEnum>;
  tier?: InputMaybe<OrderDirectionEnum>;
  tier_desc?: InputMaybe<OrderDirectionEnum>;
};

/**
 * The formulary enrichment fields needed to annotate a drug with how a formulary
 * treats it: its tier, and whether prior authorization or step therapy applies.
 *
 * Deliberately narrower than FormularyDrug. This type is read by services that
 * enrich a batch of candidate NDCs and must not pay for fields they discard — see
 * the formularyDrugStatuses query.
 */
export type FormularyDrugStatus = {
  __typename?: 'FormularyDrugStatus';
  /** PA flag */
  isPriorAuth?: Maybe<Scalars['Boolean']['output']>;
  /** Step Therapy flag */
  isStepTherapy?: Maybe<Scalars['Boolean']['output']>;
  /** An 11-digit drug identifier assigned by the FDA that identifies a drug by its manufacturer, strength, form, and package size */
  ndc: Scalars['String']['output'];
  /** Prior authorization type (Restrictive PA or PA Applies) */
  priorAuthType?: Maybe<PriorAuthType>;
  /**
   * Whether this NDC is on the formulary. When NON_FORMULARY, every field below is
   * null — the NDC was looked up and is simply not on the formulary.
   */
  status: FormularyStatus;
  /** Step Therapy category */
  stepTherapyCategory?: Maybe<Scalars['String']['output']>;
  /** Step Therapy level - indicates Step 1, 2, 3, etc */
  stepTherapyLevel?: Maybe<Scalars['Int']['output']>;
  /** Step Therapy requirement - indicates how many drugs of a previous step must be tried */
  stepTherapyRequirement?: Maybe<Scalars['Int']['output']>;
  /** Formulary tier of the drug */
  tier?: Maybe<Scalars['String']['output']>;
  /** Description of the tier */
  tierDesc?: Maybe<Scalars['String']['output']>;
};

export type FormularyDrugStatusInput = {
  /** The UUID of the formulary the NDCs are looked up against */
  formularyId: Scalars['ID']['input'];
  /**
   * The NDCs to look up. Dashes are stripped, so both 11-digit and dashed NDCs are
   * accepted. At least one is required and at most 1000 are allowed; a larger
   * batch is rejected as a bad request rather than silently truncated. Each NDC
   * must be exactly 11 digits once dashes are removed.
   */
  ndcs: Array<Scalars['String']['input']>;
};

export type FormularyFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type FormularyList = {
  __typename?: 'FormularyList';
  pagination: Pagination;
  results?: Maybe<Array<Formulary>>;
};

export type FormularyOrder = {
  name?: InputMaybe<OrderDirectionEnum>;
};

/**
 * Whether an NDC is on the formulary it was looked up against.
 *
 * Derived per request rather than stored: the same NDC is on one formulary and off
 * another, so this describes the lookup, not the drug.
 */
export enum FormularyStatus {
  /** The NDC is not on the formulary. Every enrichment field is null. */
  NonFormulary = 'NON_FORMULARY',
  /**
   * The NDC is on the formulary. The enrichment fields carry its formulary
   * treatment, though any individual one may still be null if the formulary does
   * not specify it.
   */
  OnFormulary = 'ON_FORMULARY'
}

/** Whether an alternative is covered by the formulary the request enriched against. */
export enum FormularyStatusEnum {
  /**
   * Known not to be on the formulary. This is what the Drug Catalog renders as
   * "NF".
   */
  NonFormulary = 'NON_FORMULARY',
  OnFormulary = 'ON_FORMULARY',
  /**
   * Coverage was not determined — no formulary was requested, or enrichment did not
   * complete. Distinct from `NON_FORMULARY`: an unchecked drug must not be shown as
   * excluded from coverage.
   */
  Unknown = 'UNKNOWN'
}

/** Input for generating an IFPFile report. */
export type GenerateIfpFileReportInput = {
  ifpFileID: Scalars['ID']['input'];
  type: IfpFileReportType;
};

export type GenerateLakerTemplatesInput = {
  /** Group ID associated to plan design */
  group_id: Scalars['String']['input'];
  /** Plan Test suite identifier */
  plan_test_suite_id: Scalars['ID']['input'];
  /** Subgroup ID associated to plan design */
  subgroup_id: Scalars['String']['input'];
};

export type GenerateReprocessorReportInput = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  reportType: ReprocessorReportTypeEnum;
  reprocessorBatchID: Scalars['ID']['input'];
};

export type Geolocation = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type GoogleWalletPass = {
  __typename?: 'GoogleWalletPass';
  savePassToken: Scalars['String']['output'];
};

export type GrandfatherMatchingInput = {
  /** The input file. */
  file: Scalars['String']['input'];
  /** The chosen matching scheme. */
  scheme: Scalars['String']['input'];
};

export type GrandfatherMatchingResponse = {
  __typename?: 'GrandfatherMatchingResponse';
  /** File containing matching data. */
  file: Scalars['String']['output'];
  /** Object with details on the matching operation. */
  stats: GrandfatherMatchingStats;
};

export enum GrandfatherMatchingScheme {
  FullNameOnly = 'FULL_NAME_ONLY',
  MemberIdPersonCode = 'MEMBER_ID_PERSON_CODE',
  NameDob = 'NAME_DOB',
  NameOnly = 'NAME_ONLY'
}

export type GrandfatherMatchingStats = {
  __typename?: 'GrandfatherMatchingStats';
  /** Error messages to be returned in response. */
  errors: Array<Scalars['String']['output']>;
  /** True if the headers in the input file were valid. */
  headers_valid: Scalars['Boolean']['output'];
  /** The number of lines in the input file including the header line. */
  input_lines: Scalars['Int']['output'];
  /** Number of lines that are unparsable. */
  invalid_lines: Scalars['Int']['output'];
  /** The chosen matching scheme. */
  matching_scheme: GrandfatherMatchingScheme;
  /** Number of successful matches. */
  successful_matches: Scalars['Int']['output'];
  /** Number of unsuccessful matches. */
  unsuccessful_matches: Scalars['Int']['output'];
};

export type Group = {
  __typename?: 'Group';
  accountHolder?: Maybe<Partner>;
  accumulateSeparately: Scalars['Boolean']['output'];
  autoEnrollment?: Maybe<Scalars['Int']['output']>;
  benCapAction?: Maybe<Scalars['Int']['output']>;
  benefitPeriodMonths: Scalars['Int']['output'];
  benefitRestart?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use benefitStartDate */
  benefit_start_date?: Maybe<Scalars['Time']['output']>;
  bin: Scalars['String']['output'];
  cardCarrierTemplate?: Maybe<Scalars['String']['output']>;
  cardEnvelopTemplate?: Maybe<Scalars['String']['output']>;
  cardTemplate?: Maybe<Scalars['String']['output']>;
  carrierCode: Scalars['String']['output'];
  carrierV2?: Maybe<Carrier>;
  /** @deprecated Use carrierCode */
  carrier_code: Scalars['String']['output'];
  code: Scalars['String']['output'];
  copayHandlerAfterCapId?: Maybe<Scalars['String']['output']>;
  copayHandlerMailId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  /** @deprecated Use createdAt */
  created_at?: Maybe<Scalars['Time']['output']>;
  credentialID: Scalars['Int']['output'];
  daysSupply90ForceMailOrder?: Maybe<Scalars['Boolean']['output']>;
  deductibleNaAfterOOPCap: Scalars['Boolean']['output'];
  defaultPlans: Array<DefaultPlan>;
  department: DepartmentConnection;
  departments?: Maybe<DepartmentList>;
  designatedPharmacyComment?: Maybe<Scalars['String']['output']>;
  designatedPharmacyFror?: Maybe<DesignatedPharmacyFror>;
  designatedPharmacyHas340b?: Maybe<Scalars['Boolean']['output']>;
  designatedPharmacyHasCopayIncentive?: Maybe<Scalars['Boolean']['output']>;
  designatedPharmacyHasFror?: Maybe<Scalars['Boolean']['output']>;
  designatedPharmacyPoc?: Maybe<Scalars['String']['output']>;
  details?: Maybe<GroupDetails>;
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use effectiveDate */
  effective_date?: Maybe<Scalars['Time']['output']>;
  excludeAccums: Scalars['Boolean']['output'];
  excludeDaw2: Scalars['Boolean']['output'];
  excludeGenFromDed: Scalars['Boolean']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  extendFirstBenefitPeriod: Scalars['Boolean']['output'];
  /** List of feature flags with values scoped to a group. */
  featureFlags: Array<FeatureFlag>;
  groupToEligFlags?: Maybe<Array<GroupToEligFlag>>;
  hasDesignatedPharmacy?: Maybe<Scalars['Boolean']['output']>;
  hasPreferredPharmacy: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ignoreHistory?: Maybe<Scalars['Boolean']['output']>;
  implementationPhase?: Maybe<GroupImplementationPhase>;
  implementation_phase?: Maybe<GroupImplementationPhase>;
  implementation_project?: Maybe<ImplementationProject>;
  insuranceType: Scalars['String']['output'];
  invoiceConfig?: Maybe<Array<Maybe<InvoiceConfig>>>;
  /** @deprecated Use invoiceConfig */
  invoice_config?: Maybe<Array<Maybe<InvoiceConfig>>>;
  isInZebra: Scalars['Boolean']['output'];
  mailNetwork?: Maybe<PharmacyNetwork>;
  maxAllowedCostKey?: Maybe<Scalars['Cents']['output']>;
  maxAllowedCostMO?: Maybe<Scalars['Cents']['output']>;
  maxAllowedCostOL?: Maybe<Scalars['Cents']['output']>;
  maxAllowedCostSP?: Maybe<Scalars['Cents']['output']>;
  maxPrescriptions: Scalars['Int']['output'];
  maxRevDaysOldKey?: Maybe<Scalars['Int']['output']>;
  maxRevDaysOldMO?: Maybe<Scalars['Int']['output']>;
  maxRevDaysOldOL?: Maybe<Scalars['Int']['output']>;
  maxRevDaysOldSP?: Maybe<Scalars['Int']['output']>;
  maxRxDaysOldKey?: Maybe<Scalars['Int']['output']>;
  maxRxDaysOldMO?: Maybe<Scalars['Int']['output']>;
  maxRxDaysOldOL?: Maybe<Scalars['Int']['output']>;
  maxRxDaysOldSP?: Maybe<Scalars['Int']['output']>;
  maxWrittenDaysOld?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  partnerRelationships?: Maybe<Array<PartnerRelationship>>;
  partners?: Maybe<PartnerList>;
  pcLogic?: Maybe<Scalars['String']['output']>;
  pcn: Scalars['String']['output'];
  planCode: PlanCodeConnection;
  /** @deprecated Use planCode */
  plansV2?: Maybe<PlanCodeV2List>;
  predateAutoEnrollDays?: Maybe<Scalars['Int']['output']>;
  prescriberCheck: Scalars['Int']['output'];
  prescriberListId?: Maybe<Scalars['String']['output']>;
  printCardOption: Scalars['String']['output'];
  pushToSalesforce?: Maybe<Scalars['Boolean']['output']>;
  runOutDate?: Maybe<Scalars['Date']['output']>;
  scriptSourceEnabled: Scalars['Boolean']['output'];
  service?: Maybe<Scalars['String']['output']>;
  serviceNotes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use serviceNotes */
  service_notes?: Maybe<Scalars['String']['output']>;
  sfAccountId?: Maybe<Scalars['String']['output']>;
  sfAccountUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<GroupStatus>;
  subgroup: SubgroupConnection;
  subgroupsV2?: Maybe<SubGroupListV2>;
  taxCalculation?: Maybe<Scalars['String']['output']>;
  terminationDays?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use expirationDate */
  termination_date?: Maybe<Scalars['Time']['output']>;
  testOnly: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use updatedAt */
  updated_at?: Maybe<Scalars['Time']['output']>;
  /** @deprecated Use updatedBy */
  updated_by?: Maybe<Scalars['String']['output']>;
  zebraSyncStrategy: Scalars['String']['output'];
  /**
   * Raw groups_in_zebra feature toggle level: 0 (Laker), 1 (member data syncing,
   * pre-go-live), or 2 (adjudicated in Zebra). Lets clients distinguish
   * pre-go-live groups from live ones.
   */
  zebraToggleLevel: Scalars['Int']['output'];
  zebraUuid: Scalars['ID']['output'];
};


export type GroupAccountHolderArgs = {
  order?: InputMaybe<Array<AccountHolderOrder>>;
};


export type GroupDepartmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DepartmentOrder>;
  where?: InputMaybe<DepartmentFilter>;
};


export type GroupDepartmentsArgs = {
  order?: InputMaybe<Array<DepartmentOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<DepartmentFilter>;
};


export type GroupFeatureFlagsArgs = {
  featureNames?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GroupPartnersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type GroupPlanCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<PlanCodeV2Order>;
  where?: InputMaybe<PlanCodeV2Filters>;
};


export type GroupPlansV2Args = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PlanCodeV2Filters>;
};


export type GroupSubgroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SubgroupOrder>;
  where?: InputMaybe<SubgroupFilters>;
};


export type GroupSubgroupsV2Args = {
  order?: InputMaybe<Array<SubGroupOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<SubGroupFilters>;
};

/**
 * The rows sharing one value of the grouped column. Shared by every where used
 * connection, so the bucket type does not vary with the grouped dimension — only
 * the enum that produces it does.
 */
export type GroupBucket = {
  __typename?: 'GroupBucket';
  /**
   * Rows in this bucket. Across all pages of one `groups` selection the buckets sum
   * to the connection's `count`.
   */
  count: Scalars['Int']['output'];
  /**
   * The grouped column's value rendered as a string, or null when the column is
   * NULL. Dates are `YYYY-MM-DD`, integers are decimal, and IDs are UUIDs.
   *
   * Passing a non-null key back as the `eq` of the matching filter field selects
   * exactly this bucket's rows — the rendering is the one that field's input
   * accepts, so the key travels back verbatim. For a null key, use `isNull: true`
   * on the matching filter field instead, since `eq: null` applies no predicate.
   */
  key?: Maybe<Scalars['String']['output']>;
};

/**
 * A window over the buckets of one `groups(by:)` selection.
 *
 * Buckets are ordered by `count` descending, then by the grouped value ascending
 * with nulls last — so the first page is the largest buckets. The tiebreak is on the
 * value rather than on the rendered `key`, which is the difference between priority
 * 2 sorting before 10 and after it. There is no `order` argument: the ordering a
 * summary UI wants is the only one offered.
 */
export type GroupBucketConnection = {
  __typename?: 'GroupBucketConnection';
  /** Distinct buckets matching the connection's filters. Not a row count. */
  count: Scalars['Int']['output'];
  edges: Array<GroupBucketEdge>;
  pageInfo: PageInfo;
};

export type GroupBucketEdge = {
  __typename?: 'GroupBucketEdge';
  cursor: Scalars['String']['output'];
  node: GroupBucket;
};

export type GroupConnection = {
  __typename?: 'GroupConnection';
  count: Scalars['Int']['output'];
  edges: Array<GroupEdge>;
  pageInfo: PageInfo;
};

export type GroupDetails = {
  __typename?: 'GroupDetails';
  address_1?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  groupUUID: Scalars['ID']['output'];
  id: Scalars['Int']['output'];
  legalEntityName?: Maybe<Scalars['String']['output']>;
  legalStateOfJurisdiction?: Maybe<Scalars['String']['output']>;
  openEnrollmentEnd?: Maybe<Scalars['Time']['output']>;
  openEnrollmentStart?: Maybe<Scalars['Time']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  planRenewalDate?: Maybe<Scalars['Time']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type GroupDocumentation = ClientDocumentation & Node & {
  __typename?: 'GroupDocumentation';
  createdAt: Scalars['Time']['output'];
  group: Group;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** temp URL generated on demand */
  signedUrl: Scalars['URL']['output'];
  type: Scalars['String']['output'];
};

export type GroupDocumentationCreate = {
  file: Scalars['Upload']['input'];
  groupId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type GroupDocumentationUpdate = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GroupEdge = {
  __typename?: 'GroupEdge';
  cursor: Scalars['String']['output'];
  node: Group;
};

export type GroupFilters = {
  carrierCode?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  codeComposite?: InputMaybe<StringFilter>;
  hasOrganization?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<IdFilter>;
  partnerID?: InputMaybe<IdFilter>;
  /** @deprecated Use partnerId */
  partner_id?: InputMaybe<IdFilter>;
  status?: InputMaybe<StringFilter>;
};

export enum GroupImplementationPhase {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  PendingAccountConfiguration = 'PENDING_ACCOUNT_CONFIGURATION',
  Testing = 'TESTING'
}

export type GroupList = {
  __typename?: 'GroupList';
  pagination: Pagination;
  results?: Maybe<Array<Group>>;
};

export type GroupOrder = {
  benefit_start_date?: InputMaybe<OrderDirectionEnum>;
  code?: InputMaybe<OrderDirectionEnum>;
  created_at?: InputMaybe<OrderDirectionEnum>;
  effective_date?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  /** sort by active/future/inactive */
  status?: InputMaybe<OrderDirectionEnum>;
  termination_date?: InputMaybe<OrderDirectionEnum>;
};

export enum GroupStatus {
  Active = 'ACTIVE',
  Future = 'FUTURE',
  Inactive = 'INACTIVE'
}

export type GroupToAccountInput = {
  account_id: Scalars['ID']['input'];
  group_id: Scalars['ID']['input'];
};

export type GroupToEligFlag = {
  __typename?: 'GroupToEligFlag';
  displayName: Scalars['String']['output'];
  eligFlagID: Scalars['ID']['output'];
  groupID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  normalizerIngestionValue: Scalars['String']['output'];
};

export type GroupToPartnerInput = {
  config?: InputMaybe<Scalars['Map']['input']>;
  group_id: Scalars['ID']['input'];
  partner_id: Scalars['ID']['input'];
  relationship: Scalars['String']['input'];
};

export type Handler = {
  __typename?: 'Handler';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum HandlerDetailType {
  /** B */
  Brand = 'BRAND',
  /** G */
  Generic = 'GENERIC',
  /** M */
  MultiSource = 'MULTI_SOURCE'
}

/** A generic handler type for plan configuration. */
export enum HandlerType {
  Age = 'AGE',
  BillCost = 'BILL_COST',
  Copay = 'COPAY',
  Cost = 'COST',
  DispenseFee = 'DISPENSE_FEE',
  DispenseLimit = 'DISPENSE_LIMIT',
  Misc = 'MISC',
  Refill = 'REFILL'
}

export type IcdCode = {
  __typename?: 'ICDCode';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  ver: Scalars['String']['output'];
};

export type IcdCodeFilters = {
  code?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  ver?: InputMaybe<StringFilter>;
};

export type IcdCodeInput = {
  code: Scalars['String']['input'];
  primary: Scalars['Boolean']['input'];
  ver: Scalars['String']['input'];
};

export type IcdCodeList = {
  __typename?: 'ICDCodeList';
  pagination: Pagination;
  results?: Maybe<Array<IcdCode>>;
};

export type IcdCodeOrder = {
  code?: InputMaybe<OrderDirectionEnum>;
  title?: InputMaybe<OrderDirectionEnum>;
  ver?: InputMaybe<OrderDirectionEnum>;
};

export type IdFilter = {
  /** Equal */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** In */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * IFPFile represents a file uploaded to the Internal File Processor system,
 * along with its processing metadata and associated rows.
 */
export type IfpFile = Node & {
  __typename?: 'IFPFile';
  created: Scalars['Time']['output'];
  /**
   * For CUSTOM_DRUG_LIST_IMPORTER_V2 files, returns context including the IDs of
   * every custom drug list touched during the commit phase. Null for other job types.
   */
  customDrugListFileContext?: Maybe<IfpFileCustomDrugListContext>;
  /**
   * Error information if status is ERROR.
   * Contains structured data about what went wrong and where in the processing pipeline.
   */
  errorInfo?: Maybe<IfpFileErrorInfo>;
  /** The file's checksum (SHA256). */
  fileChecksum: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jobType: IfpFileJobTypes;
  /**
   * If IFPFile has jobType related to Pharmacy Network Entity,
   * this field will contain the Pharmacy Network associated with the file.
   * Otherwise, it will be null.
   */
  pharmacyNetwork?: Maybe<PharmacyNetwork>;
  /**
   * For PLAN_TEST_CASES_IMPORT files, returns the deduplicated plan → test suite
   * mappings created during commit. Empty for other job types or uncommitted files.
   */
  planTestSuiteMappings?: Maybe<Array<IfpFileRowSuiteMapping>>;
  processingEndTime?: Maybe<Scalars['Time']['output']>;
  processingStartTime?: Maybe<Scalars['Time']['output']>;
  /**
   * Paginated list of rows associated with this IFPJob.
   *
   * Audited: rowData can carry member PHI for the member-facing job types. The row
   * read gets its own event rather than riding the parent's, because gqlgen
   * resolves child fields after the parent's directive chain has published.
   * entityType is the row, not the file; the file UUID travels in searchCriteria.
   */
  rows: IfpFileRowConnection;
  s3Key: Scalars['String']['output'];
  status: IfpFileStatus;
  /** A summary of the row counts for this job. */
  summary: IfpFileSummary;
  updated: Scalars['Time']['output'];
  uploaderEmail: Scalars['String']['output'];
};


/**
 * IFPFile represents a file uploaded to the Internal File Processor system,
 * along with its processing metadata and associated rows.
 */
export type IfpFileRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<IfpFileRowOrder>;
  where?: InputMaybe<IfpFileRowFilters>;
};

/** Relay-style connection for IFPFiles. */
export type IfpFileConnection = {
  __typename?: 'IFPFileConnection';
  /** Number of IFPFiles that match the given filters, or total number of IFPFiles if no filters are applied. */
  count: Scalars['Int']['output'];
  edges: Array<IfpFileEdge>;
  pageInfo: PageInfo;
};

/**
 * File context specific to CUSTOM_DRUG_LIST_IMPORTER_V2 files.
 * Populated on the file after the commit phase completes.
 */
export type IfpFileCustomDrugListContext = {
  __typename?: 'IFPFileCustomDrugListContext';
  /** IDs of the custom drug lists touched during the commit phase. Empty until the file is committed. */
  customDrugListIDs: Array<Scalars['ID']['output']>;
};

/** Relay-style edge for the IFPFile connection. */
export type IfpFileEdge = {
  __typename?: 'IFPFileEdge';
  cursor: Scalars['String']['output'];
  node: IfpFile;
};

/**
 * Error information when an IFPFile has status ERROR.
 * Contains structured data about what went wrong and where.
 */
export type IfpFileErrorInfo = {
  __typename?: 'IFPFileErrorInfo';
  /** Additional contextual information about the error (one level deep) */
  details?: Maybe<Scalars['Map']['output']>;
  /** Human-readable error message describing what went wrong */
  message: Scalars['String']['output'];
  /** Phase where the error occurred (e.g., header_validation, importer_resolution, commit) */
  phase: Scalars['String']['output'];
  /** Timestamp when the error occurred */
  timestamp: Scalars['Time']['output'];
};

/** Input for filtering IFPFiles, e.g., by ID. */
export type IfpFileFilters = {
  created?: InputMaybe<TimeFilter>;
  fileChecksum?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  jobType?: InputMaybe<Array<IfpFileJobTypes>>;
  s3Key?: InputMaybe<StringFilter>;
  status?: InputMaybe<Array<IfpFileStatus>>;
};

/** Particular input for ifpFileMaclistEntryImporter mutation. */
export type IfpFileInput = {
  file: Scalars['Upload']['input'];
  uploaderEmail: Scalars['String']['input'];
};

/** Defines the particular business operation that the IFPFile is intended to perform. */
export enum IfpFileJobTypes {
  BatchReprocessingClaimsetCreate = 'BATCH_REPROCESSING_CLAIMSET_CREATE',
  BenefitAdjustmentsImport = 'BENEFIT_ADJUSTMENTS_IMPORT',
  BentestMemberCreate = 'BENTEST_MEMBER_CREATE',
  CrosswalkImport = 'CROSSWALK_IMPORT',
  CustomDrugListImporter = 'CUSTOM_DRUG_LIST_IMPORTER',
  CustomDrugListImporterV2 = 'CUSTOM_DRUG_LIST_IMPORTER_V2',
  DepartmentCreate = 'DEPARTMENT_CREATE',
  HistoricalClaimsImport = 'HISTORICAL_CLAIMS_IMPORT',
  MaclistEntryImporter = 'MACLIST_ENTRY_IMPORTER',
  MpaCreate = 'MPA_CREATE',
  PharmacyNetworkEntityFullReplacement = 'PHARMACY_NETWORK_ENTITY_FULL_REPLACEMENT',
  PharmacyNetworkEntityUpsert = 'PHARMACY_NETWORK_ENTITY_UPSERT',
  PlanCodeCreate = 'PLAN_CODE_CREATE',
  PlanTestCasesImport = 'PLAN_TEST_CASES_IMPORT',
  ProcessRuleLineFullReplacement = 'PROCESS_RULE_LINE_FULL_REPLACEMENT',
  ProcessRuleLineUpsert = 'PROCESS_RULE_LINE_UPSERT',
  SubgroupDelete = 'SUBGROUP_DELETE',
  SubgroupTimelineUpsert = 'SUBGROUP_TIMELINE_UPSERT',
  SubgroupUpsert = 'SUBGROUP_UPSERT'
}

/** Input for ordering IFPFiles. */
export type IfpFileOrder = {
  created?: InputMaybe<OrderDirectionEnum>;
};

/** Defines the type of report related to an IFPFile. */
export enum IfpFileReportType {
  AllRows = 'ALL_ROWS',
  InvalidRows = 'INVALID_ROWS'
}

/** Represents a single row from an IFPFile, along with its processing metadata. */
export type IfpFileRow = Node & {
  __typename?: 'IFPFileRow';
  /** Any error encountered during the commit phase for this row. */
  commitError?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  /**
   * Parsed crosswalk metadata (only for CROSSWALK_IMPORT job type).
   * Returns null for other job types.
   */
  crosswalkMetadata?: Maybe<CrosswalkRowMetadata>;
  id: Scalars['ID']['output'];
  /** The intended operation for this row (e.g., CREATE). Null if not yet validated. */
  operation?: Maybe<IfpFileRowOperation>;
  rowData: Scalars['Map']['output'];
  rowNumber: Scalars['Int']['output'];
  status: IfpFileRowStatus;
  /**
   * Metadata about target entities affected by this row.
   * For CROSSWALK_IMPORT: contains dry-run validation results (member state, changes, warnings).
   */
  targetEntitiesMeta?: Maybe<Scalars['Map']['output']>;
  /** The explicit storage target for this row (e.g., PORTAL_AND_ZEBRA). Null if not yet validated. */
  targetStorage?: Maybe<IfpFileRowTargetStorage>;
  updatedAt: Scalars['Time']['output'];
  /** Any validation errors encountered for this row. */
  validationErrors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Relay-style connection for IFPFileRows. */
export type IfpFileRowConnection = {
  __typename?: 'IFPFileRowConnection';
  edges: Array<IfpFileRowEdge>;
  pageInfo: PageInfo;
};

/** Relay-style edge for the IFPFileRow connection. */
export type IfpFileRowEdge = {
  __typename?: 'IFPFileRowEdge';
  cursor: Scalars['String']['output'];
  node: IfpFileRow;
};

/**
 * Input for filtering IFPFileRows, e.g., by status.
 * Rows are automatically scoped to the parent IFPFile - you cannot query rows from a different file.
 */
export type IfpFileRowFilters = {
  status?: InputMaybe<Array<IfpFileRowStatus>>;
};

/** Defines the intended operation for a given IFPFileRow during processing. */
export enum IfpFileRowOperation {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

/** Input for ordering IFPFileRows. */
export type IfpFileRowOrder = {
  rowNumber?: InputMaybe<OrderDirectionEnum>;
};

/** Defines the status of a given IFPFileRow. */
export enum IfpFileRowStatus {
  Committed = 'COMMITTED',
  Committing = 'COMMITTING',
  CommitFailed = 'COMMIT_FAILED',
  Invalid = 'INVALID',
  QueuedForCommit = 'QUEUED_FOR_COMMIT',
  QueuedForValidation = 'QUEUED_FOR_VALIDATION',
  SystemRetroTermed = 'SYSTEM_RETRO_TERMED',
  Valid = 'VALID',
  Validating = 'VALIDATING'
}

/**
 * Represents a mapping between a benefit plan and the plan test suite
 * created during a PLAN_TEST_CASES_IMPORT IFP file commit.
 */
export type IfpFileRowSuiteMapping = {
  __typename?: 'IFPFileRowSuiteMapping';
  planID: Scalars['ID']['output'];
  planTestSuiteID: Scalars['ID']['output'];
};

/** Defines the explicit storage target(s) for a given IFPFileRow. */
export enum IfpFileRowTargetStorage {
  Portal = 'PORTAL',
  PortalAndZebra = 'PORTAL_AND_ZEBRA',
  Zebra = 'ZEBRA'
}

/** Defines the high-level status of an IFPFile. */
export enum IfpFileStatus {
  AwaitingReview = 'AWAITING_REVIEW',
  Committing = 'COMMITTING',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  QueuedForCommit = 'QUEUED_FOR_COMMIT',
  QueuedForValidation = 'QUEUED_FOR_VALIDATION',
  Validating = 'VALIDATING'
}

/**
 * A summary of the row counts for an IFPFile, separating the
 * validation (pre-commit) from commit (post-commit) results.
 */
export type IfpFileSummary = {
  __typename?: 'IFPFileSummary';
  /** A detailed breakdown of the commit-phase results. */
  commitDetails: IfpFileSummaryCommitDetails;
  /** Total rows parsed from the file. */
  totalRows: Scalars['Int']['output'];
  /** A detailed breakdown of the validation-phase results. */
  validationDetails: IfpFileSummaryValidationDetails;
};

/**
 * A detailed breakdown of the rows processed during the commit phase.
 * All fields are non-nullable and will default to 0 if not applicable.
 */
export type IfpFileSummaryCommitDetails = {
  __typename?: 'IFPFileSummaryCommitDetails';
  /** Number of rows that failed the commit step (status 'COMMIT_FAILED'). */
  commitFailedRows: Scalars['Int']['output'];
  /** Number of *new* entities created. */
  createdRows: Scalars['Int']['output'];
  /** Number of *existing* entities. */
  deletedRows: Scalars['Int']['output'];
  /** Number of committed 'noop' rows, which changed nothing. Not counted in updatedRows. */
  noopRows: Scalars['Int']['output'];
  /** The total number of rows successfully committed. */
  totalCommittedRows: Scalars['Int']['output'];
  /** Number of *existing* entities updated (excludes noopRows). */
  updatedRows: Scalars['Int']['output'];
};

/**
 * A detailed breakdown of the rows processed during the validation phase.
 * All fields are non-nullable and will default to 0 if not applicable.
 */
export type IfpFileSummaryValidationDetails = {
  __typename?: 'IFPFileSummaryValidationDetails';
  /** The total number of invalid rows. */
  totalInvalidRows: Scalars['Int']['output'];
  /** The total number of valid rows. */
  totalValidRows: Scalars['Int']['output'];
  /** The total number of rows successfully validated (valid + invalid). */
  totalValidatedRows: Scalars['Int']['output'];
  /** Number of valid rows of 'create' operation. */
  validCreateRows: Scalars['Int']['output'];
  /** Number of valid 'noop' rows, which change nothing. Not counted in validUpdateRows. */
  validNoopRows: Scalars['Int']['output'];
  /** Number of existing lines absent from the CSV that will be retro-termed on commit. Non-zero only for PROCESS_RULE_LINE_FULL_REPLACEMENT jobs. */
  validSystemRetroTermedRows: Scalars['Int']['output'];
  /** Number of valid rows of 'update' operation. */
  validUpdateRows: Scalars['Int']['output'];
};

/** A presigned link to a zip of one extraction run's JSON. */
export type ImplementationManualExtractedJsonDownload = {
  __typename?: 'ImplementationManualExtractedJsonDownload';
  /** The run folder the zip was built from, e.g. v002. */
  extractionVersion: Scalars['String']['output'];
  fileCount: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  /** Short-lived presigned GET URL. Open it to download; do not store it. */
  url: Scalars['String']['output'];
};

/** The step an EXTRACTION_IN_PROGRESS run has reached, as the AI agent reports it. */
export enum ImplementationManualExtractionPhase {
  /** The agent is creating the draft benefit plans in Portal, or retrying a failed one. */
  CreatingPlans = 'CREATING_PLANS',
  /** The agent is reading the workbook into one draft per plan. */
  Extracting = 'EXTRACTING'
}

/** One benefit plan the extraction found in an Implementation Manual workbook. */
export type ImplementationManualPlanCandidate = {
  __typename?: 'ImplementationManualPlanCandidate';
  /**
   * The benefit plan this candidate's provisioning created. Every candidate is stored linked to
   * one - createManualPlanCandidates rejects a candidate without a benefitPlanId - so in practice
   * this is null only when that plan has since been deleted.
   *
   * It must be resolved rather than read from the column: benefit_plan is soft-deleted, so the
   * candidate's benefit_plan_uuid outlives the plan and the FK's ON DELETE SET NULL never fires.
   * Returning the stored UUID would hand out a link to a plan that no longer reads back. The
   * resolver loads through the benefit plan loader, which excludes soft-deleted rows, and reports
   * a vanished plan as null.
   *
   * This is the plan the candidate BUILT, not the plan it was built from - see isWorkbookTemplate
   * for why templatePlan is a different relationship.
   */
  benefitPlan?: Maybe<BenefitPlan>;
  /**
   * Always false: the agent provisions every plan before reporting it.
   * @deprecated Always false.
   */
  canProvision: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  /** @deprecated Always null: candidates no longer fail; the work item does. */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** Fields the extraction read for this plan. */
  fieldCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /**
   * True when this candidate is the workbook's own template COLUMN: the column every other plan
   * column in the sheet expresses its differences against, and the same cell the extraction
   * artifact's templateCell points at.
   *
   * This is NOT a template plan. A template plan is an existing benefit plan a new draft is cloned
   * from - templatePlan, a benefit_plan reference, added by the selection flow. This flag is a
   * property of the spreadsheet, decided by the extraction, and says nothing about which plan a
   * draft is based on. A candidate can be the workbook template and be built from no template plan,
   * and one built from a template plan need not be the workbook's template column.
   */
  isWorkbookTemplate: Scalars['Boolean']['output'];
  /** Of fieldCount, how many the extraction is not confident about. Never greater than fieldCount. */
  lowConfidenceCount: Scalars['Int']['output'];
  /** Position in the workbook. Stable for the life of the work item; the key a replayed extraction reports against. */
  ordinal: Scalars['Int']['output'];
  selectedAt?: Maybe<Scalars['Time']['output']>;
  selectedBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated Always null: candidates are no longer skipped. */
  skipReason?: Maybe<Scalars['String']['output']>;
  sourceColumn?: Maybe<Scalars['String']['output']>;
  sourceSheet?: Maybe<Scalars['String']['output']>;
  status: ImplementationManualPlanCandidateStatus;
  suggestedName: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export enum ImplementationManualPlanCandidateStatus {
  /**
   * Never returned: the agent provisions every plan before reporting it.
   * @deprecated Never returned. Candidates arrive as DRAFT_CREATED.
   */
  Available = 'AVAILABLE',
  /** commitDraftPlan deployed the plan. */
  Committed = 'COMMITTED',
  /** The agent created this plan as a draft; it waits on commitDraftPlan. */
  DraftCreated = 'DRAFT_CREATED',
  /**
   * Never returned: candidates no longer fail; the work item does.
   * @deprecated Never returned. Use the work item's FAILED status and failureReason.
   */
  Failed = 'FAILED',
  /**
   * Never returned: the agent provisions every plan before reporting it.
   * @deprecated Never returned. Candidates arrive as DRAFT_CREATED.
   */
  Provisioning = 'PROVISIONING',
  /**
   * Never returned: candidates are no longer skipped.
   * @deprecated Never returned. Candidates are no longer skipped.
   */
  Skipped = 'SKIPPED'
}

/** Deprecated projection of status: AWAITING_EXTRACTION before review, IN_PROGRESS for AWAITING_REVIEW, COMPLETE for COMPLETED, FAILED for FAILED. */
export enum ImplementationManualProgress {
  AwaitingExtraction = 'AWAITING_EXTRACTION',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type ImplementationManualUpload = {
  __typename?: 'ImplementationManualUpload';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  /**
   * Candidates with a provisioned plan: DRAFT_CREATED or COMMITTED. Ordinal order.
   * @deprecated Use createdCandidatesCount.
   */
  createdCandidates: Array<ImplementationManualPlanCandidate>;
  /** Count of candidates with a provisioned plan (DRAFT_CREATED or COMMITTED). */
  createdCandidatesCount: Scalars['Int']['output'];
  /**
   * Always null. An extraction that reports no plans now fails the work item, and failureReason says so.
   * @deprecated Use status FAILED and failureReason.
   */
  emptyExtractionNotice?: Maybe<Scalars['String']['output']>;
  /**
   * Which step the AI run has reached, read from the agent on this query. Set only on the
   * single-manual query (implementationManualUpload), only while status is
   * EXTRACTION_IN_PROGRESS, and only once the agent reports a step; null otherwise,
   * including from an agent that predates the field. The list query never reads the agent.
   */
  extractionPhase?: Maybe<ImplementationManualExtractionPhase>;
  /**
   * Why this work item is FAILED, in forge's own words. Never the Orchestrator's message: that
   * can echo the manual path and the agent's last output line back, and this field is read by
   * the browser. The operational detail stays in the row, for a human who goes looking.
   */
  failureReason?: Maybe<Scalars['String']['output']>;
  fileChecksum: Scalars['String']['output'];
  fileSizeBytes: Scalars['Int']['output'];
  groupId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * The AI Orchestrator job the extraction is running as, so a reviewer can correlate this work
   * item with the agent's run log. Null until the handoff succeeds — which is what distinguishes
   * QUEUED_FOR_EXTRACTION from EXTRACTION_IN_PROGRESS. Derived from the reference and the file
   * checksum, so it is stable across retries of the same workbook.
   */
  orchestratorJobId?: Maybe<Scalars['String']['output']>;
  originalFilename: Scalars['String']['output'];
  /**
   * Candidates awaiting reviewer action: DRAFT_CREATED. Ordinal order.
   * @deprecated Use planCandidates filtered by status.
   */
  pendingCandidates: Array<ImplementationManualPlanCandidate>;
  /** Every plan the extraction described, ordered by ordinal. Empty until the extraction reports. */
  planCandidates: Array<ImplementationManualPlanCandidate>;
  /** Count of every plan the extraction described. Equivalent to planCandidates length. */
  planCandidatesCount: Scalars['Int']['output'];
  /**
   * A projection of status, kept for clients that have not moved to it.
   * @deprecated Use status.
   */
  progress: ImplementationManualProgress;
  reference: Scalars['String']['output'];
  s3File?: Maybe<S3File>;
  sessionId: Scalars['Int']['output'];
  status: ImplementationManualUploadStatus;
  updatedAt: Scalars['Time']['output'];
  /** @deprecated Use createdBy instead. */
  uploaderEmail: Scalars['String']['output'];
};

export type ImplementationManualUploadConnection = {
  __typename?: 'ImplementationManualUploadConnection';
  edges: Array<ImplementationManualUploadEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImplementationManualUploadEdge = {
  __typename?: 'ImplementationManualUploadEdge';
  cursor: Scalars['String']['output'];
  node: ImplementationManualUpload;
};

export type ImplementationManualUploadFilters = {
  createdAfter?: InputMaybe<Scalars['Time']['input']>;
  createdBefore?: InputMaybe<Scalars['Time']['input']>;
  /** @deprecated No longer supported; this filter is ignored. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Organisational label filter only. */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Filter on the progress projection of status.
   * @deprecated Use status.
   */
  progress?: InputMaybe<Array<ImplementationManualProgress>>;
  /** Case-insensitive substring match on reference and name. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter on the stored intake lifecycle status. */
  status?: InputMaybe<Array<ImplementationManualUploadStatus>>;
};

/**
 * The lifecycle of a work item, in order: SCANNING -> UPLOADED -> QUEUED_FOR_EXTRACTION ->
 * EXTRACTION_IN_PROGRESS -> AWAITING_REVIEW -> COMPLETED. FAILED is reachable from every stage
 * before review, and failureReason says why.
 */
export enum ImplementationManualUploadStatus {
  /**
   * Never returned. Renamed to AWAITING_REVIEW.
   * @deprecated Never returned. Use AWAITING_REVIEW.
   */
  AwaitingPlanSelection = 'AWAITING_PLAN_SELECTION',
  /** The agent created its draft plans; a reviewer is committing them. */
  AwaitingReview = 'AWAITING_REVIEW',
  /**
   * Never returned. Every work item lands at SCANNING.
   * @deprecated Never returned. Use SCANNING.
   */
  AwaitingUpload = 'AWAITING_UPLOAD',
  /** Every draft plan has been committed. A replay that reports a new plan reopens review. */
  Completed = 'COMPLETED',
  /** The AI agent is running on this manual. */
  ExtractionInProgress = 'EXTRACTION_IN_PROGRESS',
  /** Scan, handoff, extraction or the candidates callback failed; failureReason says why. The same file can be uploaded again. */
  Failed = 'FAILED',
  /** Waiting to be handed to the AI agent, or retrying a handoff that failed. */
  QueuedForExtraction = 'QUEUED_FOR_EXTRACTION',
  /** The file is stored and the malware scan has not answered yet. */
  Scanning = 'SCANNING',
  /** The scan cleared the file; the extraction has not been handed off. */
  Uploaded = 'UPLOADED'
}

export type ImplementationProject = {
  __typename?: 'ImplementationProject';
  actual_live_date?: Maybe<Scalars['Time']['output']>;
  entry_date: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  original_live_date: Scalars['Time']['output'];
};

export type ImportGroupInput = {
  accountHolderUUID: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  salesforceURL: Scalars['String']['input'];
};

export enum IncludeImportedClaims {
  BothImportedAndNonImported = 'BOTH_IMPORTED_AND_NON_IMPORTED',
  OnlyImported = 'ONLY_IMPORTED',
  OnlyNonImported = 'ONLY_NON_IMPORTED'
}

export enum IncludeTestClaims {
  BothTestAndNonTest = 'BOTH_TEST_AND_NON_TEST',
  OnlyNonTest = 'ONLY_NON_TEST',
  OnlyTest = 'ONLY_TEST'
}

export type IncludedSuperNetwork = {
  __typename?: 'IncludedSuperNetwork';
  /**
   * Provenance for this plan's inclusion of the network: fieldPath super_network for the
   * network itself, sourced from the Benefit Design pharmacy cell it was looked up from,
   * and comment for the comment, sourced from that network's own comment cell. See
   * AiOverlay in ai_overlay.graphql.
   *
   * Matched by identity: the field-api-map's Network row carries the super network id
   * the run sent, and its block the plan's uuid. Null for a network no row names, a
   * network two rows claim, and every artifact written before the AI stack carried those
   * ids -- its rows are positional and each comment is claimed by two cells, so nothing
   * in it can be attributed (pkg/v2/aioverlay/gqlmap/descriptors_blocked.go).
   */
  aiOverlay?: Maybe<AiOverlay>;
  comment?: Maybe<Scalars['String']['output']>;
  super_network: SuperNetwork;
};

export type InputParametersMetadataDetails = {
  __typename?: 'InputParametersMetadataDetails';
  cardID?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groupCode?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  membershipUUID?: Maybe<Scalars['String']['output']>;
  personCode?: Maybe<Scalars['String']['output']>;
  subscriptionUUID?: Maybe<Scalars['String']['output']>;
};

export type Instruction = {
  __typename?: 'Instruction';
  bool_value?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['Time']['output']>;
  field: Scalars['String']['output'];
  float_value?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  int_value?: Maybe<Scalars['Int']['output']>;
  namespace: Scalars['String']['output'];
  string_value?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Time']['output']>;
};

export type InstructionInput = {
  bool_value?: InputMaybe<Scalars['Boolean']['input']>;
  field: Scalars['String']['input'];
  float_value?: InputMaybe<Scalars['Float']['input']>;
  int_value?: InputMaybe<Scalars['Int']['input']>;
  namespace: Scalars['String']['input'];
  string_value?: InputMaybe<Scalars['String']['input']>;
};

export type IntFilter = {
  /** Equal */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** In */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Matches rows where the column IS NULL (true) or IS NOT NULL (false) */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal */
  ne?: InputMaybe<Scalars['Int']['input']>;
  /** Not in */
  nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntegerClaimInstruction = ClaimInstruction & {
  __typename?: 'IntegerClaimInstruction';
  field: MpaClaimInstructionField;
  id: Scalars['ID']['output'];
  intValue: Scalars['Int']['output'];
  isEmpty: Scalars['Boolean']['output'];
};

/**
 * Three-state filter over a drug's interchangeability. `ALL` is the default and
 * does not filter — the third state is an explicit enum value rather than a null
 * so the frontend does not have to encode "unset" as an absent field.
 */
export enum InterchangeableFilterEnum {
  All = 'ALL',
  No = 'NO',
  Yes = 'YES'
}

export type Invoice = {
  __typename?: 'Invoice';
  claim_count: Scalars['Int']['output'];
  end_date: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  member_count: Scalars['Int']['output'];
  number: Scalars['String']['output'];
  partner_id: Scalars['ID']['output'];
  s3_file_id: Scalars['ID']['output'];
  sent_at: Scalars['Time']['output'];
  start_date: Scalars['Time']['output'];
  total: Scalars['Int']['output'];
};

export type InvoiceConfig = {
  __typename?: 'InvoiceConfig';
  Recipients?: Maybe<Scalars['String']['output']>;
  admin_fee_period?: Maybe<Scalars['String']['output']>;
  credit_resolution?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  detail_resolution?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  namespace?: Maybe<Scalars['String']['output']>;
  partner_id: Scalars['ID']['output'];
  pbm_contract_id: Scalars['ID']['output'];
  period: Scalars['String']['output'];
  relationship?: Maybe<Scalars['String']['output']>;
};

export type InvoiceConfigFilters = {
  group_id?: InputMaybe<IdFilter>;
  partner_id?: InputMaybe<IdFilter>;
};

export type InvoiceConfigList = {
  __typename?: 'InvoiceConfigList';
  results?: Maybe<Array<InvoiceConfig>>;
};

export type InvoiceConfigOrder = {
  partner_name?: InputMaybe<OrderDirectionEnum>;
};

export type InvoiceFilters = {
  partner_id?: InputMaybe<IdFilter>;
};

export type InvoiceOneTimeCharge = {
  __typename?: 'InvoiceOneTimeCharge';
  amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  invoice_id: Scalars['ID']['output'];
  partner_id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

export type InvoiceOneTimeChargeFilters = {
  invoice_id?: InputMaybe<IdFilter>;
  partner_id?: InputMaybe<IdFilter>;
};

export type InvoiceOneTimeChargeOrder = {
  amount?: InputMaybe<OrderDirectionEnum>;
  partner_name?: InputMaybe<OrderDirectionEnum>;
};

export type InvoiceOrder = {
  number?: InputMaybe<OrderDirectionEnum>;
  partner_name?: InputMaybe<OrderDirectionEnum>;
  sent_at?: InputMaybe<OrderDirectionEnum>;
  total?: InputMaybe<OrderDirectionEnum>;
};

/** LakerMPA represents a Member Prior Authorization record persisted from Laker. */
export type LakerMpa = Node & {
  __typename?: 'LakerMPA';
  /** Action code (e.g., 'A' for Approve) */
  action: Scalars['String']['output'];
  /** Authorization number returned from Laker */
  authnum: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  /** The drug associated with the MPA (based on NDC or GPI) */
  drug?: Maybe<DrugV2>;
  /** When the MPA starts being used in adjudication */
  effectiveAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  /** Provides subscriberNumber, groupNumber, and personCode details */
  member?: Maybe<MemberV2>;
  /** Notes about the MPA */
  notes?: Maybe<Scalars['String']['output']>;
  /** When the MPA stops being used in adjudication */
  terminatedAt?: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type LakerMpaConnection = {
  __typename?: 'LakerMPAConnection';
  count: Scalars['Int']['output'];
  edges: Array<LakerMpaEdge>;
  pageInfo: PageInfo;
};

export type LakerMpaEdge = {
  __typename?: 'LakerMPAEdge';
  cursor: Scalars['String']['output'];
  node: LakerMpa;
};

export type LakerMpaFilters = {
  authnum?: InputMaybe<StringFilter>;
  effectiveAt?: InputMaybe<TimeFilter>;
  gpi?: InputMaybe<StringFilter>;
  groupNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  ndc?: InputMaybe<StringFilter>;
  personCode?: InputMaybe<StringFilter>;
  subscriberNumber?: InputMaybe<StringFilter>;
  terminatedAt?: InputMaybe<TimeFilter>;
};

export type LakerMpaOrder = {
  authnum?: InputMaybe<OrderDirectionEnum>;
  createdAt?: InputMaybe<OrderDirectionEnum>;
  effectiveAt?: InputMaybe<OrderDirectionEnum>;
  groupNumber?: InputMaybe<OrderDirectionEnum>;
  subscriberNumber?: InputMaybe<OrderDirectionEnum>;
  terminatedAt?: InputMaybe<OrderDirectionEnum>;
};

export type LakerOuputFileInput = {
  /** Laker standard batch output file */
  file: Scalars['String']['input'];
  /** Plan Test suite identifier */
  plan_test_suite_id: Scalars['ID']['input'];
};

export type LegacyBatch = {
  __typename?: 'LegacyBatch';
  batchSettingsUuid?: Maybe<Scalars['UUID']['output']>;
  batchType: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdById?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export type LesserCostCalcSummary = {
  __typename?: 'LesserCostCalcSummary';
  calcFuncType: Scalars['String']['output'];
  cost: Scalars['Float']['output'];
  formulaName: Scalars['String']['output'];
};

export type LiftMemberAccessRestrictionInput = {
  dependentPersonUUID: Scalars['ID']['input'];
  primaryPersonUUID: Scalars['ID']['input'];
};

export type ListBatchDataSyncJobsOrder = {
  direction: OrderDirection;
  field: BatchDataSyncJobOrderField;
};

export type ListBatchSyncJobStatusesFilters = {
  cardID?: InputMaybe<Scalars['String']['input']>;
  groupCode?: InputMaybe<Scalars['String']['input']>;
  membershipUUID?: InputMaybe<Scalars['String']['input']>;
  requestMethod?: InputMaybe<BatchDataSyncJobRequestMethod>;
  requestedBy?: InputMaybe<Scalars['String']['input']>;
  requestedDate?: InputMaybe<Scalars['Date']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<BatchDataSyncJobStatus>>>;
  subscriptionUUID?: InputMaybe<Scalars['String']['input']>;
};

export type ListMembershipSyncsFilters = {
  batchDataSyncJobID: Scalars['ID']['input'];
  cardID?: InputMaybe<Scalars['String']['input']>;
  groupUUID?: InputMaybe<Scalars['ID']['input']>;
  membershipUUID?: InputMaybe<Scalars['ID']['input']>;
  syncResult?: InputMaybe<MembershipSyncResult>;
};

export type ListMembershipSyncsOrder = {
  direction: OrderDirection;
  field: MembershipSyncOrderField;
};

export type ListOfExceptionLists = {
  __typename?: 'ListOfExceptionLists';
  pagination: Pagination;
  results: Array<ExceptionList>;
};

export type ListOfExceptions = {
  __typename?: 'ListOfExceptions';
  pagination: Pagination;
  results: Array<Exception>;
};

export type LocationInformation = {
  __typename?: 'LocationInformation';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countyFIPS?: Maybe<Scalars['String']['output']>;
  countyName?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type LocationInformationInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countyFIPS?: InputMaybe<Scalars['String']['input']>;
  countyName?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type LocationInformationPartialInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countyFIPS?: InputMaybe<Scalars['String']['input']>;
  countyName?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type LookerDashboard = {
  filters?: InputMaybe<LookerReportFilters>;
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type LookerEmbedTokens = {
  __typename?: 'LookerEmbedTokens';
  apiToken?: Maybe<Scalars['String']['output']>;
  apiTokenTTL?: Maybe<Scalars['Int']['output']>;
  authenticationToken?: Maybe<Scalars['String']['output']>;
  authenticationTokenTTL?: Maybe<Scalars['Int']['output']>;
  navigationToken?: Maybe<Scalars['String']['output']>;
  navigationTokenTTL?: Maybe<Scalars['Int']['output']>;
  sessionReferenceTokenTTL?: Maybe<Scalars['Int']['output']>;
};

export type LookerReportDownloadInput = {
  dashboards?: InputMaybe<Array<LookerDashboard>>;
};

export type LookerReportFilters = {
  /**
   * Date range has to use a match expressions supported by Looker date and time filters
   * https://cloud.google.com/looker/docs/filter-expressions#date_and_time
   */
  dateRange?: InputMaybe<Scalars['String']['input']>;
  /** Department name filter */
  departmentName?: InputMaybe<StringFilter>;
  /** Group UUIDS, mapped to codes, end up in the "Group Code" filter */
  groupID?: InputMaybe<IdFilter>;
  /** Some reports use "Transaction Quarter Start Quarter" filter instead of "Date" but they behave the same */
  quarterStart?: InputMaybe<Scalars['String']['input']>;
};

export type LookerTokensInput = {
  apiToken: Scalars['String']['input'];
  navigationToken: Scalars['String']['input'];
};

/**
 * A Maximum Allowable Cost List object.
 * This is the top level of a particular MAC List, which we use to determine pricing.
 */
export type MacList = Node & {
  __typename?: 'MACList';
  created: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  entries: MacListEntryConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ncpdp522Fm?: Maybe<Scalars['Int']['output']>;
  updated: Scalars['Time']['output'];
};


/**
 * A Maximum Allowable Cost List object.
 * This is the top level of a particular MAC List, which we use to determine pricing.
 */
export type MacListEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<MacListEntryOrder>;
  where?: InputMaybe<MacListEntryFilters>;
};

export type MacListConnection = {
  __typename?: 'MACListConnection';
  count: Scalars['Int']['output'];
  edges: Array<MacListEdge>;
  pageInfo: PageInfo;
};

export type MacListEdge = {
  __typename?: 'MACListEdge';
  cursor: Scalars['String']['output'];
  node: MacList;
};

/**
 * A MAC List Entry object.
 * This object represents a particular drug price which should be active for a particular period of time.
 */
export type MacListEntry = Node & {
  __typename?: 'MACListEntry';
  brand?: Maybe<Array<BrandCode>>;
  created: Scalars['Time']['output'];
  drugDescription?: Maybe<Scalars['String']['output']>;
  drugPrice: Scalars['Dollars']['output'];
  effectiveDate: Scalars['Date']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  gpiMatch?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mony?: Maybe<Array<MonyCode>>;
  ndcMatch?: Maybe<Scalars['String']['output']>;
  updated: Scalars['Time']['output'];
};

export type MacListEntryConnection = {
  __typename?: 'MACListEntryConnection';
  edges: Array<MacListEntryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MacListEntryEdge = {
  __typename?: 'MACListEntryEdge';
  cursor: Scalars['String']['output'];
  node: MacListEntry;
};

export type MacListEntryFilters = {
  /** Searches both NDC and GPI fields */
  drugCode?: InputMaybe<StringFilter>;
  /** Searches entries by drug name. */
  drugName?: InputMaybe<StringFilter>;
  effectiveDate?: InputMaybe<DateFilter>;
  expirationDate?: InputMaybe<DateFilter>;
  /**
   * Only return entries with given status. If this field is provided,
   * the backend will ignore the effectiveDate and expirationDate fields.
   */
  status?: InputMaybe<MacListEntryStatus>;
};

export type MacListEntryInput = {
  brand?: InputMaybe<Array<BrandCode>>;
  drugPrice: Scalars['Dollars']['input'];
  effectiveDate: Scalars['Date']['input'];
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  gpiMatch?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mony?: InputMaybe<Array<MonyCode>>;
  ndcMatch?: InputMaybe<Scalars['String']['input']>;
};

export type MacListEntryOrder = {
  drugPrice?: InputMaybe<OrderDirectionEnum>;
  effectiveDate?: InputMaybe<OrderDirectionEnum>;
  expirationDate?: InputMaybe<OrderDirectionEnum>;
  gpi?: InputMaybe<OrderDirectionEnum>;
  ndc?: InputMaybe<OrderDirectionEnum>;
  type?: InputMaybe<OrderDirectionEnum>;
  value?: InputMaybe<OrderDirectionEnum>;
};

export enum MacListEntryStatus {
  /** Return only drug prices which are active now */
  Active = 'ACTIVE',
  /** Return only drug prices which have not yet gone into effect */
  Future = 'FUTURE',
  /** Return only drug prices which have expired */
  Inactive = 'INACTIVE'
}

export type MacListFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type MacListInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  entries?: InputMaybe<Array<MacListEntryInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ncpdp522Fm?: InputMaybe<Scalars['Int']['input']>;
};

export type MacListOrder = {
  created?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export enum MonyCode {
  /** M - single source, co-licensed */
  MonyCodeM = 'MONYCodeM',
  /** N - single source, no generics available */
  MonyCodeN = 'MONYCodeN',
  /** O - original product, generics available (innovative multiple source) */
  MonyCodeO = 'MONYCodeO',
  /** Y - generics, multiple sources (non-innovative multiple source) */
  MonyCodeY = 'MONYCodeY',
  Unknown = 'UNKNOWN'
}

export enum MpaClaimInstructionField {
  AddScriptTag = 'ADD_SCRIPT_TAG',
  AddSdc = 'ADD_SDC',
  AllowOtc = 'ALLOW_OTC',
  AllowRepacks = 'ALLOW_REPACKS',
  ApplyToIngredients = 'APPLY_TO_INGREDIENTS',
  ExcludePmids = 'EXCLUDE_PMIDS',
  FlatBrandCopay = 'FLAT_BRAND_COPAY',
  FlatGenericCopay = 'FLAT_GENERIC_COPAY',
  ForceGenericCopay = 'FORCE_GENERIC_COPAY',
  ForceThisBillCostHandlerId = 'FORCE_THIS_BILL_COST_HANDLER_ID',
  ForceThisCopayHandlerId = 'FORCE_THIS_COPAY_HANDLER_ID',
  ForceThisMiscHandlerId = 'FORCE_THIS_MISC_HANDLER_ID',
  IgnoreAccumulators = 'IGNORE_ACCUMULATORS',
  IgnoreAgeLimits = 'IGNORE_AGE_LIMITS',
  IgnoreDateWrittenReject = 'IGNORE_DATE_WRITTEN_REJECT',
  IgnoreDur = 'IGNORE_DUR',
  IgnoreExcludePm = 'IGNORE_EXCLUDE_PM',
  IgnoreGroupMaxDollar = 'IGNORE_GROUP_MAX_DOLLAR',
  IgnoreInvalidPrescriber = 'IGNORE_INVALID_PRESCRIBER',
  IgnoreMaintenance = 'IGNORE_MAINTENANCE',
  IgnoreMaxDaysOld = 'IGNORE_MAX_DAYS_OLD',
  IgnoreMaxPrescriptions = 'IGNORE_MAX_PRESCRIPTIONS',
  IgnoreMiscHandler = 'IGNORE_MISC_HANDLER',
  IgnorePhysicianChecks = 'IGNORE_PHYSICIAN_CHECKS',
  IgnorePreferred = 'IGNORE_PREFERRED',
  IgnorePrescriberRestrictions = 'IGNORE_PRESCRIBER_RESTRICTIONS',
  IgnorePrimaryZeroDollar = 'IGNORE_PRIMARY_ZERO_DOLLAR',
  /** @deprecated Inert: no adjudication rule reads it. Waive 9G with MARK_SCRIPT_TAG (MPA2) plus MAX_DAILY_DOSE and MAX_SCRIPT_QTY (ZEB-10634). */
  IgnoreQuantityLimits = 'IGNORE_QUANTITY_LIMITS',
  IgnoreRts = 'IGNORE_RTS',
  IgnoreRxOrigin = 'IGNORE_RX_ORIGIN',
  IgnoreScriptTooOld = 'IGNORE_SCRIPT_TOO_OLD',
  IgnoreSdcs = 'IGNORE_SDCS',
  IgnoreThisMiscHandlerId = 'IGNORE_THIS_MISC_HANDLER_ID',
  IncludePmids = 'INCLUDE_PMIDS',
  MarkScriptTag = 'MARK_SCRIPT_TAG',
  MaxDailyDose = 'MAX_DAILY_DOSE',
  MaxMpaUses = 'MAX_MPA_USES',
  MaxRefills = 'MAX_REFILLS',
  MaxScriptDays = 'MAX_SCRIPT_DAYS',
  MaxScriptDollars = 'MAX_SCRIPT_DOLLARS',
  MaxScriptQty = 'MAX_SCRIPT_QTY',
  MinScriptDays = 'MIN_SCRIPT_DAYS',
  MinScriptQty = 'MIN_SCRIPT_QTY',
  NaToBenCap = 'NA_TO_BEN_CAP',
  NaToDeductible = 'NA_TO_DEDUCTIBLE',
  NaToOop = 'NA_TO_OOP',
  OverrideCobReject = 'OVERRIDE_COB_REJECT',
  OverrideDurCompliance = 'OVERRIDE_DUR_COMPLIANCE',
  OverrideDurDoseCheck = 'OVERRIDE_DUR_DOSE_CHECK',
  OverrideDurDrugAge = 'OVERRIDE_DUR_DRUG_AGE',
  OverrideDurDrugSex = 'OVERRIDE_DUR_DRUG_SEX',
  OverrideDurDrugToDrugInteraction = 'OVERRIDE_DUR_DRUG_TO_DRUG_INTERACTION',
  OverrideDurDuplicateDrug = 'OVERRIDE_DUR_DUPLICATE_DRUG',
  OverrideDurDuplicateTherapy = 'OVERRIDE_DUR_DUPLICATE_THERAPY',
  OverrideDurIngredientScreening = 'OVERRIDE_DUR_INGREDIENT_SCREENING',
  OverridePrExcludes = 'OVERRIDE_PR_EXCLUDES',
  PlanPaysDaw = 'PLAN_PAYS_DAW',
  RejectCodesToOverride = 'REJECT_CODES_TO_OVERRIDE',
  SecondaryMessages = 'SECONDARY_MESSAGES',
  SetMaintenance = 'SET_MAINTENANCE',
  SetPreferred = 'SET_PREFERRED',
  TierField = 'TIER_FIELD',
  TreatAsMony = 'TREAT_AS_MONY',
  TreatAsMonyCopay = 'TREAT_AS_MONY_COPAY',
  TreatAsMonyCostDispFee = 'TREAT_AS_MONY_COST_DISP_FEE'
}

export type MpaCreateInput = {
  cardholderID: Scalars['String']['input'];
  commonFields?: InputMaybe<MpaOptionalFieldsInput>;
  compoundCode?: InputMaybe<CompoundCode>;
  effectiveDate: Scalars['Time']['input'];
  expirationDate: Scalars['Time']['input'];
  groupID?: InputMaybe<Scalars['UUID']['input']>;
  mpaProcessRuleInput?: InputMaybe<MpaProcessRuleInput>;
  /** Required Fields */
  personCode?: InputMaybe<Scalars['Int']['input']>;
  type: MemberPriorAuthType;
};

export type MpaExportFileV2 = {
  __typename?: 'MPAExportFileV2';
  /** Null when no matching rows were exported. */
  csvBase64?: Maybe<Scalars['String']['output']>;
  rowsWritten: Scalars['Int']['output'];
  /** True when matching rows were excluded by the 10,000-row limit. */
  truncated: Scalars['Boolean']['output'];
};

export type MpaFiltersV2 = {
  brandCode?: InputMaybe<StringFilter>;
  cardID?: InputMaybe<StringFilter>;
  cardholderID?: InputMaybe<IdFilter>;
  compoundCode?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<TimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deaClass?: InputMaybe<StringFilter>;
  effectiveDate?: InputMaybe<TimeFilter>;
  expirationDate?: InputMaybe<TimeFilter>;
  /**
   * Case-insensitive match against the drug's generic name (the GPI classification
   * descriptor). This joins through the MPA's own gpi to gpi_description.description,
   * so MPAs with a NULL ndc but a present gpi are still matched.
   */
  genericName?: InputMaybe<StringFilter>;
  gpi?: InputMaybe<StringFilter>;
  groupID?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  memberID?: InputMaybe<IdFilter>;
  ndc?: InputMaybe<StringFilter>;
  number?: InputMaybe<StringFilter>;
  /**
   * Matches the member's person_code exactly. person_code is an integer (1-999) on the
   * member table, so this joins through memberpriorauth.member: card-level MPAs (member
   * IS NULL) have no person code and are therefore excluded when this filter is set.
   */
  personCode?: InputMaybe<IntFilter>;
  pharmacyID?: InputMaybe<IdFilter>;
  prescriberID?: InputMaybe<IdFilter>;
  rxOTCInd?: InputMaybe<StringFilter>;
  therapyClass?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<TimeFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

/**
 * GPI match granularity a template applies. GPI_12 matches on the 12-character
 * GPI prefix of the claim's drug; GPI_14 matches on the full 14-character GPI.
 * The concrete GPI is truncated from the originating claim when the MPA is built.
 */
export enum MpagpiLevel {
  Gpi_12 = 'GPI_12',
  Gpi_14 = 'GPI_14'
}

export type MpaOptionalFieldsInput = {
  addSDC?: InputMaybe<Scalars['UUID']['input']>;
  addScriptTag?: InputMaybe<Scalars['String']['input']>;
  allowOTC?: InputMaybe<Scalars['Boolean']['input']>;
  allowRepacks?: InputMaybe<Scalars['Boolean']['input']>;
  applyToIngredients?: InputMaybe<Scalars['Boolean']['input']>;
  brandCode?: InputMaybe<BrandCode>;
  customDrugListID?: InputMaybe<Scalars['UUID']['input']>;
  deaClass?: InputMaybe<DeaClass>;
  flatBrandCopay?: InputMaybe<Scalars['Float']['input']>;
  flatGenericCopay?: InputMaybe<Scalars['Float']['input']>;
  forceGenericCopay?: InputMaybe<Scalars['Boolean']['input']>;
  forceThisBillCostHandlerID?: InputMaybe<Scalars['UUID']['input']>;
  forceThisCopayHandlerID?: InputMaybe<Scalars['UUID']['input']>;
  forceThisMiscHandlerID?: InputMaybe<Scalars['UUID']['input']>;
  gpi?: InputMaybe<Scalars['String']['input']>;
  ignore7571Rejects?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreAccumulators?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreAgeLimits?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreDUR?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreDateWrittenReject?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreExcludePM?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreGroupMaxDollar?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreInvalidPrescriber?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreMaxDaysOld?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreMaxPrescriptions?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreMiscHandler?: InputMaybe<Scalars['Boolean']['input']>;
  ignorePhysicianChecks?: InputMaybe<Scalars['Boolean']['input']>;
  ignorePreferred?: InputMaybe<Scalars['Boolean']['input']>;
  ignorePrescriberRestrictions?: InputMaybe<Scalars['Boolean']['input']>;
  ignorePrimaryZeroDollar?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Inert: no adjudication rule reads it. Waive 9G with MARK_SCRIPT_TAG (MPA2) plus MAX_DAILY_DOSE and MAX_SCRIPT_QTY (ZEB-10634). */
  ignoreQuantityLimits?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreRTS?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreRxOrigin?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreSDCs?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreScriptTooOld?: InputMaybe<Scalars['Boolean']['input']>;
  /** uuid Fields */
  ignoreThisMiscHandlerID?: InputMaybe<Scalars['UUID']['input']>;
  includeRxOrigin?: InputMaybe<Scalars['Boolean']['input']>;
  markScriptTag?: InputMaybe<Scalars['String']['input']>;
  /**
   * MONY codes to restrict this MPA to: distinct codes from {M,O,N,Y} concatenated,
   * order-insensitive (e.g. "Y", "MON"). Null/empty/all-four means no restriction.
   */
  matchMONY?: InputMaybe<Scalars['String']['input']>;
  maxDailyDose?: InputMaybe<Scalars['Float']['input']>;
  maxMPAUses?: InputMaybe<Scalars['Int']['input']>;
  maxRefills?: InputMaybe<Scalars['Int']['input']>;
  maxScriptDays?: InputMaybe<Scalars['Int']['input']>;
  maxScriptDollars?: InputMaybe<Scalars['Float']['input']>;
  maxScriptQty?: InputMaybe<Scalars['Float']['input']>;
  minScriptDays?: InputMaybe<Scalars['Int']['input']>;
  minScriptQty?: InputMaybe<Scalars['Float']['input']>;
  naToBenCap?: InputMaybe<Scalars['Boolean']['input']>;
  naToDeductible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Boolean Fields */
  naToOOP?: InputMaybe<Scalars['Boolean']['input']>;
  ndc?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  overrideCOBReject?: InputMaybe<Scalars['Boolean']['input']>;
  overrideDURCompliance?: InputMaybe<Scalars['Boolean']['input']>;
  overrideDURDoseCheck?: InputMaybe<Scalars['Boolean']['input']>;
  overrideDURDrugAge?: InputMaybe<Scalars['Boolean']['input']>;
  overrideDURDrugSex?: InputMaybe<Scalars['Boolean']['input']>;
  overrideDURDrugToDrugInteraction?: InputMaybe<Scalars['Boolean']['input']>;
  overrideDURDuplicateDrug?: InputMaybe<Scalars['Boolean']['input']>;
  overrideDURDuplicateTherapy?: InputMaybe<Scalars['Boolean']['input']>;
  overrideDURIngredientScreening?: InputMaybe<Scalars['Boolean']['input']>;
  overridePRExcludes?: InputMaybe<Scalars['Boolean']['input']>;
  pharmacyID?: InputMaybe<Scalars['UUID']['input']>;
  pharmacyNetworkGID?: InputMaybe<Scalars['String']['input']>;
  pharmacyNetworkID?: InputMaybe<Scalars['UUID']['input']>;
  planPaysDaw?: InputMaybe<Scalars['Boolean']['input']>;
  prescriberID?: InputMaybe<Scalars['UUID']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  rejectCodesToOverride?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rxOTCInd?: InputMaybe<RxOtcInd>;
  secondaryMessages?: InputMaybe<Scalars['String']['input']>;
  setMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  setPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  therapyClass?: InputMaybe<Scalars['String']['input']>;
  /** Optional Fields */
  tier?: InputMaybe<MpaTier>;
  /** MONYCode Fields */
  treatAsMONY?: InputMaybe<MonyCode>;
  treatAsMONYCopay?: InputMaybe<MonyCode>;
  treatAsMONYCostDispFee?: InputMaybe<MonyCode>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type MpaOrderV2 = {
  cardholderID?: InputMaybe<OrderDirectionEnum>;
  createdAt?: InputMaybe<OrderDirectionEnum>;
  createdBy?: InputMaybe<OrderDirectionEnum>;
  effectiveDate?: InputMaybe<OrderDirectionEnum>;
  expirationDate?: InputMaybe<OrderDirectionEnum>;
  id?: InputMaybe<OrderDirectionEnum>;
  memberID?: InputMaybe<OrderDirectionEnum>;
  number?: InputMaybe<OrderDirectionEnum>;
  priority?: InputMaybe<OrderDirectionEnum>;
  updatedAt?: InputMaybe<OrderDirectionEnum>;
  updatedBy?: InputMaybe<OrderDirectionEnum>;
};

export type MpaPrioritiesUpdateInput = {
  /** MPA IDs */
  mpaIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Priorities */
  priorities?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum MpaPriority {
  Highest = 'HIGHEST',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type MpaProcessRuleInput = {
  /** Exclude PMIDs */
  excludePMID?: InputMaybe<Array<InputMaybe<PmidFilter>>>;
  /** Include PMIDs */
  includePMID?: InputMaybe<Array<InputMaybe<PmidFilter>>>;
};

export type MpaProcessRuleRef = {
  __typename?: 'MPAProcessRuleRef';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MpaTemplate = {
  __typename?: 'MPATemplate';
  /** A new MPA object based on the template configuration, with the prefilled instructions applied. The MPA is not persisted. */
  mpa: Mpav2;
  /** Fields included by the template (may still be empty and require user/claim-derived values). */
  prefilledInstructions: Array<MpaClaimInstructionField>;
  /** The matched template's information, null if no template matched. */
  templateInfo?: Maybe<MpaTemplateInfo>;
};

export type MpaTemplateInfo = {
  __typename?: 'MPATemplateInfo';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum MpaTier {
  Tier_1 = 'TIER_1',
  Tier_2 = 'TIER_2',
  Tier_3 = 'TIER_3',
  Tier_4 = 'TIER_4',
  Tier_5 = 'TIER_5',
  Unknown = 'UNKNOWN'
}

export type MpaUpdateCriteriaInput = {
  brandCode?: InputMaybe<BrandCode>;
  compoundCode?: InputMaybe<CompoundCode>;
  customDrugListID?: InputMaybe<Scalars['UUID']['input']>;
  deaClass?: InputMaybe<DeaClass>;
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  gpi?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /**
   * MONY codes to restrict this MPA to: distinct codes from {M,O,N,Y} concatenated,
   * order-insensitive (e.g. "Y", "MON"). Null/empty/all-four means no restriction.
   */
  matchMONY?: InputMaybe<Scalars['String']['input']>;
  ndc?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pharmacyID?: InputMaybe<Scalars['UUID']['input']>;
  pharmacyNetworkID?: InputMaybe<Scalars['String']['input']>;
  prescriberID?: InputMaybe<Scalars['UUID']['input']>;
  rxOTCInd?: InputMaybe<RxOtcInd>;
  type?: InputMaybe<MemberPriorAuthType>;
};

export type MpaUpdateInput = {
  commonFields?: InputMaybe<MpaOptionalFieldsInput>;
  compoundCode?: InputMaybe<CompoundCode>;
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  mpaID: Scalars['UUID']['input'];
};

export type Mpav2 = {
  __typename?: 'MPAV2';
  addSDC?: Maybe<Scalars['UUID']['output']>;
  addScriptTag?: Maybe<Scalars['String']['output']>;
  allowOTC?: Maybe<Scalars['Boolean']['output']>;
  allowRepacks?: Maybe<Scalars['Boolean']['output']>;
  applyToIngredients?: Maybe<Scalars['Boolean']['output']>;
  brandCode?: Maybe<BrandCode>;
  cardholderID: Scalars['UUID']['output'];
  /** Claim instructions as a first-class, label-resolved typed list. */
  claimInstructions: Array<ClaimInstruction>;
  compoundCode?: Maybe<CompoundCode>;
  createdAt: Scalars['Time']['output'];
  /**
   * Who created this MPA. Null when the actor could not be resolved -- most often a
   * record created before actor attribution existed.
   */
  createdBy?: Maybe<Scalars['String']['output']>;
  customDrugList?: Maybe<CustomDrugListV2>;
  customDrugListID?: Maybe<Scalars['UUID']['output']>;
  deaClass?: Maybe<DeaClass>;
  /**
   * The drug this MPA matches on, resolved from `ndc` when set and falling back to
   * `gpi` otherwise. Null when the MPA carries neither, or when the stored
   * identifier matches no drug.
   */
  drug?: Maybe<DrugV2>;
  /**
   * Null when the stored date is out of range (legacy year-0001 rows). Nullable so
   * one bad row degrades to null instead of blanking the whole edges list.
   */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  excludePMIDs?: Maybe<Array<Scalars['String']['output']>>;
  excludeProcessRules?: Maybe<Array<MpaProcessRuleRef>>;
  expirationDate?: Maybe<Scalars['Time']['output']>;
  flatBrandCopay?: Maybe<Scalars['Float']['output']>;
  flatGenericCopay?: Maybe<Scalars['Float']['output']>;
  forceGenericCopay?: Maybe<Scalars['Boolean']['output']>;
  forceThisBillCostHandlerID?: Maybe<Scalars['UUID']['output']>;
  forceThisCopayHandlerID?: Maybe<Scalars['UUID']['output']>;
  forceThisMiscHandlerID?: Maybe<Scalars['UUID']['output']>;
  gpi?: Maybe<Scalars['String']['output']>;
  /** Root Level Fields (from claim) */
  id: Scalars['ID']['output'];
  ignore7571Rejects?: Maybe<Scalars['Boolean']['output']>;
  ignoreAccumulators?: Maybe<Scalars['Boolean']['output']>;
  ignoreAgeLimits?: Maybe<Scalars['Boolean']['output']>;
  ignoreDUR?: Maybe<Scalars['Boolean']['output']>;
  ignoreDateWrittenReject?: Maybe<Scalars['Boolean']['output']>;
  ignoreExcludePM?: Maybe<Scalars['Boolean']['output']>;
  ignoreGroupMaxDollar?: Maybe<Scalars['Boolean']['output']>;
  ignoreInvalidPrescriber?: Maybe<Scalars['Boolean']['output']>;
  ignoreMaintenance?: Maybe<Scalars['Boolean']['output']>;
  ignoreMaxDaysOld?: Maybe<Scalars['Boolean']['output']>;
  ignoreMaxPrescriptions?: Maybe<Scalars['Boolean']['output']>;
  ignoreMiscHandler?: Maybe<Scalars['Boolean']['output']>;
  ignorePhysicianChecks?: Maybe<Scalars['Boolean']['output']>;
  ignorePreferred?: Maybe<Scalars['Boolean']['output']>;
  ignorePrescriberRestrictions?: Maybe<Scalars['Boolean']['output']>;
  ignorePrimaryZeroDollar?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Inert: no adjudication rule reads it. Waive 9G with MARK_SCRIPT_TAG (MPA2) plus MAX_DAILY_DOSE and MAX_SCRIPT_QTY (ZEB-10634). */
  ignoreQuantityLimits?: Maybe<Scalars['Boolean']['output']>;
  ignoreRTS?: Maybe<Scalars['Boolean']['output']>;
  ignoreRxOrigin?: Maybe<Scalars['Boolean']['output']>;
  ignoreSDCs?: Maybe<Scalars['Boolean']['output']>;
  ignoreScriptTooOld?: Maybe<Scalars['Boolean']['output']>;
  ignoreThisMiscHandlerID?: Maybe<Scalars['UUID']['output']>;
  includePMIDs?: Maybe<Array<Scalars['String']['output']>>;
  includeProcessRules?: Maybe<Array<MpaProcessRuleRef>>;
  includeRxOrigin?: Maybe<Scalars['Boolean']['output']>;
  markScriptTag?: Maybe<Scalars['String']['output']>;
  /**
   * MONY codes this MPA is restricted to: distinct codes from {M,O,N,Y} concatenated,
   * order-insensitive (e.g. "Y", "MON"). Null means no restriction.
   */
  matchMONY?: Maybe<Scalars['String']['output']>;
  maxDailyDose?: Maybe<Scalars['Float']['output']>;
  maxMPAUses?: Maybe<Scalars['Int']['output']>;
  maxRefills?: Maybe<Scalars['Int']['output']>;
  maxScriptDays?: Maybe<Scalars['Int']['output']>;
  maxScriptDollars?: Maybe<Scalars['Float']['output']>;
  maxScriptQty?: Maybe<Scalars['Float']['output']>;
  /**
   * The member this MPA applies to, resolved from `memberID`. Null for card-level
   * MPAs (`memberID` is null), which apply to every member on the card.
   */
  member?: Maybe<MemberV2>;
  memberCardDetails?: Maybe<MemberCardDetailsMpav2>;
  memberID?: Maybe<Scalars['UUID']['output']>;
  minScriptDays?: Maybe<Scalars['Int']['output']>;
  minScriptQty?: Maybe<Scalars['Float']['output']>;
  naToBenCap?: Maybe<Scalars['Boolean']['output']>;
  naToDeductible?: Maybe<Scalars['Boolean']['output']>;
  naToOOP?: Maybe<Scalars['Boolean']['output']>;
  /** Drug Matching Fields */
  ndc?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  overrideCOBReject?: Maybe<Scalars['Boolean']['output']>;
  overrideDURCompliance?: Maybe<Scalars['Boolean']['output']>;
  overrideDURDoseCheck?: Maybe<Scalars['Boolean']['output']>;
  overrideDURDrugAge?: Maybe<Scalars['Boolean']['output']>;
  overrideDURDrugSex?: Maybe<Scalars['Boolean']['output']>;
  overrideDURDrugToDrugInteraction?: Maybe<Scalars['Boolean']['output']>;
  overrideDURDuplicateDrug?: Maybe<Scalars['Boolean']['output']>;
  overrideDURDuplicateTherapy?: Maybe<Scalars['Boolean']['output']>;
  overrideDURIngredientScreening?: Maybe<Scalars['Boolean']['output']>;
  overridePRExcludes?: Maybe<Scalars['Boolean']['output']>;
  pharmacy?: Maybe<PharmacyV2>;
  pharmacyID?: Maybe<Scalars['UUID']['output']>;
  pharmacyNetwork?: Maybe<PharmacyNetwork>;
  pharmacyNetworkGID?: Maybe<Scalars['String']['output']>;
  pharmacyNetworkID?: Maybe<Scalars['UUID']['output']>;
  planPaysDaw?: Maybe<Scalars['Boolean']['output']>;
  prescriber?: Maybe<PrescriberV2>;
  prescriberID?: Maybe<Scalars['UUID']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  /** Claim Instructions */
  rejectCodesToOverride?: Maybe<Array<Scalars['String']['output']>>;
  rxOTCInd?: Maybe<RxOtcInd>;
  secondaryMessages?: Maybe<Scalars['String']['output']>;
  setMaintenance?: Maybe<Scalars['Boolean']['output']>;
  setPreferred?: Maybe<Scalars['Boolean']['output']>;
  therapyClass?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<MpaTier>;
  treatAsMONY?: Maybe<MonyCode>;
  treatAsMONYCopay?: Maybe<MonyCode>;
  treatAsMONYCostDispFee?: Maybe<MonyCode>;
  type: MemberPriorAuthType;
  /**
   * Timestamp of the last write to this MPA record, or its creation if it has never
   * been edited. Null only for records predating the backfill that introduced it.
   */
  updatedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Who made that write. Null when the actor could not be resolved -- most often a
   * record last touched before actor attribution existed.
   */
  updatedBy?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type Mpav2Connection = {
  __typename?: 'MPAV2Connection';
  edges: Array<Mpav2Edge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Mpav2Edge = {
  __typename?: 'MPAV2Edge';
  cursor: Scalars['String']['output'];
  node: Mpav2;
};

export type Mpav2ProcessRuleResponse = {
  __typename?: 'MPAV2ProcessRuleResponse';
  /** The MPA Process Rule record updated. */
  idList: Array<Scalars['UUID']['output']>;
};

export type MssRequest = CaseRequest & {
  __typename?: 'MSSRequest';
  /** Group */
  group: Group;
  /** The case's unique identifier, caseID */
  id: Scalars['ID']['output'];
  /** The date that MSS request was created */
  initiatedAt: Scalars['Time']['output'];
  /** Member read the latest message or not */
  isUnread: Scalars['Boolean']['output'];
  /** Member */
  member: Member;
  /** Provider name if applicable */
  provider?: Maybe<Scalars['String']['output']>;
  /** Case reason if applicable */
  reason?: Maybe<Scalars['String']['output']>;
  /** The case's member-friendly identifier, caseNumber in SF */
  referenceNumber: Scalars['ID']['output'];
  /** Case Status */
  status?: Maybe<Scalars['String']['output']>;
  /** The status history of the MSS request */
  statusLog: Array<StatusLogEntry>;
  /** The case subject/description */
  subject: Scalars['String']['output'];
};

export enum MailOrderPathwayStatus {
  /** Case closed out-of-band (e.g. manual ops action), not a conversion */
  Closed = 'CLOSED',
  /** Member successfully transferred - new MO claim adjudicated. Distinct from CLOSED so DA can attribute conversions vs. timeouts. */
  Converted = 'CONVERTED',
  /** 100-day window elapsed without conversion */
  Expired = 'EXPIRED',
  /** Case is open and active */
  Open = 'OPEN',
  /** Status could not be determined */
  Unknown = 'UNKNOWN'
}

/** Pathway recommendation produced by DPE for a single member medication. */
export type MailOrderRequest = CaseRequest & {
  __typename?: 'MailOrderRequest';
  group: Group;
  id: Scalars['ID']['output'];
  isUnread: Scalars['Boolean']['output'];
  member: Member;
  /** The claim that created this recommended mail order pathway */
  originalClaim?: Maybe<ClaimTransaction>;
  /** All candidate pharmacies, filtered to those carrying the drug. Already sorted by savings desc. */
  pathways: Array<Pathway>;
  status: MailOrderPathwayStatus;
};

export type ManualClaimExecutionInput = {
  groupId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
  subgroupId: Scalars['ID']['input'];
};

export type ManualClaimInput = {
  dawCode?: InputMaybe<Scalars['String']['input']>;
  daySupply: Scalars['Int']['input'];
  doctorNpi: Scalars['String']['input'];
  fillNumber?: InputMaybe<Scalars['Int']['input']>;
  filledDate: Scalars['Date']['input'];
  memberId: Scalars['ID']['input'];
  ndc: Scalars['String']['input'];
  pharmacyNpi: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  rxDate: Scalars['Date']['input'];
  testCaseName: Scalars['String']['input'];
  testCategory: ManualClaimTestCategory;
};

export enum ManualClaimTestCategory {
  AccumSatisfactions = 'ACCUM_SATISFACTIONS',
  Connect = 'CONNECT',
  Copay = 'COPAY',
  Daw = 'DAW',
  DaySupply = 'DAY_SUPPLY',
  Deductible = 'DEDUCTIBLE',
  DrugCategories = 'DRUG_CATEGORIES',
  Formulary = 'FORMULARY',
  FormularyModules = 'FORMULARY_MODULES',
  Hcr = 'HCR',
  Mmo = 'MMO',
  OutOfPocket = 'OUT_OF_POCKET',
  Preventative = 'PREVENTATIVE',
  PriorAuthorization = 'PRIOR_AUTHORIZATION',
  QuantityLimit = 'QUANTITY_LIMIT',
  RefillTooSoon = 'REFILL_TOO_SOON',
  StepTherapy = 'STEP_THERAPY'
}

export type ManualPlanCandidateInput = {
  /**
   * Required. The portal benefit plan (benefit_plan.uuid, not its Zebra plan id) the agent created
   * for this candidate, as a draft; the candidate is stored linked to it and DRAFT_CREATED, ready
   * for Deploy. The plan must exist, still be a draft, and not already belong to another candidate.
   * Unique within one call. Nullable only for compatibility: a candidate without one is rejected.
   */
  benefitPlanId?: InputMaybe<Scalars['ID']['input']>;
  /** Opaque to forge: stored as-is and relayed to Translation. Never read, never indexed, never returned. */
  candidatePayload: Scalars['Map']['input'];
  fieldCount?: Scalars['Int']['input'];
  /** See ImplementationManualPlanCandidate.isWorkbookTemplate: the workbook's template column, not a template plan. */
  isWorkbookTemplate?: Scalars['Boolean']['input'];
  lowConfidenceCount?: Scalars['Int']['input'];
  /** Position in the workbook, 1-based. Unique within one call; with manualUploadId it is the idempotency key. */
  ordinal: Scalars['Int']['input'];
  /** Spreadsheet column the plan was read from, e.g. 'AF'. At most 32 characters. */
  sourceColumn?: InputMaybe<Scalars['String']['input']>;
  /** Worksheet the plan was read from. At most 128 characters. */
  sourceSheet?: InputMaybe<Scalars['String']['input']>;
  suggestedName: Scalars['String']['input'];
};

export type Match = {
  __typename?: 'Match';
  created_at?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  match_expressions?: Maybe<Array<MatchExpression>>;
  updated_at?: Maybe<Scalars['Time']['output']>;
};

export type MatchExpression = {
  __typename?: 'MatchExpression';
  bool_value?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['Time']['output']>;
  datetime_value?: Maybe<Scalars['Time']['output']>;
  field: Scalars['String']['output'];
  float_value?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  int_value?: Maybe<Scalars['Int']['output']>;
  namespace: Scalars['String']['output'];
  operator: Scalars['String']['output'];
  string_value?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Time']['output']>;
};

export type MatchExpressionInput = {
  bool_value?: InputMaybe<Scalars['Boolean']['input']>;
  datetime_value?: InputMaybe<Scalars['Time']['input']>;
  field: Scalars['String']['input'];
  float_value?: InputMaybe<Scalars['Float']['input']>;
  int_value?: InputMaybe<Scalars['Int']['input']>;
  namespace: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  string_value?: InputMaybe<Scalars['String']['input']>;
};

export type MatchExpressionUpdate = {
  id: Scalars['ID']['input'];
  match_expressions: Array<MatchExpressionInput>;
};

export type MatchInput = {
  match_expressions?: InputMaybe<Array<MatchExpressionInput>>;
};

export type MatchRule = {
  __typename?: 'MatchRule';
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  last_materialized_at?: Maybe<Scalars['Time']['output']>;
  logic: Scalars['String']['output'];
  matches?: Maybe<Array<Match>>;
  name: Scalars['String']['output'];
  subtype?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  update_owner?: Maybe<Scalars['String']['output']>;
  update_schedule?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Time']['output']>;
};

export type MatchRuleDrugFilters = {
  dea_class_code?: InputMaybe<StringFilter>;
  gpi?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  label_name?: InputMaybe<StringFilter>;
  med_id?: InputMaybe<StringFilter>;
  mony?: InputMaybe<StringFilter>;
  ndc?: InputMaybe<StringFilter>;
};

export type MatchRuleDrugOrder = {
  name?: InputMaybe<OrderDirectionEnum>;
};

export type MatchRuleFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type MatchRuleInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logic: Scalars['String']['input'];
  matches?: InputMaybe<Array<MatchInput>>;
  name: Scalars['String']['input'];
  subtype?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  update_owner?: InputMaybe<Scalars['String']['input']>;
  update_schedule?: InputMaybe<Scalars['String']['input']>;
};

export type MatchRuleList = {
  __typename?: 'MatchRuleList';
  pagination: Pagination;
  results?: Maybe<Array<MatchRule>>;
};

export type MatchRuleOrder = {
  name?: InputMaybe<OrderDirectionEnum>;
  type?: InputMaybe<OrderDirectionEnum>;
};

export type Member = {
  __typename?: 'Member';
  accumulatorType?: Maybe<Scalars['String']['output']>;
  /** Accumulators - OOP-to-date and Deductible-to-date for a member and member's family for benefit year */
  accumulators?: Maybe<Accumulators>;
  /** The member's address line 1 */
  address_1?: Maybe<Scalars['String']['output']>;
  /** The member's address line 2 */
  address_2?: Maybe<Scalars['String']['output']>;
  /**
   * `null` means alt card IDs could not be resolved yet: the member is still
   * syncing to Zebra. An empty list means the member is synced and genuinely
   * has no alternate card IDs.
   *
   * Carries no `@audit` of its own: the collection that reached the member is what
   * records the disclosure, because one event per row is the shape a bulk read must
   * not take. A parent without an audit annotation therefore leaves this read
   * untracked — see docs/09-shared-portal-reads.md for which parents those are.
   */
  altCardIDs?: Maybe<Array<AltCardId>>;
  /** The member's alternative card ID */
  alt_card_id?: Maybe<Scalars['String']['output']>;
  /**
   * Date when approved advocate access expires.
   * After this date, the approved advocate designation is no longer valid.
   */
  approvedAdvocateExpirationDate?: Maybe<Scalars['Time']['output']>;
  /**
   * Comma-separated list of approved advocate names from Salesforce.
   * Used to determine if a member has an authorized advocate who can make decisions on their behalf.
   */
  approvedAdvocates?: Maybe<Scalars['String']['output']>;
  /** The date of the last member card id print date of the member */
  card_date_of_print?: Maybe<Scalars['Time']['output']>;
  /** The member's card ID */
  card_id: Scalars['String']['output'];
  /** The flag indicates whether or not the member card id will be printed */
  card_to_be_printed: Scalars['Boolean']['output'];
  /**
   * Salesforce cases (case requests) associated with this member.
   * Supports filtering, ordering, and forward pagination.
   */
  cases?: Maybe<CaseRequestConnection>;
  /** The member's city */
  city?: Maybe<Scalars['String']['output']>;
  /** The member's claims */
  claims?: Maybe<ClaimList>;
  /** The member's claims V2 */
  claimsV2?: Maybe<ClaimConnectionV2>;
  cobTimeline: Array<MemberCobTimelineRecord>;
  /** Name of carrier */
  cob_carrier_name: Scalars['String']['output'];
  /** Has COB coverage */
  cob_coverage?: Maybe<Scalars['Boolean']['output']>;
  /** Type of COB Coverage */
  cob_coverage_type?: Maybe<MemberCobCoverageTypeEnum>;
  /** Date COB ends */
  cob_end?: Maybe<Scalars['Time']['output']>;
  /** Date COB starts */
  cob_start?: Maybe<Scalars['Time']['output']>;
  /** The member's country */
  country?: Maybe<Scalars['String']['output']>;
  /** The member's coverage end date */
  coverage_end?: Maybe<Scalars['Time']['output']>;
  /** The member's coverage level */
  coverage_level: MemberCoverageLevelEnum;
  /** The member's coverage start date */
  coverage_start: Scalars['Time']['output'];
  /** The member's created time */
  created_at?: Maybe<Scalars['Time']['output']>;
  /** The member's date of birth */
  dateOfBirth: Scalars['Date']['output'];
  /**
   * The member's date of birth
   * @deprecated Use dateOfBirth
   */
  date_of_birth: Scalars['Time']['output'];
  /**
   * The date the member died, null when the member is not known to have died.
   *
   * Only `membersV2` sources this from Zebra; the `members` query has nowhere to read it
   * from and always reports null.
   */
  death_date?: Maybe<Scalars['Date']['output']>;
  /**
   * Whether the member is deceased.
   *
   * FHIR searches this concept both as a date and as a boolean, so both are exposed here.
   * They are stored separately rather than one being read off the other, so this can be true
   * with `death_date` null: a death may be reported without its date. The reverse cannot
   * happen — a member with a `death_date` is always deceased.
   *
   * Only `membersV2` sources this from Zebra; the `members` query has nowhere to read it
   * from and always reports false.
   */
  deceased: Scalars['Boolean']['output'];
  /** The member's department */
  department: Department;
  /**
   * Contains details of any data discrepancies found between PortalDB and ZebraDB.
   * Nil response means a sync to Zebra is in progress.
   */
  discrepancyDetails?: Maybe<MemberDiscrepancyDetails>;
  eligibilityFlagTimeline: Array<MemberEligibilityFlagTimelineRecord>;
  eligibilityTimeline: Array<MemberEligibilityTimelineRecord>;
  /** The member's email (from the Eligibility file -- not related to their account). */
  email?: Maybe<Scalars['String']['output']>;
  /** The member's emergency contact. */
  emergency_contact?: Maybe<EmergencyContact>;
  /** The member's family */
  family_members: Array<FamilyMember>;
  /**
   * The member's addresses, each in the shape FHIR gives an address.
   *
   * A list because an address is one in FHIR, and because a member may have more than one: a
   * mailing address distinct from a residence, or an address the member has moved away from.
   * Read every entry rather than only the first.
   */
  fhir_addresses: Array<MemberAddress>;
  /** The member's first name */
  first_name: Scalars['String']['output'];
  /** The member's gender */
  gender: MemberGenderEnum;
  /** The member's group */
  group: Group;
  groupTimeline: Array<CardholderToGroupTimelineRecord>;
  /** The member's unique identifier */
  id: Scalars['ID']['output'];
  /** The member's laker person code */
  laker_person_code: Scalars['String']['output'];
  /** The member's last name */
  last_name: Scalars['String']['output'];
  /** The member's marital status, from https://build.fhir.org/valueset-marital-status.html value set. */
  marital_status: MemberMaritalStatusEnum;
  /**
   * The member's marital status as a display name, e.g. "Legally Separated".
   *
   * This is the display FHIR publishes for the code behind `marital_status`.
   */
  marital_status_display: Scalars['String']['output'];
  /**
   * The member's prior authorizations (MPAs).
   * Fetches MPAs from the Zebra database for this member.
   */
  memberPriorAuthorizations: Mpav2Connection;
  /** The member's primary key id */
  member_id: Scalars['ID']['output'];
  /** The member's middle name */
  middle_name?: Maybe<Scalars['String']['output']>;
  /** The member's out of pocket cap accumulator value */
  out_of_pocket_cap_amount?: Maybe<Scalars['Int']['output']>;
  /**
   * Every coverage alternative for this member, read in one read-only transaction.
   * Requires the PA reviewer permissions and the enable_pa_assistant gate.
   */
  paAssistantCoverages: PaAssistantCoverageConnection;
  /**
   * The member's public patient identifier: the same UUID `id` holds, in the
   * public form (e.g. `smrx-1-mem-<uuid>`).
   */
  patient_id?: Maybe<Scalars['ID']['output']>;
  /** The member's person code */
  person_code: Scalars['String']['output'];
  /** The member's person uuid */
  person_uuid: Scalars['String']['output'];
  /** The member's alternative phone number */
  phone_alt?: Maybe<Scalars['String']['output']>;
  /** The member's cell phone number */
  phone_cell?: Maybe<Scalars['String']['output']>;
  /** The member's default phone number */
  phone_default?: Maybe<Scalars['String']['output']>;
  /** The member's home phone number */
  phone_home?: Maybe<Scalars['String']['output']>;
  /** The member's work phone number */
  phone_work?: Maybe<Scalars['String']['output']>;
  planCodes: Array<PlanCodeV2>;
  /**
   * The member's plan
   * @deprecated Use planCodes
   */
  plan_code?: Maybe<PlanCodeV2>;
  /** The member's potential benefit periods. */
  potentialLookbackBenefitPeriods?: Maybe<Array<BenefitPeriod>>;
  /** The member's preferred language as the code it is stored as, e.g. "en" or "es". */
  preferred_language?: Maybe<Scalars['String']['output']>;
  /** The member's preferred language as an English display name, e.g. "English". */
  preferred_language_display?: Maybe<Scalars['String']['output']>;
  /**
   * The `uuid` of the member holding the policy of this member's household, which is this
   * member itself when `type` is PRIMARY.
   *
   * It is resolved as of now, by the same rules as the group and the coverage window. Null
   * when the household has no policy holder on record. Only `membersV2` sources this from
   * Zebra.
   */
  primary_member_uuid?: Maybe<Scalars['ID']['output']>;
  /** The member's profile */
  profile?: Maybe<Profile>;
  /** The member's registration information */
  registration?: Maybe<Registration>;
  /** The member's relationship to the subscriber */
  relationship_to_subscriber: MemberRelationshipEnum;
  sdcTotals: SdcTotalsByScopeConnection;
  /** The member's social security number */
  ssn?: Maybe<Scalars['String']['output']>;
  /** The member's state */
  state?: Maybe<Scalars['String']['output']>;
  /** The member's coverage status */
  status: MemberStatusEnum;
  subgroupTimeline: Array<MemberToSubgroupTimelineRecord>;
  /** The member's subgroup v2 */
  subgroupV2: SubgroupDetail;
  /** The member's suffix */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The member's title if any */
  title: Scalars['String']['output'];
  /** The member's type */
  type: MemberTypeEnum;
  /** The member's updated time */
  updated_at?: Maybe<Scalars['Time']['output']>;
  /** Any workers compensation data associated with the member, if relevant to the plan */
  workers_comp?: Maybe<WorkersComp>;
  /** The member's zip code */
  zip?: Maybe<Scalars['String']['output']>;
};


export type MemberAccumulatorsArgs = {
  where?: InputMaybe<MemberAccumsFilter>;
};


export type MemberCasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<CaseRequestOrder>;
  where?: InputMaybe<CaseRequestFilters>;
};


export type MemberClaimsArgs = {
  order?: InputMaybe<Array<ClaimOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<ClaimFilters>;
};


export type MemberClaimsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClaimOrderV2>>;
  where?: InputMaybe<Array<ClaimFilterV2>>;
};


export type MemberCobTimelineArgs = {
  dataSource: DataSourceEnum;
};


export type MemberEligibilityFlagTimelineArgs = {
  dataSource: DataSourceEnum;
};


export type MemberEligibilityTimelineArgs = {
  dataSource: DataSourceEnum;
};


export type MemberGroupTimelineArgs = {
  dataSource: DataSourceEnum;
};


export type MemberMemberPriorAuthorizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<MpaOrderV2>;
  where?: InputMaybe<MpaFiltersV2>;
};


export type MemberPaAssistantCoveragesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberSdcTotalsArgs = {
  where: SdcTotalsByScopeFilters;
};


export type MemberSubgroupTimelineArgs = {
  dataSource: DataSourceEnum;
};

/** An admin restriction of a primary member's access to a dependent's PHI. */
export type MemberAccessRestriction = {
  __typename?: 'MemberAccessRestriction';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  liftedAt?: Maybe<Scalars['Time']['output']>;
  liftedBy?: Maybe<Scalars['String']['output']>;
};

export type MemberAccumsFilter = {
  /** when applied, returns values applicable at a given time */
  effectiveAt?: InputMaybe<TimeFilter>;
};

/**
 * One of a member's addresses, in the shape of the FHIR Address datatype
 * (https://hl7.org/fhir/R5/datatypes.html#Address).
 *
 * Every field is nullable, and `line` may be empty, because no part of an address is
 * required: an address may be known only by its city and state. A field is absent rather
 * than blank when it holds nothing.
 */
export type MemberAddress = {
  __typename?: 'MemberAddress';
  /** The city. */
  city?: Maybe<Scalars['String']['output']>;
  /**
   * The country. Defaults to "USA" when no country is recorded, so an address always names
   * one; it is not evidence that a country was given for the member.
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * The street lines, in order, the first being the street itself and the rest what follows
   * it, such as an apartment number. Empty for an address known only by its city or postal
   * code.
   */
  line: Array<Scalars['String']['output']>;
  /**
   * The postal code. Named for the FHIR field, which covers postal codes that are not US
   * ZIP codes.
   */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** The state. */
  state?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the address names somewhere post can be sent, somewhere that physically exists,
   * or both.
   */
  type?: Maybe<MemberAddressTypeEnum>;
  /** What the address is used for. */
  use?: Maybe<MemberAddressUseEnum>;
};

/**
 * MemberAddressTypeEnum describes whether an address names somewhere post can be sent,
 * somewhere that physically exists, or both.
 *
 * The values are the FHIR Address.type value set
 * (https://hl7.org/fhir/R5/valueset-address-type.html), whose binding is likewise a
 * required one.
 */
export enum MemberAddressTypeEnum {
  Both = 'BOTH',
  Physical = 'PHYSICAL',
  Postal = 'POSTAL'
}

/**
 * MemberAddressUseEnum describes what an address is used for.
 *
 * The values are the FHIR Address.use value set
 * (https://hl7.org/fhir/R5/valueset-address-use.html). That binding is a required one, so
 * these are the only uses an address can report: a use outside the set needs a FHIR
 * extension rather than a new value here.
 */
export enum MemberAddressUseEnum {
  Billing = 'BILLING',
  Home = 'HOME',
  Old = 'OLD',
  Temp = 'TEMP',
  Work = 'WORK'
}

export enum MemberCobCoverageTypeEnum {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  P = 'P',
  S = 'S',
  T = 'T',
  U = 'U'
}

export type MemberCobTimelineRecord = TimelineRecord & {
  __typename?: 'MemberCOBTimelineRecord';
  createdAt?: Maybe<Scalars['Time']['output']>;
  effectiveDate: Scalars['Date']['output'];
  /**
   * A temporary V2 that mirrors effectiveDate.
   * @deprecated Use effectiveDate, which is now non-nullable
   */
  effectiveDateV2: Scalars['Date']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  /**
   * Unique identifier for this timeline record, suitable for cache and fetching purposes.
   * Should be unique for each member (e.g., composite of member id + static string).
   */
  id: Scalars['ID']['output'];
  otherCoveragePrimary?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type MemberCobTimelineRecordInput = {
  effectiveDate: Scalars['Date']['input'];
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  otherCoveragePrimary: Scalars['Boolean']['input'];
  timelineRecordKey?: InputMaybe<Scalars['Int']['input']>;
};

export type MemberCardDetailsMpav2 = {
  __typename?: 'MemberCardDetailsMPAV2';
  cardID: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  groupNumber: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  personCode?: Maybe<Scalars['Int']['output']>;
};

export type MemberCardIdPrintInput = {
  /** The flag indicate whether or not the member card ID will be printed */
  card_print_button: Scalars['Boolean']['input'];
};

/** Returning the oldMember and the newMember to show the delta. */
export type MemberChange = {
  __typename?: 'MemberChange';
  errors: Array<MemberMergeError>;
  memberInfoOverride: Scalars['Boolean']['output'];
  newMember?: Maybe<Member>;
  oldMember?: Maybe<Member>;
  status: MemberMergeStatus;
  warnings: Array<MemberMergeError>;
};

/** Relay-style connection of Members sourced from the v2 member service. */
export type MemberConnection = {
  __typename?: 'MemberConnection';
  /**
   * Number of members that satisfy the filters (or total members when filters are omitted).
   * Computed lazily — only when this field is selected.
   */
  count: Scalars['Int']['output'];
  edges: Array<MemberEdge>;
  pageInfo: PageInfo;
};

export type MemberCoverageDrug = {
  __typename?: 'MemberCoverageDrug';
  labelName?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  ndc: Scalars['String']['output'];
};

export type MemberCoverageFormularyDrug = {
  __typename?: 'MemberCoverageFormularyDrug';
  isPriorAuth?: Maybe<Scalars['Boolean']['output']>;
  isSpecialty?: Maybe<Scalars['Boolean']['output']>;
  isStepTherapy?: Maybe<Scalars['Boolean']['output']>;
  quantityLimitCount?: Maybe<Scalars['String']['output']>;
  quantityLimitDuration?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  tierDescription?: Maybe<Scalars['String']['output']>;
};

export enum MemberCoverageLevelEnum {
  Double = 'DOUBLE',
  Family = 'FAMILY',
  Individual = 'INDIVIDUAL'
}

export type MemberDiscrepancyDetails = {
  __typename?: 'MemberDiscrepancyDetails';
  cobTimeline?: Maybe<TimelineDiscrepancies>;
  dataSources?: Maybe<Array<DataSourceEnum>>;
  eligibilityFlagsTimeline?: Maybe<TimelineDiscrepancies>;
  /**
   * Timeline record matching info between Portal and Zebra databases.
   * Each field contains match details for the corresponding timeline type.
   */
  eligibilityTimeline?: Maybe<TimelineDiscrepancies>;
  groupTimeline?: Maybe<TimelineDiscrepancies>;
  /**
   * Unique identifier for this discrepancy details object, suitable for cache and fetching purposes.
   * Should be unique for each member (e.g., composite of member id + static string).
   */
  id: Scalars['ID']['output'];
  metadataDiscrepancies?: Maybe<Array<MetadataDiscrepancy>>;
  subgroupTimeline?: Maybe<TimelineDiscrepancies>;
};

/**
 * Coverage of one drug under the member's current plan and the requested network.
 * It is calculated per request rather than stored, so it has no global ID.
 */
export type MemberDrugCoverage = {
  __typename?: 'MemberDrugCoverage';
  coinsurance?: Maybe<Scalars['String']['output']>;
  copay?: Maybe<Scalars['String']['output']>;
  coverage?: Maybe<Scalars['String']['output']>;
  drug: MemberCoverageDrug;
  formularyDrug?: Maybe<MemberCoverageFormularyDrug>;
};

export type MemberDrugCoverageConnection = {
  __typename?: 'MemberDrugCoverageConnection';
  count: Scalars['Int']['output'];
  edges: Array<MemberDrugCoverageEdge>;
  pageInfo: PageInfo;
};

export type MemberDrugCoverageEdge = {
  __typename?: 'MemberDrugCoverageEdge';
  cursor: Scalars['String']['output'];
  node: MemberDrugCoverage;
};

export type MemberDrugCoverageInput = {
  daysSupply?: InputMaybe<Scalars['Int']['input']>;
  /** Starts-with match on the drug label name, at least two characters */
  labelName?: InputMaybe<Scalars['String']['input']>;
  /** Comma-separated NDCs; exactly one of ndc and labelName is required */
  ndc?: InputMaybe<Scalars['String']['input']>;
  /** The `SuperNetwork.id` of one of the included networks of the member's current plan */
  superNetworkId: Scalars['ID']['input'];
};

/** Earlier entries, and earlier fields within an entry, take precedence */
export type MemberDrugCoverageOrder = {
  coverage?: InputMaybe<OrderDirectionEnum>;
  labelName?: InputMaybe<OrderDirectionEnum>;
  ndc?: InputMaybe<OrderDirectionEnum>;
};

export type MemberDrugLookupLinkOption = {
  __typename?: 'MemberDrugLookupLinkOption';
  /** The name of the option */
  option: Scalars['String']['output'];
};

export type MemberDrugLookupLinkOptionList = {
  __typename?: 'MemberDrugLookupLinkOptionList';
  results?: Maybe<Array<MemberDrugLookupLinkOption>>;
};

/** Relay-style edge associated with a Member. */
export type MemberEdge = {
  __typename?: 'MemberEdge';
  cursor: Scalars['String']['output'];
  node: Member;
};

export type MemberEligibilityFlagTimelineRecord = TimelineRecord & {
  __typename?: 'MemberEligibilityFlagTimelineRecord';
  createdAt: Scalars['Time']['output'];
  effectiveDate: Scalars['Date']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  flagCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type MemberEligibilityFlagTimelineRecordInput = {
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  flagCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MemberEligibilityTimelineRecord = TimelineRecord & {
  __typename?: 'MemberEligibilityTimelineRecord';
  adjudicatorPersonCode: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  effectiveDate: Scalars['Date']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  memberType: MemberTypeEnum;
  providerPersonCode: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type MemberEligibilityTimelineRecordInput = {
  effectiveDate: Scalars['Date']['input'];
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  timelineRecordKey?: InputMaybe<Scalars['Int']['input']>;
};

export type MemberFilters = {
  address_city?: InputMaybe<StringFilter>;
  address_country?: InputMaybe<StringFilter>;
  /**
   * The address's postal code. Named for the FHIR field, which covers postal codes that are
   * not US ZIP codes.
   */
  address_postal_code?: InputMaybe<StringFilter>;
  address_state?: InputMaybe<StringFilter>;
  address_type?: InputMaybe<MemberAddressTypeEnum>;
  /**
   * The following filter `fhir_addresses`, one part of an address each, after the FHIR
   * Patient search parameters of the same names (`address-city`, `address-use`, ...).
   */
  address_use?: InputMaybe<MemberAddressUseEnum>;
  card_id?: InputMaybe<StringFilter>;
  date_of_birth?: InputMaybe<TimeFilter>;
  /**
   * The date the member died. Only `membersV2` evaluates this filter; the `members` query
   * reads PortalDB, which has no death_date column, so it is silently ignored there.
   */
  death_date?: InputMaybe<DateFilter>;
  /**
   * Whether the member is deceased. Filter on this rather than on `death_date` being present:
   * the two are stored separately, so a member can be deceased with no date recorded.
   *
   * Only `membersV2` evaluates this filter, for the same reason `death_date` gives.
   */
  deceased?: InputMaybe<BooleanFilter>;
  emergency_contact_name?: InputMaybe<StringFilter>;
  /**
   * The emergency contact's phone number, as stored. There is no normalisation: a filter
   * matches only the digits and punctuation the number was recorded with.
   */
  emergency_contact_phone?: InputMaybe<StringFilter>;
  emergency_contact_relationship?: InputMaybe<StringFilter>;
  first_name?: InputMaybe<StringFilter>;
  /** Get Eligibility History Records */
  getEligHistory?: InputMaybe<BooleanFilter>;
  /**
   * The group's code, as reported by `group { code }` — not the group UUID `group_id` takes.
   * Both select the same members, so use whichever identifier you hold.
   *
   * Matched exactly, and codes are stored upper-cased: `cauto` finds nothing, `CAUTO` finds the
   * group.
   */
  group_code?: InputMaybe<StringFilter>;
  group_id?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  last_name?: InputMaybe<StringFilter>;
  /**
   * The member's marital status. Filter by the value `marital_status` reports; the stored HL7
   * code behind it is not exposed.
   *
   * UNKNOWN matches every member whose stored code has no status of its own, which is what
   * `marital_status` reports for them.
   */
  marital_status?: InputMaybe<MemberMaritalStatusEnum>;
  person_code?: InputMaybe<StringFilter>;
  /**
   * The member's preferred language, filtered on the stored code (e.g. "en"), not on the
   * display name `preferred_language_display` reports.
   *
   * Only `membersV2` evaluates the filters below this line.
   */
  preferred_language?: InputMaybe<StringFilter>;
  relationship_to_subscriber?: InputMaybe<StringFilter>;
  skipValidCoverageChecks?: InputMaybe<BooleanFilter>;
  ssn?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  sub_group_id?: InputMaybe<IdFilter>;
  /**
   * typeahead is a filter meant to be used for typeahead searches, typically used in searchboxes and dropdown selects in
   * the UI. This typeahead filter does an OR search on member card ID, and the member's first and last name.
   */
  typeahead?: InputMaybe<StringFilter>;
};

/** MemberFullReplacementAccumulator holds the accumulator information for the Med Replacement and Full Replacement accumulator types */
export type MemberFullReplacementAccumulator = {
  __typename?: 'MemberFullReplacementAccumulator';
  /**
   * assist deductible accumulator value of a the member
   * sum of all the ingested third party Rx Deductible accumulator values (RxNxt, RxPartner ...)
   */
  assistDeductible?: Maybe<Scalars['Int']['output']>;
  /**
   * assist oop accumulator value of a the member
   * sum of all the ingested third party Rx OOP accumulator values (RxNxt, RxPartner ...)
   */
  assistOop?: Maybe<Scalars['Int']['output']>;
  /** The time the record was last updated. */
  credentialId?: Maybe<Scalars['Int']['output']>;
  /** full deductible accumulator value of a the member, this can be changed from the UI */
  fullDeductible: Scalars['Int']['output'];
  /** full oop accumulator value of a the member, this can be changed from the UI */
  fullOop: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** med deductible accumulator value of a the member, this can be changed from the UI */
  medDeductible: Scalars['Int']['output'];
  /** med OOP accumulator value of a the member, this can be changed from the UI */
  medOop: Scalars['Int']['output'];
  membershipId: Scalars['ID']['output'];
  /** rx deductible accumulator value of a the member */
  rxDeductible: Scalars['Int']['output'];
  /** laker deductible accumulator value of a the member */
  rxLakerDeductible: Scalars['Int']['output'];
  /** laker oop accumulator value of a the member */
  rxLakerOop: Scalars['Int']['output'];
  /** rx oop accumulator value of a the member */
  rxOop: Scalars['Int']['output'];
  /** rxnxt deductible accumulator value of a the member */
  rxRxnxtDeductible: Scalars['Int']['output'];
  /** rxnxt oop accumulator value of a the member */
  rxRxnxtOop: Scalars['Int']['output'];
  /** The time the record was last updated. */
  updatedAt: Scalars['Time']['output'];
};

export type MemberFullReplacementAccumulatorFilters = {
  /** when applied, returns values applicable at a given time */
  effectiveAt?: InputMaybe<TimeFilter>;
  membershipId?: InputMaybe<IdFilter>;
};

export type MemberFullReplacementAccumulatorInput = {
  accumulatorType: Scalars['String']['input'];
  effectiveAt?: InputMaybe<Scalars['Time']['input']>;
  fullDeductible: Scalars['Int']['input'];
  fullOop: Scalars['Int']['input'];
  medDeductible: Scalars['Int']['input'];
  medOop: Scalars['Int']['input'];
  membershipId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type MemberFullReplacementAccumulatorList = {
  __typename?: 'MemberFullReplacementAccumulatorList';
  results: Array<MemberFullReplacementAccumulator>;
};

export enum MemberGenderEnum {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

/**
 * MemberKey uses string ProviderPersonCode which comes from provider during file ingestion.
 *  in contrast with MemberKeyV2 which uses adjudicator person code generate by us.
 */
export type MemberKey = {
  cardID: Scalars['String']['input'];
  groupNumber: Scalars['String']['input'];
  personCode: Scalars['String']['input'];
};

export type MemberKeyV2 = {
  cardId: Scalars['String']['input'];
  groupNumber: Scalars['String']['input'];
  personCode: Scalars['Int']['input'];
};

export type MemberList = {
  __typename?: 'MemberList';
  /** Link to compressed members.csv, reuploads file to S3 each time read */
  csvDownloadURL?: Maybe<Scalars['String']['output']>;
  pagination: Pagination;
  results: Array<Member>;
};

/**
 * MemberMaritalStatusEnum describes a member's marital status.
 *
 * The values are the FHIR Patient.maritalStatus value set
 * (https://build.fhir.org/valueset-marital-status.html), named after each code's display
 * rather than the code itself. The trailing comments give the HL7 code stored in the
 * database; Member.marital_status_display gives the display.
 *
 * No eligibility file or API writes this data yet, so every member currently reports
 * UNKNOWN. UNKNOWN is a distinct value rather than a null so that "we hold no
 * information" is never confused with NEVER_MARRIED.
 */
export enum MemberMaritalStatusEnum {
  Annulled = 'ANNULLED',
  CommonLaw = 'COMMON_LAW',
  Divorced = 'DIVORCED',
  DomesticPartner = 'DOMESTIC_PARTNER',
  Interlocutory = 'INTERLOCUTORY',
  LegallySeparated = 'LEGALLY_SEPARATED',
  Married = 'MARRIED',
  NeverMarried = 'NEVER_MARRIED',
  Polygamous = 'POLYGAMOUS',
  Unknown = 'UNKNOWN',
  Unmarried = 'UNMARRIED',
  Widowed = 'WIDOWED'
}

export type MemberMedicalClaim = {
  __typename?: 'MemberMedicalClaim';
  adjudicationDate: Scalars['Time']['output'];
  authId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  credentialId?: Maybe<Scalars['String']['output']>;
  deductibleAmount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  memberOutOfPocketCapAmount: Scalars['Int']['output'];
  membershipId: Scalars['ID']['output'];
  meta?: Maybe<Scalars['Map']['output']>;
  planPaidCapAmount: Scalars['Int']['output'];
  sdcAmount: Scalars['Int']['output'];
  sdcId?: Maybe<Scalars['String']['output']>;
  trxMedclaimId?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
};

export type MemberMedicalClaimCreateInput = {
  adjudicationDate: Scalars['Time']['input'];
  deductibleAmount: Scalars['Int']['input'];
  memberOutOfPocketCapAmount: Scalars['Int']['input'];
  membershipId: Scalars['ID']['input'];
  planPaidCapAmount: Scalars['Int']['input'];
};

export type MemberMedicalClaimDeleteInput = {
  id: Scalars['ID']['input'];
};

export type MemberMedicalClaimFilters = {
  membershipId?: InputMaybe<IdFilter>;
};

export type MemberMedicalClaimInput = {
  action: AccumulatorActionEnum;
  adjudicationDate: Scalars['Time']['input'];
  deductibleAmount: Scalars['Int']['input'];
  effectiveAt?: InputMaybe<Scalars['Time']['input']>;
  id: Scalars['ID']['input'];
  memberOutOfPocketCapAmount: Scalars['Int']['input'];
  membershipId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  planPaidCapAmount: Scalars['Int']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type MemberMedicalClaimList = {
  __typename?: 'MemberMedicalClaimList';
  pagination: Pagination;
  results: Array<MemberMedicalClaim>;
};

export type MemberMedicalClaimOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
};

export type MemberMedicalClaimUpdateInput = {
  adjudicationDate: Scalars['Time']['input'];
  deductibleAmount: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  memberOutOfPocketCapAmount: Scalars['Int']['input'];
  planPaidCapAmount: Scalars['Int']['input'];
};

export enum MemberMergeError {
  DuplicateNewMember = 'DUPLICATE_NEW_MEMBER',
  DuplicateOldMember = 'DUPLICATE_OLD_MEMBER',
  ErrorDeletingOldMember = 'ERROR_DELETING_OLD_MEMBER',
  ErrorInPrimaryMember = 'ERROR_IN_PRIMARY_MEMBER',
  ErrorMergingClaims = 'ERROR_MERGING_CLAIMS',
  ErrorMergingFamilyMember = 'ERROR_MERGING_FAMILY_MEMBER',
  ErrorMovingAccums = 'ERROR_MOVING_ACCUMS',
  ErrorMovingAuthorizations = 'ERROR_MOVING_AUTHORIZATIONS',
  ErrorQueueingCasSync = 'ERROR_QUEUEING_CAS_SYNC',
  ErrorSettingAltCardId = 'ERROR_SETTING_ALT_CARD_ID',
  ErrorValidatingFamily = 'ERROR_VALIDATING_FAMILY',
  FailedToParseData = 'FAILED_TO_PARSE_DATA',
  GroupAccumTypeMismatch = 'GROUP_ACCUM_TYPE_MISMATCH',
  GroupCodeMismatch = 'GROUP_CODE_MISMATCH',
  MemberInfoMismatch = 'MEMBER_INFO_MISMATCH',
  NewGroupNotFound = 'NEW_GROUP_NOT_FOUND',
  NewMemberNotFound = 'NEW_MEMBER_NOT_FOUND',
  OldGroupNotFound = 'OLD_GROUP_NOT_FOUND',
  OldMemberNotFound = 'OLD_MEMBER_NOT_FOUND',
  PrimaryMissingDependents = 'PRIMARY_MISSING_DEPENDENTS',
  PrimaryToDependent = 'PRIMARY_TO_DEPENDENT',
  SubscriptionNotFound = 'SUBSCRIPTION_NOT_FOUND'
}

/** The `MemberMergeParams` represent the options for when executing a member merge. */
export type MemberMergeParams = {
  bulkCASSyncV2: Scalars['Boolean']['input'];
  dryRun: Scalars['Boolean']['input'];
  setAltCardId: Scalars['Boolean']['input'];
};

/**
 * The `MemberMergeResult` from the memberMerge mutation. This can either return `changes` or the links to s3 files for download,
 * `resultsFile` and `errorsFile`.
 */
export type MemberMergeResult = {
  __typename?: 'MemberMergeResult';
  changes: Array<MemberChange>;
  dryRun: Scalars['Boolean']['output'];
  errorsFile: Scalars['URL']['output'];
  resultsFile: Scalars['URL']['output'];
};

export enum MemberMergeStatus {
  MergeCompleted = 'MERGE_COMPLETED',
  MergeDrySuccess = 'MERGE_DRY_SUCCESS',
  MergeError = 'MERGE_ERROR',
  MergeInvalid = 'MERGE_INVALID',
  MergeRequested = 'MERGE_REQUESTED',
  MergeValidated = 'MERGE_VALIDATED'
}

export type MemberOrder = {
  card_id?: InputMaybe<OrderDirectionEnum>;
  created_at?: InputMaybe<OrderDirectionEnum>;
  date_of_birth?: InputMaybe<OrderDirectionEnum>;
  first_name?: InputMaybe<OrderDirectionEnum>;
  last_name?: InputMaybe<OrderDirectionEnum>;
  person_code?: InputMaybe<OrderDirectionEnum>;
  ssn?: InputMaybe<OrderDirectionEnum>;
  status?: InputMaybe<OrderDirectionEnum>;
  updated_at?: InputMaybe<OrderDirectionEnum>;
};

export enum MemberPriorAuthType {
  /** MemberPriorAuthTypeApproved */
  A = 'A',
  /** MemberPriorAuthTypeDeclined */
  D = 'D'
}

/**
 * MemberRelationshipEnum values are written to the `relationship_to_subscriber` field on the `membership` table.
 * They are lowercase on purpose.
 */
export enum MemberRelationshipEnum {
  Child = 'child',
  Other = 'other',
  Primary = 'primary',
  Spouse = 'spouse'
}

export enum MemberStatusEnum {
  Active = 'ACTIVE',
  Future = 'FUTURE',
  Inactive = 'INACTIVE'
}

export type MemberTimelineRecord = CardholderToGroupTimelineRecord | MemberCobTimelineRecord | MemberEligibilityFlagTimelineRecord | MemberEligibilityTimelineRecord | MemberToSubgroupTimelineRecord;

export type MemberToSubgroupTimelineRecord = TimelineRecord & {
  __typename?: 'MemberToSubgroupTimelineRecord';
  benefitPlan?: Maybe<BenefitPlan>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  effectiveDate: Scalars['Date']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  groupNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  subgroupNumber: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type MemberToSubgroupTimelineRecordInput = {
  effectiveDate: Scalars['Date']['input'];
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  /** In zebra source flow: id is for updating an existing record - if not provided, a new record will be created. */
  id?: InputMaybe<Scalars['ID']['input']>;
  subgroupKey: SubgroupKey;
  timelineRecordKey?: InputMaybe<Scalars['Int']['input']>;
};

/** MemberTypeEnum values are written to the `type` field on the `membership` table. They are lowercase on purpose. */
export enum MemberTypeEnum {
  Dependent = 'dependent',
  Primary = 'primary'
}

export type MemberV2 = {
  __typename?: 'MemberV2';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  cardId?: Maybe<Scalars['String']['output']>;
  cardholderId: Scalars['ID']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['String']['output'];
  dob?: Maybe<Scalars['Time']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employerID?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  flex2?: Maybe<Scalars['String']['output']>;
  gender: Scalars['Int']['output'];
  group?: Maybe<Group>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  /**
   * The member's prior authorizations (MPAs).
   * Retrieves MPAs where the member is either the specific member or MPAs that apply to all members on the card.
   * This includes both member-specific MPAs (member = this member's UUID) and card-level MPAs (member IS NULL).
   */
  memberPriorAuthorizations: Mpav2Connection;
  middleName?: Maybe<Scalars['String']['output']>;
  patientResidence?: Maybe<Scalars['String']['output']>;
  personCode: Scalars['Int']['output'];
  phoneAlt?: Maybe<Scalars['String']['output']>;
  phoneCell?: Maybe<Scalars['String']['output']>;
  phoneDefault?: Maybe<Scalars['String']['output']>;
  phoneHome?: Maybe<Scalars['String']['output']>;
  phoneWork?: Maybe<Scalars['String']['output']>;
  placeOfService?: Maybe<Scalars['Int']['output']>;
  /**
   * The portal membership UUID for this member.
   * Null when no portal membership matches the member's natural key (group + card ID + person code).
   */
  portalMembershipUUID?: Maybe<Scalars['ID']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  pregnancyIndicator?: Maybe<Scalars['String']['output']>;
  primaryCardholder?: Maybe<Scalars['Boolean']['output']>;
  relationshipCode: Scalars['Int']['output'];
  serviceId?: Maybe<Scalars['Int']['output']>;
  smoker?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type MemberV2MemberPriorAuthorizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<MpaOrderV2>;
  where?: InputMaybe<MpaFiltersV2>;
};

export type MembershipSync = {
  __typename?: 'MembershipSync';
  cardID: Scalars['String']['output'];
  destinations?: Maybe<Array<SyncDestination>>;
  failureReason?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  groupCode: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  groupUUID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  membershipUUID: Scalars['ID']['output'];
  personCode: Scalars['String']['output'];
  result: MembershipSyncResult;
};

export type MembershipSyncConnection = {
  __typename?: 'MembershipSyncConnection';
  edges?: Maybe<Array<MembershipSyncEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MembershipSyncEdge = {
  __typename?: 'MembershipSyncEdge';
  cursor: Scalars['String']['output'];
  node: MembershipSync;
};

export enum MembershipSyncOrderField {
  FullName = 'FULL_NAME',
  GroupCode = 'GROUP_CODE',
  Id = 'ID'
}

export enum MembershipSyncResult {
  Failure = 'FAILURE',
  InProgress = 'IN_PROGRESS',
  Skipped = 'SKIPPED',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN'
}

export type MetadataDiscrepancy = {
  __typename?: 'MetadataDiscrepancy';
  fieldName: Scalars['String']['output'];
  portalDbValue?: Maybe<Scalars['String']['output']>;
  zebraDbValue?: Maybe<Scalars['String']['output']>;
};

export type MiscHandler = {
  __typename?: 'MiscHandler';
  created: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  miscHandlerDetails: Array<MiscHandlerDetail>;
  modified: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MiscHandlerConnection = {
  __typename?: 'MiscHandlerConnection';
  edges: Array<MiscHandlerEdge>;
  pageInfo: PageInfo;
};

export type MiscHandlerDetail = {
  __typename?: 'MiscHandlerDetail';
  consecutive?: Maybe<Scalars['Boolean']['output']>;
  consecutiveDays?: Maybe<Scalars['Int']['output']>;
  dollarAction?: Maybe<DollarAction>;
  dollarPeriod?: Maybe<PeriodType>;
  dollarPeriodX?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  ignoreCurrentScript?: Maybe<Scalars['Int']['output']>;
  matchDigits?: Maybe<Scalars['Int']['output']>;
  matchHandler?: Maybe<Scalars['Int']['output']>;
  matchHistGroup?: Maybe<Scalars['Int']['output']>;
  matchMony?: Maybe<MonyCode>;
  matchSelRange?: Maybe<Scalars['Int']['output']>;
  maxDollars?: Maybe<Scalars['Float']['output']>;
  miscHandlerUuid: Scalars['ID']['output'];
  type: MiscHandlerDetailType;
  unitPeriod?: Maybe<PeriodType>;
  unitPeriodX?: Maybe<Scalars['Int']['output']>;
  unitType?: Maybe<UnitType>;
  units?: Maybe<Scalars['Float']['output']>;
};

export type MiscHandlerDetailOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
};

export enum MiscHandlerDetailType {
  /** P */
  Primary = 'PRIMARY',
  /** S */
  Secondary = 'SECONDARY',
  /** T */
  Tertiary = 'TERTIARY'
}

export type MiscHandlerEdge = {
  __typename?: 'MiscHandlerEdge';
  cursor: Scalars['String']['output'];
  node: MiscHandler;
};

export type MiscHandlerFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type MiscHandlerOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export type ModifyMemberMedicalClaimInput = {
  transactions: Array<MemberMedicalClaimInput>;
};

export type ModifySdcAccumTransactionsInput = {
  transactions: Array<SdcAccumTransactionsInput>;
};

export type ModifyTestCaseListInput = {
  /** List of existing and new test cases input */
  plan_test_cases: Array<PlanTestCaseInput>;
  /** Test Cases are being modified and created for specified plan test suite ID */
  plan_test_suite_id: Scalars['ID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  CreateContact: Contact;
  DeleteContact?: Maybe<Scalars['ID']['output']>;
  /** placeholder to ensure no empty types (gql requirement) */
  Empty?: Maybe<Scalars['String']['output']>;
  /** Run CAS sync for Member, this is important to be also available to Buwelo */
  RunCASSyncForMember: Scalars['Boolean']['output'];
  UpdateContact: Contact;
  /** Updates that can be made by existing members to their profile */
  UpdateMemberProfile?: Maybe<Member>;
  /** add a new full replacement transaction or medical transaction of member accumulator or sdc values */
  addAccumTransaction: Scalars['Boolean']['output'];
  addDrugListItemV2?: Maybe<DrugListItemV2>;
  /** add a new SDC transaction */
  addSDCTransaction: Scalars['Boolean']['output'];
  /**
   * Adds one or more drugs to a drug list, returning a list of Match objects corresponding
   * to the rows in the table (each row in the UI being on Match).
   * Each [MatchExpressionInput!] corresponds to a row in the sub-table, putting them into
   * the parent list then enables multiple adds to happen in a single mutation.
   */
  add_drug_to_list?: Maybe<Array<Match>>;
  adjustClaim: AdjustClaimOutput;
  /**
   * Approve a list of Sent835s. This request will generate a NACHA file from the approved 835s, move the files to the
   * appropriate locations, and update the status of the sent_835s records. The mutation takes a list of Sent835 IDs to
   * approve. It returns the ID of the generated NACHA file.
   */
  approveSent835s?: Maybe<Scalars['ID']['output']>;
  associateGroupToAccount: Group;
  associateGroupToPartner: RelatedGroup;
  associatePartnerToAccount: AccountPartner;
  /**
   * Automatically selects the MPA template for a claim by matching its reject
   * codes, then returns a non-persisted MPA prefilled from that template (core
   * fields plus claim instructions) alongside the matched template's info.
   *
   * This is the default path when opening an MPA from a claim. When the reject
   * codes match no template, `templateInfo` and `prefilledInstructions` come
   * back empty and only the MPA core fields (dates, GPI level, NDC) are filled,
   * so the client falls back to manual entry. When they match more than one
   * template, the first matching reject in claim order wins; the user can
   * switch templates afterwards.
   */
  buildMPAFromTemplate: MpaTemplate;
  /** Bulk save CostListDetails for a CostList, supporting deletes as well. */
  bulkSaveCostListDetail: Array<CostListDetail>;
  /** Bulk set expiration date for multiple prescribers in a list (bulk terminate) */
  bulkTerminatePrescribers: Scalars['Boolean']['output'];
  bulkUpdateProcessRuleLines: BulkUpdateProcessRuleLinesResponse;
  /**
   * Bulk update test case results
   * Updates result and/or issue_category for multiple test case results
   */
  bulkUpdateTestCaseResults: BulkUpdateTestCaseResultsResponse;
  /** API to create, update or delete designated pharmacy records. */
  bulkUpsertDesignatedPharmacy: Array<Maybe<DesignatedPharmacy>>;
  bulkUpsertProcessRuleAttachments: BulkUpsertProcessRuleAttachmentsPayload;
  chainUpsertBulk: Array<ChainUpsertResult>;
  checkNameIsUnique: Scalars['String']['output'];
  claimSetCreate: ClaimSet;
  /**
   * clone plan components clones the plan components like accumulator, plan_rules, programs, allowances, overrides, etc.
   * type: the type of the plan component to clone
   * type: accumulator, plan_rule, program, allowance, override
   */
  clone_plan_component: Scalars['Boolean']['output'];
  /**
   * Deploy. Clears benefit_plan.isDraft and advances the candidate DRAFT_CREATED -> COMMITTED in one transaction, moving its
   * implementation manual AWAITING_REVIEW -> COMPLETED when this was the last draft. Idempotent.
   * Attaches nothing — no plan_code, no group. Makes the plan attachable; attachment is a separate act.
   * Identify the draft by its plan candidate or by its benefit plan; exactly one.
   */
  commitDraftPlan: BenefitPlan;
  /**
   * Kicks off the commit process for all valid rows in the IFP file.
   * This is a fast, non-blocking call that queues a task for the worker.
   * Returns the IFPFile in a 'QUEUED_FOR_COMMIT' state.
   *
   * Includes scoped filtering to only allow committing certain job types
   * based on user permissions.
   *
   * Example: Only users with 'create_department' permission can commit
   * DEPARTMENT_CREATE IFP files.
   */
  commitIFPFile?: Maybe<IfpFile>;
  /**
   * Sets the 'groups_in_zebra' toggle to 2 (Full Zebra Adjudication) and sets
   * the group's zebraSyncStrategy to 'subgroups_synced'.
   * WARNING: This ONLY updates the feature flag and sync strategy for the group in the database.
   * It does NOT perform any other action to set up Zebra infrastructure.
   */
  configureGroupForZebra: Group;
  /**
   * copy_programs
   * Copies the programs with the specified IDs onto the plan with the specified ID
   * id: the benefit plan ID to which we are copying the programs
   * program_ids: the IDs of the programs to be copied
   * isFuture: whether the programs are future programs
   */
  copy_programs?: Maybe<Array<PlanRule>>;
  createAccount: Account;
  createAltCardID: AltCardId;
  /**
   * Synchronously uploads a file to S3 and creates an
   * IFPFile record with status 'QUEUED_FOR_VALIDATION'.
   * Returns the specific IFPFile interface.
   *
   * Includes scoped filtering to only allow creating certain job types
   * based on user permissions.
   *
   * Example: Only users with 'create_department' permission can create
   * DEPARTMENT_CREATE IFP files.
   */
  createAndUploadIFPFile?: Maybe<IfpFile>;
  createBatchDataSyncJob: CreateBatchDataSyncJobResponse;
  createCOBObject: CreateCobObjectPayload;
  /** Create a new connection. */
  createConnection?: Maybe<Connection>;
  createCopiedProcessRule: ProcessRule;
  /** Create a new CostList and copy details from an existing CostList if `copyFromID` is provided. */
  createCostList: CostList;
  /** Create a new CostGroup. */
  createCostListGroup: CostListGroup;
  createCustomDrugListV2?: Maybe<CustomDrugListV2>;
  createDURObject: DurObject;
  /** @deprecated Use groupCreateDepartment */
  createDepartment: Department;
  /** Create a dependent member */
  createDependent?: Maybe<Member>;
  /** Initiate a DrugListUpload and return a pre-signed URL for uploading the file. */
  createDrugListUpload: CreateDrugListUploadOutput;
  /** Create a new fill rule */
  createFillRule: FillRule;
  createGroup: Group;
  /** Create a new Handler (Age, Cost, etc) and optionally copy details from another */
  createHandlerAndCopyDetails: Scalars['ID']['output'];
  /**
   * Synchronously uploads a custom drug list file to S3 and creates an
   * IFPFile record with status 'QUEUED_FOR_VALIDATION' to be processed asynchronously.
   * This mutation handles the upload and queuing; validation and further processing occur asynchronously.
   * The update type determines how existing drug data should be handled:
   * - 'create_update': Create new drugs and update existing ones
   * - 'create_update_delete': Create new drugs, update existing ones, and delete omitted drugs
   * - null: Default behavior (typically 'create_update')
   */
  createIFPDrugListUpload: CreateIfpDrugListUploadPayload;
  /**
   * Stores the workbook and opens a SCANNING work item. A rejection carries a stable
   * `code` extension: FILE_REQUIRED, FILE_TOO_LARGE (with `maxBytes`), UNSUPPORTED_FILE_TYPE,
   * NOT_A_WORKBOOK, BAD_USER_INPUT, or DUPLICATE_MANUAL. DUPLICATE_MANUAL also carries
   * `existingUploadId`, `existingReference` and `existingStatus` when forge can name the
   * work item already holding this file, so the client can link to it.
   */
  createImplementationManualUpload: ImplementationManualUpload;
  /**
   * createLakerMpa is used to create MPA record in Laker.
   *
   * Shares requester->group access and the per-group mpa_override toggle with
   * createMpaOverride, so non-root callers get the same denials: a group without
   * the toggle gets "feature not enabled for this group"; a caller outside the
   * group gets "not authorized". Root callers bypass both checks.
   */
  createLakerMpa: CreateLakerMpaResponse;
  /**
   * Reported by the AI Orchestrator when extraction finishes. Idempotent on (manualUploadId,
   * ordinal). Moves the work item to AWAITING_REVIEW in the same transaction, or back to it from
   * COMPLETED when a replay adds a plan. A first report with no plans fails the work item and
   * returns it. A payload larger than MAX_CANDIDATES_PER_MANUAL writes no candidates, fails a work
   * item not yet under review, and raises TOO_MANY_CANDIDATES.
   */
  createManualPlanCandidates: ImplementationManualUpload;
  /** Restricts the primary from the dependent's PHI. Fails if the pair is already restricted. */
  createMemberAccessRestriction: MemberAccessRestriction;
  /** Create full oop or full deductible or med oop or med deductible of member accumulator values */
  createMemberFullReplacementAccumulator?: Maybe<MemberFullReplacementAccumulator>;
  /** Create member medical claim data */
  createMemberMedicalClaim?: Maybe<MemberMedicalClaim>;
  /**
   * createMpaOverride creates a partner-context MPA override directly in Zebra
   * (memberpriorauth). Gated by the `enable_mpa_override` Statsig gate and the
   * per-group mpa_override feature toggle, and requester->group access within the
   * resolver, so we can bypass standard FGA within the `authorize_inputs.go`.
   * Root callers bypass the gate, the toggle and the group check. For everyone
   * else: a group without the toggle gets "feature not enabled for this group";
   * a caller outside the group, or any caller while the kill-switch is off, gets
   * "not authorized".
   */
  createMpaOverride: CreateMpaOverrideResponse;
  /** createMpaV2 is used to create MPA record. */
  createMpaV2: Mpav2;
  createPartner: Partner;
  /** Create a new pharmacy with optional payment center and hours information */
  createPharmacy: PharmacyV2;
  createPharmacyNetwork: PharmacyNetwork;
  createPharmacyNetworkProgram: PharmacyNetworkProgram;
  createPlan: Plan;
  /** @deprecated Use groupCreatePlanCode */
  createPlanCodeV2: PlanCodeV2;
  /** Create a new Plan Test Suite */
  createPlanTestSuite: PlanTestSuite;
  createPrescriber: PrescriberV2;
  /** Generates a presigned URL for uploading or downloading a document */
  createPresignedUrl: PresignedUrlResponse;
  /** Create a primary member */
  createPrimary?: Maybe<Member>;
  createSDC: Sdcv2;
  /** Create sdc of member */
  createSDCAccumsStore?: Maybe<SdcAccumsStore>;
  /** Request the creation of Sent835s for Pharmacy Remittance. Returns true if successfully processed. */
  createSent835: Scalars['Boolean']['output'];
  /** Create a new step therapy */
  createStepTherapyV2: StepTherapyV2;
  /** @deprecated Use groupCreateSubgroup */
  createSubgroupV2: SubgroupDetail;
  /**
   * Create a CSV-based test run. Uses test suites created from CSV upload
   * and executes them against specified groups/plans.
   */
  createTestRunCSV: CreateTestRunPayload;
  /**
   * Create a manual claim test run. Generates a single test case from
   * manual input and executes it against specified groups/plans.
   */
  createTestRunManualClaim: CreateTestRunPayload;
  /**
   * Create a template-based test run. Clones test suites from templates
   * and executes them against specified groups/plans.
   */
  createTestRunTemplate: CreateTestRunPayload;
  /** Create a new transmission format. */
  createTransmissionFormat?: Maybe<TransmissionFormat>;
  /** Create a 'manual' transmission */
  createTransmissionJob?: Maybe<TransmissionJob>;
  create_authorized_resource: AuthorizedResource;
  create_benefit_plan: BenefitPlan;
  create_credential: Credential;
  /** creates a drug list (MatchRule) with the given name, returning the fully initialized MatchRule */
  create_drug_list: MatchRule;
  /** creates a payee and update payee info of pharmacy, returning the fully initialized payee */
  create_payee: Payee;
  /**
   * create_plan_rule
   * The id field is the id of the benefit plan with which the plan rule
   * should be associated
   */
  create_plan_rule: PlanRule;
  /** deactivate payee */
  deactivate_payee: Payee;
  deleteAltCardID: Scalars['Boolean']['output'];
  /** Delete a CostListGroup by ID. */
  deleteCostListGroup: Scalars['Boolean']['output'];
  deleteDURProgramDetail: Scalars['Boolean']['output'];
  /** @deprecated Use groupDeleteDepartment */
  deleteDepartment: Scalars['Boolean']['output'];
  deleteDrugListItemV2: Scalars['Boolean']['output'];
  deleteGroup: Scalars['Boolean']['output'];
  /** Deletes an implementation manual. */
  deleteImplementationManual: Scalars['ID']['output'];
  /** Delete member medical claim data */
  deleteMemberMedicalClaim: Scalars['Boolean']['output'];
  deletePharmacyNetwork: Scalars['ID']['output'];
  deletePlan: Scalars['Boolean']['output'];
  /** @deprecated Use groupDeletePlanCode */
  deletePlanCodeV2: Scalars['Boolean']['output'];
  /** Delete a Plan to DUR Program */
  deletePlanDURProgram: Scalars['Boolean']['output'];
  /** Delete a plan fill rule */
  deletePlanFillRule: Scalars['Boolean']['output'];
  /** Delete a plan step therapy */
  deletePlanStepTherapy: Scalars['Boolean']['output'];
  /** Delete Plan Test Suite And Linked Test Cases */
  deletePlanTestSuite?: Maybe<Scalars['ID']['output']>;
  deletePlanToCOB: Scalars['Boolean']['output'];
  deleteProcessRule: Scalars['Boolean']['output'];
  deleteProcessRuleAttachment: Scalars['Boolean']['output'];
  deleteSDC: Scalars['Boolean']['output'];
  /**
   * deleteSDCCrossAccumConfig
   * The id is the id of the sdc_cross_accum_config to delete
   *   The benefit_plan_id is the id of the benefit plan on which the sdc_cross_accum_config is set
   */
  deleteSDCCrossAccumConfig?: Maybe<Scalars['Boolean']['output']>;
  /** Request the deletion of a list of Sent835. The IDs of the successfully deleted Sent835s are returned. */
  deleteSent835s: Array<Scalars['ID']['output']>;
  /** @deprecated Use groupDeleteSubgroup */
  deleteSubGroup: Scalars['Boolean']['output'];
  /** Delete single plan test case */
  deleteTestCase: PlanTestCase;
  /** Delete multiple plan test cases */
  deleteTestCases: DeletePlanTestCasesResponse;
  /**
   * delete_accumulator
   * The id is the id of the accumulator to delete
   *   The benefit_plan_id is the id of the benefit plan on which the accumulator is set
   */
  delete_accumulator?: Maybe<Scalars['Boolean']['output']>;
  delete_authorized_resource: Scalars['Boolean']['output'];
  /**
   * delete_benefit_plan deletes a benefit plan
   * The id field is the id of the plan to be deleted
   */
  delete_benefit_plan: Scalars['Boolean']['output'];
  delete_credential: Scalars['Boolean']['output'];
  /**
   * deletes a drug from a drug list. The id is the ID of the drug list we're editing.
   * The input is a list of Match IDs representing the rows we want to delete from the
   * drug list.
   */
  delete_drug_from_list: Scalars['Boolean']['output'];
  /** deletes the drug list (MatchRule) with the given ID */
  delete_drug_list: Scalars['Boolean']['output'];
  /**
   * delete_plan_rule
   * The id is the id of the plan rule to be deleted
   */
  delete_plan_rule: Scalars['Boolean']['output'];
  disassociateGroupFromAccount: Scalars['Boolean']['output'];
  disassociateGroupFromPartner: Scalars['Boolean']['output'];
  disassociatePartnerFromAccount: Scalars['Boolean']['output'];
  /**
   * Zips the JSON of the extraction run the page's AI overlay describes (the newest field-api-map's
   * vNNN, once its meta.json exists) and returns a short-lived download link. A mutation because
   * the first call for a run writes the zip; later calls for the same run reuse it.
   * EXTRACTED_JSON_UNAVAILABLE means that run has not finished yet; EXTRACTED_JSON_TOO_LARGE means
   * the run exceeds the zip limit; NOT_FOUND means no such work item.
   */
  downloadImplementationManualExtractedJson: ImplementationManualExtractedJsonDownload;
  /**
   * Generates a downloadable report file (CSV) for the given IFPFile,
   * containing details about each row's status, validation errors, and commit errors.
   * Returns a pre-signed S3 link for downloading the report.
   */
  generateIFPFileReport: S3FileLink;
  /** Generate Laker Input Files And Store In S3 */
  generateLakerFiles?: Maybe<Scalars['String']['output']>;
  generateReprocessorReport: ReprocessorReport;
  /** Generate 835 Not Included Claims List And Store In S3 */
  generateSent835ClaimsFile?: Maybe<Scalars['String']['output']>;
  /** Generate 835 Files List And Store In S3 */
  generateSent835sFile?: Maybe<Scalars['String']['output']>;
  groupBulkDeleteDepartments: BulkDeleteDepartmentsOutput;
  groupBulkDeletePlanCodes: BulkDeletePlanCodesOutput;
  groupBulkEditSubgroups: BulkEditSubgroupsOutput;
  groupBulkUpdateSubgroupDetails: BulkUpdateSubgroupDetailsOutput;
  groupCreateDefaultPlan: DefaultPlan;
  groupCreateDepartment: Department;
  groupCreatePlanCode: PlanCodeV2;
  /**
   * Adds a new schedule to an existing Plan Code. The new schedule must not overlap
   * with any existing schedules for the same Plan Code UUID. When assessmentToken is
   * provided, applies subgroup detail synchronization with the schedule creation.
   */
  groupCreatePlanCodeSchedule: PlanCodeV2;
  groupCreateSubgroup: Array<Subgroup>;
  /** Appends SubgroupDetail to a set of previously existing SubgroupDetails */
  groupCreateSubgroupDetail: SyncedSubgroupDetail;
  groupDeleteDefaultPlan: Scalars['Boolean']['output'];
  groupDeleteDepartment: Scalars['Boolean']['output'];
  groupDeletePlanCode: Scalars['Boolean']['output'];
  /**
   * Deletes a single plan code schedule record. When assessmentToken is provided,
   * also deletes anchored subgroup details and retracts coverage. Blocked if
   * deletion would create a gap in the plan code timeline (unless it is the last record).
   * When the schedule has associated subgroup details, assessmentToken is required.
   */
  groupDeletePlanCodeSchedule: Scalars['Boolean']['output'];
  groupDeleteSubgroup: Scalars['ID']['output'];
  groupDeleteSubgroupDetail: Scalars['ID']['output'];
  groupDeleteSubgroupDetails: BulkDeleteSubgroupDetailsOutput;
  groupDeleteSubgroups: Array<Scalars['ID']['output']>;
  groupDocumentationCreate: GroupDocumentation;
  groupDocumentationDelete: Scalars['ID']['output'];
  groupDocumentationUpdate: GroupDocumentation;
  groupUpdateDefaultPlan: DefaultPlan;
  groupUpdatePlanCode: PlanCodeV2;
  groupUpdateSubgroup: Subgroup;
  groupUpdateSubgroupDetail: SubgroupDetail;
  /**
   * Upload csv file to S3 bucket and registers it on ifp_table.
   * This file will then be processed by the Internal File Processor job.
   */
  ifpFileMaclistEntryImporter?: Maybe<IfpFile>;
  importGroup: Group;
  /** Invite a user to Partner Portal */
  inviteToPartnerPortal: Credential;
  /** Mark a transmission job as failed. Intended for jobs that are stuck. */
  killTransmissionJob?: Maybe<TransmissionJob>;
  /** Lifts the pair's active restriction. */
  liftMemberAccessRestriction: MemberAccessRestriction;
  /** Create or update a MAC List */
  maclist?: Maybe<MacList>;
  /** Mark tutorials as viewed, returning the new full list of tutorials that have been viewed */
  markTutorialsViewed?: Maybe<Array<ViewedTutorialKey>>;
  /** Request a member merge synchronously. */
  memberMerge: MemberMergeResult;
  /** Modify member medical claims and create new member medical claims for a specified member */
  modifyMemberMedicalClaims: Array<MemberMedicalClaim>;
  /** Modify sdc accum store and create new sdc accum store for a specified member */
  modifySDCAccumTransactions: Array<SdcAccumTransactions>;
  /** Modify existing plan test cases and create new test cases for specified plan test suite */
  modifyTestCases: Array<PlanTestCase>;
  /**
   * Applies the explicitly chosen MPA template (by key, from `mpaTemplates`) and
   * returns a non-persisted MPA prefilled from it (core fields plus claim
   * instructions) alongside the template's info.
   *
   * This is the manual-override path: use it when the user picks a template
   * directly rather than relying on the reject-code match from
   * `buildMPAFromTemplate`. When `claimId` is provided, claim-derived fields
   * (e.g. GPI at the chosen template's level) are recomputed from that claim;
   * without it, they are left empty. Errors if no template has the given key,
   * or if `claimId` matches no claim.
   */
  overrideMPAWithTemplate: MpaTemplate;
  pharmacyNetworkAddMACList: PharmacyNetworkMac;
  pharmacyNetworkDeleteMACList: Scalars['ID']['output'];
  pharmacyNetworkEntityCreate: PharmacyNetworkEntity;
  pharmacyNetworkEntityDelete: Scalars['ID']['output'];
  pharmacyNetworkEntityUpdate: PharmacyNetworkEntity;
  pharmacyNetworkUpdateMACList: PharmacyNetworkMac;
  pharmacyPaymentCenterUpsertBulk: Array<PharmacyPaymentCenterUpsertResult>;
  pharmacyRemittanceReceiverUpsertBulk: Array<PharmacyRemittanceReceiverUpsertResult>;
  pharmacyStateLicenseUpsertBulk: Array<PharmacyStateLicenseUpsertResult>;
  pharmacyUpsertBulk: Array<PharmacyUpsertResult>;
  /**
   * plan_add_included_networks adds super networks that the plan has available
   * id: ID of the benefit plan being updated
   * input: should only have the super_network_ids field set. The network_ids field will not be used for this mutation
   */
  plan_add_included_networks: Scalars['Boolean']['output'];
  /**
   * plan_remove_included_networks removes the listed super_networks from the plan's included networks
   * id: ID of the benefit plan being updated
   * input: should only have the super_network_ids field set. The network_ids field will not be used for this mutation
   */
  plan_remove_included_networks: Scalars['Boolean']['output'];
  /** Play selected test cases */
  playSelectedTestCases?: Maybe<Array<PlanTestCaseDccResult>>;
  /** Create or update a Prescriber List */
  prescriberList?: Maybe<PrescriberList>;
  /** Add a prescriber to a prescriber list */
  prescriberListDetail: PrescriberListDetail;
  /**
   * Upserts prescribers in bulk.
   *
   * dryRun makes the call record instead of write: what prescriber would have held
   * is written to the prescriber_shadow table rather than to prescriber — one row
   * per NPI in the batch, unchanged rows included, keyed on npi so a new import
   * overwrites the previous one. Nothing is persisted to prescriber and no events
   * are published; the results carry the stored rows. Drift is then measured by
   * comparing the two tables in SQL; the logs carry only a per-batch summary.
   */
  prescriberUpsertBulk: Array<PrescriberUpsertResult>;
  /** Mark isUnread as false once the message is clicked */
  recordCaseRead: Scalars['Boolean']['output'];
  /** Records an analytics event in Statsig, attributed to the caller's session. */
  recordPortalEvent: Scalars['Boolean']['output'];
  reimportGroup: Group;
  /** Reorder plan fill rules */
  reorderPlanFillRules: PlanFillRuleOrderList;
  /** Reorder plan step therapies */
  reorderPlanStepTherapies: PlanStepTherapyOrderList;
  reorderProcessRuleAttachment: ProcessRuleAttachmentPriorityList;
  /** Completely replacing plan test cases of a benefit plan by copying the test cases from one benefit plan to another. */
  replaceTestCases: Array<PlanTestCase>;
  reprocessorBatchCreate: ReprocessorBatch;
  reprocessorBatchProcessAllClaims?: Maybe<ClaimSet>;
  reprocessorBatchReset?: Maybe<ClaimSet>;
  reprocessorBatchReverseAllClaims?: Maybe<ClaimSet>;
  requestConsent: Consent;
  /** Retry a transmission */
  rerunTransmissionJob?: Maybe<TransmissionJob>;
  resendConsent: Consent;
  /**
   * Resend a list of Sent835s. Can only resend 835 files that have been previously attempted to be sent.
   * The IDs of the successfully resent Sent835s are returned.
   */
  resendSent835s: Array<Scalars['ID']['output']>;
  /** Reset selected test cases */
  resetSelectedTestCases?: Maybe<Array<PlanTestCaseDccResult>>;
  reversalClaim: ReversalClaimResponse;
  runPlanTestSuite: RunPlanTestSuiteResponse;
  sendClaim: SendClaimResponse;
  /** Send a demo event to Kafka for testing */
  sendDemoEvent: SendDemoEventResponse;
  /**
   * Replace an MPA's claim instructions with the provided typed desired set:
   * present fields are set, omitted fields are cleared. Scalar fields and process
   * rules are saved together in one transaction.
   */
  setMPAClaimInstructionsV2: Mpav2;
  signConsent: Consent;
  startPrescriberImport: PrescriberImportStartResult;
  /** Performs a batch partial update of FillRuleLine entities. */
  syncFillRuleLines: Array<FillRuleLine>;
  /** Performs a batch partial update of StepTherapyLine entities. */
  syncStepTherapyLines: Array<StepTherapyLine>;
  /** Terminate validity for an existing connection. */
  terminateConnectionValidity: Scalars['Boolean']['output'];
  terminateConsent: Consent;
  /**
   * Creates a public document shown for all groups that do not have their own
   * group-specific document of that type.
   */
  universalDocumentationCreate: PublicDocumentation;
  universalDocumentationDelete: Scalars['ID']['output'];
  universalDocumentationUpdate: PublicDocumentation;
  /**
   * Delete the account of the currently authenticated user.
   * Returns the deleted credential ID.
   */
  unregisterSelf: Scalars['ID']['output'];
  updateAccount: Account;
  /** Modify an existing connection. */
  updateConnection?: Maybe<Connection>;
  updateCustomDrugListV2?: Maybe<CustomDrugListV2>;
  /** @deprecated Departments cannot be updated. Delete and recreate */
  updateDepartment: Department;
  updateDrugListItemV2?: Maybe<DrugListItemV2>;
  /** Update the status of an existing DrugListUpload. */
  updateDrugListUpload: CustomDrugListUpload;
  updateGroup: Group;
  updateGroupDetails: GroupDetails;
  /** id is the Group UUID as returned in the ID field of the Group GraphQL object */
  updateGroupOnboardingStatus: OnboardingProgress;
  /**
   * Updates a single IFPFileRow's data and synchronously re-runs the validation
   * pipeline against the new data. The row's status, validationErrors, operation,
   * and targetStorage are updated based on the re-validation result, and the
   * parent IFPFile's summary counters reflect the change on the next read.
   *
   * Includes scoped filtering to only allow updating rows on files for job types
   * the user has mutate permission for. Refuses if the parent file is in any
   * status other than AWAITING_REVIEW, or if the row has already been committed
   * (COMMITTED, COMMIT_FAILED).
   *
   * Scope: only the edited row is re-validated. Sibling rows previously flagged
   * invalid against this row's prior state (e.g., intra-file duplicate auth
   * numbers) retain their stale errors until they are themselves re-edited or
   * the file is re-validated end-to-end.
   */
  updateIFPFileRow: IfpFileRow;
  updateMPAClaimInstructionsV2: Mpav2;
  updateMPACriteriaV2: Mpav2;
  updateMPAPrioritiesV2?: Maybe<Array<Mpav2>>;
  updateMPAProcessRule: Mpav2ProcessRuleResponse;
  updateMPAV2: Mpav2;
  /** Update an existing member */
  updateMember?: Maybe<Member>;
  /** Update status of member's card_to_be_printed */
  updateMemberCardIDStatus?: Maybe<Member>;
  /** Update full oop or full deductible or med oop or med deductible of member accumulator values */
  updateMemberFullReplacementAccumulator?: Maybe<MemberFullReplacementAccumulator>;
  /** Update member medical claim data */
  updateMemberMedicalClaim?: Maybe<MemberMedicalClaim>;
  updatePartner: Partner;
  updatePharmacyNetwork: PharmacyNetwork;
  updatePharmacyNetworkProgram: PharmacyNetworkProgram;
  /** update pharmacy and associated payment center, returning the updated pharmacy */
  updatePharmacyV2: PharmacyV2;
  updatePlanCOBSettings: Plan;
  /** @deprecated Use groupUpdatePlanCode */
  updatePlanCodeV2: Array<PlanCodeV2>;
  /** Update or create a Plan DAW for a Plan. */
  updatePlanDAW: PlanDaw;
  updatePlanHandler: Plan;
  /** Update Plan Test Suite Details */
  updatePlanTestSuite: PlanTestSuite;
  updatePrescriber: PrescriberV2;
  updateProcessRule: UpdateProcessRuleResponse;
  updateProcessRuleLineDetails: UpdateProcessRuleLineDetailsResponse;
  /** updateProfile makes changes to an existing profile */
  updateProfile: Profile;
  /**
   * updateRelationshipsForGroup is used to replace all partner_group records for a given group with the provided input.
   * The operations happen in a transaction. Returns true or false that the mutation succeeded.
   */
  updateRelationshipsForGroup: Scalars['Boolean']['output'];
  updateSDC: Sdcv2;
  /** Update sdc of member */
  updateSDCAccumsStore?: Maybe<SdcAccumsStore>;
  updateSDCCrossAccumConfigs: Array<SdcCrossAccumConfig>;
  /** Update Sent835 PLB values from a CSV upload. This update is all-or-nothing and expects `Payee,PLB` columns. */
  updateSent835sPLBs: Array<Scalars['ID']['output']>;
  /** @deprecated Use groupUpdateSubgroup */
  updateSubgroupV2: SubgroupDetail;
  /** Modify existing plan test cases and create new test cases for specified plan test suite */
  updateTestCasesPriorities: Array<PlanTestCase>;
  /**
   * Update TestRunExecution validation status and/or discard reason.
   * Optionally accepts test case result updates to process atomically in a single transaction,
   * with automatic recalculation of pass/fail/error counters.
   */
  updateTestRunExecution: TestRunExecution;
  /** Modify an existing format. */
  updateTransmissionFormat?: Maybe<TransmissionFormat>;
  /**
   * update_accumulator makes changes to an existing accumulator
   * The id is the id of the benefit_plan on which the accumulator is set
   */
  update_accumulator: Accumulator;
  /**
   * update_accumulators is identical to update_accumulator (singular) except that it allows multiple updates
   * to be passed which are all successfully updated, or all failed, transactionally.
   * The id is the id of the benefit_plan on which the accumulator is set
   */
  update_accumulators: Array<Accumulator>;
  update_authorized_resource: AuthorizedResource;
  /**
   * update_benefit_plan makes modifications to an existing benefit plan.
   * The id field must be the id of the plan to be updated.
   */
  update_benefit_plan: BenefitPlan;
  update_credential: Credential;
  /**
   * The id is the ID of the Match object we're updating the MatchExpressions for.
   * The input is the new list of MatchExpressions to set for the Match
   */
  update_drug_in_list: Scalars['Boolean']['output'];
  /** updates the name of a drug list returning the full drug list (MatchRule) with the update on success */
  update_drug_list: MatchRule;
  /** creates a payee and update payee info of pharmacy, returning the fully initialized payee */
  update_payee: Payee;
  /**
   * update_plan_rule modifies an existing plan rule
   * The id is the id of the plan rule to be modified.
   */
  update_plan_rule: PlanRule;
  /**
   * update_plan_rule_priorities
   * The id is the id of the benefit plan on which the plan rules are defined
   */
  update_plan_rule_priorities: PlanRulePriorityList;
  /**
   * add a new full replacement transaction or medical transaction of member accumulator or sdc values
   * @deprecated use addAccumTransaction instead
   */
  upsertAccumulatorTransaction: Scalars['Boolean']['output'];
  upsertAgeHandlerDetails: Array<AgeHandlerDetail>;
  upsertAndDeleteProcessRuleLines: UpdateProcessRuleResponse;
  /** Upsert BillCostHandlerDetails */
  upsertBillCostHandlerDetails: Array<BillCostHandlerDetail>;
  upsertCOBObjectLines: UpsertCobObjectLinesPayload;
  /** upsert copay handler details in bulk */
  upsertCopayHandlerDetails: Array<CopayHandlerDetail>;
  upsertCostHandlerDetails: Array<CostHandlerDetail>;
  upsertDURProgramDetails: Array<Maybe<DurProgramDetail>>;
  upsertDispenseFeeHandlerDetails: Array<DispenseFeeHandlerDetail>;
  upsertEligibilityTimeline?: Maybe<MemberTimelineRecord>;
  upsertMemberEligibilityFlag?: Maybe<MemberEligibilityFlagTimelineRecord>;
  upsertMiscHandlerDetails: UpsertMiscHandlerDetailsPayload;
  /** Upsert a Plan to DUR Program */
  upsertPlanDURProgram: PlanDurProgram;
  /** Insert or update a plan fill rule */
  upsertPlanFillRule: PlanFillRule;
  /** Insert or update a plan step therapy */
  upsertPlanStepTherapy: PlanStepTherapy;
  upsertPlanToCOB: PlanToCob;
  upsertProcessRuleAttachment?: Maybe<ProcessRuleAttachment>;
  /** Insert or update a step therapy line */
  upsertStepTherapyLine: StepTherapyLine;
};


export type MutationCreateContactArgs = {
  input: ContactInput;
};


export type MutationDeleteContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRunCasSyncForMemberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateContactArgs = {
  id: Scalars['ID']['input'];
  input: ContactInput;
};


export type MutationUpdateMemberProfileArgs = {
  input: UpdateMemberProfileInput;
};


export type MutationAddAccumTransactionArgs = {
  input: AddAccumsTransactionInput;
};


export type MutationAddDrugListItemV2Args = {
  input: AddDrugListItemInputV2;
};


export type MutationAddSdcTransactionArgs = {
  input: AddSdcTransactionInput;
};


export type MutationAddDrugToListArgs = {
  id: Scalars['ID']['input'];
  input: Array<InputMaybe<Array<MatchExpressionInput>>>;
};


export type MutationAdjustClaimArgs = {
  input: AdjustClaimInput;
};


export type MutationApproveSent835sArgs = {
  input: ApproveSent835sInput;
};


export type MutationAssociateGroupToAccountArgs = {
  input: GroupToAccountInput;
};


export type MutationAssociateGroupToPartnerArgs = {
  input: GroupToPartnerInput;
};


export type MutationAssociatePartnerToAccountArgs = {
  input: PartnerToAccountInput;
};


export type MutationBuildMpaFromTemplateArgs = {
  input: BuildMpaFromTemplateInput;
};


export type MutationBulkSaveCostListDetailArgs = {
  input: BulkSaveCostListDetailInput;
};


export type MutationBulkTerminatePrescribersArgs = {
  input: BulkTerminatePrescribersInput;
};


export type MutationBulkUpdateProcessRuleLinesArgs = {
  input?: InputMaybe<BulkUpdateProcessRuleLinesInput>;
};


export type MutationBulkUpdateTestCaseResultsArgs = {
  input: BulkUpdateTestCaseResultsInput;
};


export type MutationBulkUpsertDesignatedPharmacyArgs = {
  input: BulkUpsertDesignatedPharmacyInput;
};


export type MutationBulkUpsertProcessRuleAttachmentsArgs = {
  input: BulkUpsertProcessRuleAttachmentsInput;
};


export type MutationChainUpsertBulkArgs = {
  chains: Array<ChainInput>;
};


export type MutationCheckNameIsUniqueArgs = {
  input?: InputMaybe<CheckNameIsUniqueInput>;
};


export type MutationClaimSetCreateArgs = {
  input: CreateClaimSetInput;
};


export type MutationClonePlanComponentArgs = {
  benefit_plan_id: Scalars['ID']['input'];
  effective_from?: InputMaybe<Scalars['Time']['input']>;
  effective_to?: InputMaybe<Scalars['Time']['input']>;
  type: Scalars['String']['input'];
};


export type MutationCommitDraftPlanArgs = {
  input: CommitDraftPlanInput;
};


export type MutationCommitIfpFileArgs = {
  ifpFileID: Scalars['ID']['input'];
};


export type MutationConfigureGroupForZebraArgs = {
  groupID: Scalars['ID']['input'];
};


export type MutationCopyProgramsArgs = {
  id: Scalars['ID']['input'];
  isFuture?: InputMaybe<Scalars['Boolean']['input']>;
  program_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationCreateAccountArgs = {
  input: CreateUpdateAccountInput;
};


export type MutationCreateAltCardIdArgs = {
  input: CreateAltCardIdInput;
};


export type MutationCreateAndUploadIfpFileArgs = {
  input: CreateAndUploadIfpFileInput;
};


export type MutationCreateBatchDataSyncJobArgs = {
  params: CreateBatchDataSyncJobRequest;
};


export type MutationCreateCobObjectArgs = {
  input: CreateCobObjectInput;
};


export type MutationCreateConnectionArgs = {
  input: CreateConnectionInput;
};


export type MutationCreateCopiedProcessRuleArgs = {
  createCopiedProcessRuleInput?: InputMaybe<CreateCopiedProcessRuleInput>;
};


export type MutationCreateCostListArgs = {
  input: CreateCostListInput;
};


export type MutationCreateCostListGroupArgs = {
  input: CreateCostGroupInput;
};


export type MutationCreateCustomDrugListV2Args = {
  input: CreateCustomDrugListV2Input;
};


export type MutationCreateDurObjectArgs = {
  input: CreateDurObjectInput;
};


export type MutationCreateDepartmentArgs = {
  input: CreateDepartmentInput;
};


export type MutationCreateDependentArgs = {
  input: CreateDependentInput;
};


export type MutationCreateDrugListUploadArgs = {
  input: CreateDrugListUploadInput;
};


export type MutationCreateFillRuleArgs = {
  input: CreateFillRuleInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateHandlerAndCopyDetailsArgs = {
  input: CreateHandlerInput;
};


export type MutationCreateIfpDrugListUploadArgs = {
  input: CreateIfpDrugListUploadInput;
};


export type MutationCreateImplementationManualUploadArgs = {
  input: CreateImplementationManualUploadInput;
};


export type MutationCreateLakerMpaArgs = {
  input: CreateLakerMpaRequest;
};


export type MutationCreateManualPlanCandidatesArgs = {
  input: CreateManualPlanCandidatesInput;
};


export type MutationCreateMemberAccessRestrictionArgs = {
  input: CreateMemberAccessRestrictionInput;
};


export type MutationCreateMemberFullReplacementAccumulatorArgs = {
  input: MemberFullReplacementAccumulatorInput;
};


export type MutationCreateMemberMedicalClaimArgs = {
  input: MemberMedicalClaimCreateInput;
};


export type MutationCreateMpaOverrideArgs = {
  input: CreateMpaOverrideRequest;
};


export type MutationCreateMpaV2Args = {
  input: MpaCreateInput;
};


export type MutationCreatePartnerArgs = {
  input: CreatePartnerInput;
};


export type MutationCreatePharmacyArgs = {
  input: PharmacyInputV2;
};


export type MutationCreatePharmacyNetworkArgs = {
  input: PharmacyNetworkCreateInput;
};


export type MutationCreatePharmacyNetworkProgramArgs = {
  input: PharmacyNetworkProgramCreateInput;
};


export type MutationCreatePlanArgs = {
  input: CreatePlanInput;
};


export type MutationCreatePlanCodeV2Args = {
  input: CreatePlanCodeV2Input;
};


export type MutationCreatePlanTestSuiteArgs = {
  input: CreatePlanTestSuiteInput;
};


export type MutationCreatePrescriberArgs = {
  input: PrescriberInput;
};


export type MutationCreatePresignedUrlArgs = {
  input: PresignedUrlInput;
};


export type MutationCreatePrimaryArgs = {
  input: CreatePrimaryInput;
};


export type MutationCreateSdcArgs = {
  input: CreateSdcInput;
};


export type MutationCreateSdcAccumsStoreArgs = {
  input: SdcAccumsStoreInput;
};


export type MutationCreateSent835Args = {
  input: CreateSent835Input;
};


export type MutationCreateStepTherapyV2Args = {
  input: CreateStepTherapyV2Input;
};


export type MutationCreateSubgroupV2Args = {
  input: CreateSubGroupInput;
};


export type MutationCreateTestRunCsvArgs = {
  input: CreateTestRunCsvInput;
};


export type MutationCreateTestRunManualClaimArgs = {
  input: CreateTestRunManualClaimInput;
};


export type MutationCreateTestRunTemplateArgs = {
  input: CreateTestRunTemplateInput;
};


export type MutationCreateTransmissionFormatArgs = {
  input: CreateTransmissionFormatInput;
};


export type MutationCreateTransmissionJobArgs = {
  input: CreateTransmissionJobInput;
};


export type MutationCreateAuthorizedResourceArgs = {
  input: AuthorizedResourceInput;
};


export type MutationCreateBenefitPlanArgs = {
  input: BenefitPlanInput;
};


export type MutationCreateCredentialArgs = {
  input: CredentialInput;
};


export type MutationCreateDrugListArgs = {
  in?: InputMaybe<PlanDrugListInput>;
};


export type MutationCreatePayeeArgs = {
  in?: InputMaybe<PayeeInput>;
};


export type MutationCreatePlanRuleArgs = {
  id: Scalars['ID']['input'];
  input: PlanRuleInput;
};


export type MutationDeactivatePayeeArgs = {
  in?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteAltCardIdArgs = {
  input: DeleteAltCardIdInput;
};


export type MutationDeleteCostListGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDurProgramDetailArgs = {
  input: DeleteDurProgramDetailInput;
};


export type MutationDeleteDepartmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDrugListItemV2Args = {
  input: DeleteDrugListItemInputV2;
};


export type MutationDeleteGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteImplementationManualArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMemberMedicalClaimArgs = {
  input: MemberMedicalClaimDeleteInput;
};


export type MutationDeletePharmacyNetworkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePlanCodeV2Args = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePlanDurProgramArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePlanFillRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePlanStepTherapyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePlanTestSuiteArgs = {
  input: DeletePlanTestSuiteInput;
};


export type MutationDeletePlanToCobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProcessRuleArgs = {
  deleteProcessRuleInput?: InputMaybe<DeleteProcessRuleInput>;
};


export type MutationDeleteProcessRuleAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSdcArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSdcCrossAccumConfigArgs = {
  benefit_plan_uuid: Scalars['UUID']['input'];
  uuid: Scalars['UUID']['input'];
};


export type MutationDeleteSent835sArgs = {
  input: DeleteSent835sInput;
};


export type MutationDeleteSubGroupArgs = {
  input: DeleteSubGroupInput;
};


export type MutationDeleteTestCaseArgs = {
  input: DeletePlanTestCaseInput;
};


export type MutationDeleteTestCasesArgs = {
  input: DeletePlanTestCasesInput;
};


export type MutationDeleteAccumulatorArgs = {
  benefit_plan_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteAuthorizedResourceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteBenefitPlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCredentialArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteDrugFromListArgs = {
  id: Scalars['ID']['input'];
  input: Array<Scalars['ID']['input']>;
};


export type MutationDeleteDrugListArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePlanRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisassociateGroupFromAccountArgs = {
  input: GroupToAccountInput;
};


export type MutationDisassociateGroupFromPartnerArgs = {
  input: GroupToPartnerInput;
};


export type MutationDisassociatePartnerFromAccountArgs = {
  input: PartnerToAccountInput;
};


export type MutationDownloadImplementationManualExtractedJsonArgs = {
  uploadId: Scalars['ID']['input'];
};


export type MutationGenerateIfpFileReportArgs = {
  input: GenerateIfpFileReportInput;
};


export type MutationGenerateLakerFilesArgs = {
  input: GenerateLakerTemplatesInput;
};


export type MutationGenerateReprocessorReportArgs = {
  input: GenerateReprocessorReportInput;
};


export type MutationGenerateSent835ClaimsFileArgs = {
  where?: InputMaybe<Sent835sToClaimsMissedFilters>;
};


export type MutationGenerateSent835sFileArgs = {
  where?: InputMaybe<Sent835Filters>;
};


export type MutationGroupBulkDeleteDepartmentsArgs = {
  input: BulkDeleteDepartmentsInput;
};


export type MutationGroupBulkDeletePlanCodesArgs = {
  input: BulkDeletePlanCodesInput;
};


export type MutationGroupBulkEditSubgroupsArgs = {
  input: BulkEditSubgroupsInput;
};


export type MutationGroupBulkUpdateSubgroupDetailsArgs = {
  input: BulkUpdateSubgroupDetailsInput;
};


export type MutationGroupCreateDefaultPlanArgs = {
  input: CreateDefaultPlanInput;
};


export type MutationGroupCreateDepartmentArgs = {
  input: CreateDepartmentInput;
};


export type MutationGroupCreatePlanCodeArgs = {
  input: CreatePlanCodeV2Input;
};


export type MutationGroupCreatePlanCodeScheduleArgs = {
  input: CreatePlanCodeScheduleInput;
};


export type MutationGroupCreateSubgroupArgs = {
  input: Array<CreateSubgroupInput>;
};


export type MutationGroupCreateSubgroupDetailArgs = {
  input: CreateSubgroupDetailInput;
};


export type MutationGroupDeleteDefaultPlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGroupDeleteDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
};


export type MutationGroupDeletePlanCodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGroupDeletePlanCodeScheduleArgs = {
  input: DeletePlanCodeScheduleInput;
};


export type MutationGroupDeleteSubgroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGroupDeleteSubgroupDetailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGroupDeleteSubgroupDetailsArgs = {
  input: BulkDeleteSubgroupDetailsInput;
};


export type MutationGroupDeleteSubgroupsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationGroupDocumentationCreateArgs = {
  input: GroupDocumentationCreate;
};


export type MutationGroupDocumentationDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGroupDocumentationUpdateArgs = {
  input: GroupDocumentationUpdate;
};


export type MutationGroupUpdateDefaultPlanArgs = {
  input: UpdateDefaultPlanInput;
};


export type MutationGroupUpdatePlanCodeArgs = {
  input: UpdatePlanCodeV2Input;
};


export type MutationGroupUpdateSubgroupArgs = {
  input: UpdateSubgroupInput;
};


export type MutationGroupUpdateSubgroupDetailArgs = {
  input: UpdateSubgroupDetailInput;
};


export type MutationIfpFileMaclistEntryImporterArgs = {
  input: IfpFileInput;
};


export type MutationImportGroupArgs = {
  input: ImportGroupInput;
};


export type MutationInviteToPartnerPortalArgs = {
  id: Scalars['Int']['input'];
};


export type MutationKillTransmissionJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLiftMemberAccessRestrictionArgs = {
  input: LiftMemberAccessRestrictionInput;
};


export type MutationMaclistArgs = {
  ignoreWarnings?: InputMaybe<Scalars['Boolean']['input']>;
  input: MacListInput;
};


export type MutationMarkTutorialsViewedArgs = {
  viewedTutorials?: InputMaybe<Array<ViewedTutorialKey>>;
};


export type MutationMemberMergeArgs = {
  file: Scalars['Upload']['input'];
  params: MemberMergeParams;
};


export type MutationModifyMemberMedicalClaimsArgs = {
  input: ModifyMemberMedicalClaimInput;
};


export type MutationModifySdcAccumTransactionsArgs = {
  input: ModifySdcAccumTransactionsInput;
};


export type MutationModifyTestCasesArgs = {
  input: ModifyTestCaseListInput;
};


export type MutationOverrideMpaWithTemplateArgs = {
  input: OverrideMpaWithTemplateInput;
};


export type MutationPharmacyNetworkAddMacListArgs = {
  input: PharmacyNetworkMacCreate;
};


export type MutationPharmacyNetworkDeleteMacListArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPharmacyNetworkEntityCreateArgs = {
  input: PharmacyNetworkEntityCreate;
};


export type MutationPharmacyNetworkEntityDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPharmacyNetworkEntityUpdateArgs = {
  input: PharmacyNetworkEntityUpdate;
};


export type MutationPharmacyNetworkUpdateMacListArgs = {
  input: PharmacyNetworkMacUpdate;
};


export type MutationPharmacyPaymentCenterUpsertBulkArgs = {
  paymentCenters: Array<PharmacyPaymentCenterInput>;
};


export type MutationPharmacyRemittanceReceiverUpsertBulkArgs = {
  remittanceReceivers: Array<PharmacyRemittanceReceiverInput>;
};


export type MutationPharmacyStateLicenseUpsertBulkArgs = {
  stateLicenses: Array<PharmacyStateLicenseInput>;
};


export type MutationPharmacyUpsertBulkArgs = {
  input: PharmacyBulkUpsert;
};


export type MutationPlanAddIncludedNetworksArgs = {
  id: Scalars['ID']['input'];
  input: PlanNetworksInput;
};


export type MutationPlanRemoveIncludedNetworksArgs = {
  id: Scalars['ID']['input'];
  input: PlanNetworksInput;
};


export type MutationPlaySelectedTestCasesArgs = {
  input: SelectedTestCasesInput;
};


export type MutationPrescriberListArgs = {
  input: PrescriberListInput;
};


export type MutationPrescriberListDetailArgs = {
  input: PrescriberListDetailInput;
};


export type MutationPrescriberUpsertBulkArgs = {
  dryRun?: Scalars['Boolean']['input'];
  input: Array<PrescriberInput>;
};


export type MutationRecordCaseReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRecordPortalEventArgs = {
  metadata?: InputMaybe<Scalars['Map']['input']>;
  name: Scalars['String']['input'];
};


export type MutationReimportGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReorderPlanFillRulesArgs = {
  input: PlanFillRuleOrderListInput;
};


export type MutationReorderPlanStepTherapiesArgs = {
  input: PlanStepTherapyOrderListInput;
};


export type MutationReorderProcessRuleAttachmentArgs = {
  input: ProcessRuleAttachmentPriorityListInput;
};


export type MutationReplaceTestCasesArgs = {
  input: ReplacePlanTestCasesInput;
};


export type MutationReprocessorBatchCreateArgs = {
  input: CreateReprocessorBatchInput;
};


export type MutationReprocessorBatchProcessAllClaimsArgs = {
  input: ReprocessorBatchActionInput;
};


export type MutationReprocessorBatchResetArgs = {
  input: ReprocessorBatchActionInput;
};


export type MutationReprocessorBatchReverseAllClaimsArgs = {
  input: ReprocessorBatchReverseAllClaimsInput;
};


export type MutationRequestConsentArgs = {
  input: RequestConsentInput;
};


export type MutationRerunTransmissionJobArgs = {
  id: Scalars['ID']['input'];
  input: RerunTransmissionJobInput;
};


export type MutationResendConsentArgs = {
  input: ResendConsentInput;
};


export type MutationResendSent835sArgs = {
  input: ResendSent835sInput;
};


export type MutationResetSelectedTestCasesArgs = {
  input: SelectedTestCasesInput;
};


export type MutationReversalClaimArgs = {
  input: SendClaimInput;
};


export type MutationRunPlanTestSuiteArgs = {
  input: RunPlanTestSuiteInput;
};


export type MutationSendClaimArgs = {
  input: SendClaimInput;
};


export type MutationSendDemoEventArgs = {
  input: SendDemoEventInput;
};


export type MutationSetMpaClaimInstructionsV2Args = {
  input: UpdateMpaClaimInstructionsV2Input;
};


export type MutationSignConsentArgs = {
  input: SignConsentInput;
};


export type MutationSyncFillRuleLinesArgs = {
  input: SyncFillRuleLinesInput;
};


export type MutationSyncStepTherapyLinesArgs = {
  input: SyncStepTherapyLinesInput;
};


export type MutationTerminateConnectionValidityArgs = {
  input: TerminateConnectionValidityInput;
};


export type MutationTerminateConsentArgs = {
  input: TerminateConsentInput;
};


export type MutationUniversalDocumentationCreateArgs = {
  input: UniversalDocumentationCreate;
};


export type MutationUniversalDocumentationDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUniversalDocumentationUpdateArgs = {
  input: UniversalDocumentationUpdate;
};


export type MutationUpdateAccountArgs = {
  id: Scalars['ID']['input'];
  input: CreateUpdateAccountInput;
};


export type MutationUpdateConnectionArgs = {
  input: UpdateConnectionInput;
};


export type MutationUpdateCustomDrugListV2Args = {
  input: UpdateCustomDrugListV2Input;
};


export type MutationUpdateDepartmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDepartmentInput;
};


export type MutationUpdateDrugListItemV2Args = {
  input: UpdateDrugListItemInputV2;
};


export type MutationUpdateDrugListUploadArgs = {
  input: UpdateDrugListUploadInput;
};


export type MutationUpdateGroupArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGroupInput;
};


export type MutationUpdateGroupDetailsArgs = {
  groupID: Scalars['ID']['input'];
  input: UpdateGroupDetailsInput;
};


export type MutationUpdateGroupOnboardingStatusArgs = {
  id: Scalars['ID']['input'];
  input: OnboardingStatusUpdateInput;
};


export type MutationUpdateIfpFileRowArgs = {
  input: UpdateIfpFileRowInput;
};


export type MutationUpdateMpaClaimInstructionsV2Args = {
  input: MpaUpdateInput;
};


export type MutationUpdateMpaCriteriaV2Args = {
  input: MpaUpdateCriteriaInput;
};


export type MutationUpdateMpaPrioritiesV2Args = {
  input: MpaPrioritiesUpdateInput;
};


export type MutationUpdateMpaProcessRuleArgs = {
  input: UpdateMpaProcessRuleInput;
};


export type MutationUpdateMpav2Args = {
  input: MpaUpdateInput;
};


export type MutationUpdateMemberArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMemberInput;
};


export type MutationUpdateMemberCardIdStatusArgs = {
  id: Scalars['ID']['input'];
  input: MemberCardIdPrintInput;
};


export type MutationUpdateMemberFullReplacementAccumulatorArgs = {
  input: MemberFullReplacementAccumulatorInput;
};


export type MutationUpdateMemberMedicalClaimArgs = {
  input: MemberMedicalClaimUpdateInput;
};


export type MutationUpdatePartnerArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePartnerInput;
};


export type MutationUpdatePharmacyNetworkArgs = {
  input: PharmacyNetworkUpdateInput;
};


export type MutationUpdatePharmacyNetworkProgramArgs = {
  input: PharmacyNetworkProgramUpdateInput;
};


export type MutationUpdatePharmacyV2Args = {
  input: PharmacyUpdateInputV2;
};


export type MutationUpdatePlanCobSettingsArgs = {
  input: UpdatePlanCobSettingsInput;
};


export type MutationUpdatePlanCodeV2Args = {
  id: Scalars['ID']['input'];
  input: PlanCodeV2Updates;
};


export type MutationUpdatePlanDawArgs = {
  input: UpdatePlanDawInput;
};


export type MutationUpdatePlanHandlerArgs = {
  input: UpdatePlanHandlerInput;
};


export type MutationUpdatePlanTestSuiteArgs = {
  input: UpdatePlanTestSuiteInput;
};


export type MutationUpdatePrescriberArgs = {
  id: Scalars['ID']['input'];
  input: PrescriberInput;
};


export type MutationUpdateProcessRuleArgs = {
  updateProcessRuleInput?: InputMaybe<UpdateProcessRuleInput>;
};


export type MutationUpdateProcessRuleLineDetailsArgs = {
  input: UpdateProcessRuleLineDetailsInput;
};


export type MutationUpdateProfileArgs = {
  input: ProfileInput;
};


export type MutationUpdateRelationshipsForGroupArgs = {
  input: UpdateRelationshipsForGroupInput;
};


export type MutationUpdateSdcArgs = {
  input: UpdateSdcInput;
};


export type MutationUpdateSdcAccumsStoreArgs = {
  input: SdcAccumsStoreInput;
};


export type MutationUpdateSdcCrossAccumConfigsArgs = {
  benefitPlanID: Scalars['UUID']['input'];
  input: Array<SdcCrossAccumConfigInput>;
};


export type MutationUpdateSent835sPlBsArgs = {
  input: UpdateSent835sPlBsInput;
};


export type MutationUpdateSubgroupV2Args = {
  input: UpdateSubGroupInput;
};


export type MutationUpdateTestCasesPrioritiesArgs = {
  input: UpdateTestCasesPrioritiesInput;
};


export type MutationUpdateTestRunExecutionArgs = {
  input: UpdateTestRunExecutionInput;
};


export type MutationUpdateTransmissionFormatArgs = {
  input: UpdateTransmissionFormatInput;
};


export type MutationUpdateAccumulatorArgs = {
  id: Scalars['ID']['input'];
  input: AccumulatorInput;
};


export type MutationUpdateAccumulatorsArgs = {
  id: Scalars['ID']['input'];
  input: Array<AccumulatorInput>;
};


export type MutationUpdateAuthorizedResourceArgs = {
  id: Scalars['Int']['input'];
  input: AuthorizedResourceInput;
};


export type MutationUpdateBenefitPlanArgs = {
  id: Scalars['ID']['input'];
  input: BenefitPlanInput;
};


export type MutationUpdateCredentialArgs = {
  id: Scalars['Int']['input'];
  input: CredentialInput;
};


export type MutationUpdateDrugInListArgs = {
  id: Scalars['ID']['input'];
  input: Array<MatchExpressionUpdate>;
};


export type MutationUpdateDrugListArgs = {
  id: Scalars['ID']['input'];
  input: PlanDrugListInput;
};


export type MutationUpdatePayeeArgs = {
  in?: InputMaybe<PayeeInput>;
};


export type MutationUpdatePlanRuleArgs = {
  id: Scalars['ID']['input'];
  input: PlanRuleInput;
};


export type MutationUpdatePlanRulePrioritiesArgs = {
  id: Scalars['ID']['input'];
  input: PlanRulePriorityListInput;
};


export type MutationUpsertAccumulatorTransactionArgs = {
  input: AddAccumsTransactionInput;
};


export type MutationUpsertAgeHandlerDetailsArgs = {
  input: Array<AgeHandlerDetailUpsertInput>;
};


export type MutationUpsertAndDeleteProcessRuleLinesArgs = {
  input?: InputMaybe<UpsertProcessRuleLinesInput>;
};


export type MutationUpsertBillCostHandlerDetailsArgs = {
  input: Array<BillCostHandlerDetailUpsertInput>;
};


export type MutationUpsertCobObjectLinesArgs = {
  inputs: Array<UpsertCobObjectLineInput>;
};


export type MutationUpsertCopayHandlerDetailsArgs = {
  input: Array<CopayHandlerDetailUpsertInput>;
};


export type MutationUpsertCostHandlerDetailsArgs = {
  input: Array<CostHandlerDetailUpsertInput>;
};


export type MutationUpsertDurProgramDetailsArgs = {
  input: UpsertDurProgramDetailsInput;
};


export type MutationUpsertDispenseFeeHandlerDetailsArgs = {
  input: Array<DispenseFeeHandlerDetailUpsertInput>;
};


export type MutationUpsertEligibilityTimelineArgs = {
  input: UpsertEligibilityTimelineInput;
};


export type MutationUpsertMemberEligibilityFlagArgs = {
  input: UpsertMemberEligibilityFlagInput;
};


export type MutationUpsertMiscHandlerDetailsArgs = {
  inputs: Array<UpsertMiscHandlerDetailInput>;
};


export type MutationUpsertPlanDurProgramArgs = {
  input: UpsertPlanDurProgramInput;
};


export type MutationUpsertPlanFillRuleArgs = {
  input: PlanFillRuleInput;
};


export type MutationUpsertPlanStepTherapyArgs = {
  input: PlanStepTherapyInput;
};


export type MutationUpsertPlanToCobArgs = {
  input: PlanToCobInput;
};


export type MutationUpsertProcessRuleAttachmentArgs = {
  input: ProcessRuleAttachmentInput;
};


export type MutationUpsertStepTherapyLineArgs = {
  input: UpsertStepTherapyLineInput;
};

export type NcpdpAuthorizationResponse = {
  __typename?: 'NCPDPAuthorizationResponse';
  dollarsAuthorized: Scalars['String']['output'];
  effectiveDate: Scalars['String']['output'];
  expirationDate: Scalars['String']['output'];
  numberAssigned: Scalars['String']['output'];
  numberOfRefillsAuthorized: Scalars['String']['output'];
  processedDate: Scalars['String']['output'];
  quantity: Scalars['String']['output'];
  quantityAccumulated: Scalars['String']['output'];
};

export type NcpdpBenefitStage = {
  __typename?: 'NCPDPBenefitStage';
  amount: Scalars['NCPDPAmount']['output'];
  qualifier: Scalars['String']['output'];
};

export type NcpdpBenefitStageInput = {
  amount: Scalars['String']['input'];
  qualifier: Scalars['String']['input'];
};

export type NcpdpClaim = {
  __typename?: 'NCPDPClaim';
  alternateID: Scalars['String']['output'];
  associatedPrescriptionServiceDate: Scalars['String']['output'];
  associatedPrescriptionServiceReferenceNumber: Scalars['String']['output'];
  compoundCode: Scalars['String']['output'];
  compoundType: Scalars['String']['output'];
  datePrescriptionWritten?: Maybe<Scalars['Time']['output']>;
  daysSupply: Scalars['String']['output'];
  daysSupplyIntendedToBeDispensed: Scalars['String']['output'];
  delayReasonCode: Scalars['String']['output'];
  dispenseAsWrittenProductSelectionCode: Scalars['String']['output'];
  dispensingStatus: Scalars['String']['output'];
  fillNumber: Scalars['String']['output'];
  icnTcn?: Maybe<Scalars['String']['output']>;
  intermediaryAuthorizationID: Scalars['String']['output'];
  intermediaryAuthorizationTypeID: Scalars['String']['output'];
  levelOfService: Scalars['String']['output'];
  numberOfRefillsAuthorized: Scalars['String']['output'];
  originallyPrescribedProductServiceCode: Scalars['String']['output'];
  originallyPrescribedProductServiceIDQualifier: Scalars['String']['output'];
  originallyPrescribedQuantity: Scalars['String']['output'];
  otherCoverageCode: Scalars['String']['output'];
  patientAssignmentIndicator: Scalars['String']['output'];
  pharmacyServiceType: Scalars['String']['output'];
  prescriptionOriginCode: Scalars['String']['output'];
  prescriptionServiceReferenceNumber?: Maybe<Scalars['String']['output']>;
  prescriptionServiceReferenceNumberQualifier?: Maybe<Scalars['String']['output']>;
  priorAuthorizationNumber: Scalars['String']['output'];
  priorAuthorizationTypeCode: Scalars['String']['output'];
  procedureModifierCode: Array<Scalars['String']['output']>;
  procedureModifierCodeCount: Scalars['String']['output'];
  productServiceID: Scalars['String']['output'];
  productServiceIDQualifier: Scalars['String']['output'];
  quantityDispensed: Scalars['String']['output'];
  quantityIntendedToBeDispensed: Scalars['String']['output'];
  quantityPrescribed: Scalars['String']['output'];
  routeOfAdministration: Scalars['String']['output'];
  scheduledPrescriptionIDNumber: Scalars['String']['output'];
  specialPackagingIndicator: Scalars['String']['output'];
  submissionClarificationCode: Array<Scalars['String']['output']>;
  submissionClarificationCodeCount: Scalars['String']['output'];
  transactionReferenceNumber: Scalars['String']['output'];
  unitOfMeasure: Scalars['String']['output'];
};

export type NcpdpClaimInput = {
  alternateID: Scalars['String']['input'];
  associatedPrescriptionServiceDate: Scalars['String']['input'];
  associatedPrescriptionServiceReferenceNumber: Scalars['String']['input'];
  compoundCode: Scalars['String']['input'];
  compoundType: Scalars['String']['input'];
  datePrescriptionWritten?: InputMaybe<Scalars['Time']['input']>;
  daysSupply: Scalars['String']['input'];
  daysSupplyIntendedToBeDispensed: Scalars['String']['input'];
  delayReasonCode: Scalars['String']['input'];
  dispenseAsWrittenProductSelectionCode: Scalars['String']['input'];
  dispensingStatus: Scalars['String']['input'];
  fillNumber: Scalars['String']['input'];
  icnTcn?: InputMaybe<Scalars['String']['input']>;
  intermediaryAuthorizationID: Scalars['String']['input'];
  intermediaryAuthorizationTypeID: Scalars['String']['input'];
  levelOfService: Scalars['String']['input'];
  numberOfRefillsAuthorized: Scalars['String']['input'];
  originallyPrescribedProductServiceCode: Scalars['String']['input'];
  originallyPrescribedProductServiceIDQualifier: Scalars['String']['input'];
  originallyPrescribedQuantity: Scalars['String']['input'];
  otherCoverageCode: Scalars['String']['input'];
  patientAssignmentIndicator: Scalars['String']['input'];
  pharmacyServiceType: Scalars['String']['input'];
  prescriptionOriginCode: Scalars['String']['input'];
  prescriptionServiceReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  prescriptionServiceReferenceNumberQualifier?: InputMaybe<Scalars['String']['input']>;
  priorAuthorizationNumber: Scalars['String']['input'];
  priorAuthorizationTypeCode: Scalars['String']['input'];
  procedureModifierCode?: InputMaybe<Array<Scalars['String']['input']>>;
  procedureModifierCodeCount: Scalars['String']['input'];
  productServiceID: Scalars['String']['input'];
  productServiceIDQualifier: Scalars['String']['input'];
  quantityDispensed: Scalars['String']['input'];
  quantityIntendedToBeDispensed: Scalars['String']['input'];
  quantityPrescribed: Scalars['String']['input'];
  routeOfAdministration: Scalars['String']['input'];
  scheduledPrescriptionIDNumber: Scalars['String']['input'];
  specialPackagingIndicator: Scalars['String']['input'];
  submissionClarificationCode: Array<Scalars['String']['input']>;
  submissionClarificationCodeCount: Scalars['String']['input'];
  transactionReferenceNumber: Scalars['String']['input'];
  unitOfMeasure: Scalars['String']['input'];
};

export type NcpdpClaimResponse = {
  __typename?: 'NCPDPClaimResponse';
  icnTcn?: Maybe<Scalars['String']['output']>;
  preferredProductCostShareIncentive: Scalars['String']['output'];
  preferredProductCount: Scalars['String']['output'];
  preferredProductDescription: Scalars['String']['output'];
  preferredProductID: Scalars['String']['output'];
  preferredProductIDQualifier: Scalars['String']['output'];
  preferredProductIncentive: Scalars['String']['output'];
  prescriptionServiceReferenceNumber?: Maybe<Scalars['String']['output']>;
  prescriptionServiceReferenceNumberQualifier?: Maybe<Scalars['String']['output']>;
};

export type NcpdpCompound = {
  __typename?: 'NCPDPCompound';
  dispensingUnitFormIndicator: Scalars['String']['output'];
  dosageFormDescriptionCode: Scalars['String']['output'];
  ingredientComponentCount: Scalars['String']['output'];
  ingredients?: Maybe<Array<Maybe<NcpdpIngredient>>>;
};

export type NcpdpCompoundInput = {
  dispensingUnitFormIndicator: Scalars['String']['input'];
  dosageFormDescriptionCode: Scalars['String']['input'];
  ingredientComponentCount: Scalars['String']['input'];
  ingredients?: InputMaybe<Array<InputMaybe<NcpdpIngredientInput>>>;
};

export type NcpdpCoordination = {
  __typename?: 'NCPDPCoordination';
  coordinationOfBenefitsOtherPaymentsCount: Scalars['String']['output'];
  otherPayers?: Maybe<Array<Maybe<NcpdpOtherPayer>>>;
};

export type NcpdpCoordinationInput = {
  coordinationOfBenefitsOtherPaymentsCount: Scalars['String']['input'];
  otherPayers?: InputMaybe<Array<InputMaybe<NcpdpOtherPayerInput>>>;
};

export type NcpdpdurPpsComponent = {
  __typename?: 'NCPDPDURPpsComponent';
  durPpsCodeCounter: Scalars['String']['output'];
  durpsLLevelOfEffort: Scalars['String']['output'];
  professionalServiceCode: Scalars['String']['output'];
  reasonForServiceCode: Scalars['String']['output'];
  resultOfServiceCode: Scalars['String']['output'];
};

export type NcpdpdurPpsComponentInput = {
  durPpsCodeCounter: Scalars['String']['input'];
  durpsLLevelOfEffort: Scalars['String']['input'];
  professionalServiceCode: Scalars['String']['input'];
  reasonForServiceCode: Scalars['String']['input'];
  resultOfServiceCode: Scalars['String']['input'];
};

export type NcpdpdurPpsResponse = {
  __typename?: 'NCPDPDURPpsResponse';
  clinicalSignificanceCode: Scalars['String']['output'];
  databaseIndicator: Scalars['String']['output'];
  durAdditionalText: Scalars['String']['output'];
  durFreeTextMessage: Scalars['String']['output'];
  durPPSResponseCodeCounter: Scalars['String']['output'];
  otherPharmacyIndicator: Scalars['String']['output'];
  otherPrescriberIndicator: Scalars['String']['output'];
  previousDateOfFill: Scalars['String']['output'];
  quantityOfPreviousFill: Scalars['String']['output'];
  reasonForServiceCode: Scalars['String']['output'];
};

export type NcpdpHeader = {
  __typename?: 'NCPDPHeader';
  binNumber: Scalars['String']['output'];
  dateOfService?: Maybe<Scalars['Time']['output']>;
  processorControlNumber: Scalars['String']['output'];
  serviceProviderID: Scalars['String']['output'];
  serviceProviderIDQualifier: Scalars['Int']['output'];
  transactionCount: Scalars['Int']['output'];
  versionReleaseNumber: Scalars['String']['output'];
};

export type NcpdpHeaderInput = {
  binNumber: Scalars['String']['input'];
  dateOfService: Scalars['Time']['input'];
  processorControlNumber: Scalars['String']['input'];
  serviceProviderID: Scalars['String']['input'];
  serviceProviderIDQualifier: Scalars['Int']['input'];
  transactionCode: Scalars['String']['input'];
  transactionCount: Scalars['Int']['input'];
  versionReleaseNumber: Scalars['String']['input'];
};

export type NcpdpIngredient = {
  __typename?: 'NCPDPIngredient';
  basisOfCostDetermination: Scalars['String']['output'];
  drugCost: Scalars['NCPDPAmount']['output'];
  productID: Scalars['String']['output'];
  productIDQualifier: Scalars['String']['output'];
  quantity: Scalars['String']['output'];
};

export type NcpdpIngredientInput = {
  basisOfCostDetermination: Scalars['String']['input'];
  drugCost: Scalars['String']['input'];
  productID: Scalars['String']['input'];
  productIDQualifier: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
};

export type NcpdpInsurance = {
  __typename?: 'NCPDPInsurance';
  cardholderFirstName: Scalars['String']['output'];
  cardholderID: Scalars['String']['output'];
  cardholderLastName: Scalars['String']['output'];
  cmsPartDDefinedQualifiedFacility: Scalars['String']['output'];
  eligibilityClarificationCode: Scalars['String']['output'];
  groupID: Scalars['String']['output'];
  homePlan: Scalars['String']['output'];
  medicaidAgencyNumber: Scalars['String']['output'];
  medicaidIDNumber: Scalars['String']['output'];
  medicaidIndicator: Scalars['String']['output'];
  medigapID: Scalars['String']['output'];
  otherPayerBINNumber: Scalars['String']['output'];
  otherPayerCardholderID: Scalars['String']['output'];
  otherPayerGroupID: Scalars['String']['output'];
  otherPayerProcessorControlNumber: Scalars['String']['output'];
  patientRelationshipCode: Scalars['String']['output'];
  personCode: Scalars['String']['output'];
  planID: Scalars['String']['output'];
  providerAcceptAssignmentIndicator: Scalars['String']['output'];
};

export type NcpdpInsuranceAddInfoResponse = {
  __typename?: 'NCPDPInsuranceAddInfoResponse';
  benefitID: Scalars['String']['output'];
  contractNumber: Scalars['String']['output'];
  formularyID: Scalars['String']['output'];
  licsLevel: Scalars['String']['output'];
  medicarePartDCoverageCode: Scalars['String']['output'];
  nextMedicarePartDEffectiveDate: Scalars['String']['output'];
  nextMedicarePartDTerminationDate: Scalars['String']['output'];
};

export type NcpdpInsuranceInput = {
  cardholderFirstName: Scalars['String']['input'];
  cardholderID: Scalars['String']['input'];
  cardholderLastName: Scalars['String']['input'];
  cmsPartDDefinedQualifiedFacility: Scalars['String']['input'];
  eligibilityClarificationCode: Scalars['String']['input'];
  groupID: Scalars['String']['input'];
  homePlan: Scalars['String']['input'];
  medicaidAgencyNumber: Scalars['String']['input'];
  medicaidIDNumber: Scalars['String']['input'];
  medicaidIndicator: Scalars['String']['input'];
  medigapID: Scalars['String']['input'];
  otherPayerBINNumber: Scalars['String']['input'];
  otherPayerCardholderID: Scalars['String']['input'];
  otherPayerGroupID: Scalars['String']['input'];
  otherPayerProcessorControlNumber: Scalars['String']['input'];
  patientRelationshipCode: Scalars['String']['input'];
  personCode: Scalars['String']['input'];
  planID: Scalars['String']['input'];
  providerAcceptAssignmentIndicator: Scalars['String']['input'];
};

export type NcpdpInsuranceResponse = {
  __typename?: 'NCPDPInsuranceResponse';
  cardholderID: Scalars['String']['output'];
  groupID: Scalars['String']['output'];
  medicaidAgencyNumber: Scalars['String']['output'];
  medicaidIDNumber: Scalars['String']['output'];
  networkReimbursementID: Scalars['String']['output'];
  payerID: Scalars['String']['output'];
  payerIDQualifier: Scalars['String']['output'];
  planID: Scalars['String']['output'];
};

export type NcpdpMessageResponse = {
  __typename?: 'NCPDPMessageResponse';
  message: Scalars['String']['output'];
};

export type NcpdpOtherPayer = {
  __typename?: 'NCPDPOtherPayer';
  amountPaidCount: Scalars['String']['output'];
  amounts?: Maybe<Array<Maybe<NcpdpOtherPayerAmount>>>;
  benefitStageCount: Scalars['String']['output'];
  benefitStages?: Maybe<Array<Maybe<NcpdpBenefitStage>>>;
  coverageType: Scalars['String']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  idQualifier: Scalars['String']['output'];
  internalControlNumber: Scalars['String']['output'];
  patientResponsibilityAmountCount: Scalars['String']['output'];
  patientResponsibilityAmounts?: Maybe<Array<Maybe<NcpdpOtherPayerPatientResponsibility>>>;
  rejectCount: Scalars['String']['output'];
  rejects?: Maybe<Array<Maybe<NcpdpOtherPayerReject>>>;
};

export type NcpdpOtherPayerAmount = {
  __typename?: 'NCPDPOtherPayerAmount';
  paid: Scalars['NCPDPAmount']['output'];
  qualifier: Scalars['String']['output'];
};

export type NcpdpOtherPayerAmountInput = {
  paid: Scalars['String']['input'];
  qualifier: Scalars['String']['input'];
};

export type NcpdpOtherPayerInput = {
  amountPaidCount: Scalars['String']['input'];
  amounts?: InputMaybe<Array<InputMaybe<NcpdpOtherPayerAmountInput>>>;
  benefitStageCount: Scalars['String']['input'];
  benefitStages?: InputMaybe<Array<InputMaybe<NcpdpBenefitStageInput>>>;
  coverageType: Scalars['String']['input'];
  date: Scalars['String']['input'];
  id: Scalars['String']['input'];
  idQualifier: Scalars['String']['input'];
  internalControlNumber: Scalars['String']['input'];
  patientResponsibilityAmountCount: Scalars['String']['input'];
  patientResponsibilityAmounts?: InputMaybe<Array<InputMaybe<NcpdpOtherPayerPatientResponsibilityInput>>>;
  rejectCount: Scalars['String']['input'];
  rejects?: InputMaybe<Array<InputMaybe<NcpdpOtherPayerRejectInput>>>;
};

export type NcpdpOtherPayerPatientResponsibility = {
  __typename?: 'NCPDPOtherPayerPatientResponsibility';
  amount: Scalars['NCPDPAmount']['output'];
  qualifier: Scalars['String']['output'];
};

export type NcpdpOtherPayerPatientResponsibilityInput = {
  amount: Scalars['String']['input'];
  qualifier: Scalars['String']['input'];
};

export type NcpdpOtherPayerReject = {
  __typename?: 'NCPDPOtherPayerReject';
  code: Scalars['String']['output'];
};

export type NcpdpOtherPayerRejectInput = {
  code: Scalars['String']['input'];
};

export type NcpdpOtherPayerResponse = {
  __typename?: 'NCPDPOtherPayerResponse';
  benefitEffectiveDate: Scalars['String']['output'];
  benefitTerminationDate: Scalars['String']['output'];
  cardholderID: Scalars['String']['output'];
  coverageType: Scalars['String']['output'];
  groupID: Scalars['String']['output'];
  helpDeskPhoneNumber: Scalars['String']['output'];
  idCount: Scalars['String']['output'];
  idQualifier: Scalars['String']['output'];
  otherPayerID: Scalars['String']['output'];
  patientRelationshipCode: Scalars['String']['output'];
  personCode: Scalars['String']['output'];
  processorControlNumber: Scalars['String']['output'];
};

export type NcpdpParsedFields = {
  __typename?: 'NCPDPParsedFields';
  originallyPrescribedQuantity?: Maybe<Scalars['Float']['output']>;
  quantityDispensed?: Maybe<Scalars['Float']['output']>;
  quantityPrescribed?: Maybe<Scalars['Float']['output']>;
};

export type NcpdpPatient = {
  __typename?: 'NCPDPPatient';
  city: Scalars['String']['output'];
  dateOfBirth: Scalars['String']['output'];
  emailAddress: Scalars['String']['output'];
  employerID: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  genderCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  idQualifier: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  placeOfService: Scalars['String']['output'];
  pregnancyIndicator: Scalars['String']['output'];
  residence: Scalars['String']['output'];
  smokerNonSmokerCode: Scalars['String']['output'];
  stateOrProvince: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  zipPostalCode: Scalars['String']['output'];
};

export type NcpdpPatientInput = {
  city: Scalars['String']['input'];
  dateOfBirth: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  employerID: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  genderCode: Scalars['String']['input'];
  id: Scalars['String']['input'];
  idQualifier: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  placeOfService: Scalars['String']['input'];
  pregnancyIndicator: Scalars['String']['input'];
  residence: Scalars['String']['input'];
  smokerNonSmokerCode: Scalars['String']['input'];
  stateOrProvince: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
  zipPostalCode: Scalars['String']['input'];
};

export type NcpdpPatientResponse = {
  __typename?: 'NCPDPPatientResponse';
  dateOfBirth: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type NcpdpPharmacyProvider = {
  __typename?: 'NCPDPPharmacyProvider';
  providerID: Scalars['String']['output'];
  providerIDQualifier: Scalars['String']['output'];
};

export type NcpdpPharmacyProviderInput = {
  providerID: Scalars['String']['input'];
  providerIDQualifier: Scalars['String']['input'];
};

export type NcpdpPrescriber = {
  __typename?: 'NCPDPPrescriber';
  cityAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  idQualifier: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  primaryCareProvIDerID: Scalars['String']['output'];
  primaryCareProvIDerIDQualifier: Scalars['String']['output'];
  primaryCareProvIDerLastName: Scalars['String']['output'];
  stateProvinceAddress: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  zipPostalZone: Scalars['String']['output'];
};

export type NcpdpPrescriberInput = {
  cityAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  idQualifier: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  primaryCareProvIDerID: Scalars['String']['input'];
  primaryCareProvIDerIDQualifier: Scalars['String']['input'];
  primaryCareProvIDerLastName: Scalars['String']['input'];
  stateProvinceAddress: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
  zipPostalZone: Scalars['String']['input'];
};

export type NcpdpPricingInput = {
  basisOfCostDetermination: Scalars['String']['input'];
  dispensingFeeSubmitted: Scalars['String']['input'];
  flatSalesTaxAmountSubmitted: Scalars['String']['input'];
  grossAmountDue: Scalars['String']['input'];
  incentiveAmountSubmitted: Scalars['String']['input'];
  ingredientCost: Scalars['String']['input'];
  medicaidPaidAmount: Scalars['String']['input'];
  otherAmountClaimedSubmitted: Array<Scalars['String']['input']>;
  otherAmountClaimedSubmittedCount: Scalars['String']['input'];
  otherAmountClaimedSubmittedQualifier: Array<Scalars['String']['input']>;
  patientPaidAmountSubmitted: Scalars['String']['input'];
  percentageSalesTaxAmountSubmitted: Scalars['String']['input'];
  percentageSalesTaxBasisSubmitted: Scalars['String']['input'];
  percentageSalesTaxRateSubmitted: Scalars['String']['input'];
  professionalServiceFeeSubmitted: Scalars['String']['input'];
  usualAndCustomaryCharge: Scalars['String']['input'];
};

export type NcpdpPricingResponseWithAmounts = {
  __typename?: 'NCPDPPricingResponseWithAmounts';
  accumulatedDeductibleAmount?: Maybe<Scalars['NCPDPAmount']['output']>;
  amountAppliedToPeriodicDeductible?: Maybe<Scalars['NCPDPAmount']['output']>;
  amountAttributedToCoverageGap?: Maybe<Scalars['NCPDPAmount']['output']>;
  amountAttributedToProcessorFee?: Maybe<Scalars['NCPDPAmount']['output']>;
  amountAttributedToSalesTax?: Maybe<Scalars['NCPDPAmount']['output']>;
  amountBrandDrug?: Maybe<Scalars['NCPDPAmount']['output']>;
  amountBrandNonPreferredFormularySelection?: Maybe<Scalars['NCPDPAmount']['output']>;
  amountCodesProviderNetworkSelection?: Maybe<Scalars['NCPDPAmount']['output']>;
  amountExceedingPeriodicBenefitMaximum?: Maybe<Scalars['NCPDPAmount']['output']>;
  amountNonPreferredFormularySelection?: Maybe<Scalars['NCPDPAmount']['output']>;
  amountOfCoinsurance?: Maybe<Scalars['NCPDPAmount']['output']>;
  amountOfCopay?: Maybe<Scalars['NCPDPAmount']['output']>;
  basisOfCalculationCoinsurance: Scalars['String']['output'];
  basisOfCalculationCopay: Scalars['String']['output'];
  basisOfCalculationDispensingFee: Scalars['String']['output'];
  basisOfCalculationFlatSalesTax: Scalars['String']['output'];
  basisOfCalculationPercentageSalesTax: Scalars['String']['output'];
  basisOfReimbursementDetermination: Scalars['String']['output'];
  benefitStageAmount?: Maybe<Scalars['NCPDPAmount']['output']>;
  benefitStageCount: Scalars['String']['output'];
  benefitStageQualifier: Scalars['String']['output'];
  dispensingFeeContractedReimbursableAmount?: Maybe<Scalars['NCPDPAmount']['output']>;
  dispensingFeePaid?: Maybe<Scalars['NCPDPAmount']['output']>;
  estimatedGenericSavings?: Maybe<Scalars['NCPDPAmount']['output']>;
  flatSalesTaxAmountPaid?: Maybe<Scalars['NCPDPAmount']['output']>;
  healthPlanFundedAssistanceAmount?: Maybe<Scalars['NCPDPAmount']['output']>;
  incentiveAmountPaid?: Maybe<Scalars['NCPDPAmount']['output']>;
  ingredientCostContractedReimbursableAmount?: Maybe<Scalars['NCPDPAmount']['output']>;
  ingredientCostPaid?: Maybe<Scalars['NCPDPAmount']['output']>;
  otherAmountPaid?: Maybe<Array<Maybe<Scalars['NCPDPAmount']['output']>>>;
  otherAmountPaidCount?: Maybe<Scalars['String']['output']>;
  otherAmountPaidQualifier?: Maybe<Array<Scalars['String']['output']>>;
  otherPayerAmountRecognized?: Maybe<Scalars['NCPDPAmount']['output']>;
  patientPayAmount?: Maybe<Scalars['NCPDPAmount']['output']>;
  patientSalesTaxAmount?: Maybe<Scalars['NCPDPAmount']['output']>;
  percentageSalesTaxAmountPaid?: Maybe<Scalars['NCPDPAmount']['output']>;
  percentageSalesTaxBasisPaid?: Maybe<Scalars['String']['output']>;
  percentageSalesTaxRatePaid?: Maybe<Scalars['NCPDPAmount']['output']>;
  planSalesTaxAmount?: Maybe<Scalars['NCPDPAmount']['output']>;
  pricingResponseBase?: Maybe<Scalars['NCPDPAmount']['output']>;
  professionalServiceFeePaid?: Maybe<Scalars['NCPDPAmount']['output']>;
  remainingBenefitAmount?: Maybe<Scalars['NCPDPAmount']['output']>;
  remainingDeductibleAmount?: Maybe<Scalars['NCPDPAmount']['output']>;
  spendingAccountAmountRemaining?: Maybe<Scalars['NCPDPAmount']['output']>;
  totalAmountPaid?: Maybe<Scalars['NCPDPAmount']['output']>;
};

export type NcpdpPricingWithAmounts = {
  __typename?: 'NCPDPPricingWithAmounts';
  basisOfCostDetermination?: Maybe<Scalars['String']['output']>;
  dispensingFeeSubmitted?: Maybe<Scalars['NCPDPAmount']['output']>;
  flatSalesTaxAmountSubmitted?: Maybe<Scalars['NCPDPAmount']['output']>;
  grossAmountDue?: Maybe<Scalars['NCPDPAmount']['output']>;
  incentiveAmountSubmitted?: Maybe<Scalars['NCPDPAmount']['output']>;
  ingredientCost?: Maybe<Scalars['NCPDPAmount']['output']>;
  medicaidPaidAmount?: Maybe<Scalars['NCPDPAmount']['output']>;
  otherAmountClaimedSubmitted?: Maybe<Array<Maybe<Scalars['NCPDPAmount']['output']>>>;
  otherAmountClaimedSubmittedCount?: Maybe<Scalars['String']['output']>;
  otherAmountClaimedSubmittedQualifier?: Maybe<Array<Scalars['String']['output']>>;
  patientPaidAmountSubmitted?: Maybe<Scalars['NCPDPAmount']['output']>;
  percentageSalesTaxAmountSubmitted?: Maybe<Scalars['NCPDPAmount']['output']>;
  percentageSalesTaxBasisSubmitted?: Maybe<Scalars['NCPDPAmount']['output']>;
  percentageSalesTaxRateSubmitted?: Maybe<Scalars['NCPDPAmount']['output']>;
  professionalServiceFeeSubmitted?: Maybe<Scalars['NCPDPAmount']['output']>;
  usualAndCustomaryCharge?: Maybe<Scalars['NCPDPAmount']['output']>;
};

export type NcpdpReject = {
  __typename?: 'NCPDPReject';
  code: Scalars['String']['output'];
  details: Scalars['String']['output'];
  handlerType?: Maybe<Scalars['String']['output']>;
  handlerUUID?: Maybe<Scalars['UUID']['output']>;
  message: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
};

export type NcpdpResponseHeader = {
  __typename?: 'NCPDPResponseHeader';
  dateOfService: Scalars['Time']['output'];
  responseStatus: NcpdpResponseHeaderStatus;
  serviceProviderID: Scalars['String']['output'];
  serviceProviderIDQualifier: Scalars['Int']['output'];
  transactionCode: Scalars['String']['output'];
  transactionCount: Scalars['Int']['output'];
  versionReleaseNumber: Scalars['String']['output'];
};

export enum NcpdpResponseHeaderStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type NcpdpStatusResponse = {
  __typename?: 'NCPDPStatusResponse';
  approvedMessageCode: Scalars['String']['output'];
  approvedMessageCodeCount: Scalars['String']['output'];
  authorizationNumber: Scalars['String']['output'];
  helpDeskPhoneNumber: Scalars['String']['output'];
  helpDeskPhoneNumberQualifier: Scalars['String']['output'];
  internalControlNumber: Scalars['String']['output'];
  rejectFieldOccurrenceIndicator: Scalars['String']['output'];
  rejects: Array<NcpdpReject>;
  status: Scalars['String']['output'];
  transactionReferenceNumber: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type NcpdpTransaction = {
  __typename?: 'NCPDPTransaction';
  claim?: Maybe<NcpdpClaim>;
  compound?: Maybe<NcpdpCompound>;
  coordination?: Maybe<NcpdpCoordination>;
  durs?: Maybe<Array<Maybe<NcpdpdurPpsComponent>>>;
  header: NcpdpHeader;
  insurance?: Maybe<NcpdpInsurance>;
  /** JSON representation of the Request Transaction */
  json: Scalars['Map']['output'];
  parsedFields?: Maybe<NcpdpParsedFields>;
  parsedPricing?: Maybe<NcpdpPricingWithAmounts>;
  patient?: Maybe<NcpdpPatient>;
  pharmacyProvider?: Maybe<NcpdpPharmacyProvider>;
  prescriber?: Maybe<NcpdpPrescriber>;
};

export type NcpdpTransactionInput = {
  claim?: InputMaybe<NcpdpClaimInput>;
  compound?: InputMaybe<NcpdpCompoundInput>;
  coordination?: InputMaybe<NcpdpCoordinationInput>;
  durs?: InputMaybe<Array<InputMaybe<NcpdpdurPpsComponentInput>>>;
  header: NcpdpHeaderInput;
  insurance?: InputMaybe<NcpdpInsuranceInput>;
  patient?: InputMaybe<NcpdpPatientInput>;
  pharmacyProvider?: InputMaybe<NcpdpPharmacyProviderInput>;
  prescriber?: InputMaybe<NcpdpPrescriberInput>;
  pricing?: InputMaybe<NcpdpPricingInput>;
};

export type NcpdpTransactionResponse = {
  __typename?: 'NCPDPTransactionResponse';
  authorization?: Maybe<NcpdpAuthorizationResponse>;
  claim?: Maybe<NcpdpClaimResponse>;
  durs: Array<Maybe<NcpdpdurPpsResponse>>;
  header: NcpdpResponseHeader;
  insurance?: Maybe<NcpdpInsuranceResponse>;
  insuranceAddInfo?: Maybe<NcpdpInsuranceAddInfoResponse>;
  /** JSON representation of the Response Transaction */
  json: Scalars['Map']['output'];
  message?: Maybe<NcpdpMessageResponse>;
  otherPayer?: Maybe<NcpdpOtherPayerResponse>;
  parsedPricing?: Maybe<NcpdpPricingResponseWithAmounts>;
  patient?: Maybe<NcpdpPatientResponse>;
  status?: Maybe<NcpdpStatusResponse>;
};

export type Nacha = {
  __typename?: 'Nacha';
  /** Total Claim count. */
  TotalClaimCount?: Maybe<Scalars['Int']['output']>;
  /** Total Paid Amount. */
  TotalPaid?: Maybe<Scalars['Float']['output']>;
  /** Total Payees count. */
  TotalPayees?: Maybe<Scalars['Int']['output']>;
  /** The time at which this NACHA was created. */
  created_at: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /** ID of the s3_file record file to which this NACHA is associated. */
  s3_file_id?: Maybe<Scalars['ID']['output']>;
  /** The Sent835 records that are associated with this NACHA. */
  sent_835s: Sent835List;
};

export type NachaFilters = {
  achTraceNumber?: InputMaybe<StringFilter>;
  authorizationNumber?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<TimeFilter>;
  endDate?: InputMaybe<TimeFilter>;
  id?: InputMaybe<IdFilter>;
  payeeIds?: InputMaybe<IdFilter>;
  startDate?: InputMaybe<TimeFilter>;
};

export type NachaList = {
  __typename?: 'NachaList';
  pagination: Pagination;
  results: Array<Nacha>;
};

export type NachaOrder = {
  created_at?: InputMaybe<OrderDirectionEnum>;
  id?: InputMaybe<OrderDirectionEnum>;
};

export type NcpdpRejection = {
  __typename?: 'NcpdpRejection';
  /** NCPDP Rejection Code */
  code: Scalars['String']['output'];
  /** NCPDP Rejection Description */
  description: Scalars['String']['output'];
};

export type NcpdpRejectionFilters = {
  /** Filters on the NCPDP Rejection Code */
  code?: InputMaybe<StringFilter>;
  /**
   * codeOrDescription is an OR filter on the code and description fields. This is used, for instance, in a dropdown menu
   * where a user might type to filter results by either field. If this filter is present, it overrides all other filters.
   */
  codeOrDescription?: InputMaybe<StringFilter>;
  /** Filters on the NCPDP Rejection Description */
  description?: InputMaybe<StringFilter>;
};

export type NcpdpRejectionList = {
  __typename?: 'NcpdpRejectionList';
  pagination?: Maybe<Pagination>;
  results: Array<NcpdpRejection>;
};

export type NcpdpRejectionOrder = {
  code?: InputMaybe<OrderDirectionEnum>;
};

export enum NetworkType {
  Broad = 'BROAD',
  Commercial = 'COMMERCIAL',
  Discount = 'DISCOUNT',
  Limited = 'LIMITED',
  Ltc = 'LTC',
  Mail = 'MAIL',
  Narrow = 'NARROW',
  Oon = 'OON',
  Preferred = 'PREFERRED',
  Specialty = 'SPECIALTY',
  Vaccine = 'VACCINE',
  Workers = 'WORKERS',
  WorkersOon = 'WORKERS_OON'
}

/**
 * The node interface, for Relay compliance.
 *  - https://relay.dev/docs/next/glossary/#node
 *  - https://relay.dev/docs/guides/graphql-server-specification/#object-identification
 *  - https://graphql.org/learn/global-object-identification/#node-interface
 */
export type Node = {
  id: Scalars['ID']['output'];
};

export type NormalizerLineStats = {
  __typename?: 'NormalizerLineStats';
  parse_errors?: Maybe<Scalars['Int']['output']>;
  post_transform_errors?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  transform_errors?: Maybe<Scalars['Int']['output']>;
  validation_errors?: Maybe<Scalars['Int']['output']>;
};

export type NotificationRecipient = {
  __typename?: 'NotificationRecipient';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NotificationRecipientInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum OccCode {
  BillingForCopay = 'BILLING_FOR_COPAY',
  ManagedCarePlanDenial = 'MANAGED_CARE_PLAN_DENIAL',
  NotSpecified = 'NOT_SPECIFIED',
  NoOtherCoverageIdentified = 'NO_OTHER_COVERAGE_IDENTIFIED',
  OtherCoverageDeniedNotParticipatingProvider = 'OTHER_COVERAGE_DENIED_NOT_PARTICIPATING_PROVIDER',
  OtherCoverageExistsNotCovered = 'OTHER_COVERAGE_EXISTS_NOT_COVERED',
  OtherCoverageExistsNotInEffectOnDos = 'OTHER_COVERAGE_EXISTS_NOT_IN_EFFECT_ON_DOS',
  OtherCoverageExistsPaymentCollected = 'OTHER_COVERAGE_EXISTS_PAYMENT_COLLECTED',
  OtherCoverageExistsPaymentNotCollected = 'OTHER_COVERAGE_EXISTS_PAYMENT_NOT_COLLECTED'
}

export type OnboardingFilters = {
  account_id?: InputMaybe<IdFilter>;
  actual_live_date?: InputMaybe<TimeFilter>;
  group_id?: InputMaybe<IdFilter>;
  incomplete_only?: InputMaybe<Scalars['Boolean']['input']>;
  original_live_date?: InputMaybe<TimeFilter>;
};

export type OnboardingProgress = {
  __typename?: 'OnboardingProgress';
  group: Group;
  group_id: Scalars['ID']['output'];
  tasks?: Maybe<Array<Maybe<OnboardingTaskStatus>>>;
};

export type OnboardingProgressList = {
  __typename?: 'OnboardingProgressList';
  pagination?: Maybe<Pagination>;
  results?: Maybe<Array<OnboardingProgress>>;
};

export type OnboardingStatusUpdateInput = {
  new_status: Scalars['String']['input'];
  onboarding_task_id: Scalars['ID']['input'];
};

export type OnboardingTask = {
  __typename?: 'OnboardingTask';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OnboardingTaskStatus = {
  __typename?: 'OnboardingTaskStatus';
  status: Scalars['String']['output'];
  task: OnboardingTask;
};

export type OperationHours = {
  __typename?: 'OperationHours';
  allDay?: Maybe<Scalars['Boolean']['output']>;
  start?: Maybe<Scalars['timeOnly']['output']>;
  stop?: Maybe<Scalars['timeOnly']['output']>;
  weekday: WeekdayEnum;
};

export type OperationHoursInput = {
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['timeOnly']['input']>;
  stop?: InputMaybe<Scalars['timeOnly']['input']>;
  weekday: WeekdayEnum;
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OrderDirectionEnum {
  /** Ascending */
  Asc = 'ASC',
  /** Descending */
  Desc = 'DESC'
}

export type Organization = Node & {
  __typename?: 'Organization';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phoneContactDetails?: Maybe<Array<OrganizationPhoneContactDetails>>;
};

export type OrganizationPhoneContactDetails = Node & {
  __typename?: 'OrganizationPhoneContactDetails';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  operationHours: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type OverrideMpaWithTemplateInput = {
  /** The originating claim, when the flow has one, used to recompute claim-derived fields. */
  claimId?: InputMaybe<Scalars['UUID']['input']>;
  /** The template to apply. */
  templateKey: Scalars['String']['input'];
};

/**
 * One competing coverage alternative for a member, as Portal records it. Its five
 * intervals are the membership's, the cardholder-to-group subscription's, the
 * group's, the subgroup (available coverage) record's and the plan code's own, all
 * read in one transaction; effective coverage is their intersection. Every
 * alternative is returned, including gaps and overlaps; Forge applies no clinical
 * date policy and picks no winner. A null link without an error is absent from
 * Portal data; a link the caller may not read is a field error.
 */
export type PaAssistantCoverage = Node & {
  __typename?: 'PAAssistantCoverage';
  /**
   * The linked benefit plan. Its own formulary field resolves one live version; PA
   * consumers must read formularies here instead, which returns every current one.
   */
  benefitPlan?: Maybe<BenefitPlan>;
  /** Cardholder-to-group coverage start, as in groupTimeline. */
  cardholderEffective?: Maybe<Scalars['Date']['output']>;
  /** Cardholder-to-group coverage end, as in groupTimeline. */
  cardholderExpiration?: Maybe<Scalars['Date']['output']>;
  /**
   * Every current version of the benefit plan's formulary. An empty connection
   * means no formulary; more than one edge means the versions conflict.
   */
  formularies: PaAssistantFormularyConnection;
  /**
   * The linked group, for display. Its own date fields resolve live; use
   * groupEffective and groupExpiration for coverage.
   */
  group?: Maybe<Group>;
  /** The group record's own effective date. */
  groupEffective?: Maybe<Scalars['Date']['output']>;
  /** The group record's own termination date. */
  groupExpiration?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Member coverage start of this membership, as in eligibilityTimeline. */
  memberEffective?: Maybe<Scalars['Date']['output']>;
  /** Member coverage end of this membership, as in eligibilityTimeline. */
  memberExpiration?: Maybe<Scalars['Date']['output']>;
  /**
   * The linked plan code, for display. Its own date fields resolve live; use
   * planCodeEffective and planCodeExpiration for coverage.
   */
  planCode?: Maybe<PlanCodeV2>;
  /** The plan code record's own effective date. */
  planCodeEffective?: Maybe<Scalars['Date']['output']>;
  /** The plan code record's own end date. */
  planCodeExpiration?: Maybe<Scalars['Date']['output']>;
  /** The subgroup (available coverage) record's own effective date. */
  subgroupEffective?: Maybe<Scalars['Date']['output']>;
  /** The subgroup (available coverage) record's own end date. */
  subgroupExpiration?: Maybe<Scalars['Date']['output']>;
};


/**
 * One competing coverage alternative for a member, as Portal records it. Its five
 * intervals are the membership's, the cardholder-to-group subscription's, the
 * group's, the subgroup (available coverage) record's and the plan code's own, all
 * read in one transaction; effective coverage is their intersection. Every
 * alternative is returned, including gaps and overlaps; Forge applies no clinical
 * date policy and picks no winner. A null link without an error is absent from
 * Portal data; a link the caller may not read is a field error.
 */
export type PaAssistantCoverageFormulariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PaAssistantCoverageConnection = {
  __typename?: 'PAAssistantCoverageConnection';
  edges: Array<PaAssistantCoverageEdge>;
  pageInfo: PageInfo;
};

export type PaAssistantCoverageEdge = {
  __typename?: 'PAAssistantCoverageEdge';
  cursor: Scalars['String']['output'];
  node: PaAssistantCoverage;
};

export type PaAssistantFormularyConnection = {
  __typename?: 'PAAssistantFormularyConnection';
  edges: Array<PaAssistantFormularyEdge>;
  pageInfo: PageInfo;
};

export type PaAssistantFormularyEdge = {
  __typename?: 'PAAssistantFormularyEdge';
  cursor: Scalars['String']['output'];
  node: Formulary;
};

export type PmidFilter = {
  /** PMID order */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** PMID */
  pmid: Scalars['UUID']['input'];
  /** PMID priority */
  priority?: InputMaybe<MpaPriority>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  /** The total amount of items retrievable */
  count: Scalars['Int']['output'];
  /** The page of the result set */
  page: Scalars['Int']['output'];
  /** The max amount of items in the result set */
  perPage: Scalars['Int']['output'];
};

export type PaginationInput = {
  /** The page number to request */
  page: Scalars['Int']['input'];
  /** The max amount of items to return per request */
  perPage: Scalars['Int']['input'];
};

export type Partner = {
  __typename?: 'Partner';
  account_holder?: Maybe<Scalars['Boolean']['output']>;
  address_1?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  bucket_type?: Maybe<Scalars['String']['output']>;
  business_relationships?: Maybe<BusinessRelationshipList>;
  city?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  contacts?: Maybe<ContactList>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Time']['output']>;
  groups?: Maybe<GroupList>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  related_groups?: Maybe<RelatedGroupList>;
  s3_bucket: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  useCarrierCode?: Maybe<Scalars['Boolean']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type PartnerBusinessRelationshipsArgs = {
  order?: InputMaybe<Array<BusinessRelationshipOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PartnerFilters>;
};


export type PartnerContactsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type PartnerGroupsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type PartnerRelatedGroupsArgs = {
  order?: InputMaybe<Array<RelatedGroupOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PartnerFilters>;
};

export type PartnerFilters = {
  account_holder?: InputMaybe<BooleanFilter>;
  code?: InputMaybe<StringFilter>;
  group_id?: InputMaybe<IdFilter>;
  group_name?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  plan_sponsor?: InputMaybe<BooleanFilter>;
  relationship?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

/** PartnerGroupRelationship is a list of Business Intermediary IDs to set for the relationship type by `name`. */
export type PartnerGroupRelationship = {
  businessIntermediaryIDs: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type PartnerList = {
  __typename?: 'PartnerList';
  pagination: Pagination;
  results?: Maybe<Array<Partner>>;
};

export type PartnerOrder = {
  code?: InputMaybe<OrderDirectionEnum>;
  created_at?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  type?: InputMaybe<OrderDirectionEnum>;
};

export type PartnerRelationship = {
  __typename?: 'PartnerRelationship';
  partnerUUID: Scalars['ID']['output'];
  relationship: Scalars['String']['output'];
};

export type PartnerToAccountInput = {
  account_id: Scalars['ID']['input'];
  partner_id: Scalars['ID']['input'];
  relationship: Scalars['String']['input'];
};

export type Pathway = {
  __typename?: 'Pathway';
  brandNameCode: Scalars['String']['output'];
  drug: DrugV2;
  /** The label name associated with the pathway, if available. */
  labelName?: Maybe<Scalars['String']['output']>;
  memberCopayAmount?: Maybe<Scalars['Cents']['output']>;
  memberSavingsAmount?: Maybe<Scalars['Cents']['output']>;
  mony: Scalars['String']['output'];
  pharmacy: PharmacyV2;
  planPayAmount?: Maybe<Scalars['Cents']['output']>;
  planSavingsAmount?: Maybe<Scalars['Cents']['output']>;
};

export type Payee = {
  __typename?: 'Payee';
  accountNumber: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  altReceiverId?: Maybe<Scalars['Int']['output']>;
  chain?: Maybe<Array<Maybe<ChainCode>>>;
  city: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactTitle: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  email: Scalars['String']['output'];
  email835: Scalars['String']['output'];
  fax: Scalars['String']['output'];
  financialInstitutionName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nabp: Scalars['String']['output'];
  name: Scalars['String']['output'];
  npi: Scalars['String']['output'];
  pharmacy?: Maybe<Array<Maybe<Pharmacy>>>;
  phone: Scalars['String']['output'];
  routingNumber: Scalars['String']['output'];
  s3Bucket: Scalars['String']['output'];
  s3Path: Scalars['String']['output'];
  state: Scalars['String']['output'];
  taxId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
  zip: Scalars['String']['output'];
};

export type PayeeFilters = {
  accountNumber?: InputMaybe<StringFilter>;
  chainCode?: InputMaybe<StringFilter>;
  city?: InputMaybe<StringFilter>;
  /**
   * A `complete` payee is one that has their bank account info on file. We can only perform remittance on `complete` payees.
   * A `true` value returns payees with bank account info on file; a `false` value with return those without their info on file.
   */
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  email835?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  nabp?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  npi?: InputMaybe<StringFilter>;
  routingNumber?: InputMaybe<StringFilter>;
  s3Bucket?: InputMaybe<StringFilter>;
  s3Path?: InputMaybe<StringFilter>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<StringFilter>;
  taxId?: InputMaybe<StringFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type PayeeInput = {
  ID?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<Scalars['String']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  altReceiverId?: InputMaybe<Scalars['Int']['input']>;
  chainId?: InputMaybe<Array<Scalars['String']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactTitle?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email835?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  financialInstitutionName?: InputMaybe<Scalars['String']['input']>;
  nabp?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  npi?: InputMaybe<Scalars['String']['input']>;
  pharmacyId?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type PayeeList = {
  __typename?: 'PayeeList';
  pagination: Pagination;
  results: Array<Payee>;
};

export type PayeeOrder = {
  name?: InputMaybe<OrderDirectionEnum>;
};

export type PcrJob = Node & {
  __typename?: 'PcrJob';
  connectionName: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Time']['output']>;
  fileName: Scalars['String']['output'];
  groupCodes: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobId: Scalars['Int']['output'];
  partnerName: Scalars['String']['output'];
  startDate?: Maybe<Scalars['Time']['output']>;
  status: PcrJobStatus;
  statusMessage: Scalars['String']['output'];
  /**
   * Paid claims written by the job, read from `meta.paid_claims_count`.
   * Null when the job recorded no count.
   */
  totalClaimsCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Elapsed seconds between the job's last `running` status and the `success`
   * that followed it. Null when the job never succeeded.
   */
  trueRunTimeSeconds?: Maybe<Scalars['Float']['output']>;
};

export type PcrJobConnection = {
  __typename?: 'PcrJobConnection';
  edges: Array<PcrJobEdge>;
  pageInfo: PageInfo;
};

export type PcrJobEdge = {
  __typename?: 'PcrJobEdge';
  cursor: Scalars['String']['output'];
  node: PcrJob;
};

export type PcrJobFilters = {
  createdAt?: InputMaybe<TimeFilter>;
  groupCode?: InputMaybe<StringFilter>;
  partnerName?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type PcrJobOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
};

export enum PcrJobStatus {
  Blocked = 'BLOCKED',
  Failed = 'FAILED',
  NotificationSent = 'NOTIFICATION_SENT',
  PartialSuccess = 'PARTIAL_SUCCESS',
  Queued = 'QUEUED',
  Rerun = 'RERUN',
  Running = 'RUNNING',
  Skipped = 'SKIPPED',
  Started = 'STARTED',
  Success = 'SUCCESS'
}

export enum Period {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY'
}

export enum PeriodType {
  /** 6 */
  BenefitYearTime = 'BenefitYearTime',
  /** 3 */
  CalendarMonthTime = 'CalendarMonthTime',
  /** 9 */
  CalendarQuarterTime = 'CalendarQuarterTime',
  /** 5 */
  CalendarYearTime = 'CalendarYearTime',
  /** 10 */
  GroupPlanListDatesTime = 'GroupPlanListDatesTime',
  /** 8 */
  LifetimeTime = 'LifetimeTime',
  /** 0 */
  NotActiveTime = 'NotActiveTime',
  /** 1 */
  ScriptTime = 'ScriptTime',
  /** 2 */
  XDaysTime = 'XDaysTime',
  /** 4 */
  XMonthsTime = 'XMonthsTime',
  /** 7 */
  XYearsTime = 'XYearsTime'
}

export type Pharmacy = {
  __typename?: 'Pharmacy';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  chainCode?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  fax: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  nabp: Scalars['String']['output'];
  name: Scalars['String']['output'];
  npi: Scalars['String']['output'];
  /** The Payee Information with which this pharmacy is associated */
  payee: Payee;
  phone: Scalars['String']['output'];
  placeId?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  type: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type PharmacyBulkUpsert = {
  overrideProtected?: InputMaybe<Scalars['Boolean']['input']>;
  pharmacies: Array<PharmacyInputV2>;
};

export type PharmacyConnection = {
  __typename?: 'PharmacyConnection';
  edges: Array<PharmacyEdge>;
  pageInfo: PageInfo;
};

export type PharmacyDissociateInput = {
  ID: Scalars['ID']['input'];
};

export type PharmacyEdge = {
  __typename?: 'PharmacyEdge';
  cursor: Scalars['String']['output'];
  node: PharmacyV2;
};

export type PharmacyFilters = {
  chainCode?: InputMaybe<StringFilter>;
  city?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  nabp?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  npi?: InputMaybe<StringFilter>;
  radius?: InputMaybe<IntFilter>;
  state?: InputMaybe<StringFilter>;
  userGeoLocation?: InputMaybe<Geolocation>;
  zip?: InputMaybe<StringFilter>;
};

export type PharmacyFiltersV2 = {
  chainCode?: InputMaybe<StringFilter>;
  city?: InputMaybe<StringFilter>;
  /**
   * Deprecated: Use the node(id: ID!) query instead to fetch a single pharmacy by ID.
   * @deprecated Use the node(id: ID!) query instead to fetch a single pharmacy by ID.
   */
  id?: InputMaybe<IdFilter>;
  isContracted?: InputMaybe<BooleanFilter>;
  isOverrideProtected?: InputMaybe<BooleanFilter>;
  nabp?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  networkId?: InputMaybe<IdFilter>;
  networkStatus?: InputMaybe<PharmacyNetworkStatus>;
  npi?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  state?: InputMaybe<StringFilter>;
  status?: InputMaybe<PharmacyStatus>;
  /** Matches type, secondaryType or tertiaryType. */
  type?: InputMaybe<PharmacyType>;
  zip?: InputMaybe<StringFilter>;
};

export type PharmacyHours = {
  __typename?: 'PharmacyHours';
  /** Daily operation hours for each day of the week */
  daily: Array<OperationHours>;
  /** When true, the pharmacy is open 24/7 and overrides all daily operation hours */
  is247: Scalars['Boolean']['output'];
};

export type PharmacyHoursInput = {
  /** Daily operation hours for each day of the week */
  daily?: InputMaybe<Array<OperationHoursInput>>;
  /** When true, the pharmacy is open 24/7 and overrides all daily operation hours */
  is247?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PharmacyInputV2 = {
  chainCode?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactInformationInput>;
  dea?: InputMaybe<Scalars['String']['input']>;
  deaExpirationDate?: InputMaybe<Scalars['Time']['input']>;
  deactivationCode?: InputMaybe<Scalars['String']['input']>;
  dispenserClass?: InputMaybe<DispenserClass>;
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  federalTaxID?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<PharmacyHoursInput>;
  isOverrideProtected?: InputMaybe<Scalars['Boolean']['input']>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInformationInput>;
  locationContact?: InputMaybe<ContactInformationInput>;
  locationPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  nabp: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  npi: Scalars['String']['input'];
  payeeId?: InputMaybe<Scalars['UUID']['input']>;
  paymentCenterId?: InputMaybe<Scalars['String']['input']>;
  reinstatementCode?: InputMaybe<Scalars['String']['input']>;
  reinstatementDate?: InputMaybe<Scalars['Time']['input']>;
  remittanceID?: InputMaybe<Scalars['String']['input']>;
  secondaryType?: InputMaybe<PharmacyType>;
  services?: InputMaybe<PharmacyServicesInput>;
  stateTaxID?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
  tertiaryType?: InputMaybe<PharmacyType>;
  type?: InputMaybe<PharmacyType>;
};

export type PharmacyList = {
  __typename?: 'PharmacyList';
  pagination: Pagination;
  results: Array<Pharmacy>;
};

export type PharmacyNetwork = Node & {
  __typename?: 'PharmacyNetwork';
  description: Scalars['String']['output'];
  entities: PharmacyNetworkEntityConnection;
  id: Scalars['ID']['output'];
  mac: PharmacyNetworkMacConnection;
  name: Scalars['String']['output'];
  processModifier?: Maybe<ProcessRule>;
  type?: Maybe<NetworkType>;
};


export type PharmacyNetworkEntitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PharmacyNetworkMacArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum PharmacyNetworkAssociationType {
  Chain = 'CHAIN',
  Direct = 'DIRECT'
}

export type PharmacyNetworkConnection = {
  __typename?: 'PharmacyNetworkConnection';
  edges: Array<PharmacyNetworkEdge>;
  pageInfo: PageInfo;
};

export type PharmacyNetworkConnectionFilters = {
  type?: InputMaybe<PharmacyNetworkAssociationType>;
};

export type PharmacyNetworkCreateInput = {
  /**
   * Optional existing pharmacy network to clone.
   * Will copy: type, description, process rule id
   * Will clone: associated entities, mac lists associations
   *
   * This field is in-error if provided simultaneously with `description` or `type` in a request.
   */
  copyFrom?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  processModifierID?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<NetworkType>;
};

export type PharmacyNetworkEdge = {
  __typename?: 'PharmacyNetworkEdge';
  /**
   * DIRECT or CHAIN
   * The type of association between a Pharmacy and a Pharmacy Network. This is only populated by the PharmacyV2.networks() resolver
   */
  associationType?: Maybe<PharmacyNetworkAssociationType>;
  cursor: Scalars['String']['output'];
  /** The first day this pharmacy-to-network membership is effective. */
  effective?: Maybe<Scalars['Date']['output']>;
  /** The pharmacy network classification for this pharmacy-to-network membership. */
  networkStatus?: Maybe<PharmacyNetworkStatus>;
  node: PharmacyNetwork;
  /** The first day this pharmacy-to-network membership is no longer effective. */
  termination?: Maybe<Scalars['Date']['output']>;
};

export type PharmacyNetworkEntity = {
  effective: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  inclusion: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  termination?: Maybe<Scalars['Date']['output']>;
};

export type PharmacyNetworkEntityAll = Node & PharmacyNetworkEntity & {
  __typename?: 'PharmacyNetworkEntityAll';
  effective: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  inclusion: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  termination?: Maybe<Scalars['Date']['output']>;
};

export type PharmacyNetworkEntityChain = Node & PharmacyNetworkEntity & {
  __typename?: 'PharmacyNetworkEntityChain';
  chain: ChainCode;
  effective: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  inclusion: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  termination?: Maybe<Scalars['Date']['output']>;
};

export type PharmacyNetworkEntityChildNetwork = Node & PharmacyNetworkEntity & {
  __typename?: 'PharmacyNetworkEntityChildNetwork';
  effective: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  inclusion: Scalars['Boolean']['output'];
  network: PharmacyNetwork;
  priority: Scalars['Int']['output'];
  termination?: Maybe<Scalars['Date']['output']>;
};

export type PharmacyNetworkEntityConnection = {
  __typename?: 'PharmacyNetworkEntityConnection';
  edges?: Maybe<Array<Maybe<PharmacyNetworkEntityEdge>>>;
  pageInfo: PageInfo;
};

export type PharmacyNetworkEntityCreate = {
  effective: Scalars['Date']['input'];
  inclusion: Scalars['Boolean']['input'];
  pharmacyNetworkID: Scalars['ID']['input'];
  priority: Scalars['Int']['input'];
  /** A relationship is required, but you may only populate one of the relationship fields or else an error will be thrown */
  relation: PharmacyNetworkEntityCreateRelation;
  termination?: InputMaybe<Scalars['Date']['input']>;
};

/** You must provide one and only one of the relation identifiers, providing multiple is an error, providing none is an error */
export type PharmacyNetworkEntityCreateRelation = {
  /** If this relation should represent the special All Pharmacies default case */
  allPharmacies?: InputMaybe<Scalars['Boolean']['input']>;
  /** A chain code global object ID, when provided will cause the PharmacyNetworkEntity to be created as a Chain type */
  chainCodeID?: InputMaybe<Scalars['ID']['input']>;
  /** A pharmacy global object ID or pharmacy UUID (If PharmacyV2 has not yet moved to global IDs). */
  pharmacyID?: InputMaybe<Scalars['ID']['input']>;
  /** A pharmacy network global object ID, must not be the same network as this entity belongs to. Must not create a loop back to a parent entity. The network provided will be added as a child/subnetwork of this network. Only 5 nested levels of networks are permitted and the server shall throw an error if creating deeper networks */
  pharmacyNetworkID?: InputMaybe<Scalars['ID']['input']>;
};

export type PharmacyNetworkEntityEdge = {
  __typename?: 'PharmacyNetworkEntityEdge';
  cursor: Scalars['String']['output'];
  node: PharmacyNetworkEntity;
};

export type PharmacyNetworkEntityPharmacy = Node & PharmacyNetworkEntity & {
  __typename?: 'PharmacyNetworkEntityPharmacy';
  effective: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  inclusion: Scalars['Boolean']['output'];
  pharmacy: PharmacyV2;
  priority: Scalars['Int']['output'];
  termination?: Maybe<Scalars['Date']['output']>;
};

/** You can resort or update dates, but not change the linked item, changing the linked item involves delete & create to simplify the UI usage */
export type PharmacyNetworkEntityUpdate = {
  effective?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  inclusion?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  termination?: InputMaybe<Scalars['Date']['input']>;
};

export type PharmacyNetworkFilters = {
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<NetworkType>;
};

/** Relation between PharmacyNetwork & MACLists, only one is allowed per effective-date range (so no overlaps as only one list may be active at a time but you could add future lists to become active) */
export type PharmacyNetworkMac = Node & {
  __typename?: 'PharmacyNetworkMAC';
  effective: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  maclist: MacList;
  termination?: Maybe<Scalars['Date']['output']>;
};

export type PharmacyNetworkMacConnection = {
  __typename?: 'PharmacyNetworkMACConnection';
  edges?: Maybe<Array<Maybe<PharmacyNetworkMacEdge>>>;
  pageInfo: PageInfo;
};

export type PharmacyNetworkMacCreate = {
  effective: Scalars['Date']['input'];
  maclistID: Scalars['ID']['input'];
  pharmacyNetworkID: Scalars['ID']['input'];
  termination?: InputMaybe<Scalars['Date']['input']>;
};

export type PharmacyNetworkMacEdge = {
  __typename?: 'PharmacyNetworkMACEdge';
  cursor: Scalars['String']['output'];
  node: PharmacyNetworkMac;
};

export type PharmacyNetworkMacUpdate = {
  effective?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  termination?: InputMaybe<Scalars['Date']['input']>;
};

export type PharmacyNetworkOrder = {
  description?: InputMaybe<OrderDirectionEnum>;
  id?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  type?: InputMaybe<OrderDirectionEnum>;
};

export type PharmacyNetworkProgram = {
  __typename?: 'PharmacyNetworkProgram';
  /**
   * Pharmacy network program channel can be any of the following:
   *
   * RETAIL
   * MAIL
   * SPECIALTY
   *
   * These are the same values as the pharamcy networks.
   */
  channel: Scalars['String']['output'];
  /** Pharmacy Network Program Code */
  code: Scalars['String']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Name of the Pharmacy Network Program */
  name: Scalars['String']['output'];
  /**
   * Pharmacy network program type can be any of the following:
   *
   * BROAD
   * NARROW
   * LIMITED
   * PREFERRED
   * DISCOUNT
   * VACCINE
   * WORKERSCOMP
   *
   * These are the same values as the pharamcy networks.
   */
  type: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** Mutation */
export type PharmacyNetworkProgramCreateInput = {
  channel: Scalars['String']['input'];
  code: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

/** Query */
export type PharmacyNetworkProgramFilters = {
  channel?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type PharmacyNetworkProgramList = {
  __typename?: 'PharmacyNetworkProgramList';
  pagination?: Maybe<Pagination>;
  results: Array<PharmacyNetworkProgram>;
};

export type PharmacyNetworkProgramOrder = {
  channel?: InputMaybe<OrderDirectionEnum>;
  code?: InputMaybe<OrderDirectionEnum>;
  createdAt?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  type?: InputMaybe<OrderDirectionEnum>;
};

export type PharmacyNetworkProgramUpdateInput = {
  channel: Scalars['String']['input'];
  code: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

/** The network classification assigned to a pharmacy by the pharmacy network classification engine. */
export enum PharmacyNetworkStatus {
  /** The pharmacy is excluded from the network. */
  Excluded = 'EXCLUDED',
  /** The pharmacy is in network. */
  InNetwork = 'IN_NETWORK',
  /** The pharmacy is out of network. */
  OutOfNetwork = 'OUT_OF_NETWORK',
  /** The pharmacy is available only for regulatory purposes. */
  RegulatoryOnly = 'REGULATORY_ONLY'
}

export type PharmacyNetworkUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  processModifierID?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<NetworkType>;
};

export type PharmacyOrder = {
  chainCode?: InputMaybe<OrderDirectionEnum>;
  createdAt?: InputMaybe<OrderDirectionEnum>;
  nabp?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  npi?: InputMaybe<OrderDirectionEnum>;
};

export type PharmacyOrderV2 = {
  chainCode?: InputMaybe<OrderDirectionEnum>;
  id?: InputMaybe<OrderDirectionEnum>;
  nabp?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  npi?: InputMaybe<OrderDirectionEnum>;
};

export type PharmacyPaymentCenter = Node & {
  __typename?: 'PharmacyPaymentCenter';
  contact?: Maybe<ContactInformation>;
  id: Scalars['ID']['output'];
  isOverrideProtected?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<LocationInformation>;
  name?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
};

export type PharmacyPaymentCenterInput = {
  contact?: InputMaybe<ContactInformationInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<LocationInformationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  npi?: InputMaybe<Scalars['String']['input']>;
};

export type PharmacyPaymentCenterUpsertResult = BaseError | PharmacyPaymentCenter | ValidationError;

export type PharmacyRemittanceReceiver = Node & {
  __typename?: 'PharmacyRemittanceReceiver';
  contact?: Maybe<ContactInformation>;
  federalTaxID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<LocationInformation>;
  name?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
};

export type PharmacyRemittanceReceiverInput = {
  contact?: InputMaybe<ContactInformationInput>;
  federalTaxID?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<LocationInformationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  npi?: InputMaybe<Scalars['String']['input']>;
};

export type PharmacyRemittanceReceiverUpsertResult = BaseError | PharmacyRemittanceReceiver | ValidationError;

export type PharmacyServices = {
  __typename?: 'PharmacyServices';
  acceptsEPrescriptions?: Maybe<Scalars['Boolean']['output']>;
  acceptsEPrescriptionsCode?: Maybe<Scalars['String']['output']>;
  closedDoorFacility?: Maybe<Scalars['Boolean']['output']>;
  closedDoorFacilityCode?: Maybe<Scalars['String']['output']>;
  compoundingService?: Maybe<Scalars['Boolean']['output']>;
  compoundingServiceCode?: Maybe<Scalars['String']['output']>;
  deliveryService?: Maybe<Scalars['Boolean']['output']>;
  deliveryServiceCode?: Maybe<Scalars['String']['output']>;
  driveUpWindow?: Maybe<Scalars['Boolean']['output']>;
  driveUpWindowCode?: Maybe<Scalars['String']['output']>;
  durableMedicalEquipment?: Maybe<Scalars['Boolean']['output']>;
  durableMedicalEquipmentCode?: Maybe<Scalars['String']['output']>;
  emergencyService24Hour?: Maybe<Scalars['Boolean']['output']>;
  emergencyService24HourCode?: Maybe<Scalars['String']['output']>;
  handicappedAccessible?: Maybe<Scalars['Boolean']['output']>;
  handicappedAccessibleCode?: Maybe<Scalars['String']['output']>;
  immunizationsProvided?: Maybe<Scalars['Boolean']['output']>;
  immunizationsProvidedCode?: Maybe<Scalars['String']['output']>;
  multiDoseCompliancePackaging?: Maybe<Scalars['Boolean']['output']>;
  multiDoseCompliancePackagingCode?: Maybe<Scalars['String']['output']>;
  program340BStatus?: Maybe<Scalars['Boolean']['output']>;
  program340BStatusCode?: Maybe<Scalars['String']['output']>;
  walkInClinic?: Maybe<Scalars['Boolean']['output']>;
  walkInClinicCode?: Maybe<Scalars['String']['output']>;
};

export type PharmacyServicesInput = {
  acceptsEPrescriptions?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsEPrescriptionsCode?: InputMaybe<Scalars['String']['input']>;
  closedDoorFacility?: InputMaybe<Scalars['Boolean']['input']>;
  closedDoorFacilityCode?: InputMaybe<Scalars['String']['input']>;
  compoundingService?: InputMaybe<Scalars['Boolean']['input']>;
  compoundingServiceCode?: InputMaybe<Scalars['String']['input']>;
  deliveryService?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryServiceCode?: InputMaybe<Scalars['String']['input']>;
  driveUpWindow?: InputMaybe<Scalars['Boolean']['input']>;
  driveUpWindowCode?: InputMaybe<Scalars['String']['input']>;
  durableMedicalEquipment?: InputMaybe<Scalars['Boolean']['input']>;
  durableMedicalEquipmentCode?: InputMaybe<Scalars['String']['input']>;
  emergencyService24Hour?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyService24HourCode?: InputMaybe<Scalars['String']['input']>;
  handicappedAccessible?: InputMaybe<Scalars['Boolean']['input']>;
  handicappedAccessibleCode?: InputMaybe<Scalars['String']['input']>;
  immunizationsProvided?: InputMaybe<Scalars['Boolean']['input']>;
  immunizationsProvidedCode?: InputMaybe<Scalars['String']['input']>;
  multiDoseCompliancePackaging?: InputMaybe<Scalars['Boolean']['input']>;
  multiDoseCompliancePackagingCode?: InputMaybe<Scalars['String']['input']>;
  program340BStatus?: InputMaybe<Scalars['Boolean']['input']>;
  program340BStatusCode?: InputMaybe<Scalars['String']['input']>;
  walkInClinic?: InputMaybe<Scalars['Boolean']['input']>;
  walkInClinicCode?: InputMaybe<Scalars['String']['input']>;
};

export type PharmacyStateLicense = Node & {
  __typename?: 'PharmacyStateLicense';
  deleteDate?: Maybe<Scalars['Time']['output']>;
  expirationDate?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  licenseNumber: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type PharmacyStateLicenseInput = {
  deleteDate?: InputMaybe<Scalars['Time']['input']>;
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  id: Scalars['ID']['input'];
  licenseNumber: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type PharmacyStateLicenseUpsertResult = BaseError | PharmacyStateLicense | ValidationError;

export enum PharmacyStatus {
  /** The pharmacy is active when effective date is in the past and expiration date is in the future */
  Active = 'ACTIVE',
  /** The pharmacy is inactive when effective date is in the future or expiration date is in the past */
  Inactive = 'INACTIVE'
}

export enum PharmacyType {
  N01Retail = 'N01_RETAIL',
  N04LongTermCare = 'N04_LONG_TERM_CARE',
  N05MailOrder = 'N05_MAIL_ORDER',
  N06HomeInfusion = 'N06_HOME_INFUSION',
  N07NonDispensing = 'N07_NON_DISPENSING',
  N08Tribal = 'N08_TRIBAL',
  N09Va = 'N09_VA',
  N11Institutional = 'N11_INSTITUTIONAL',
  N12ManagedCare = 'N12_MANAGED_CARE',
  N13Dme = 'N13_DME',
  N14Clinic = 'N14_CLINIC',
  N15Specialty = 'N15_SPECIALTY',
  N16Nuclear = 'N16_NUCLEAR',
  N17Military = 'N17_MILITARY',
  N18Compounding = 'N18_COMPOUNDING',
  N19Oxygen = 'N19_OXYGEN',
  N20NursingFacility = 'N20_NURSING_FACILITY',
  N21CustomizedEquipment = 'N21_CUSTOMIZED_EQUIPMENT',
  N22Dialysis = 'N22_DIALYSIS',
  N23ParenteralEnteralNutrition = 'N23_PARENTERAL_ENTERAL_NUTRITION'
}

export type PharmacyUpdateInput = {
  ID: Scalars['ID']['input'];
  chainId?: InputMaybe<Scalars['String']['input']>;
  payeeId: Scalars['String']['input'];
};

export type PharmacyUpdateInputV2 = {
  chainCode?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactInformationPartialInput>;
  dea?: InputMaybe<Scalars['String']['input']>;
  deaExpirationDate?: InputMaybe<Scalars['Time']['input']>;
  deactivationCode?: InputMaybe<Scalars['String']['input']>;
  dispenserClass?: InputMaybe<DispenserClass>;
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  federalTaxID?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<PharmacyHoursInput>;
  id: Scalars['ID']['input'];
  isOverrideProtected?: InputMaybe<Scalars['Boolean']['input']>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInformationPartialInput>;
  locationContact?: InputMaybe<ContactInformationPartialInput>;
  locationPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  nabp?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payeeId?: InputMaybe<Scalars['UUID']['input']>;
  paymentCenter?: InputMaybe<PharmacyPaymentCenterInput>;
  paymentCenterId?: InputMaybe<Scalars['String']['input']>;
  reinstatementCode?: InputMaybe<Scalars['String']['input']>;
  reinstatementDate?: InputMaybe<Scalars['Time']['input']>;
  remittanceID?: InputMaybe<Scalars['String']['input']>;
  secondaryType?: InputMaybe<PharmacyType>;
  stateTaxID?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
  tertiaryType?: InputMaybe<PharmacyType>;
  type?: InputMaybe<PharmacyType>;
};

export type PharmacyUpsertResult = BaseError | PharmacyV2 | ValidationError;

export type PharmacyV2 = Node & {
  __typename?: 'PharmacyV2';
  /**
   * The active MAC list entries for this pharmacy, resolved across all of its network memberships.
   * Supports filtering by drug code (NDC/GPI) and ordering.
   */
  activeMacListEntries: MacListEntryConnection;
  chain?: Maybe<ChainCode>;
  contact: ContactInformation;
  dea?: Maybe<Scalars['String']['output']>;
  deaExpirationDate?: Maybe<Scalars['Time']['output']>;
  deactivationCode?: Maybe<Scalars['String']['output']>;
  dispenserClass?: Maybe<DispenserClass>;
  /**
   * Returns the list of drugs matching the given filter along with whether each
   * drug is a specialty drug available at this pharmacy.
   *
   * When the filter's memberId is provided, a drug's specialty status is
   * determined by that member's plan formulary instead of the global formulary.
   */
  drugAvailability: Array<DrugAvailability>;
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  expirationDate?: Maybe<Scalars['Time']['output']>;
  federalTaxID?: Maybe<Scalars['String']['output']>;
  hours?: Maybe<PharmacyHours>;
  id: Scalars['ID']['output'];
  /** Whether this pharmacy has a contract with us (implemented via network membership) */
  isContracted: Scalars['Boolean']['output'];
  isOverrideProtected: Scalars['Boolean']['output'];
  legalBusinessName?: Maybe<Scalars['String']['output']>;
  location: LocationInformation;
  locationContact?: Maybe<ContactInformation>;
  locationPhoneNumber?: Maybe<Scalars['String']['output']>;
  nabp: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**
   * The pharmacy network classification, intended to replace isContracted.
   *
   * Null means "no answer" — the NPI is unknown or classification failed. Render nothing for null; it
   * does not mean OUT_OF_NETWORK.
   */
  networkStatus?: Maybe<PharmacyNetworkStatus>;
  /** The Pharmacy Networks associated with this pharmacy */
  networks: PharmacyNetworkConnection;
  npi: Scalars['String']['output'];
  /** The Payee Information with which this pharmacy is associated */
  payee?: Maybe<Payee>;
  /** The Pharmacy Payment Center associated with this pharmacy */
  paymentCenter?: Maybe<PharmacyPaymentCenter>;
  /**
   * The networks that make this pharmacy in-network, batched per page. Empty unless networkStatus is
   * IN_NETWORK, and also empty when the lookup failed.
   */
  qualifyingNetworks: Array<PharmacyNetwork>;
  reinstatementCode?: Maybe<Scalars['String']['output']>;
  reinstatementDate?: Maybe<Scalars['Time']['output']>;
  remittanceID?: Maybe<Scalars['String']['output']>;
  secondaryType?: Maybe<PharmacyType>;
  services?: Maybe<PharmacyServices>;
  stateTaxID?: Maybe<Scalars['String']['output']>;
  status: PharmacyStatus;
  storeNumber?: Maybe<Scalars['String']['output']>;
  tertiaryType?: Maybe<PharmacyType>;
  type?: Maybe<PharmacyType>;
};


export type PharmacyV2ActiveMacListEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<MacListEntryOrder>;
  where?: InputMaybe<MacListEntryFilters>;
};


export type PharmacyV2DrugAvailabilityArgs = {
  where?: InputMaybe<DrugAvailabilityFilter>;
};


export type PharmacyV2NetworksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PharmacyNetworkConnectionFilters>;
};

export type Plan = {
  __typename?: 'Plan';
  /**
   * Provenance for the handlers an AI extractor chose for this plan, keyed by the
   * handler field: any of the nine UpdatePlanHandlerInput sets (defaultCostHandler
   * through oopAfterCapCopayHandler). Today the agent sets refill, dispense limit, bill
   * cost and age. See AiOverlay in ai_overlay.graphql.
   *
   * Read from the field-api-map's UpdatePlanHandler block for the portal plan built on
   * this one (portalPlan). The block has no row id, because the row is the plan: it is
   * this plan's when it names the portal plan, or, when it names no plan, when the
   * manual linked only this one. A handler every plan is given as a fixed default has
   * no source cell and no provenance, so a field is absent rather than null when the
   * workbook did not choose it. aiValue is the cell as read, not the handler's name;
   * userOverridden says the plan now points at a different handler.
   */
  aiOverlay?: Maybe<AiOverlay>;
  allowCOB: Scalars['Boolean']['output'];
  allowNegativePayments: Scalars['Boolean']['output'];
  benAfterCapCopayHandler?: Maybe<CopayHandler>;
  benefitRestart?: Maybe<Scalars['Time']['output']>;
  created: Scalars['Time']['output'];
  defaultAgeHandler?: Maybe<AgeHandler>;
  defaultBillCostHandler?: Maybe<BillCostHandler>;
  defaultCopayHandler?: Maybe<CopayHandler>;
  defaultCostHandler?: Maybe<CostHandler>;
  defaultDispFeeHandler?: Maybe<DispenseFeeHandler>;
  defaultDispLimitHandler?: Maybe<DispenseLimitHandler>;
  defaultRefillHandler?: Maybe<RefillHandler>;
  expirationDate?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  onlyPayPrimaryClaims: Scalars['Boolean']['output'];
  oopAfterCapCopayHandler?: Maybe<CopayHandler>;
  papn?: Maybe<PrescriberList>;
  papn2?: Maybe<PrescriberList>;
  papn3?: Maybe<PrescriberList>;
  portalPlan?: Maybe<BenefitPlan>;
  rejectRepack: Scalars['Boolean']['output'];
  umac?: Maybe<Scalars['UUID']['output']>;
  umac2?: Maybe<Scalars['UUID']['output']>;
  umac3?: Maybe<Scalars['UUID']['output']>;
  updated: Scalars['Time']['output'];
};

export type PlanCodeConnection = {
  __typename?: 'PlanCodeConnection';
  count: Scalars['Int']['output'];
  edges: Array<PlanCodeEdge>;
  pageInfo: PageInfo;
};

export type PlanCodeEdge = {
  __typename?: 'PlanCodeEdge';
  cursor: Scalars['String']['output'];
  node: PlanCodeV2;
};

export type PlanCodeScheduleImpactAssessment = {
  __typename?: 'PlanCodeScheduleImpactAssessment';
  /**
   * Opaque token encoding the assessment state. Pass to groupCreatePlanCodeSchedule
   * to opt-in for automated subgroup detail synchronization. If the underlying data
   * has changed since the assessment, the mutation will fail.
   */
  assessmentToken: Scalars['String']['output'];
  /** Subgroups that would be impacted by this plan code schedule addition. */
  impactedSubgroups: Array<SubgroupScheduleImpact>;
};

export type PlanCodeV2 = {
  __typename?: 'PlanCodeV2';
  benefitPlan?: Maybe<BenefitPlan>;
  /** @deprecated Use benefitPlan */
  benefit_plan?: Maybe<BenefitPlan>;
  /** @deprecated Use benefitPlan */
  benefit_plan_id?: Maybe<Scalars['ID']['output']>;
  /**
   * A human friendly name. Will default to the same value as received but should be editable. Is solely
   * used for display purposes.
   */
  displayName: Scalars['String']['output'];
  /** @deprecated Use displayName */
  display_name: Scalars['String']['output'];
  /** Date on which the plan code is live for adjudications */
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use effectiveDate */
  effective_from?: Maybe<Scalars['Time']['output']>;
  /** @deprecated Use expirationDate */
  effective_to?: Maybe<Scalars['Time']['output']>;
  /** Date on or after which plan code cannot have any claims adjudicated against it */
  expirationDate?: Maybe<Scalars['Date']['output']>;
  group: Group;
  /** @deprecated Use group */
  group_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isInZebra: Scalars['Boolean']['output'];
  /** The unique Plan Code ID */
  normalized: Scalars['String']['output'];
  /** @deprecated Use benefitPlan */
  plan_id?: Maybe<Scalars['ID']['output']>;
  /**
   * The version of the plan code we received from the customer. It may have characters that are illegal
   * for some internal uses so it is normalized and stored in `normalized`
   */
  received: Scalars['String']['output'];
  /** The version of the plan code used for all internal purposes, e.g. creating subgroup designations */
  recordID: Scalars['ID']['output'];
  /** Effectivity status of the plan code */
  status: PlanStatusEnum;
};

export type PlanCodeV2Filters = {
  benefitPlanId?: InputMaybe<IdFilter>;
  /** @deprecated Use benefitPlanId */
  benefit_plan_id?: InputMaybe<IdFilter>;
  effectiveDate?: InputMaybe<DateFilter>;
  expirationDate?: InputMaybe<DateFilter>;
  groupId?: InputMaybe<IdFilter>;
  /** @deprecated Use groupId */
  group_id?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  normalized?: InputMaybe<StringFilter>;
};

export type PlanCodeV2List = {
  __typename?: 'PlanCodeV2List';
  /** @deprecated Use PlanCodeConnection */
  pagination: Pagination;
  /** @deprecated Use PlanCodeConnection */
  results: Array<PlanCodeV2>;
};

export type PlanCodeV2Order = {
  effectiveDate?: InputMaybe<OrderDirectionEnum>;
  expirationDate?: InputMaybe<OrderDirectionEnum>;
  groupId?: InputMaybe<OrderDirectionEnum>;
  normalized?: InputMaybe<OrderDirectionEnum>;
  planId?: InputMaybe<OrderDirectionEnum>;
  /** @deprecated Use planId */
  plan_id?: InputMaybe<OrderDirectionEnum>;
  status?: InputMaybe<OrderDirectionEnum>;
};

export type PlanCodeV2Updates = {
  updates: Array<UpdatePlanCodeV2Input>;
};

export type PlanConnection = {
  __typename?: 'PlanConnection';
  edges: Array<PlanEdge>;
  pageInfo: PageInfo;
};

export type PlanDaw = {
  __typename?: 'PlanDAW';
  dawSettings: Array<PlanDawSetting>;
  excludeForOop: Scalars['Boolean']['output'];
  excludeFromDed: Scalars['Boolean']['output'];
  forceZero: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  planPayAfterOop: Scalars['Boolean']['output'];
  planUUID: Scalars['UUID']['output'];
};

export type PlanDawSetting = {
  __typename?: 'PlanDAWSetting';
  code: Scalars['Int']['output'];
  setting: DawSetting;
};

export type PlanDurProgram = {
  __typename?: 'PlanDURProgram';
  durProgram: DurProgram;
  durProgramID: Scalars['ID']['output'];
  effectiveDate: Scalars['Time']['output'];
  expirationDate?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  planID: Scalars['ID']['output'];
};

export type PlanDependencyFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  planID?: InputMaybe<IdFilter>;
};

export type PlanDependencyOrder = {
  id?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export type PlanDrugList = {
  __typename?: 'PlanDrugList';
  pagination?: Maybe<Pagination>;
  results?: Maybe<Array<MatchRule>>;
};

export type PlanDrugListFilters = {
  comment?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  subtype?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type PlanDrugListInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subtype?: InputMaybe<Scalars['String']['input']>;
};

export type PlanDrugListOrder = {
  Name?: InputMaybe<OrderDirectionEnum>;
  Type?: InputMaybe<OrderDirectionEnum>;
};

export type PlanEdge = {
  __typename?: 'PlanEdge';
  cursor: Scalars['String']['output'];
  node: Plan;
};

/** PlanFillRule is a fill rule associated with a plan */
export type PlanFillRule = {
  __typename?: 'PlanFillRule';
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  expirationDate?: Maybe<Scalars['Time']['output']>;
  fillRule?: Maybe<FillRule>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  planID: Scalars['ID']['output'];
};

export type PlanFillRuleInput = {
  effectiveDate: Scalars['Time']['input'];
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  fillRuleID: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  planID: Scalars['ID']['input'];
};

export type PlanFillRuleOrder = {
  __typename?: 'PlanFillRuleOrder';
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
};

export type PlanFillRuleOrderInput = {
  id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};

export type PlanFillRuleOrderList = {
  __typename?: 'PlanFillRuleOrderList';
  planFillRules?: Maybe<Array<PlanFillRuleOrder>>;
};

export type PlanFillRuleOrderListInput = {
  planFillRules?: InputMaybe<Array<PlanFillRuleOrderInput>>;
};

export type PlanFilters = {
  name?: InputMaybe<StringFilter>;
  number?: InputMaybe<StringFilter>;
  uuid?: InputMaybe<IdFilter>;
};

export type PlanNetworksInput = {
  super_networks?: InputMaybe<Array<CommentedId>>;
};

export type PlanOrder = {
  created?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

/**
 * One place a fill rule is used: a single plan_to_fill_rule row binding the fill rule to
 * a plan. A plan using the same fill rule more than once yields one PlanRelatedFillRule
 * per row, each with its own order and dates.
 */
export type PlanRelatedFillRule = Node & {
  __typename?: 'PlanRelatedFillRule';
  fillRule: FillRule;
  /** Number of the group using the plan. See PlanRelatedProcessRule.groupNumber. */
  groupNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Global ID of the underlying plan_to_fill_rule row — unique per edge, and
   * resolvable through Query.node.
   */
  id: Scalars['ID']['output'];
  plan: Plan;
  planFillRule: PlanFillRule;
};

export type PlanRelatedFillRuleConnection = {
  __typename?: 'PlanRelatedFillRuleConnection';
  /** Total matching plan_to_fill_rule rows, not distinct plans. */
  count: Scalars['Int']['output'];
  edges: Array<PlanRelatedFillRuleEdge>;
  /**
   * Bucket counts over the same rows this connection selects, grouped by `by`. Behaves
   * as PlanRelatedProcessRuleConnection.groups does: the aggregate covers the whole
   * filtered set, and the pagination arguments window the bucket list.
   */
  groups: GroupBucketConnection;
  pageInfo: PageInfo;
};


export type PlanRelatedFillRuleConnectionGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  by: PlanRelatedFillRuleGroupBy;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlanRelatedFillRuleEdge = {
  __typename?: 'PlanRelatedFillRuleEdge';
  cursor: Scalars['String']['output'];
  node: PlanRelatedFillRule;
};

/**
 * The rows to select. Every field is optional, and the ones that are set are ANDed. The
 * date fields take DateFilter for the reason PlanRelatedProcessRuleFilters' do.
 */
export type PlanRelatedFillRuleFilters = {
  /** plan.number */
  adjudicatorPlanID?: InputMaybe<StringFilter>;
  /** groups.number, or "multi" — see PlanRelatedProcessRule.groupNumber */
  groupNumber?: InputMaybe<StringFilter>;
  planID?: InputMaybe<IdFilter>;
  planName?: InputMaybe<StringFilter>;
  /** plan.expiration_date */
  planTerminationDate?: InputMaybe<DateFilter>;
  /** plan_to_fill_rule.effective_date */
  planToFillRuleEffectiveDate?: InputMaybe<DateFilter>;
  /** plan_to_fill_rule.plan_to_fill_rule_order */
  planToFillRuleOrder?: InputMaybe<IntFilter>;
  /** plan_to_fill_rule.expiration_date */
  planToFillRuleTerminationDate?: InputMaybe<DateFilter>;
};

/** One groupable column of the fill-rule-to-plan join. Mirrors PlanRelatedFillRuleFilters. */
export enum PlanRelatedFillRuleGroupBy {
  AdjudicatorPlanId = 'ADJUDICATOR_PLAN_ID',
  GroupNumber = 'GROUP_NUMBER',
  PlanId = 'PLAN_ID',
  PlanName = 'PLAN_NAME',
  PlanTerminationDate = 'PLAN_TERMINATION_DATE',
  PlanToFillRuleEffectiveDate = 'PLAN_TO_FILL_RULE_EFFECTIVE_DATE',
  PlanToFillRuleOrder = 'PLAN_TO_FILL_RULE_ORDER',
  PlanToFillRuleTerminationDate = 'PLAN_TO_FILL_RULE_TERMINATION_DATE'
}

/**
 * The sort to apply. Set the direction on the one field to sort by; rows are sorted by
 * plan name ascending when nothing is set. If more than one field is set, the first one
 * listed here wins.
 */
export type PlanRelatedFillRuleOrder = {
  adjudicatorPlanID?: InputMaybe<OrderDirectionEnum>;
  groupNumber?: InputMaybe<OrderDirectionEnum>;
  planName?: InputMaybe<OrderDirectionEnum>;
  planTerminationDate?: InputMaybe<OrderDirectionEnum>;
  planToFillRuleEffectiveDate?: InputMaybe<OrderDirectionEnum>;
  planToFillRuleOrder?: InputMaybe<OrderDirectionEnum>;
  planToFillRuleTerminationDate?: InputMaybe<OrderDirectionEnum>;
};

/**
 * One place a process rule is used: a single process rule attachment binding the
 * rule to a plan. A plan attached to the same rule more than once yields one
 * PlanRelatedProcessRule per attachment, each with its own priority and dates.
 */
export type PlanRelatedProcessRule = {
  __typename?: 'PlanRelatedProcessRule';
  /**
   * Number of the group using the plan, through either group_to_plan or a subgroup's
   * override plan. "multi" when more than one group uses it, null when none does. Every
   * link counts, whatever its dates.
   */
  groupNumber?: Maybe<Scalars['String']['output']>;
  /** UUID of the underlying process rule attachment — unique per edge. */
  id: Scalars['ID']['output'];
  plan: Plan;
  processRule: ProcessRule;
  processRuleAttachment: ProcessRuleAttachment;
};

export type PlanRelatedProcessRuleConnection = {
  __typename?: 'PlanRelatedProcessRuleConnection';
  /** Total matching attachments, not distinct plans. */
  count: Scalars['Int']['output'];
  edges: Array<PlanRelatedProcessRuleEdge>;
  /**
   * Bucket counts over the same attachments this connection selects, grouped by
   * `by`.
   *
   * The aggregate always covers this connection's whole filtered set — the
   * connection's own `first`/`after`/`last`/`before` do not narrow it. The
   * pagination arguments here window the resulting bucket list instead. `first`
   * defaults to 20, and a `first` or `last` above 500 is limited to 500. The
   * arguments combine as they do on the connection, so a cursor that matches no
   * bucket is ignored. A negative `first` or `last` is an error, as it is on the
   * connection itself.
   */
  groups: GroupBucketConnection;
  pageInfo: PageInfo;
};


export type PlanRelatedProcessRuleConnectionGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  by: PlanRelatedProcessRuleGroupBy;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlanRelatedProcessRuleEdge = {
  __typename?: 'PlanRelatedProcessRuleEdge';
  cursor: Scalars['String']['output'];
  node: PlanRelatedProcessRule;
};

/**
 * The rows to select. Every field is optional, and the ones that are set are ANDed.
 *
 * The date fields take DateFilter rather than TimeFilter because the columns behind
 * them are `date`: they have no time of day to compare against, so a timestamp input
 * would only invite a value that cannot be honoured.
 */
export type PlanRelatedProcessRuleFilters = {
  /** plan.number */
  adjudicatorPlanID?: InputMaybe<StringFilter>;
  /** groups.number, or "multi" — see PlanRelatedProcessRule.groupNumber */
  groupNumber?: InputMaybe<StringFilter>;
  planID?: InputMaybe<IdFilter>;
  planName?: InputMaybe<StringFilter>;
  /** plan.expiration_date */
  planTerminationDate?: InputMaybe<DateFilter>;
  /** process_rule_attachment.effective_date */
  processRuleAttachmentEffectiveDate?: InputMaybe<DateFilter>;
  /** process_rule_attachment.priority */
  processRuleAttachmentPriority?: InputMaybe<IntFilter>;
  /** process_rule_attachment.expiration_date */
  processRuleAttachmentTerminationDate?: InputMaybe<DateFilter>;
};

/** One groupable column of the rule-to-plan join. Mirrors PlanRelatedProcessRuleFilters. */
export enum PlanRelatedProcessRuleGroupBy {
  AdjudicatorPlanId = 'ADJUDICATOR_PLAN_ID',
  GroupNumber = 'GROUP_NUMBER',
  PlanId = 'PLAN_ID',
  PlanName = 'PLAN_NAME',
  PlanTerminationDate = 'PLAN_TERMINATION_DATE',
  ProcessRuleAttachmentEffectiveDate = 'PROCESS_RULE_ATTACHMENT_EFFECTIVE_DATE',
  ProcessRuleAttachmentPriority = 'PROCESS_RULE_ATTACHMENT_PRIORITY',
  ProcessRuleAttachmentTerminationDate = 'PROCESS_RULE_ATTACHMENT_TERMINATION_DATE'
}

/**
 * The sort to apply. Set the direction on the one field to sort by; attachments are
 * sorted by plan name ascending when nothing is set. If more than one field is set,
 * the first one listed here wins.
 */
export type PlanRelatedProcessRuleOrder = {
  adjudicatorPlanID?: InputMaybe<OrderDirectionEnum>;
  groupNumber?: InputMaybe<OrderDirectionEnum>;
  planName?: InputMaybe<OrderDirectionEnum>;
  planTerminationDate?: InputMaybe<OrderDirectionEnum>;
  processRuleAttachmentEffectiveDate?: InputMaybe<OrderDirectionEnum>;
  processRuleAttachmentPriority?: InputMaybe<OrderDirectionEnum>;
  processRuleAttachmentTerminationDate?: InputMaybe<OrderDirectionEnum>;
};

/**
 * One place a step therapy is used: a single plan_to_step_therapy row binding the step
 * therapy to a plan. A plan using the same step therapy more than once yields one
 * PlanRelatedStepTherapy per row, each with its own order and dates.
 */
export type PlanRelatedStepTherapy = Node & {
  __typename?: 'PlanRelatedStepTherapy';
  /** Number of the group using the plan. See PlanRelatedProcessRule.groupNumber. */
  groupNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Global ID of the underlying plan_to_step_therapy row — unique per edge, and
   * resolvable through Query.node.
   */
  id: Scalars['ID']['output'];
  plan: Plan;
  planStepTherapy: PlanStepTherapy;
  stepTherapy: StepTherapyV2;
};

export type PlanRelatedStepTherapyConnection = {
  __typename?: 'PlanRelatedStepTherapyConnection';
  /** Total matching plan_to_step_therapy rows, not distinct plans. */
  count: Scalars['Int']['output'];
  edges: Array<PlanRelatedStepTherapyEdge>;
  /**
   * Bucket counts over the same rows this connection selects, grouped by `by`. Behaves
   * as PlanRelatedProcessRuleConnection.groups does: the aggregate covers the whole
   * filtered set, and the pagination arguments window the bucket list.
   */
  groups: GroupBucketConnection;
  pageInfo: PageInfo;
};


export type PlanRelatedStepTherapyConnectionGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  by: PlanRelatedStepTherapyGroupBy;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlanRelatedStepTherapyEdge = {
  __typename?: 'PlanRelatedStepTherapyEdge';
  cursor: Scalars['String']['output'];
  node: PlanRelatedStepTherapy;
};

/**
 * The rows to select. Every field is optional, and the ones that are set are ANDed. The
 * date fields take DateFilter for the reason PlanRelatedProcessRuleFilters' do.
 */
export type PlanRelatedStepTherapyFilters = {
  /** plan.number */
  adjudicatorPlanID?: InputMaybe<StringFilter>;
  /** groups.number, or "multi" — see PlanRelatedProcessRule.groupNumber */
  groupNumber?: InputMaybe<StringFilter>;
  planID?: InputMaybe<IdFilter>;
  planName?: InputMaybe<StringFilter>;
  /** plan.expiration_date */
  planTerminationDate?: InputMaybe<DateFilter>;
  /** plan_to_step_therapy.effective_date */
  planToStepTherapyEffectiveDate?: InputMaybe<DateFilter>;
  /** plan_to_step_therapy.plan_to_step_therapy_order */
  planToStepTherapyOrder?: InputMaybe<IntFilter>;
  /** plan_to_step_therapy.expiration_date */
  planToStepTherapyTerminationDate?: InputMaybe<DateFilter>;
};

/** One groupable column of the step-therapy-to-plan join. Mirrors PlanRelatedStepTherapyFilters. */
export enum PlanRelatedStepTherapyGroupBy {
  AdjudicatorPlanId = 'ADJUDICATOR_PLAN_ID',
  GroupNumber = 'GROUP_NUMBER',
  PlanId = 'PLAN_ID',
  PlanName = 'PLAN_NAME',
  PlanTerminationDate = 'PLAN_TERMINATION_DATE',
  PlanToStepTherapyEffectiveDate = 'PLAN_TO_STEP_THERAPY_EFFECTIVE_DATE',
  PlanToStepTherapyOrder = 'PLAN_TO_STEP_THERAPY_ORDER',
  PlanToStepTherapyTerminationDate = 'PLAN_TO_STEP_THERAPY_TERMINATION_DATE'
}

/**
 * The sort to apply. Set the direction on the one field to sort by; rows are sorted by
 * plan name ascending when nothing is set. If more than one field is set, the first one
 * listed here wins.
 */
export type PlanRelatedStepTherapyOrder = {
  adjudicatorPlanID?: InputMaybe<OrderDirectionEnum>;
  groupNumber?: InputMaybe<OrderDirectionEnum>;
  planName?: InputMaybe<OrderDirectionEnum>;
  planTerminationDate?: InputMaybe<OrderDirectionEnum>;
  planToStepTherapyEffectiveDate?: InputMaybe<OrderDirectionEnum>;
  planToStepTherapyOrder?: InputMaybe<OrderDirectionEnum>;
  planToStepTherapyTerminationDate?: InputMaybe<OrderDirectionEnum>;
};

export type PlanRule = {
  __typename?: 'PlanRule';
  /**
   * Provenance for the fields an AI extractor wrote on this plan rule. See AiOverlay in
   * ai_overlay.graphql.
   *
   * Always null today, and not because a resolver is missing. The extractor's plan_rule
   * proposals are recorded as unusable in pkg/v2/aioverlay/gqlmap: its 124 extracted
   * values carry 9 labels (Copay, Dose Change, Emergency, Gender, Lost Script, Max
   * Script Limit, Quantity, Refill Tolerance, Vacation) which overlap the fields of this
   * type by zero, and the 86 Copay values describe copay tiers rather than anything on a
   * plan rule. Binding them would attach confident provenance to the wrong fields.
   *
   * The field is published now so the review UI is written once, against every type it
   * will eventually cover, rather than being retrofitted when a future artifact carries
   * plan-rule values forge can stand behind.
   */
  aiOverlay?: Maybe<AiOverlay>;
  benefit_plan_id: Scalars['ID']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Time']['output']>;
  drug_lists?: Maybe<Array<MatchRule>>;
  effective_starting?: Maybe<Scalars['Time']['output']>;
  friendly_name?: Maybe<Scalars['String']['output']>;
  fror_drug_lists?: Maybe<Array<MatchRule>>;
  id: Scalars['ID']['output'];
  instructions?: Maybe<Array<Instruction>>;
  match_rules?: Maybe<Array<MatchRule>>;
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  termination_date?: Maybe<Scalars['Time']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Time']['output']>;
};


export type PlanRuleDrugListsArgs = {
  order?: InputMaybe<MatchRuleOrder>;
};


export type PlanRuleFrorDrugListsArgs = {
  order?: InputMaybe<MatchRuleOrder>;
};

export type PlanRuleDrugFilters = {
  gpi?: InputMaybe<StringFilter>;
  id: Scalars['ID']['input'];
  label_name?: InputMaybe<StringFilter>;
  med_id?: InputMaybe<StringFilter>;
  mony?: InputMaybe<StringFilter>;
  ndc?: InputMaybe<StringFilter>;
};

export type PlanRuleExpression = {
  operator: PlanRuleExpressionOperatorEnum;
  value: Scalars['String']['input'];
};

export enum PlanRuleExpressionOperatorEnum {
  In = 'IN',
  NotIn = 'NOT_IN'
}

export type PlanRuleFilters = {
  benefit_plan_id?: InputMaybe<IdFilter>;
  comment?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  recordStatus?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type PlanRuleInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  drug_lists?: InputMaybe<Array<Scalars['ID']['input']>>;
  effective_starting?: InputMaybe<Scalars['Time']['input']>;
  fror_drug_lists?: InputMaybe<Array<Scalars['ID']['input']>>;
  instructions?: InputMaybe<Array<InstructionInput>>;
  match_rules?: InputMaybe<Array<MatchRuleInput>>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  termination_date?: InputMaybe<Scalars['Time']['input']>;
  type: Scalars['String']['input'];
};

export type PlanRuleList = {
  __typename?: 'PlanRuleList';
  pagination: Pagination;
  results?: Maybe<Array<PlanRule>>;
};

export type PlanRuleOrder = {
  name?: InputMaybe<OrderDirectionEnum>;
};

export type PlanRulePriorityList = {
  __typename?: 'PlanRulePriorityList';
  priorities: Array<Scalars['ID']['output']>;
};

export type PlanRulePriorityListInput = {
  priorities: Array<Scalars['ID']['input']>;
};

export type PlanRulesDrugFilters = {
  gpi?: InputMaybe<StringFilter>;
  label_name?: InputMaybe<StringFilter>;
  match_expressions: Array<MatchExpressionInput>;
  med_id?: InputMaybe<StringFilter>;
  mony?: InputMaybe<StringFilter>;
  ndc?: InputMaybe<StringFilter>;
  plan_rule_expressions: Array<PlanRuleExpression>;
};

export enum PlanStatusEnum {
  Active = 'ACTIVE',
  Future = 'FUTURE',
  Inactive = 'INACTIVE'
}

/** PlanStepTherapy represents the association between a plan and a step therapy */
export type PlanStepTherapy = {
  __typename?: 'PlanStepTherapy';
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  expirationDate?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  planID: Scalars['ID']['output'];
  stepTherapy?: Maybe<StepTherapyV2>;
};

export type PlanStepTherapyInput = {
  effectiveDate: Scalars['Time']['input'];
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  planID: Scalars['ID']['input'];
  stepTherapyID: Scalars['ID']['input'];
};

export type PlanStepTherapyOrder = {
  __typename?: 'PlanStepTherapyOrder';
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
};

export type PlanStepTherapyOrderInput = {
  id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};

export type PlanStepTherapyOrderList = {
  __typename?: 'PlanStepTherapyOrderList';
  planStepTherapies?: Maybe<Array<PlanStepTherapyOrder>>;
};

export type PlanStepTherapyOrderListInput = {
  planStepTherapies?: InputMaybe<Array<PlanStepTherapyOrderInput>>;
};

export type PlanStructureOption = {
  __typename?: 'PlanStructureOption';
  /** Card ID string sent to the adjudicator for this plan structure */
  cardID: Scalars['String']['output'];
  /** Display name for the plan structure (e.g. "Pareto plans") */
  name: Scalars['String']['output'];
  /** Pre-configured person code */
  personCode: Scalars['String']['output'];
};

/** Response for plan test assignment query */
export type PlanTestAssignment = Node & {
  __typename?: 'PlanTestAssignment';
  /** Available subgroups for assignment */
  availableSubgroups: Array<SyncedSubgroup>;
  /** Available templates for assignment */
  availableTemplates: Array<PlanTestAssignmentTemplate>;
  /** Benefit plan information (if plan filter is provided) */
  benefitPlan?: Maybe<BenefitPlan>;
  /** Group information */
  group: Group;
  /** Global ID for Relay Node interface */
  id: Scalars['ID']['output'];
  /** Plan's formulary information */
  planFormulary?: Maybe<Formulary>;
  /** Auto-selected subgroup */
  selectedSubgroup?: Maybe<SyncedSubgroup>;
  /** Auto-selected template */
  selectedTemplate?: Maybe<PlanTestAssignmentTemplate>;
  /** Reason for subgroup selection */
  subgroupSelectionReason: Scalars['String']['output'];
  /** Reason for template selection */
  templateSelectionReason: Scalars['String']['output'];
};

/** Connection for plan test assignment query with cursor pagination */
export type PlanTestAssignmentConnection = {
  __typename?: 'PlanTestAssignmentConnection';
  /** Assignment edges */
  edges: Array<PlanTestAssignmentEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
};

/** Edge for plan test assignment */
export type PlanTestAssignmentEdge = {
  __typename?: 'PlanTestAssignmentEdge';
  /** Cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The assignment node */
  node: PlanTestAssignment;
};

/** Filters for plan test assignment query */
export type PlanTestAssignmentFilters = {
  /** Optional: Group IDs to filter subgroups. Either groupIds or planIDs must be provided. */
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional: Plan code IDs to further filter subgroups. Either groupIds or planIDs must be provided. */
  planIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Template from Golden Test Library */
export type PlanTestAssignmentTemplate = {
  __typename?: 'PlanTestAssignmentTemplate';
  benefitPlan: BenefitPlan;
  /** UUID of the template */
  id: Scalars['ID']['output'];
  /** Indicates if this template is auto-selected */
  isAutoSelected: Scalars['Boolean']['output'];
  /** Indicates if this is a global template */
  isGlobal: Scalars['Boolean']['output'];
};

export type PlanTestCase = {
  __typename?: 'PlanTestCase';
  /**
   * The BenOps AI project's score for this test case. Null for every human-built
   * test case.
   */
  aiScore?: Maybe<PlanTestCaseAiScore>;
  /**
   * The plan test case's exact date of service. When set, it is used instead of
   * date_filled_offset, and the offset is not meaningful. Null on test cases that
   * are anchored to the subgroup's start date by offset.
   */
  dateOfService?: Maybe<Scalars['Date']['output']>;
  /**
   * The plan test case's exact claim rx written date. When set, it is used instead
   * of date_written_offset, and the offset is not meaningful. Null on test cases
   * that are anchored to the subgroup's start date by offset.
   */
  datePrescriptionWritten?: Maybe<Scalars['Date']['output']>;
  /** The plan test case's date filled offset from the group start date */
  date_filled_offset: Scalars['Int']['output'];
  /** The plan test case's claim rx written date offset from the group start date */
  date_written_offset: Scalars['Int']['output'];
  /** The plan test case's daw code */
  daw_code?: Maybe<Scalars['String']['output']>;
  /** The plan test case's day supply */
  day_supply: Scalars['Int']['output'];
  /** The drug label name resolved from the plan test case's NDC */
  drug_name?: Maybe<Scalars['String']['output']>;
  /** The plan test case's expected coinsurance */
  expected_coinsurance?: Maybe<Scalars['Int']['output']>;
  /** The plan test case's expected copay */
  expected_copay?: Maybe<Scalars['Float']['output']>;
  /** The plan test case's expected coverage */
  expected_coverage: CoverageEnum;
  /** The plan test case's fill number */
  fill_number: Scalars['Int']['output'];
  /** The plan test case's unique identifier */
  id: Scalars['ID']['output'];
  /** The plan test case's linked test member */
  member: TestMember;
  /** The plan test case's linked test member unique identifier */
  membership_id: Scalars['ID']['output'];
  /** The plan test case's name */
  name: Scalars['String']['output'];
  /** The plan test case's NDC */
  ndc: Scalars['String']['output'];
  /** The plan test case's pharmacy NPI */
  pharmacy_npi: Scalars['String']['output'];
  /** The plan test case's prescriber NPI */
  prescriber_npi?: Maybe<Scalars['String']['output']>;
  /** The plan test case's priority number */
  priority: Scalars['Int']['output'];
  /** The plan test case's quantity value */
  quantity: Scalars['Float']['output'];
  /** The plan test case's number of refills authorized */
  refills_authorized?: Maybe<Scalars['Int']['output']>;
  /** The plan test case's linked super network unique identifier */
  super_network_id: Scalars['String']['output'];
  /** The plan test case's DCC result */
  test_case_dcc_result?: Maybe<PlanTestCaseDccResult>;
  /** The plan test case's test category */
  test_category?: Maybe<Scalars['String']['output']>;
  /** If a test case has been executed in the adjudication system, then test results are populated */
  test_result?: Maybe<TestCaseResult>;
  /** The plan test case's zebra test result (from test_case_zebra_result table) */
  zebraTestResult?: Maybe<ZebraTestCaseResult>;
};

/**
 * The BenOps AI project's account of how it arrived at a test case's expected
 * result. Every field is the AI project's own text, stored and returned as
 * received; forge does not interpret it.
 */
export type PlanTestCaseAiScore = {
  __typename?: 'PlanTestCaseAIScore';
  /** How the expected result was derived, for example engine or extraction. */
  basis?: Maybe<Scalars['String']['output']>;
  /** Detail for basis, such as the engine rule that produced the result. */
  basisDetail?: Maybe<Scalars['String']['output']>;
  /** The AI project's self-reported confidence, for example high, medium or low. */
  confidence?: Maybe<Scalars['String']['output']>;
  /** Caveats for the reviewer, such as overlays that can change the result. */
  notes?: Maybe<Scalars['String']['output']>;
  /** The AI project's explanation of the expected result. */
  rationale?: Maybe<Scalars['String']['output']>;
  /** The AI project's identifier for the row this case was generated from. */
  rowId?: Maybe<Scalars['String']['output']>;
  /** The workbook and engine cells the expected result came from, as the AI project wrote them. */
  sourceCells?: Maybe<Scalars['String']['output']>;
};

/** Input form of PlanTestCaseAIScore. The fields have the same meaning. */
export type PlanTestCaseAiScoreInput = {
  basis?: InputMaybe<Scalars['String']['input']>;
  basisDetail?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  rowId?: InputMaybe<Scalars['String']['input']>;
  sourceCells?: InputMaybe<Scalars['String']['input']>;
};

export type PlanTestCaseDccResult = {
  __typename?: 'PlanTestCaseDCCResult';
  /** The plan test case's expected coinsurance */
  coinsurance?: Maybe<Scalars['Int']['output']>;
  /** The plan test case's expected copay */
  copay?: Maybe<Scalars['Float']['output']>;
  /** The plan test case's expected coverage */
  coverage?: Maybe<CoverageEnum>;
  /** The plan test case's error message if play through DCC fails */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The plan test case's unique identifier for existing test case */
  planTestCaseUUID: Scalars['String']['output'];
  /** The plan test case's expected status */
  status: Scalars['String']['output'];
};

export type PlanTestCaseFilters = {
  plan_test_suite_id?: InputMaybe<IdFilter>;
  testRunExecutionID?: InputMaybe<IdFilter>;
};

export type PlanTestCaseInput = {
  /**
   * The BenOps AI project's score for this test case, stored as received. At most
   * 8 KB once serialized. Accepted only on AI-generated suites.
   */
  ai_score?: InputMaybe<PlanTestCaseAiScoreInput>;
  /**
   * Card ID of the test member, used with person_code instead of member_id. The
   * member is looked up in the configured BenOps AI test group, so this form is
   * accepted only on AI-generated suites.
   */
  card_id?: InputMaybe<Scalars['String']['input']>;
  /**
   * The plan test case's exact date of service. Supply this instead of relying on
   * date_filled_offset; when it is set the offset is ignored. Both exact dates must
   * be given together.
   */
  dateOfService?: InputMaybe<Scalars['Date']['input']>;
  /**
   * The plan test case's exact claim rx written date. Supply this instead of relying
   * on date_written_offset; when it is set the offset is ignored. Both exact dates
   * must be given together.
   */
  datePrescriptionWritten?: InputMaybe<Scalars['Date']['input']>;
  /** The plan test case's date filled offset from the group start date */
  date_filled_offset: Scalars['Int']['input'];
  /** The plan test case's claim rx written date offset from the group start date */
  date_written_offset: Scalars['Int']['input'];
  /** The plan test case's dsw code */
  daw_code?: InputMaybe<Scalars['String']['input']>;
  /** The plan test case's day supply */
  day_supply: Scalars['Int']['input'];
  /** The plan test case's expected coinsurance */
  expected_coinsurance?: InputMaybe<Scalars['Int']['input']>;
  /** The plan test case's expected copay */
  expected_copay?: InputMaybe<Scalars['Float']['input']>;
  /** The plan test case's expected coverage */
  expected_coverage: CoverageEnum;
  /** The plan test case's fill number */
  fill_number?: InputMaybe<Scalars['Int']['input']>;
  /** The plan test case's unique identifier for existing test case */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The plan test case's linked test member. Give either this or card_id with
   * person_code, not both.
   */
  member_id?: InputMaybe<Scalars['ID']['input']>;
  /** The plan test case's NDC */
  ndc: Scalars['String']['input'];
  /** Person code of the test member; see card_id. */
  person_code?: InputMaybe<Scalars['String']['input']>;
  /** The plan test case's pharmacy NPI */
  pharmacy_npi: Scalars['String']['input'];
  /** The plan test case's prescriber NPI */
  prescriber_npi?: InputMaybe<Scalars['String']['input']>;
  /** The plan test case's quantity value */
  quantity: Scalars['Float']['input'];
  /** The plan test case's number of refills authorized */
  refills_authorized?: InputMaybe<Scalars['Int']['input']>;
  /** The plan test case's linked super network unique identifier */
  super_network_id?: InputMaybe<Scalars['String']['input']>;
  /** The plan test case's name */
  test_case_name: Scalars['String']['input'];
  /** The plan test case's test category */
  test_category?: InputMaybe<Scalars['String']['input']>;
};

export type PlanTestCaseList = {
  __typename?: 'PlanTestCaseList';
  pagination: Pagination;
  results: Array<PlanTestCase>;
};

export type PlanTestSuite = {
  __typename?: 'PlanTestSuite';
  adjudication_test_percentage_passed?: Maybe<Scalars['Int']['output']>;
  benefit_plan_code: Scalars['String']['output'];
  benefit_plan_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** True when the BenOps AI project created this suite. Per-execution clones are false. */
  isAiGenerated: Scalars['Boolean']['output'];
};

export type PlanTestSuiteFilters = {
  /** Exact filter for Benefit Plan Laker Code */
  benefit_plan_code?: InputMaybe<StringFilter>;
  /** Exact filter for Benefit Plan ID */
  benefit_plan_id?: InputMaybe<IdFilter>;
  /** Group associated with benefit plan */
  group_code?: InputMaybe<StringFilter>;
  /** Filter by whether the test suite is global */
  isGlobal?: InputMaybe<BooleanFilter>;
};

export type PlanTestSuiteGroupSubgroupFilters = {
  /** Exact filter for Group ID */
  group_id?: InputMaybe<IdFilter>;
  /** Exact filter for Plan Test Suite ID */
  plan_test_suite_id: IdFilter;
  /** Exact filter for Subgroup ID */
  subgroup_id?: InputMaybe<IdFilter>;
};

export type PlanTestSuiteGroupsSubgroups = {
  __typename?: 'PlanTestSuiteGroupsSubgroups';
  benefit_plan_id: Scalars['ID']['output'];
  group_code?: Maybe<Scalars['String']['output']>;
  group_id?: Maybe<Scalars['ID']['output']>;
  group_name?: Maybe<Scalars['String']['output']>;
  subgroup?: Maybe<Scalars['String']['output']>;
  subgroup_id?: Maybe<Scalars['ID']['output']>;
  test_suite_id: Scalars['ID']['output'];
};

export type PlanTestSuiteIdFilter = {
  /** Exact filter for ID */
  id: IdFilter;
};

export type PlanTestSuiteList = {
  __typename?: 'PlanTestSuiteList';
  pagination: Pagination;
  results: Array<PlanTestSuiteResult>;
};

export type PlanTestSuiteOrder = {
  benefit_plan_code?: InputMaybe<OrderDirectionEnum>;
  benefit_plan_name?: InputMaybe<OrderDirectionEnum>;
  group_code?: InputMaybe<OrderDirectionEnum>;
  group_effective_date?: InputMaybe<OrderDirectionEnum>;
  subgroup?: InputMaybe<OrderDirectionEnum>;
};

export type PlanTestSuiteResult = {
  __typename?: 'PlanTestSuiteResult';
  adjudication_test_percentage_passed?: Maybe<Scalars['Int']['output']>;
  benefit_plan_code: Scalars['String']['output'];
  benefit_plan_id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  group_code?: Maybe<Scalars['String']['output']>;
  group_effective_date?: Maybe<Scalars['Time']['output']>;
  group_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  plan_name: Scalars['String']['output'];
  subgroup?: Maybe<Scalars['String']['output']>;
  subgroup_id?: Maybe<Scalars['ID']['output']>;
  test_suite_id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type PlanToCob = {
  __typename?: 'PlanToCOB';
  cobObject: Cob;
  cobObjectID: Scalars['ID']['output'];
  effectiveDate: Scalars['Time']['output'];
  expirationDate?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  planID: Scalars['ID']['output'];
};

export type PlanToCobInput = {
  cobObjectID: Scalars['ID']['input'];
  effectiveDate: Scalars['Time']['input'];
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  planID: Scalars['ID']['input'];
};

export type PlayThroughDccInput = {
  /** The UUID of the benefit plan for which we're looking up coverage */
  benefit_plan_id: Scalars['ID']['input'];
  days_supply: Scalars['Int']['input'];
  /** Exact match on drug NDC */
  ndc: Scalars['String']['input'];
  /** The Super Network UUID */
  super_network_id: Scalars['ID']['input'];
};

export type PortalSubgroup = Subgroup & {
  __typename?: 'PortalSubgroup';
  currentBenefitPlanOverride?: Maybe<PlanCodeV2>;
  currentBenefitStartDate?: Maybe<Scalars['Date']['output']>;
  currentDepartment?: Maybe<Department>;
  currentPlanCode?: Maybe<PlanCodeV2>;
  currentTerminationDate?: Maybe<Scalars['Date']['output']>;
  details: Array<PortalSubgroupDetail>;
  firstEffectiveDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  status: GroupStatus;
};

export type PortalSubgroupDetail = SubgroupDetail & {
  __typename?: 'PortalSubgroupDetail';
  benefitStartDate?: Maybe<Scalars['Date']['output']>;
  department?: Maybe<Department>;
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  familyBenCap?: Maybe<Scalars['Cents']['output']>;
  familyDed?: Maybe<Scalars['Cents']['output']>;
  familyOop?: Maybe<Scalars['Cents']['output']>;
  id: Scalars['ID']['output'];
  individualBenCap?: Maybe<Scalars['Cents']['output']>;
  individualDed?: Maybe<Scalars['Cents']['output']>;
  individualOop?: Maybe<Scalars['Cents']['output']>;
  name: Scalars['String']['output'];
  overridePlan?: Maybe<Plan>;
  planCode?: Maybe<PlanCodeV2>;
};

export type PrescriberConnection = {
  __typename?: 'PrescriberConnection';
  edges: Array<PrescriberEdge>;
  pageInfo: PageInfo;
};

export type PrescriberEdge = {
  __typename?: 'PrescriberEdge';
  cursor: Scalars['String']['output'];
  node: PrescriberV2;
};

export type PrescriberFiltersV2 = {
  city?: InputMaybe<StringFilter>;
  /** Composite search across NPI, first name, and last name. */
  composite?: InputMaybe<StringFilter>;
  dea?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  lastName?: InputMaybe<StringFilter>;
  npi?: InputMaybe<StringFilter>;
  state?: InputMaybe<StringFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type PrescriberImportStartResult = {
  __typename?: 'PrescriberImportStartResult';
  message: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['Time']['output']>;
};

export type PrescriberImportStatus = {
  __typename?: 'PrescriberImportStatus';
  message: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['Time']['output']>;
};

export type PrescriberInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dea?: InputMaybe<Scalars['String']['input']>;
  deaExpirationDate?: InputMaybe<Scalars['Time']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  npi: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  taxonomyCode?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A Prescriber List object.
 * This is the top level of a particular Prescriber List, which we use to group prescribers.
 */
export type PrescriberList = Node & {
  __typename?: 'PrescriberList';
  created: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['Time']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type PrescriberListConnection = {
  __typename?: 'PrescriberListConnection';
  count: Scalars['Int']['output'];
  edges: Array<PrescriberListEdge>;
  pageInfo: PageInfo;
};

/**
 * Prescriber List Detail represents the association between a prescriber and a prescriber list,
 * including effective and expiration dates for the association.
 */
export type PrescriberListDetail = Node & {
  __typename?: 'PrescriberListDetail';
  effectiveDate: Scalars['Date']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  prescriber: PrescriberV2;
  prescriberList: PrescriberList;
};

export type PrescriberListDetailConnection = {
  __typename?: 'PrescriberListDetailConnection';
  count: Scalars['Int']['output'];
  edges: Array<PrescriberListDetailEdge>;
  pageInfo: PageInfo;
};

export type PrescriberListDetailEdge = {
  __typename?: 'PrescriberListDetailEdge';
  cursor: Scalars['String']['output'];
  node: PrescriberListDetail;
};

export type PrescriberListDetailFilters = {
  effectiveDate?: InputMaybe<DateFilter>;
  expirationDate?: InputMaybe<DateFilter>;
  id?: InputMaybe<IdFilter>;
  prescriberId?: InputMaybe<IdFilter>;
  prescriberListId?: InputMaybe<IdFilter>;
  prescriberNpi?: InputMaybe<StringFilter>;
};

export type PrescriberListDetailInput = {
  effectiveDate: Scalars['Date']['input'];
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  prescriberId: Scalars['ID']['input'];
  prescriberListId: Scalars['ID']['input'];
};

export type PrescriberListDetailOrder = {
  created?: InputMaybe<OrderDirectionEnum>;
  effectiveDate?: InputMaybe<OrderDirectionEnum>;
  expirationDate?: InputMaybe<OrderDirectionEnum>;
};

export type PrescriberListEdge = {
  __typename?: 'PrescriberListEdge';
  cursor: Scalars['String']['output'];
  node: PrescriberList;
};

export type PrescriberListFilters = {
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type PrescriberListInput = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type PrescriberListOrder = {
  name?: InputMaybe<OrderDirectionEnum>;
};

export type PrescriberOrderV2 = {
  city?: InputMaybe<OrderDirectionEnum>;
  createdAt?: InputMaybe<OrderDirectionEnum>;
  dea?: InputMaybe<OrderDirectionEnum>;
  firstName?: InputMaybe<OrderDirectionEnum>;
  id?: InputMaybe<OrderDirectionEnum>;
  lastName?: InputMaybe<OrderDirectionEnum>;
  npi?: InputMaybe<OrderDirectionEnum>;
  state?: InputMaybe<OrderDirectionEnum>;
  zip?: InputMaybe<OrderDirectionEnum>;
};

export type PrescriberUpsertResult = BaseError | PrescriberV2 | ValidationError;

export type PrescriberV2 = {
  __typename?: 'PrescriberV2';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  dea?: Maybe<Scalars['String']['output']>;
  deaExpirationDate?: Maybe<Scalars['Time']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['Time']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  npi: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  taxonomyCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export enum PresignedActionEnum {
  Download = 'DOWNLOAD',
  Upload = 'UPLOAD'
}

export type PresignedUrlInput = {
  /** The operation type: 'UPLOAD' or 'DOWNLOAD' */
  action: PresignedActionEnum;
  /** Salesforce case identifier */
  caseId: Scalars['ID']['input'];
  /** Document request file reference identifier, only required for 'DOWNLOAD' action */
  documentRequestFileReferenceId?: InputMaybe<Scalars['ID']['input']>;
  /** Document request identifier */
  documentRequestId: Scalars['ID']['input'];
  /** The filename of the document, only required for 'UPLOAD' action */
  filename?: InputMaybe<Scalars['String']['input']>;
};

export type PresignedUrlResponse = {
  __typename?: 'PresignedUrlResponse';
  /** The expiration timestamp of the presigned URL */
  expiresAt: Scalars['Time']['output'];
  /** The presigned URL for uploading or downloading the document */
  url: Scalars['String']['output'];
};

/** The stage of dredd's normalizer pipeline that rejected a line. */
export enum PreviewStage {
  Parser = 'PARSER',
  Transform = 'TRANSFORM',
  /**
   * A stage dredd reports that this schema does not know about yet. Clients should
   * treat it as "some other stage" rather than as a bug; the error's message still
   * says what went wrong.
   */
  Unknown = 'UNKNOWN'
}

/**
 * Member portal PA tracker statuses. Coarser than the partner portal labels, which break the
 * completed states down further.
 */
export enum PriorAuthTrackerStatus {
  /** Complete with decision outcome Approved or Overturned */
  Approved = 'APPROVED',
  /** SF Status Cancelled, or Complete with decision outcome Withdrawn */
  CancelledAndWithdrawnByRequestor = 'CANCELLED_AND_WITHDRAWN_BY_REQUESTOR',
  /** SF Status Draft, with both decision outcome fields blank */
  Created = 'CREATED',
  /** Complete with decision outcome Denied or Upheld */
  Denied = 'DENIED',
  /** Complete with decision outcome Cancel */
  Dismissed = 'DISMISSED',
  /** SF Status InProgress, with both decision outcome fields blank */
  MdResponseReceivedPendingClinicalReview = 'MD_RESPONSE_RECEIVED_PENDING_CLINICAL_REVIEW',
  /** Complete with decision outcome Partially Approved or Partially Overturned */
  PartiallyApproved = 'PARTIALLY_APPROVED',
  /** SF Status Reopen, whatever the decision outcome fields hold */
  Reopened = 'REOPENED',
  /** SF Status Pending, with both decision outcome fields blank */
  RequestForInformationSent = 'REQUEST_FOR_INFORMATION_SENT'
}

export enum PriorAuthType {
  PaApplies = 'PA_APPLIES',
  RestrictivePa = 'RESTRICTIVE_PA'
}

export type PriorAuthorizationRequest = CaseRequest & {
  __typename?: 'PriorAuthorizationRequest';
  /** Authorization End Date. Expiration date after which PA will have to be applied for again. */
  authorizationEndDate?: Maybe<Scalars['String']['output']>;
  /**
   * Authorization Start Date. The date the PA becomes effective. Reliably populated
   * on granted outcomes (Approved / Overturned / Partially Approved); null otherwise.
   */
  authorizationStartDate?: Maybe<Scalars['String']['output']>;
  /** Days supply of the drug requested, e.g. "28". Free text in Salesforce, so not numeric. */
  daysSupply?: Maybe<Scalars['String']['output']>;
  /** Decision outcome (Cancel, Partially Approved, Denied, etc.) */
  decisionOutcome?: Maybe<Scalars['String']['output']>;
  /**
   * Decision outcome description, including rejection reason.
   * NOTE: Salesforce calls this 'decision outcome status'
   */
  decisionOutcomeDescription?: Maybe<Scalars['String']['output']>;
  /** Drug name */
  drugName: Scalars['String']['output'];
  /**
   * The date a decision is expected, computed as initiatedAt plus 15 days.
   * Only set while a decision is still pending.
   * A display-only estimate, not a commitment, and not sourced from Salesforce.
   */
  estimatedDecisionDate?: Maybe<Scalars['Time']['output']>;
  /** Group */
  group: Group;
  /** The case's unique identifier, caseID */
  id: Scalars['ID']['output'];
  /** The date that PA request was initiated */
  initiatedAt: Scalars['Time']['output'];
  /** Member read the latest message or not */
  isUnread: Scalars['Boolean']['output'];
  /** Member */
  member: Member;
  /**
   * The 11-digit NDC of the requested drug. Null when Salesforce has no NDC on the
   * case, so consumers must be able to fall back to matching on drugName.
   */
  ndc?: Maybe<Scalars['String']['output']>;
  /** doctor name */
  provider: Scalars['String']['output'];
  /** Quantity of the drug requested, e.g. "4". Free text in Salesforce, so not numeric. */
  quantity?: Maybe<Scalars['String']['output']>;
  /** The case reason */
  reason?: Maybe<Scalars['String']['output']>;
  /** The case's member-friendly identifier, banjo authorization ID in SF */
  referenceNumber: Scalars['ID']['output'];
  /** Case Status. Different from the status shown on the frontend, since it's computed internally */
  status?: Maybe<Scalars['String']['output']>;
  /** The status of the PA request */
  statusLog: Array<StatusLogEntry>;
  /** Last updated time */
  statusUpdatedAt: Scalars['Time']['output'];
  /** The status the member portal PA tracker displays. Null for states the tracker doesn't surface. */
  trackerStatus?: Maybe<PriorAuthTrackerStatus>;
};

export type ProcessRule = {
  __typename?: 'ProcessRule';
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  expirationDate?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  processRuleAttachments: Array<ProcessRuleAttachment>;
  processRuleLines: Array<ProcessRuleLine>;
  usedInFillRules: FillRuleRelatedProcessRuleConnection;
  /** Plans this process rule is attached to, one edge per attachment row. */
  usedInPlans: PlanRelatedProcessRuleConnection;
  usedInStepTherapies: StepTherapyRelatedProcessRuleConnection;
};


export type ProcessRuleUsedInFillRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<FillRuleRelatedProcessRuleOrder>;
  where?: InputMaybe<FillRuleRelatedProcessRuleFilters>;
};


export type ProcessRuleUsedInPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<PlanRelatedProcessRuleOrder>;
  where?: InputMaybe<PlanRelatedProcessRuleFilters>;
};


export type ProcessRuleUsedInStepTherapiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<StepTherapyRelatedProcessRuleOrder>;
  where?: InputMaybe<StepTherapyRelatedProcessRuleFilters>;
};

export type ProcessRuleAttachment = {
  __typename?: 'ProcessRuleAttachment';
  /**
   * Provenance for the fields an AI extractor wrote on this attachment. See AiOverlay in
   * ai_overlay.graphql.
   *
   * Provenance for a plan's process rules belongs here rather than on ProcessRule or
   * ProcessRuleLine, because the rule and its lines are a shared library row: one
   * process_rule is attached to many plans, groups and members, so provenance stored
   * against it would be shown to every plan that shares it while being true of only the
   * one the workbook described. This row is the plan-scoped one, and it holds the values
   * a workbook actually sets — the date window and the evaluation priority.
   *
   * Matched by identity. A process rule names no single attachment, so the artifact's
   * process_rule_attachment rows carry, as target_id, the id UpsertProcessRuleAttachment
   * returned for the row, and an overlay is this attachment's only when that id is this
   * attachment's id. Null for an attachment that is not on a plan, and for every
   * artifact written before the AI stack recorded those ids.
   *
   * effectiveDate is the only field provenanced, and only where the agent read the date
   * off a cell. The dates it sets from a constant or derives from go-live are not
   * attributed, because no cell is their source. userOverridden compares the calendar
   * date.
   *
   * priority carries no provenance even when the rest does: the artifact proposes no
   * value for it, and it is the field here where a wrong value reorders evaluation rather
   * than mis-stating one cell.
   */
  aiOverlay?: Maybe<AiOverlay>;
  attachmentOrder?: Maybe<Scalars['Int']['output']>;
  customDrugList?: Maybe<CustomDrugListV2>;
  customDrugListUUID?: Maybe<Scalars['UUID']['output']>;
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  expirationDate?: Maybe<Scalars['Time']['output']>;
  group?: Maybe<Group>;
  groupUUID?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['ID']['output'];
  member?: Maybe<MemberV2>;
  memberUUID?: Maybe<Scalars['UUID']['output']>;
  pharmacy?: Maybe<PharmacyV2>;
  pharmacyNetwork?: Maybe<PharmacyNetwork>;
  pharmacyNetworkUUID?: Maybe<Scalars['UUID']['output']>;
  pharmacyUUID?: Maybe<Scalars['UUID']['output']>;
  planUUID?: Maybe<Scalars['UUID']['output']>;
  prescriber?: Maybe<PrescriberV2>;
  prescriberUUID?: Maybe<Scalars['UUID']['output']>;
  priority: Scalars['Int']['output'];
  processRule?: Maybe<ProcessRule>;
  processRuleUUID: Scalars['ID']['output'];
  subgroup?: Maybe<SyncedSubgroup>;
  subgroupUUID?: Maybe<Scalars['UUID']['output']>;
};

export type ProcessRuleAttachmentConnection = {
  __typename?: 'ProcessRuleAttachmentConnection';
  edges: Array<ProcessRuleAttachmentEdge>;
  pageInfo: PageInfo;
};

export type ProcessRuleAttachmentEdge = {
  __typename?: 'ProcessRuleAttachmentEdge';
  cursor: Scalars['String']['output'];
  node: ProcessRuleAttachment;
};

export type ProcessRuleAttachmentInput = {
  ID?: InputMaybe<Scalars['ID']['input']>;
  customDrugListID?: InputMaybe<Scalars['ID']['input']>;
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  groupID?: InputMaybe<Scalars['ID']['input']>;
  memberID?: InputMaybe<Scalars['ID']['input']>;
  pharmacyID?: InputMaybe<Scalars['ID']['input']>;
  pharmacyNetworkID?: InputMaybe<Scalars['ID']['input']>;
  planID?: InputMaybe<Scalars['ID']['input']>;
  prescriberID?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  processRuleID: Scalars['ID']['input'];
  subgroupID?: InputMaybe<Scalars['ID']['input']>;
};

export type ProcessRuleAttachmentPriority = {
  __typename?: 'ProcessRuleAttachmentPriority';
  id: Scalars['ID']['output'];
  priority: Scalars['Int']['output'];
};

export type ProcessRuleAttachmentPriorityInput = {
  id: Scalars['ID']['input'];
  priority: Scalars['Int']['input'];
};

export type ProcessRuleAttachmentPriorityList = {
  __typename?: 'ProcessRuleAttachmentPriorityList';
  attachments: Array<ProcessRuleAttachmentPriority>;
};

export type ProcessRuleAttachmentPriorityListInput = {
  attachments: Array<ProcessRuleAttachmentPriorityInput>;
};

export type ProcessRuleConnection = {
  __typename?: 'ProcessRuleConnection';
  edges: Array<ProcessRuleEdge>;
  pageInfo: PageInfo;
};

export type ProcessRuleEdge = {
  __typename?: 'ProcessRuleEdge';
  cursor: Scalars['String']['output'];
  node: ProcessRule;
};

export type ProcessRuleFilters = {
  customDrugListID?: InputMaybe<IdFilter>;
  groupID?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  memberID?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  pharmacyID?: InputMaybe<IdFilter>;
  pharmacyNetworkID?: InputMaybe<IdFilter>;
  planID?: InputMaybe<IdFilter>;
  prescriberID?: InputMaybe<IdFilter>;
  subgroupID?: InputMaybe<IdFilter>;
};

export type ProcessRuleLine = {
  __typename?: 'ProcessRuleLine';
  action: ProcessRuleLineInclusion;
  customDrugList?: Maybe<CustomDrugListV2>;
  description?: Maybe<Scalars['String']['output']>;
  drugType?: Maybe<DrugType>;
  drugTypeLabel?: Maybe<Scalars['String']['output']>;
  drugValue?: Maybe<Scalars['String']['output']>;
  drugValueLabel?: Maybe<Scalars['String']['output']>;
  effectiveDate: Scalars['Time']['output'];
  expirationDate?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  inclusionLabel?: Maybe<Scalars['String']['output']>;
  insertNetworkPMBefore?: Maybe<Scalars['Boolean']['output']>;
  insertNetworkPMBeforeLabel?: Maybe<Scalars['String']['output']>;
  lineNumber: Scalars['Int']['output'];
  processRuleLineActions?: Maybe<ProcessRuleLineActions>;
  processRuleLineCriteria?: Maybe<ProcessRuleLineCriteria>;
  processRuleLineDynConds: Array<ProcessRuleLineDynCond>;
};

export type ProcessRuleLineActions = {
  __typename?: 'ProcessRuleLineActions';
  addRegulatoryFee?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use sdc instead */
  addSdc?: Maybe<Scalars['UUID']['output']>;
  ageHandler?: Maybe<AgeHandler>;
  allowNegativePayments: Scalars['Boolean']['output'];
  billCostHandler?: Maybe<BillCostHandler>;
  copayHandler?: Maybe<CopayHandler>;
  costHandler?: Maybe<CostHandler>;
  deferMessage?: Maybe<Scalars['Boolean']['output']>;
  dispenseFeeHandler?: Maybe<DispenseFeeHandler>;
  dispenseLimitHandler?: Maybe<DispenseLimitHandler>;
  /** @deprecated Field is no longer used */
  excludeWithRejectCode?: Maybe<Scalars['String']['output']>;
  forceZeroTax: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ignore7571Reject: Scalars['Boolean']['output'];
  ignoreAccums: Scalars['Boolean']['output'];
  ignoreDateWrittenReject: Scalars['Boolean']['output'];
  ignoreGroupMaxDollar: Scalars['Boolean']['output'];
  ignoreInvalidPrescriber: Scalars['Boolean']['output'];
  ignoreOTCReject: Scalars['Boolean']['output'];
  ignorePhysicianChecks: Scalars['Boolean']['output'];
  ignorePrescriberRestrictions: Scalars['Boolean']['output'];
  /** @deprecated Inert: no adjudication rule reads it. Waive 9G with MARK_SCRIPT_TAG (MPA2) plus MAX_DAILY_DOSE and MAX_SCRIPT_QTY (ZEB-10634). */
  ignoreQuantityLimits: Scalars['Boolean']['output'];
  ignoreRepackReject: Scalars['Boolean']['output'];
  ignoreScriptTooOld: Scalars['Boolean']['output'];
  ignoreZeroCost: Scalars['Boolean']['output'];
  incentiveFee?: Maybe<Scalars['Float']['output']>;
  limitOOP?: Maybe<Scalars['Float']['output']>;
  mac?: Maybe<MacList>;
  /** @deprecated Use mac instead */
  macUUID?: Maybe<Scalars['UUID']['output']>;
  maintenanceFlag: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  messageOnlyRts: Scalars['Boolean']['output'];
  miscHandler?: Maybe<MiscHandler>;
  naToBencap?: Maybe<Scalars['Boolean']['output']>;
  naToDeductible?: Maybe<Scalars['Boolean']['output']>;
  naToOop?: Maybe<Scalars['Boolean']['output']>;
  naToSdcBencap?: Maybe<Scalars['Boolean']['output']>;
  naToSdcDeductible?: Maybe<Scalars['Boolean']['output']>;
  naToSdcOop?: Maybe<Scalars['Boolean']['output']>;
  onlyUseMessageIfHandlerUsed?: Maybe<Scalars['Boolean']['output']>;
  onlyUseMessageIfReject?: Maybe<Scalars['Boolean']['output']>;
  onlyUseMessageIfRejectAgainstLine?: Maybe<Scalars['Boolean']['output']>;
  oopLimitApplyDeductible?: Maybe<Scalars['Boolean']['output']>;
  otherAmtPaidFee?: Maybe<Scalars['Float']['output']>;
  overrideGroupMaxDollar?: Maybe<Scalars['Float']['output']>;
  overrideMACList?: Maybe<MacList>;
  overrideMACPrice?: Maybe<Scalars['Float']['output']>;
  pharmacyFee?: Maybe<Scalars['Float']['output']>;
  planPaysDaw: Scalars['Boolean']['output'];
  preferredFlag?: Maybe<Scalars['Boolean']['output']>;
  refillHandler?: Maybe<RefillHandler>;
  rejectCode?: Maybe<Scalars['String']['output']>;
  repackFlag: Scalars['Boolean']['output'];
  return5452FValue?: Maybe<Scalars['String']['output']>;
  sdc?: Maybe<Sdcv2>;
  setScriptTag?: Maybe<Scalars['String']['output']>;
  setTier?: Maybe<Scalars['String']['output']>;
  skipDur: Scalars['Boolean']['output'];
  taxPercentage?: Maybe<Scalars['Float']['output']>;
  treatAsMony?: Maybe<Scalars['String']['output']>;
  treatAsMonyCopay?: Maybe<Scalars['String']['output']>;
  treatAsMonyCostDispFee?: Maybe<Scalars['String']['output']>;
};

export type ProcessRuleLineActionsInput = {
  addRegulatoryFee?: InputMaybe<Scalars['Float']['input']>;
  addSdc?: InputMaybe<Scalars['UUID']['input']>;
  ageHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  allowNegativePayments?: InputMaybe<Scalars['Boolean']['input']>;
  billCostHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  copayHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  costHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  deferMessage?: InputMaybe<Scalars['Boolean']['input']>;
  dispenseFeeHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  dispenseLimitHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** @deprecated Field is no longer used */
  excludeWithRejectCode?: InputMaybe<Scalars['String']['input']>;
  forceZeroTax?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ignore7571Reject?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreAccums?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreDateWrittenReject?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreGroupMaxDollar?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreInvalidPrescriber?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreOTCReject?: InputMaybe<Scalars['Boolean']['input']>;
  ignorePhysicianChecks?: InputMaybe<Scalars['Boolean']['input']>;
  ignorePrescriberRestrictions?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Inert: no adjudication rule reads it. Waive 9G with MARK_SCRIPT_TAG (MPA2) plus MAX_DAILY_DOSE and MAX_SCRIPT_QTY (ZEB-10634). */
  ignoreQuantityLimits?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreRepackReject?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreScriptTooOld?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreZeroCost?: InputMaybe<Scalars['Boolean']['input']>;
  incentiveFee?: InputMaybe<Scalars['Float']['input']>;
  limitOOP?: InputMaybe<Scalars['Float']['input']>;
  macUUID?: InputMaybe<Scalars['UUID']['input']>;
  maintenanceFlag?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  messageOnlyRts?: InputMaybe<Scalars['Boolean']['input']>;
  miscHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  naToBencap?: InputMaybe<Scalars['Boolean']['input']>;
  naToDeductible?: InputMaybe<Scalars['Boolean']['input']>;
  naToOop?: InputMaybe<Scalars['Boolean']['input']>;
  naToSdcBencap?: InputMaybe<Scalars['Boolean']['input']>;
  naToSdcDeductible?: InputMaybe<Scalars['Boolean']['input']>;
  naToSdcOop?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUseMessageIfHandlerUsed?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUseMessageIfReject?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUseMessageIfRejectAgainstLine?: InputMaybe<Scalars['Boolean']['input']>;
  oopLimitApplyDeductible?: InputMaybe<Scalars['Boolean']['input']>;
  otherAmtPaidFee?: InputMaybe<Scalars['Float']['input']>;
  overrideGroupMaxDollar?: InputMaybe<Scalars['Float']['input']>;
  overrideMACListID?: InputMaybe<Scalars['UUID']['input']>;
  overrideMACPrice?: InputMaybe<Scalars['Float']['input']>;
  pharmacyFee?: InputMaybe<Scalars['Float']['input']>;
  planPaysDaw?: InputMaybe<Scalars['Boolean']['input']>;
  preferredFlag?: InputMaybe<Scalars['Boolean']['input']>;
  refillHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  rejectCode?: InputMaybe<Scalars['String']['input']>;
  repackFlag?: InputMaybe<Scalars['Boolean']['input']>;
  return5452FValue?: InputMaybe<Scalars['String']['input']>;
  setScriptTag?: InputMaybe<Scalars['String']['input']>;
  setTier?: InputMaybe<Scalars['String']['input']>;
  skipDur?: InputMaybe<Scalars['Boolean']['input']>;
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
  treatAsMony?: InputMaybe<Scalars['String']['input']>;
  treatAsMonyCopay?: InputMaybe<Scalars['String']['input']>;
  treatAsMonyCostDispFee?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessRuleLineConnection = {
  __typename?: 'ProcessRuleLineConnection';
  edges: Array<ProcessRuleLineEdge>;
  pageInfo: PageInfo;
};

export type ProcessRuleLineCriteria = {
  __typename?: 'ProcessRuleLineCriteria';
  applyOnlyIfCompound: Scalars['Boolean']['output'];
  applyOnlyIfDMR?: Maybe<Scalars['Boolean']['output']>;
  applyOnlyIfDosageForm?: Maybe<Scalars['String']['output']>;
  applyOnlyIfEligibilityFlag?: Maybe<Scalars['UUID']['output']>;
  applyOnlyIfEligibilityFlagLabel?: Maybe<Scalars['String']['output']>;
  applyOnlyIfGroupOOPCapExceeded: Scalars['Boolean']['output'];
  applyOnlyIfMaintenance: Scalars['Boolean']['output'];
  applyOnlyIfOTC: Scalars['Boolean']['output'];
  applyOnlyIfPAPN?: Maybe<Scalars['Boolean']['output']>;
  applyOnlyIfPAPN2?: Maybe<Scalars['Boolean']['output']>;
  applyOnlyIfPAPN3?: Maybe<Scalars['Boolean']['output']>;
  applyOnlyIfRepack: Scalars['Boolean']['output'];
  applyOnlyIfUMAC: Scalars['Boolean']['output'];
  applyOnlyIfWebPricing: Scalars['Boolean']['output'];
  eligibilityFlag?: Maybe<EligibilityFlag>;
  gpiMatchDigits?: Maybe<Scalars['Int']['output']>;
  historicGPIMatchDigits?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lookbackGroupStartDateOption: Scalars['Boolean']['output'];
  matchAge?: Maybe<Scalars['String']['output']>;
  matchBrandCode?: Maybe<Scalars['String']['output']>;
  matchChainCode?: Maybe<Scalars['String']['output']>;
  matchDaysPriorSD?: Maybe<Scalars['Int']['output']>;
  matchDaysSupply?: Maybe<Scalars['String']['output']>;
  matchDxCode?: Maybe<Scalars['String']['output']>;
  matchDxCodeQual?: Maybe<Scalars['String']['output']>;
  matchFlex2?: Maybe<Scalars['String']['output']>;
  matchGender?: Maybe<Scalars['Int']['output']>;
  matchHistoricalDays?: Maybe<Scalars['Int']['output']>;
  matchLevelOfEffort?: Maybe<Scalars['String']['output']>;
  matchMemberState?: Maybe<Scalars['String']['output']>;
  matchOtherCoverageCode?: Maybe<Scalars['String']['output']>;
  matchPCN?: Maybe<Scalars['String']['output']>;
  matchPharmacy?: Maybe<Scalars['String']['output']>;
  matchPharmacyState?: Maybe<Scalars['String']['output']>;
  matchPharmacyType?: Maybe<Scalars['String']['output']>;
  matchPrescriber?: Maybe<Scalars['String']['output']>;
  matchRefillNumber?: Maybe<Scalars['String']['output']>;
  matchRouteOfAdmin?: Maybe<Scalars['String']['output']>;
  matchScriptTag?: Maybe<Scalars['String']['output']>;
  matchServiceID?: Maybe<Scalars['Int']['output']>;
  matchSubmissionClarificationCode?: Maybe<Scalars['String']['output']>;
  matchSubmittedBIN?: Maybe<Scalars['String']['output']>;
  matchSubmittedGroup?: Maybe<Scalars['String']['output']>;
  matchSubmittedPA?: Maybe<Scalars['String']['output']>;
  matchTier?: Maybe<Scalars['String']['output']>;
  mony?: Maybe<Scalars['String']['output']>;
  priorSDDays?: Maybe<Scalars['Int']['output']>;
};

export type ProcessRuleLineCriteriaInput = {
  applyOnlyIfCompound?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfDMR?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfDosageForm?: InputMaybe<Scalars['String']['input']>;
  applyOnlyIfEligibilityFlag?: InputMaybe<Scalars['UUID']['input']>;
  applyOnlyIfGroupOOPCapExceeded?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfOTC?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfPAPN?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfPAPN2?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfPAPN3?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfRepack?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfUMAC?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfWebPricing?: InputMaybe<Scalars['Boolean']['input']>;
  gpiMatchDigits?: InputMaybe<Scalars['Int']['input']>;
  historicGPIMatchDigits?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lookbackGroupStartDateOption?: InputMaybe<Scalars['Boolean']['input']>;
  matchAge?: InputMaybe<Scalars['String']['input']>;
  matchBrandCode?: InputMaybe<Scalars['String']['input']>;
  matchChainCode?: InputMaybe<Scalars['String']['input']>;
  matchDaysPriorSD?: InputMaybe<Scalars['Int']['input']>;
  matchDaysSupply?: InputMaybe<Scalars['String']['input']>;
  matchDxCode?: InputMaybe<Scalars['String']['input']>;
  matchDxCodeQual?: InputMaybe<Scalars['String']['input']>;
  matchFlex2?: InputMaybe<Scalars['String']['input']>;
  matchGender?: InputMaybe<Scalars['Int']['input']>;
  matchHistoricalDays?: InputMaybe<Scalars['Int']['input']>;
  matchLevelOfEffort?: InputMaybe<Scalars['String']['input']>;
  matchMemberState?: InputMaybe<Scalars['String']['input']>;
  matchOtherCoverageCode?: InputMaybe<Scalars['String']['input']>;
  matchPCN?: InputMaybe<Scalars['String']['input']>;
  matchPharmacy?: InputMaybe<Scalars['String']['input']>;
  matchPharmacyState?: InputMaybe<Scalars['String']['input']>;
  matchPharmacyType?: InputMaybe<Scalars['String']['input']>;
  matchPrescriber?: InputMaybe<Scalars['String']['input']>;
  matchRefillNumber?: InputMaybe<Scalars['String']['input']>;
  matchRouteOfAdmin?: InputMaybe<Scalars['String']['input']>;
  matchScriptTag?: InputMaybe<Scalars['String']['input']>;
  matchServiceID?: InputMaybe<Scalars['Int']['input']>;
  matchSubmissionClarificationCode?: InputMaybe<Scalars['String']['input']>;
  matchSubmittedBIN?: InputMaybe<Scalars['String']['input']>;
  matchSubmittedGroup?: InputMaybe<Scalars['String']['input']>;
  matchSubmittedPA?: InputMaybe<Scalars['String']['input']>;
  matchTier?: InputMaybe<Scalars['String']['input']>;
  mony?: InputMaybe<Scalars['String']['input']>;
  priorSDDays?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessRuleLineDynCond = {
  __typename?: 'ProcessRuleLineDynCond';
  dynamicField?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['ID']['output'];
  operator?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProcessRuleLineDynCondInput = {
  dynamicField?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessRuleLineEdge = {
  __typename?: 'ProcessRuleLineEdge';
  cursor: Scalars['String']['output'];
  node: ProcessRuleLine;
};

export type ProcessRuleLineError = {
  __typename?: 'ProcessRuleLineError';
  lineId: Scalars['ID']['output'];
  lineNumber: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export enum ProcessRuleLineInclusion {
  ContinueProcessing = 'CONTINUE_PROCESSING',
  ExcludeAlways = 'EXCLUDE_ALWAYS',
  IncludeAlways = 'INCLUDE_ALWAYS'
}

export type ProcessRuleLineInput = {
  action: ProcessRuleLineInclusion;
  cardholderUUID?: InputMaybe<Scalars['UUID']['input']>;
  customDrugList?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  drugType?: InputMaybe<DrugType>;
  drugValue?: InputMaybe<Scalars['String']['input']>;
  effectiveDate: Scalars['Time']['input'];
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  formularyListUUID?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  insertNetworkPMBefore?: InputMaybe<Scalars['Boolean']['input']>;
  lineNumber: Scalars['Int']['input'];
  memberUUID?: InputMaybe<Scalars['UUID']['input']>;
  physicianListUUID?: InputMaybe<Scalars['UUID']['input']>;
  processRuleLineActions?: InputMaybe<ProcessRuleLineActionsInput>;
  processRuleLineCriteria?: InputMaybe<ProcessRuleLineCriteriaInput>;
  processRuleLineDynConds?: InputMaybe<Array<InputMaybe<ProcessRuleLineDynCondInput>>>;
};

export type ProcessRuleOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  priority?: InputMaybe<OrderDirectionEnum>;
};

export type Profile = {
  __typename?: 'Profile';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  invitationSentAt?: Maybe<Scalars['Time']['output']>;
  isPasswordSet: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneCell?: Maybe<Scalars['String']['output']>;
  phoneCellVerifiedAt?: Maybe<Scalars['Time']['output']>;
  phonePrimary?: Maybe<Scalars['String']['output']>;
  phonePrimaryVerifiedAt?: Maybe<Scalars['Time']['output']>;
  phoneVerifiedAt?: Maybe<Scalars['Time']['output']>;
  secondaryVerification?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ProfileInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  person_uuid: Scalars['String']['input'];
  phonePrimary?: InputMaybe<Scalars['String']['input']>;
  phone_cell?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Provider = {
  __typename?: 'Provider';
  document?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ProviderFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type ProviderList = {
  __typename?: 'ProviderList';
  pagination: Pagination;
  results: Array<Provider>;
};

export type ProviderOrder = {
  name?: InputMaybe<OrderDirectionEnum>;
  type?: InputMaybe<OrderDirectionEnum>;
};

export type PublicDocumentation = ClientDocumentation & Node & {
  __typename?: 'PublicDocumentation';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  /** public link to resource */
  url: Scalars['URL']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Get full list of sdc */
  SDCV2?: Maybe<SdcConnection>;
  /** Get Claims List in sent_835s */
  Sent835sClaims?: Maybe<Sent835sToClaimsList>;
  /** Get Claims List which are missed in sent_835s file */
  Sent835sClaimsMissed?: Maybe<Sent835sToClaimsMissedList>;
  accounts: AccountList;
  accumTransactions?: Maybe<TransactionConnection>;
  actorS3Files: S3FileList;
  /** Get a list of AgeHandlers with filters */
  ageHandlers: AgeHandlerConnection;
  auditCorrelationGroups: AuditCorrelationGroupConnection;
  auditLogFilterOptions: AuditLogFilterOptions;
  auditLogReport: AuditLogEventConnection;
  /**
   * Returns a presigned download URL for an existing report, valid for 5 minutes
   * from generation. Kept separate from `auditReports` rather than inlined on each
   * edge, since a result list can stay on screen longer than the URL's TTL.
   */
  auditReportDownloadUrl: Scalars['URL']['output'];
  /**
   * Generates the OCR Investigation report and returns a presigned download
   * URL for the PDF, valid for 5 minutes.
   */
  auditReportOCRInvestigationPDF: Scalars['URL']['output'];
  auditReports: AuditReportConnection;
  benefitPlanDrugCoverageCopays?: Maybe<BenefitPlanDrugCoverageCopayList>;
  benefitPlanTypes: Array<BenefitPlanType>;
  benefit_plans: BenefitPlanList;
  /** Get a list of BillCostHandlers with filters */
  billCostHandlers: BillCostHandlerConnection;
  body_part_codes: BodyPartCodeList;
  boxToken?: Maybe<Scalars['String']['output']>;
  carrierCodes?: Maybe<Array<CarrierCode>>;
  /** Get a list of cases for partner portal needs */
  caseRequests?: Maybe<CaseRequestConnection>;
  chainCodeSearch: ChainCodeConnection;
  /**
   * Changelog entries have no mutations and can only be queried.
   * Fine-grain authorization will be checked within the resolver,
   * while the high-level authorization check here ensures that only
   * those who have access to the admin UI can query changelogs.
   */
  changelogEntries?: Maybe<ChangelogEntryConnection>;
  claimLookups: ClaimLookups;
  claimTransactionContext: ClaimTransactionContext;
  claimTransactions: ClaimTransactionList;
  claimTransactionsV2: ClaimTransactionListV2;
  /**
   * Returns the claims response (ClaimTransactionListV2) saved as JSON in test_case_zebra_result
   * for a given executionRunId and testCaseId.
   */
  claimsTestCaseResult: ClaimTransactionListV2;
  claimsV2: ClaimConnectionV2;
  claims_report: Report;
  clientDocumentation: ClientDocumentationConnection;
  cobs: CobConnection;
  compareLakerTestResults: TestResultList;
  connectionRelatedGroups: ConnectionRelatedGroupList;
  connectionVersions: ConnectionList;
  connections: ConnectionList;
  connectionsForGroups: ConnectionForGroupList;
  consents: ConsentConnection;
  contacts?: Maybe<ContactList>;
  /** Get a list of CopayHandlers with filters */
  copayHandlers: CopayHandlerConnection;
  /** Get a list of CostHandlers with filters */
  costHandlers: CostHandlerConnection;
  /** Get a list of CostLists with filters */
  costLists: CostListConnection;
  /** @deprecated Use groupCreateSubgroup */
  createSubgroups: SubgroupValidation;
  credentials: CredentialList;
  /**
   * Scheduled credentials moves grouped by the run that created them. Callers without root
   * access only see the runs they authored.
   *
   * Orders apply in the sequence given, one field per entry, and default to scheduledFor, status,
   * then createdAt, all descending. Give every entry the same direction: pages are cut on the
   * first entry's.
   *
   * Not audited with @audit: the results identify people by UUID only and carry no PHI.
   */
  credentialsMoveRuns: CredentialsMoveRunConnection;
  /**
   * The credentials moves of one run, for opening a run listed by credentialsMoveRuns. Callers
   * without root access only see the moves they authored.
   *
   * Orders apply in the sequence given, one field per entry, and default to oldest first.
   *
   * Not audited with @audit: the results identify people by UUID only and carry no PHI.
   */
  credentialsMoveSchedules: CredentialsMoveScheduleConnection;
  crossAccumulatorConfig?: Maybe<CrossAccumulatorConfig>;
  customDrugListsV2?: Maybe<CustomDrugListsV2Connection>;
  /** Get list of DAW Settings that may be set on a Plan DAW. */
  dawSettings: Array<DawSetting>;
  dcc_comparison: ComparisonResult;
  defaultTestCases: Array<PlanTestCase>;
  dependentAccessList: DependentAccessConnection;
  /** Get a list of DispenseFeeHandlers with filters */
  dispenseFeeHandlers: DispenseFeeHandlerConnection;
  /** Get a list of DispenseLimitHandlers with filters */
  dispenseLimitHandlers: DispenseLimitHandlerConnection;
  dosageForms: Array<DosageFormOption>;
  /**
   * Alternatives for a drug, for the Drug Catalog table.
   *
   * Returns an empty list for a drug with no alternatives. `ndc` must be 11 digits
   * and `limit` must not exceed 200; either violation is a validation error, not a
   * server error. Errors when the Drug Alternatives Service is unreachable or the
   * 2s deadline is exceeded — a `PARTIAL` enrichment is not an error and returns
   * rows with potentially incomplete coverage fields.
   */
  drugAlternatives: DrugAlternativesResponse;
  drugByNDC?: Maybe<DrugV2>;
  /**
   * Indications for a drug, for the Drug Catalog indication filter. Standalone
   * rather than a field on the alternatives payload because the dropdown is
   * populated before any alternatives query runs.
   *
   * Returns an empty list for a drug with no indications. `ndc` must be 11 digits;
   * anything else is a validation error, not a server error.
   */
  drugIndications: Array<DrugIndication>;
  drugListItemsV2?: Maybe<DrugListItemConnectionV2>;
  /** Gets and validates a drug list upload by ID */
  drugListUploadByID: CustomDrugListUpload;
  /** Gets and validates a drug list upload */
  drugListUploads?: Maybe<DrugListUploadsV2Connection>;
  drugPricing: DrugPricingResponse;
  drugPricingPlanStructures: Array<PlanStructureOption>;
  /** Get a list of drug gpis */
  drug_gpis?: Maybe<DrugGpiList>;
  drug_lists: PlanDrugList;
  drug_programs?: Maybe<Array<DrugProgram>>;
  /** Get a list of drugs */
  drugs?: Maybe<DrugList>;
  /** Get a list of DURAgeComponent with filters */
  durAgeComponents: DurAgeComponentConnection;
  /** Get a list of DURComplianceComponent with filters */
  durComplianceComponents: DurComplianceComponentConnection;
  /** Get a list of DUR Dose Maintenance components with filters */
  durDoseMaintenanceComponents: DurDoseMaintenanceComponentConnection;
  /** Get a list of DURDrugToDrugComponent with filters */
  durDrugToDrugComponents: DurDrugToDrugComponentConnection;
  /** Get a list of DURDupDrugComponent with filters */
  durDupDrugComponents: DurDupDrugComponentConnection;
  /** Get a list of DUR Dup Therapy components with filters */
  durDupTherapyComponents: DurDupTherapyComponentConnection;
  /** Get a list of DURGenderComponent with filters */
  durGenderComponents: DurGenderComponentConnection;
  /** Get a list of DUR Ingredient components with filters */
  durIngredientComponents: DurIngredientComponentConnection;
  /** Get a list of DUR Programs with filters */
  durPrograms: DurProgramConnection;
  /** Get the list of elig flags */
  eligFlags?: Maybe<Array<EligFlag>>;
  eligibilityFlags: Array<EligibilityFlag>;
  exceptionLists?: Maybe<ListOfExceptionLists>;
  exceptions?: Maybe<ListOfExceptions>;
  /** Export a MAC List as a .csv file */
  exportMACList?: Maybe<Scalars['URL']['output']>;
  /** Search fill rules */
  fillRules: FillRuleConnection;
  /**
   * # Filter options for changelog entries based on the resource type and ID.
   * Fine-grain authorization will be checked within the resolver,
   * while the high-level authorization check here ensures that only
   * those who have access to the admin UI can query changelog filters.
   */
  filterOptionsForChangelogEntries?: Maybe<ChangelogEntryFilterOptions>;
  /** Retrieve one or more formularies by ID or Name, the drugs field is filterable by NDC */
  formularies?: Maybe<FormularyList>;
  /**
   * Returns the tier, prior authorization and step therapy status of each
   * requested NDC on the given formulary.
   *
   * This is a lean alternative to benefitPlanDrugCoverageCopays for callers that
   * only need formulary enrichment. It reads formulary_drug directly and does not
   * compute coverage, copay, allowances or drug programs, so it costs a single
   * indexed query for the whole batch.
   *
   * Every requested NDC is returned, so the caller does not have to reconcile the
   * response against the request. An NDC that is not on the formulary comes back
   * with status NON_FORMULARY and null enrichment fields rather than being
   * omitted. Duplicate NDCs in the request are collapsed, and results are ordered
   * by NDC.
   */
  formularyDrugStatuses: Array<FormularyDrugStatus>;
  /** Generate Claim Files And Store In S3 */
  generateClaimsFile?: Maybe<Scalars['String']['output']>;
  generateClaimsFileV2?: Maybe<Scalars['String']['output']>;
  /** Exports selected rows, or the filtered set when ids is empty, in table column order. */
  generateMPAFileV2?: Maybe<MpaExportFileV2>;
  getAppleWalletMemberCardPass?: Maybe<AppleWalletPass>;
  getAssociatedClaims: ClaimConnectionV2;
  /** Gets Designated Pharmacy by Query */
  getBenefitPlansByNetworkAndGroup: Array<Maybe<BenefitPlanNetworkType>>;
  /**
   * Get a list of cases for member portal needs.
   * Returns PA, Connect, and MSS cases. Does not return Mail Order cases.
   */
  getCaseRequest?: Maybe<Array<Maybe<CaseRequest>>>;
  /**
   * Get detailed breakdown of operations by type.
   * Returns empty array if file is not a CROSSWALK_IMPORT job type.
   */
  getCrosswalkOperationBreakdown: Array<CrosswalkOperationBreakdown>;
  /**
   * Get crosswalk operation statistics for an IFP file.
   * Returns null if file is not a CROSSWALK_IMPORT job type.
   */
  getCrosswalkStats?: Maybe<CrosswalkOperationStats>;
  /** Gets Designated Pharmacy by Query */
  getDesignatedPharmacies: Array<Maybe<DesignatedPharmacy>>;
  getDrugs: DrugConnectionV2;
  getGoogleWalletMemberCardPass?: Maybe<GoogleWalletPass>;
  /**
   * Get Mail Order cases for member portal.
   * Returns only MailOrderRequest cases with pathway recommendations.
   */
  getMailOrderCases: Array<MailOrderRequest>;
  grandfatherMatching: GrandfatherMatchingResponse;
  /**
   * Assesses the impact of adding a new schedule to a Plan Code.
   * Returns the list of subgroup detail changes needed to keep subgroup
   * coverage synchronized. Does NOT persist any changes.
   */
  groupAssessCreatePlanCodeScheduleImpact: PlanCodeScheduleImpactAssessment;
  /**
   * Assesses the impact of deleting a single plan code schedule record.
   * Returns the synced subgroup details that would be deleted and an
   * assessment token used to confirm the deletion. Does NOT persist any changes.
   */
  groupAssessDeletePlanCodeScheduleImpact: DeletePlanCodeScheduleImpactAssessment;
  /**
   * Assesses the impact of modifying a plan code schedule's coverage range
   * (effectiveDate or expirationDate) or its benefit plan (benefitPlanId).
   * Returns the list of subgroup detail changes needed to keep coverage
   * synchronized: expansions, truncations and deletions for a coverage range
   * change, and resyncs for a benefit plan change. Does NOT persist any
   * changes. Modifying both ends of the coverage range in a single call is
   * rejected.
   */
  groupAssessUpdatePlanCodeImpact: UpdatePlanCodeImpactAssessment;
  groups?: Maybe<GroupList>;
  icd_codes: IcdCodeList;
  /**
   * Paginated list of IFPFiles, with filtering and ordering options.
   *
   * Authorization: If no jobType filter is provided, automatically returns files for all job types
   * the user has permission to view. If jobType filter is provided, validates the user has permission
   * for the requested job types and returns an error if unauthorized.
   *
   * Audited: the list is file metadata only, but it is the hop an operator takes
   * before drilling into `rows`, so the read trail records it too.
   */
  ifpFiles: IfpFileConnection;
  /** Detail page: manual with pendingCandidates and createdCandidates in one round trip. */
  implementationManualUpload?: Maybe<ImplementationManualUpload>;
  /** List page: work items with their status. The Initiate Test landing view. */
  implementationManualUploads: ImplementationManualUploadConnection;
  incomingTransmissionFormatPreview?: Maybe<Array<Maybe<Scalars['Map']['output']>>>;
  /**
   * Previews a config, and reports why any lines are missing from the result.
   * Prefer this over incomingTransmissionFormatPreview, which cannot tell a
   * config that dropped every line apart from an empty sample file.
   *
   * Null when dredd is not configured for the environment, the same as
   * incomingTransmissionFormatPreview.
   *
   * Carries no authz directive, deliberately matching
   * incomingTransmissionFormatPreview: dredd's own preview routes admit only
   * SmithRx Admin and SmithRx Super Admin, and gating the two fields differently
   * would let a config author reach one preview but not the other. Gate both, or
   * neither.
   */
  incomingTransmissionFormatPreviewV2?: Maybe<TransmissionFormatPreview>;
  invoiceConfigs?: Maybe<InvoiceConfigList>;
  /** Search and paginate Laker MPA records. */
  lakerMPAs?: Maybe<LakerMpaConnection>;
  listBatchJobStatuses: BatchSyncJobStatusConnection;
  listMembershipSyncs: MembershipSyncConnection;
  /** Get token from the current embed looker session or start a new one */
  lookerEmbedSession?: Maybe<LookerEmbedTokens>;
  /** Get tokens for cookie-less session when api_token expired */
  lookerEmbedTokens?: Maybe<LookerEmbedTokens>;
  /** Download a pdf file with all reports combined */
  lookerReportDownloadURL?: Maybe<Scalars['String']['output']>;
  /** Search MAC Lists */
  maclists: MacListConnection;
  matchRule: MatchRuleList;
  match_rule_drugs: DrugList;
  memberByKeyV2?: Maybe<MemberV2>;
  /**
   * Drug coverage under the current plan of one of the caller's own memberships.
   * A search matching more than 200 drugs fails with code DRUG_SEARCH_TOO_BROAD;
   * a membership without active coverage fails with code COVERAGE_UNAVAILABLE.
   */
  memberDrugCoverageCopays?: Maybe<MemberDrugCoverageConnection>;
  /** Retrieve options from member_drug_lookup_link_option table, no filter, order by name of the option */
  memberDrugLookupLinkOption?: Maybe<MemberDrugLookupLinkOptionList>;
  /** Get full list of member accumulators */
  memberFullReplacementAccumulator?: Maybe<MemberFullReplacementAccumulatorList>;
  /** Get full list of member medical claims */
  memberMedicalClaim?: Maybe<MemberMedicalClaimList>;
  memberPriorAuthorizationsV2: Mpav2Connection;
  /** Get a list of members */
  members?: Maybe<MemberList>;
  /**
   * Relay-paginated list of members sourced from the v2 (Zebra) member service.
   *
   * Every member carries its UUID twice: `id` holds the bare member UUID, and
   * `patient_id` the public identifier form of that same UUID.
   *
   * The `where.id` filter accepts either form, so pass back whichever of the two
   * this query returned. Filtering by the public identifier gets the identifier's
   * own kind of record checked, so one naming something other than a member is
   * rejected by name; a bare UUID naming something else is unverifiable and simply
   * resolves to no member.
   */
  membersV2: MemberConnection;
  /** Get a list of MiscHandlers with filters */
  miscHandlers: MiscHandlerConnection;
  /**
   * Lists every available MPA template as summaries (key, name, version,
   * description), in the order they should appear in the picker. Use it to
   * populate the template picker; pass a chosen template's `key` to
   * `overrideMPAWithTemplate` to prefill an MPA from it.
   */
  mpaTemplates: Array<MpaTemplateInfo>;
  /** Get a list of Nachas */
  nachas: NachaList;
  ncpdpRejections: NcpdpRejectionList;
  /** Fetches an object given its GID */
  node?: Maybe<Node>;
  onboarding?: Maybe<OnboardingProgressList>;
  onboardingTasks?: Maybe<Array<OnboardingTask>>;
  partners?: Maybe<PartnerList>;
  /** Get a list of all payees. */
  payees: PayeeList;
  pcrJobs: PcrJobConnection;
  pharmacies?: Maybe<PharmacyList>;
  pharmaciesV2?: Maybe<PharmacyConnection>;
  pharmacyNetworkPrograms?: Maybe<PharmacyNetworkProgramList>;
  pharmacyNetworks: PharmacyNetworkConnection;
  plan: Plan;
  planCOBs: Array<PlanToCob>;
  planCodesV2?: Maybe<PlanCodeV2List>;
  /** Get Plan DAW associated with a Plan. */
  planDAW?: Maybe<PlanDaw>;
  /** Get Plan DUR Programs by Plan ID */
  planDURPrograms: Array<PlanDurProgram>;
  planFillRules?: Maybe<Array<PlanFillRule>>;
  /** Get list of step therapies for a plan */
  planStepTherapies?: Maybe<Array<PlanStepTherapy>>;
  /**
   * Get smart assignment data for plan test suite creation
   * Returns auto-selected subgroup and template based on business rules
   * Supports batch queries for multiple groups and plans with cursor pagination
   */
  planTestAssignment: PlanTestAssignmentConnection;
  planTestCases: PlanTestCaseList;
  planTestSuite?: Maybe<PlanTestSuite>;
  planTestSuiteGroupsSubgroups: Array<Maybe<PlanTestSuiteGroupsSubgroups>>;
  planTestSuites?: Maybe<PlanTestSuiteList>;
  /** Get available templates from Golden Test Library (shared across all assignments) */
  planTestTemplates: Array<PlanTestAssignmentTemplate>;
  plan_rule_drugs: DrugList;
  /**
   * [MPXT-694] TODO: update plan_rules resolver to fork permissions on Portal.PlanProgram.Read and Portal.PlanConfiguration.Read
   * depending on if `type` includes standard_elective, program_standard, or program_custom ( this would need Portal.PlanProgram.Read )
   * and then remove the @authz here
   */
  plan_rules?: Maybe<PlanRuleList>;
  plan_rules_drugs: DrugList;
  plans: PlanConnection;
  portalEligibilityReport: EligibilityReport;
  prescriberImportStatus: PrescriberImportStatus;
  /** Query prescriber list details with filtering and pagination */
  prescriberListDetails: PrescriberListDetailConnection;
  /** Search Prescriber Lists */
  prescriberLists: PrescriberListConnection;
  prescribersV2?: Maybe<PrescriberConnection>;
  /** Get a list of Process Rule Attachments with filters and order by priority */
  processRuleAttachments: ProcessRuleAttachmentConnection;
  processRuleLine: ProcessRuleLine;
  /** Get a list of Process Rules with filters */
  processRuleV2: ProcessRuleConnection;
  providers?: Maybe<ProviderList>;
  /** Get a list of RefillHandlers with filters */
  refillHandlers: RefillHandlerConnection;
  relationshipsForGroup?: Maybe<RelationshipsForGroupList>;
  /** Returns a list of operations and metadata required to compose a UI to create a transmission format. */
  reportFormatOperations: ReportFormatOperationsResponse;
  reprocessorBatch?: Maybe<ReprocessorBatch>;
  reprocessorBatches: ReprocessorBatchConnection;
  resultsFile?: Maybe<Scalars['String']['output']>;
  rolesV2: Array<RoleV2>;
  s3FileLink: S3FileLink;
  s3Files: S3FileList;
  /** Get full list of sdc accum store */
  sDCAccumTransactions?: Maybe<SdcAccumTransactionsList>;
  /** Get full list of member sdcs */
  sDCAccumsStore?: Maybe<SdcAccumsStoreList>;
  /** Get full list of sdc configs */
  sDCConfig?: Maybe<SdcConfigList>;
  sDCTotalsByMember?: Maybe<SdcTotalsConnection>;
  /** Get a list of sent_835s */
  sent835s: Sent835List;
  /** session returns metadata about the user of the currently active session */
  session?: Maybe<User>;
  /** Get a list of SQS Request */
  sqs_request?: Maybe<SqsRequestList>;
  /** Search step therapies */
  stepTherapiesV2: StepTherapyConnection;
  /** Search step therapy lines */
  stepTherapyLinesV2: StepTherapyLineConnection;
  superNetworks?: Maybe<SuperNetworkList>;
  terminologies: TerminologyList;
  testMemberIDs: Array<TestMember>;
  testRunExecutions: TestRunExecutionConnection;
  testRuns: TestRunConnection;
  /**
   * Tiers returns the list of tiers available in a given formulary
   * id is the ID of the formulary for which we want to get the possible Tiers.
   */
  tiers: Array<Tier>;
  /**
   * Describes every transform callback a DreddConfig may name: its label, argument
   * shape, and whether it can be chained. Lets the config form offer what dredd
   * actually supports, rather than a list maintained here and in portals that can
   * disagree with dredd silently.
   *
   * Deliberately an opaque Map, matching how DreddTransformer already treats
   * `callback` and `args`. Typing it out would mean a forge schema change and a
   * redeploy every time dredd adds a callback, which is the coupling this field
   * exists to remove.
   *
   * Null when dredd is not configured for the environment, the same as the preview
   * fields above.
   *
   * Carries no @audit directive: the response describes dredd's build, is identical
   * for every caller and holds no member data. It changes only when dredd is
   * deployed, so a client may cache it.
   */
  transformCallbackManifest?: Maybe<Scalars['Map']['output']>;
  /** Returns the possible column delimiters */
  transmissionFormatDelimiters?: Maybe<Array<TransmissionFormatDelimiter>>;
  /** Returns a list of source key names and their types given a section_type from transmissionFormatSectionTypes. */
  transmissionFormatFieldsForSection: ReportTypeSectionFieldsResponse;
  /** Returns the set of all supported section_type parameters for input to transmissionFormatFieldsForSection. */
  transmissionFormatSectionTypes: ReportTypeListResponse;
  transmissionFormats: TransmissionFormatList;
  transmissionJobs: TransmissionJobList;
  udtGetAllConnectProgramRestrictions: Array<ConnectProgramRestrictions>;
  udtGetAllStateBasedRestrictions: Array<StateBasedRestrictions>;
  udtGetFeatureFlag: Scalars['Boolean']['output'];
  /** @deprecated Use groupCreateSubgroup */
  validateSubgroups: SubgroupValidation;
  /** Retrieve version data about the server */
  version: Version;
  whatsMyCopay?: Maybe<WhatsMyCopayList>;
  whatsMyCopayV2?: Maybe<WhatsMyCopayV2Connection>;
  /**
   * Download an Excel workbook of every entity that references the entity of `searchByEntityType` matching `searchByUUID`, one tab per result entity type.
   *
   * Deliberately takes no where/order/pagination arguments. An export is always the whole dataset, so a filtered export is not expressible here.
   *
   * Returns an error, and no workbook, when any tab would have more than 1,048,000 rows.
   */
  whereUsedExportURL?: Maybe<Scalars['String']['output']>;
  zebraCrossAccumulatorConfig?: Maybe<ZebraCrossAccumulatorConfig>;
};


export type QuerySdcv2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SdcOrderV2>;
  where?: InputMaybe<SdcFiltersV2>;
};


export type QuerySent835sClaimsArgs = {
  order?: InputMaybe<Sent835sToClaimsOrder>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<Sent835sToClaimsFilters>;
};


export type QuerySent835sClaimsMissedArgs = {
  order?: InputMaybe<Sent835sToClaimsOrder>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<Sent835sToClaimsMissedFilters>;
};


export type QueryAccountsArgs = {
  order?: InputMaybe<Array<AccountOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<AccountFilters>;
};


export type QueryAccumTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where: TransactionFilters;
};


export type QueryActorS3FilesArgs = {
  order?: InputMaybe<Array<S3FileOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<ActorS3FileFilters>;
};


export type QueryAgeHandlersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<AgeHandlerOrder>;
  where?: InputMaybe<AgeHandlerFilters>;
};


export type QueryAuditCorrelationGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AuditLogOrder>>;
  where?: InputMaybe<AuditLogFilters>;
};


export type QueryAuditLogReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AuditLogOrder>>;
  where?: InputMaybe<AuditLogFilters>;
};


export type QueryAuditReportDownloadUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuditReportOcrInvestigationPdfArgs = {
  where: AuditReportOcrInvestigationRequest;
};


export type QueryAuditReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBenefitPlanDrugCoverageCopaysArgs = {
  input: DrugCoverageCopayInput;
  order?: InputMaybe<Array<DrugCoverageCopayOrder>>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryBenefitPlansArgs = {
  order?: InputMaybe<Array<InputMaybe<BenefitPlanOrder>>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<BenefitPlanFilters>;
};


export type QueryBillCostHandlersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<BillCostHandlerOrder>;
  where?: InputMaybe<BillCostHandlerFilters>;
};


export type QueryBodyPartCodesArgs = {
  order?: InputMaybe<Array<InputMaybe<BodyPartCodeOrder>>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<BodyPartCodeFilters>;
};


export type QueryCaseRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<CaseRequestOrder>;
  where?: InputMaybe<CaseRequestFilters>;
};


export type QueryChainCodeSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChainCodeFilters>;
};


export type QueryChangelogEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ChangelogEntryOrder>;
  relationshipFilters?: InputMaybe<Array<RelationshipFilter>>;
  where?: InputMaybe<ChangelogEntryFilters>;
};


export type QueryClaimTransactionContextArgs = {
  claimsUUID: Scalars['UUID']['input'];
  dateOfService: Scalars['Time']['input'];
};


export type QueryClaimTransactionsArgs = {
  order: Array<ClaimTransactionOrder>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<ClaimTransactionFilters>;
};


export type QueryClaimTransactionsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeImportedClaims?: InputMaybe<IncludeImportedClaims>;
  includeTestClaims?: InputMaybe<IncludeTestClaims>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order: Array<ClaimTransactionOrderV2>;
  types: Array<ClaimTypeV2>;
  where?: InputMaybe<ClaimTransactionFiltersV2>;
};


export type QueryClaimsTestCaseResultArgs = {
  testCaseResultID: Scalars['ID']['input'];
};


export type QueryClaimsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<ClaimFilterV2>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeImportedClaims?: InputMaybe<IncludeImportedClaims>;
  includeTestClaims?: InputMaybe<IncludeTestClaims>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClaimOrderV2>>;
  types?: InputMaybe<Array<ClaimTypeV2>>;
};


export type QueryClaimsReportArgs = {
  order?: InputMaybe<Array<ReportOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<ReportFilters>;
};


export type QueryClientDocumentationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ClientDocumentationOrder>;
  where?: InputMaybe<ClientDocumentationFilters>;
};


export type QueryCobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<CobOrder>;
  where?: InputMaybe<CobFilters>;
};


export type QueryCompareLakerTestResultsArgs = {
  input?: InputMaybe<LakerOuputFileInput>;
};


export type QueryConnectionRelatedGroupsArgs = {
  where?: InputMaybe<ConnectionRelatedGroupFilters>;
};


export type QueryConnectionVersionsArgs = {
  order?: InputMaybe<Array<ConnectionVersionOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<ConnectionVersionFilters>;
};


export type QueryConnectionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<ConnectionFilters>;
};


export type QueryConnectionsForGroupsArgs = {
  order?: InputMaybe<Array<ConnectionForGroupOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<ConnectionForGroupFilters>;
};


export type QueryConsentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ConsentOrder>;
  where?: InputMaybe<ConsentFilters>;
};


export type QueryContactsArgs = {
  order?: InputMaybe<ContactOrder>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<ContactFilters>;
};


export type QueryCopayHandlersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<CopayHandlerOrder>;
  where?: InputMaybe<CopayHandlerFilters>;
};


export type QueryCostHandlersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<CostHandlerOrder>;
  where?: InputMaybe<CostHandlerFilters>;
};


export type QueryCostListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<CostListOrder>;
  where?: InputMaybe<CostListFilters>;
};


export type QueryCreateSubgroupsArgs = {
  input: SubgroupCreatorInput;
};


export type QueryCredentialsArgs = {
  order?: InputMaybe<Array<CredentialOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<CredentialFilters>;
};


export type QueryCredentialsMoveRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CredentialsMoveRunOrder>>;
  where?: InputMaybe<CredentialsMoveRunFilters>;
};


export type QueryCredentialsMoveSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CredentialsMoveScheduleOrder>>;
  runUUID: Scalars['UUID']['input'];
  where?: InputMaybe<CredentialsMoveScheduleFilters>;
};


export type QueryCrossAccumulatorConfigArgs = {
  input: CrossAccumulatorConfigInput;
};


export type QueryCustomDrugListsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<CustomDrugListOrderV2>;
  where?: InputMaybe<CustomDrugListFiltersV2>;
};


export type QueryDccComparisonArgs = {
  ndcs?: InputMaybe<Array<Scalars['String']['input']>>;
  plan_id: Scalars['ID']['input'];
};


export type QueryDependentAccessListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDispenseFeeHandlersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DispenseFeeHandlerOrder>;
  where?: InputMaybe<DispenseFeeHandlerFilters>;
};


export type QueryDispenseLimitHandlersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DispenseLimitHandlerOrder>;
  where?: InputMaybe<DispenseLimitHandlerFilters>;
};


export type QueryDrugAlternativesArgs = {
  input: DrugAlternativesInput;
  order?: InputMaybe<DrugAlternativesOrder>;
};


export type QueryDrugByNdcArgs = {
  ndc: Scalars['String']['input'];
};


export type QueryDrugIndicationsArgs = {
  ndc: Scalars['String']['input'];
};


export type QueryDrugListItemsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DrugListItemOrderV2>>;
  where?: InputMaybe<DrugListItemFiltersV2>;
};


export type QueryDrugListUploadByIdArgs = {
  input: DrugListUploadByIdInput;
};


export type QueryDrugListUploadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DrugListUploadFiltersV2>;
};


export type QueryDrugPricingArgs = {
  input?: InputMaybe<DrugPricingInput>;
  order?: InputMaybe<DrugPricingOrder>;
};


export type QueryDrugGpisArgs = {
  order?: InputMaybe<Array<DrugGpiOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<DrugGpiFilters>;
};


export type QueryDrugListsArgs = {
  order?: InputMaybe<Array<PlanDrugListOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PlanDrugListFilters>;
};


export type QueryDrugProgramsArgs = {
  benefit_plan_code: Scalars['String']['input'];
};


export type QueryDrugsArgs = {
  order?: InputMaybe<Array<DrugOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<DrugFilters>;
};


export type QueryDurAgeComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DurComponentOrder>;
  where?: InputMaybe<DurComponentFilters>;
};


export type QueryDurComplianceComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DurComponentOrder>;
  where?: InputMaybe<DurComponentFilters>;
};


export type QueryDurDoseMaintenanceComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DurComponentOrder>;
  where?: InputMaybe<DurComponentFilters>;
};


export type QueryDurDrugToDrugComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DurComponentOrder>;
  where?: InputMaybe<DurComponentFilters>;
};


export type QueryDurDupDrugComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DurComponentOrder>;
  where?: InputMaybe<DurComponentFilters>;
};


export type QueryDurDupTherapyComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DurComponentOrder>;
  where?: InputMaybe<DurComponentFilters>;
};


export type QueryDurGenderComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DurComponentOrder>;
  where?: InputMaybe<DurComponentFilters>;
};


export type QueryDurIngredientComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DurComponentOrder>;
  where?: InputMaybe<DurComponentFilters>;
};


export type QueryDurProgramsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DurProgramOrder>;
  where?: InputMaybe<DurProgramFilters>;
};


export type QueryExceptionListsArgs = {
  order?: InputMaybe<Array<ExceptionListOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<ExceptionListFilters>;
};


export type QueryExceptionsArgs = {
  order?: InputMaybe<Array<ExceptionOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<ExceptionFilters>;
};


export type QueryExportMacListArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<MacListEntryOrder>;
  where?: InputMaybe<MacListEntryFilters>;
};


export type QueryFillRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<PlanDependencyOrder>;
  where?: InputMaybe<PlanDependencyFilters>;
};


export type QueryFilterOptionsForChangelogEntriesArgs = {
  filter?: InputMaybe<ChangelogEntryFilterOptionsInput>;
};


export type QueryFormulariesArgs = {
  order?: InputMaybe<Array<FormularyOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<FormularyFilters>;
};


export type QueryFormularyDrugStatusesArgs = {
  input: FormularyDrugStatusInput;
};


export type QueryGenerateClaimsFileArgs = {
  where?: InputMaybe<ClaimTransactionFilters>;
};


export type QueryGenerateClaimsFileV2Args = {
  includeImportedClaims?: InputMaybe<IncludeImportedClaims>;
  includeTestClaims?: InputMaybe<IncludeTestClaims>;
  order: Array<ClaimTransactionOrderV2>;
  types: Array<ClaimTypeV2>;
  where?: InputMaybe<ClaimTransactionFiltersV2>;
};


export type QueryGenerateMpaFileV2Args = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  order?: InputMaybe<MpaOrderV2>;
  where?: InputMaybe<MpaFiltersV2>;
};


export type QueryGetAssociatedClaimsArgs = {
  claim_set_id: Scalars['ID']['input'];
};


export type QueryGetBenefitPlansByNetworkAndGroupArgs = {
  groupID: Scalars['String']['input'];
  networkType?: InputMaybe<DesignatedPharmacyNetworkType>;
};


export type QueryGetCaseRequestArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  memberID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetCrosswalkOperationBreakdownArgs = {
  ifpFileID: Scalars['UUID']['input'];
};


export type QueryGetCrosswalkStatsArgs = {
  ifpFileID: Scalars['UUID']['input'];
};


export type QueryGetDesignatedPharmaciesArgs = {
  where: DesignatedPharmacyFilter;
};


export type QueryGetDrugsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DrugOrderV2>;
  where?: InputMaybe<DrugFilterV2>;
};


export type QueryGetMailOrderCasesArgs = {
  memberID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGrandfatherMatchingArgs = {
  input: GrandfatherMatchingInput;
};


export type QueryGroupAssessCreatePlanCodeScheduleImpactArgs = {
  input: CreatePlanCodeScheduleInput;
};


export type QueryGroupAssessDeletePlanCodeScheduleImpactArgs = {
  input: DeletePlanCodeScheduleInput;
};


export type QueryGroupAssessUpdatePlanCodeImpactArgs = {
  input: UpdatePlanCodeV2Input;
};


export type QueryGroupsArgs = {
  order?: InputMaybe<Array<GroupOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<GroupFilters>;
};


export type QueryIcdCodesArgs = {
  order?: InputMaybe<Array<InputMaybe<IcdCodeOrder>>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<IcdCodeFilters>;
};


export type QueryIfpFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<IfpFileOrder>;
  where?: InputMaybe<IfpFileFilters>;
};


export type QueryImplementationManualUploadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImplementationManualUploadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImplementationManualUploadFilters>;
};


export type QueryIncomingTransmissionFormatPreviewArgs = {
  config: DreddConfig;
  file: Scalars['String']['input'];
};


export type QueryIncomingTransmissionFormatPreviewV2Args = {
  config: DreddConfig;
  file: Scalars['String']['input'];
};


export type QueryInvoiceConfigsArgs = {
  order?: InputMaybe<Array<InvoiceConfigOrder>>;
  where?: InputMaybe<InvoiceConfigFilters>;
};


export type QueryLakerMpAsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<LakerMpaOrder>;
  where?: InputMaybe<LakerMpaFilters>;
};


export type QueryListBatchJobStatusesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ListBatchSyncJobStatusesFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orders?: InputMaybe<Array<ListBatchDataSyncJobsOrder>>;
};


export type QueryListMembershipSyncsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters: ListMembershipSyncsFilters;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orders?: InputMaybe<Array<ListMembershipSyncsOrder>>;
};


export type QueryLookerEmbedTokensArgs = {
  input: LookerTokensInput;
};


export type QueryLookerReportDownloadUrlArgs = {
  where?: InputMaybe<LookerReportDownloadInput>;
};


export type QueryMaclistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<MacListOrder>;
  where?: InputMaybe<MacListFilters>;
};


export type QueryMatchRuleArgs = {
  order?: InputMaybe<Array<InputMaybe<MatchRuleOrder>>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MatchRuleFilters>;
};


export type QueryMatchRuleDrugsArgs = {
  order?: InputMaybe<Array<InputMaybe<MatchRuleDrugOrder>>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MatchRuleDrugFilters>;
};


export type QueryMemberByKeyV2Args = {
  key: MemberKeyV2;
};


export type QueryMemberDrugCoverageCopaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: MemberDrugCoverageInput;
  last?: InputMaybe<Scalars['Int']['input']>;
  memberId: Scalars['String']['input'];
  order?: InputMaybe<Array<MemberDrugCoverageOrder>>;
};


export type QueryMemberFullReplacementAccumulatorArgs = {
  where?: InputMaybe<MemberFullReplacementAccumulatorFilters>;
};


export type QueryMemberMedicalClaimArgs = {
  order?: InputMaybe<Array<MemberMedicalClaimOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MemberMedicalClaimFilters>;
};


export type QueryMemberPriorAuthorizationsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<MpaOrderV2>;
  where?: InputMaybe<MpaFiltersV2>;
};


export type QueryMembersArgs = {
  order?: InputMaybe<Array<MemberOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MemberFilters>;
};


export type QueryMembersV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MemberOrder>>;
  where?: InputMaybe<MemberFilters>;
};


export type QueryMiscHandlersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<MiscHandlerOrder>;
  where?: InputMaybe<MiscHandlerFilters>;
};


export type QueryNachasArgs = {
  order?: InputMaybe<NachaOrder>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<NachaFilters>;
};


export type QueryNcpdpRejectionsArgs = {
  order: NcpdpRejectionOrder;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<NcpdpRejectionFilters>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOnboardingArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<OnboardingFilters>;
};


export type QueryPartnersArgs = {
  order?: InputMaybe<Array<PartnerOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PartnerFilters>;
};


export type QueryPayeesArgs = {
  order?: InputMaybe<Array<PayeeOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PayeeFilters>;
};


export type QueryPcrJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<PcrJobOrder>;
  where?: InputMaybe<PcrJobFilters>;
};


export type QueryPharmaciesArgs = {
  order?: InputMaybe<Array<PharmacyOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PharmacyFilters>;
};


export type QueryPharmaciesV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<PharmacyOrderV2>;
  where?: InputMaybe<PharmacyFiltersV2>;
};


export type QueryPharmacyNetworkProgramsArgs = {
  order?: InputMaybe<Array<PharmacyNetworkProgramOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PharmacyNetworkProgramFilters>;
};


export type QueryPharmacyNetworksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<PharmacyNetworkOrder>;
  where?: InputMaybe<PharmacyNetworkFilters>;
};


export type QueryPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlanCoBsArgs = {
  planID: Scalars['ID']['input'];
};


export type QueryPlanCodesV2Args = {
  order?: InputMaybe<Array<PlanCodeV2Order>>;
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PlanStatusEnum>;
  where?: InputMaybe<PlanCodeV2Filters>;
};


export type QueryPlanDawArgs = {
  planUUID: Scalars['ID']['input'];
};


export type QueryPlanDurProgramsArgs = {
  planID: Scalars['ID']['input'];
};


export type QueryPlanFillRulesArgs = {
  planID: Scalars['ID']['input'];
};


export type QueryPlanStepTherapiesArgs = {
  planID: Scalars['ID']['input'];
};


export type QueryPlanTestAssignmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where: PlanTestAssignmentFilters;
};


export type QueryPlanTestCasesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: PlanTestCaseFilters;
};


export type QueryPlanTestSuiteArgs = {
  where: PlanTestSuiteIdFilter;
};


export type QueryPlanTestSuiteGroupsSubgroupsArgs = {
  where: PlanTestSuiteGroupSubgroupFilters;
};


export type QueryPlanTestSuitesArgs = {
  order?: InputMaybe<Array<PlanTestSuiteOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PlanTestSuiteFilters>;
};


export type QueryPlanRuleDrugsArgs = {
  order?: InputMaybe<Array<InputMaybe<MatchRuleDrugOrder>>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PlanRuleDrugFilters>;
};


export type QueryPlanRulesArgs = {
  order?: InputMaybe<Array<InputMaybe<PlanRuleOrder>>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PlanRuleFilters>;
};


export type QueryPlanRulesDrugsArgs = {
  order?: InputMaybe<Array<InputMaybe<MatchRuleDrugOrder>>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PlanRulesDrugFilters>;
};


export type QueryPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<PlanOrder>;
  where?: InputMaybe<PlanFilters>;
};


export type QueryPortalEligibilityReportArgs = {
  order?: InputMaybe<Array<EligibilityReportOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<EligibilityReportFilters>;
};


export type QueryPrescriberListDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<PrescriberListDetailOrder>;
  where?: InputMaybe<PrescriberListDetailFilters>;
};


export type QueryPrescriberListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<PrescriberListOrder>;
  where?: InputMaybe<PrescriberListFilters>;
};


export type QueryPrescribersV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<PrescriberOrderV2>;
  where?: InputMaybe<PrescriberFiltersV2>;
};


export type QueryProcessRuleAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ProcessRuleOrder>;
  where?: InputMaybe<ProcessRuleFilters>;
};


export type QueryProcessRuleLineArgs = {
  ID: Scalars['ID']['input'];
};


export type QueryProcessRuleV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ProcessRuleOrder>;
  where?: InputMaybe<ProcessRuleFilters>;
};


export type QueryProvidersArgs = {
  order?: InputMaybe<Array<ProviderOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<ProviderFilters>;
};


export type QueryRefillHandlersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<RefillHandlerOrder>;
  where?: InputMaybe<RefillHandlerFilters>;
};


export type QueryRelationshipsForGroupArgs = {
  where?: InputMaybe<RelationshipsForGroupFilters>;
};


export type QueryReprocessorBatchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReprocessorBatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ReprocessorBatchOrder>;
  where?: InputMaybe<ReprocessorBatchFilters>;
};


export type QueryResultsFileArgs = {
  fileID: Scalars['ID']['input'];
};


export type QueryS3FileLinkArgs = {
  where: S3FileLinkFilters;
};


export type QueryS3FilesArgs = {
  order?: InputMaybe<Array<S3FileOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<S3FileFilters>;
};


export type QuerySDcAccumTransactionsArgs = {
  order?: InputMaybe<Array<SdcAccumTransactionsOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<SdcAccumTransactionsFilters>;
};


export type QuerySDcAccumsStoreArgs = {
  where: SdcAccumsStoreFilters;
};


export type QuerySDcConfigArgs = {
  where: SdcConfigFilters;
};


export type QuerySDcTotalsByMemberArgs = {
  where: SdcTotalsFilters;
};


export type QuerySent835sArgs = {
  order?: InputMaybe<Array<Sent835Order>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<Sent835Filters>;
};


export type QuerySqsRequestArgs = {
  order?: InputMaybe<SqsRequestOrder>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<SqsRequestFilters>;
};


export type QueryStepTherapiesV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<PlanDependencyOrder>;
  where?: InputMaybe<PlanDependencyFilters>;
};


export type QueryStepTherapyLinesV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  stepTherapyID: Scalars['ID']['input'];
};


export type QuerySuperNetworksArgs = {
  order?: InputMaybe<Array<SuperNetworkOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<SuperNetworkFilter>;
};


export type QueryTerminologiesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryTestRunExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<TestRunExecutionOrder>;
  where?: InputMaybe<TestRunExecutionFilters>;
};


export type QueryTestRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<TestRunOrder>;
  where?: InputMaybe<TestRunFilters>;
};


export type QueryTiersArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransmissionFormatFieldsForSectionArgs = {
  section_type: Scalars['String']['input'];
  where?: InputMaybe<ReportFieldFilters>;
};


export type QueryTransmissionFormatsArgs = {
  order?: InputMaybe<Array<TransmissionFormatOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<TransmissionFormatFilters>;
};


export type QueryTransmissionJobsArgs = {
  order?: InputMaybe<Array<TransmissionJobOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<TransmissionJobFilters>;
};


export type QueryUdtGetFeatureFlagArgs = {
  featureFlagName: Scalars['String']['input'];
};


export type QueryValidateSubgroupsArgs = {
  input: SubgroupCreatorInput;
};


export type QueryWhatsMyCopayArgs = {
  where?: InputMaybe<WhatsMyCopayInput>;
};


export type QueryWhatsMyCopayV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: WhatsMyCopayV2Input;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWhereUsedExportUrlArgs = {
  input: WhereUsedExportUrlInput;
};


export type QueryZebraCrossAccumulatorConfigArgs = {
  input: CrossAccumulatorConfigInput;
};

export enum RecordType {
  Department = 'DEPARTMENT',
  PlanCode = 'PLAN_CODE',
  Subgroup = 'SUBGROUP',
  Unknown = 'UNKNOWN'
}

/** One or more resolved references: UUID entities (handlers, SDC, process rules) or code-with-label fields (rejectCodesToOverride). Pre-resolved server-side. */
export type ReferenceClaimInstruction = ClaimInstruction & {
  __typename?: 'ReferenceClaimInstruction';
  field: MpaClaimInstructionField;
  id: Scalars['ID']['output'];
  isEmpty: Scalars['Boolean']['output'];
  refs: Array<ResolvedRef>;
};

export type RefillHandler = {
  __typename?: 'RefillHandler';
  created: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  refillHandlerDetails?: Maybe<Array<RefillHandlerDetail>>;
  updated: Scalars['Time']['output'];
};

export type RefillHandlerConnection = {
  __typename?: 'RefillHandlerConnection';
  edges: Array<RefillHandlerEdge>;
  pageInfo: PageInfo;
};

export type RefillHandlerDetail = {
  __typename?: 'RefillHandlerDetail';
  auxCode: AuxCode;
  created: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  numberRefills: Scalars['Int']['output'];
  refillHandlerUUID: Scalars['ID']['output'];
  toleranceDays: Scalars['Int']['output'];
  tolerancePercent: Scalars['Float']['output'];
  type: HandlerDetailType;
  updated: Scalars['Time']['output'];
};

export type RefillHandlerEdge = {
  __typename?: 'RefillHandlerEdge';
  cursor: Scalars['String']['output'];
  node: RefillHandler;
};

export type RefillHandlerFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type RefillHandlerOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export type Registration = {
  __typename?: 'Registration';
  /** The registration date */
  created_at: Scalars['Time']['output'];
  /** The registered email */
  email: Scalars['String']['output'];
  /** The events that have occurred on the credentials */
  events?: Maybe<AuthEventsList>;
  /**
   * Mimic Login Token (if authorized)
   * Send the browser to this in a new tab (or redirect) to mimic login as this user.
   * Request this immediately when needed, not before as it'll expire quickly and may only be used once.
   * Currently frontend must build the full URL to mimic login as backend is not aware of the frontend member portal URL.
   */
  mimicLoginToken?: Maybe<Scalars['String']['output']>;
  /** The last update date */
  updated_at: Scalars['Time']['output'];
  /** Timestamp the email was verified */
  verified_at?: Maybe<Scalars['Time']['output']>;
};


export type RegistrationEventsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

/** Reject code details object */
export type Rejects = {
  __typename?: 'Rejects';
  handlerType?: Maybe<Scalars['String']['output']>;
  processRuleName?: Maybe<Scalars['String']['output']>;
  recommendedNextStep?: Maybe<Scalars['String']['output']>;
  rejectCode: Scalars['String']['output'];
  rejectDesc?: Maybe<Scalars['String']['output']>;
};

export type RelatedDrugProgram = {
  __typename?: 'RelatedDrugProgram';
  comment?: Maybe<Scalars['String']['output']>;
  drug_lists?: Maybe<Array<Maybe<AssociatedDrugList>>>;
  drug_program_name: Scalars['String']['output'];
  friendly_name?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
};

export type RelatedGroup = {
  __typename?: 'RelatedGroup';
  config?: Maybe<Scalars['Map']['output']>;
  group: Group;
  partner: Partner;
  plan_codes?: Maybe<PlanCodeV2List>;
  relationship?: Maybe<Scalars['String']['output']>;
};

export type RelatedGroupList = {
  __typename?: 'RelatedGroupList';
  pagination: Pagination;
  results?: Maybe<Array<RelatedGroup>>;
};

export type RelatedGroupOrder = {
  account_name?: InputMaybe<OrderDirectionEnum>;
  effective_date?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  relationship?: InputMaybe<OrderDirectionEnum>;
  status?: InputMaybe<OrderDirectionEnum>;
  termination_date?: InputMaybe<OrderDirectionEnum>;
};

export type RelationshipFilter = {
  field: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type RelationshipForGroup = {
  __typename?: 'RelationshipForGroup';
  /** List of business intermediaries that have this relationship with the given group. */
  businessIntermediaries: Array<Partner>;
  /** The display name of the relationship. */
  displayName: Scalars['String']['output'];
  /** The name token of the relationship. */
  name: Scalars['String']['output'];
};

export type RelationshipsForGroupFilters = {
  groupID?: InputMaybe<IdFilter>;
};

export type RelationshipsForGroupList = {
  __typename?: 'RelationshipsForGroupList';
  results?: Maybe<Array<RelationshipForGroup>>;
};

export type ReplaceOrAppendOperation =
  { append: Scalars['String']['input']; replace?: never; }
  |  { append?: never; replace: Scalars['String']['input']; };

export type ReplacePlanTestCasesInput = {
  /** Test cases will be completedly replaced from this benefit plan. */
  replace_from_benefit_plan_id: Scalars['ID']['input'];
  /** Test cases will be completely replaced to this benefit plan. */
  replace_to_benefit_plan_id: Scalars['ID']['input'];
};

export type Report = {
  __typename?: 'Report';
  pagination: Pagination;
  results: Array<ReportRow>;
};

export type ReportFieldFilters = {
  name?: InputMaybe<StringFilter>;
};

export type ReportFilters = {
  date?: InputMaybe<TimeFilter>;
  group_id?: InputMaybe<IdFilter>;
  partner_id?: InputMaybe<IdFilter>;
};

export type ReportFormatOperation = {
  __typename?: 'ReportFormatOperation';
  example: Scalars['String']['output'];
  name: Scalars['String']['output'];
  params: Array<ReportFormatOperationParam>;
  regex: Scalars['String']['output'];
};

export type ReportFormatOperationParam = {
  __typename?: 'ReportFormatOperationParam';
  name: Scalars['String']['output'];
  spec: Scalars['String']['output'];
};

export type ReportFormatOperationsResponse = {
  __typename?: 'ReportFormatOperationsResponse';
  results: Array<ReportFormatOperation>;
};

export type ReportOrder = {
  fill_processed_at?: InputMaybe<OrderDirectionEnum>;
};

export type ReportRow = {
  __typename?: 'ReportRow';
  chain_code?: Maybe<Scalars['String']['output']>;
  chain_name?: Maybe<Scalars['String']['output']>;
  claim_authorization_number: Scalars['String']['output'];
  claim_awp_unit_price: Scalars['Float']['output'];
  claim_billed_dispensing_fee: Scalars['Cents']['output'];
  claim_billed_ingredient_cost: Scalars['Cents']['output'];
  claim_billed_tax: Scalars['Cents']['output'];
  claim_claimant_card_id: Scalars['String']['output'];
  claim_compound_code: Scalars['String']['output'];
  claim_copay: Scalars['Cents']['output'];
  claim_cost_basis_term: Scalars['String']['output'];
  claim_days_supply: Scalars['Int']['output'];
  claim_dea_code: Scalars['String']['output'];
  claim_deductible: Scalars['Cents']['output'];
  claim_dispense_as_written: Scalars['String']['output'];
  claim_dispense_as_written_diff: Scalars['String']['output'];
  claim_end_service_at: Scalars['Time']['output'];
  claim_fill_processed_at: Scalars['Time']['output'];
  claim_fill_started_at: Scalars['Time']['output'];
  claim_gross_amount_due: Scalars['Cents']['output'];
  claim_gross_copay: Scalars['Cents']['output'];
  claim_mac_unit_price: Scalars['Float']['output'];
  claim_ndc: Scalars['String']['output'];
  claim_net_copay: Scalars['Cents']['output'];
  claim_network_name: Scalars['String']['output'];
  claim_new_refill_code: Scalars['Int']['output'];
  claim_num_refills: Scalars['Int']['output'];
  claim_out_of_network: Scalars['Boolean']['output'];
  claim_out_of_pocket: Scalars['Cents']['output'];
  claim_paid_ingredient_cost: Scalars['Cents']['output'];
  claim_prescription_written_at: Scalars['Time']['output'];
  claim_prior_auth_code: Scalars['String']['output'];
  claim_quantity: Scalars['Float']['output'];
  claim_route_of_administration: Scalars['String']['output'];
  claim_rx_number: Scalars['String']['output'];
  claim_self_pay: Scalars['Boolean']['output'];
  claim_strength: Scalars['String']['output'];
  claim_submitted_ingredient_cost: Scalars['Cents']['output'];
  claim_total_billed: Scalars['Cents']['output'];
  claim_total_charge: Scalars['Cents']['output'];
  claim_type: Scalars['String']['output'];
  claim_usual_cost: Scalars['Cents']['output'];
  claim_wac_unit_price: Scalars['Float']['output'];
  claim_who_paid_daw_diff: Scalars['String']['output'];
  department_code?: Maybe<Scalars['String']['output']>;
  doctor_address_1?: Maybe<Scalars['String']['output']>;
  doctor_address_2?: Maybe<Scalars['String']['output']>;
  doctor_city?: Maybe<Scalars['String']['output']>;
  doctor_first_name?: Maybe<Scalars['String']['output']>;
  doctor_last_name?: Maybe<Scalars['String']['output']>;
  doctor_name?: Maybe<Scalars['String']['output']>;
  doctor_npi: Scalars['String']['output'];
  doctor_state?: Maybe<Scalars['String']['output']>;
  doctor_zip?: Maybe<Scalars['String']['output']>;
  drug_bgt?: Maybe<Scalars['String']['output']>;
  drug_dd_id?: Maybe<Scalars['String']['output']>;
  drug_dea_class_code?: Maybe<Scalars['String']['output']>;
  drug_desi?: Maybe<Scalars['String']['output']>;
  drug_gcn?: Maybe<Scalars['String']['output']>;
  drug_generic_name?: Maybe<Scalars['String']['output']>;
  drug_gpi?: Maybe<Scalars['String']['output']>;
  drug_hic3?: Maybe<Scalars['String']['output']>;
  drug_label_name_mddb?: Maybe<Scalars['String']['output']>;
  drug_maintenance_mddb?: Maybe<Scalars['String']['output']>;
  drug_mony?: Maybe<Scalars['String']['output']>;
  drug_package_size_unit_of_measure?: Maybe<Scalars['String']['output']>;
  drug_rx_otc_mddb?: Maybe<Scalars['String']['output']>;
  drug_third_party_restriction?: Maybe<Scalars['String']['output']>;
  formulary_drug_coverage_code?: Maybe<Scalars['String']['output']>;
  formulary_drug_is_health_care_reform?: Maybe<Scalars['Boolean']['output']>;
  formulary_drug_is_preferred_specialty?: Maybe<Scalars['Boolean']['output']>;
  formulary_drug_is_prior_authorization?: Maybe<Scalars['Boolean']['output']>;
  formulary_drug_is_specialty?: Maybe<Scalars['Boolean']['output']>;
  formulary_drug_is_step_therapy?: Maybe<Scalars['Boolean']['output']>;
  formulary_drug_quantity_limit?: Maybe<Scalars['String']['output']>;
  formulary_drug_tier?: Maybe<Scalars['String']['output']>;
  formulary_drug_tier_desc?: Maybe<Scalars['String']['output']>;
  formulary_name?: Maybe<Scalars['String']['output']>;
  formulary_type?: Maybe<Scalars['String']['output']>;
  formulary_version?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  laker_user_uuid?: Maybe<Scalars['String']['output']>;
  member_address_1?: Maybe<Scalars['String']['output']>;
  member_address_2?: Maybe<Scalars['String']['output']>;
  member_age?: Maybe<Scalars['Float']['output']>;
  member_city?: Maybe<Scalars['String']['output']>;
  member_coverage_end_date?: Maybe<Scalars['Time']['output']>;
  member_coverage_start_date?: Maybe<Scalars['Time']['output']>;
  member_date_of_birth?: Maybe<Scalars['Time']['output']>;
  member_first_name?: Maybe<Scalars['String']['output']>;
  member_gender?: Maybe<Scalars['String']['output']>;
  member_laker_person_code?: Maybe<Scalars['String']['output']>;
  member_last_name?: Maybe<Scalars['String']['output']>;
  member_middle_name?: Maybe<Scalars['String']['output']>;
  member_person_code?: Maybe<Scalars['String']['output']>;
  member_relationship?: Maybe<Scalars['String']['output']>;
  member_ssn?: Maybe<Scalars['String']['output']>;
  member_state?: Maybe<Scalars['String']['output']>;
  member_suffix?: Maybe<Scalars['String']['output']>;
  member_zip?: Maybe<Scalars['String']['output']>;
  partner_group_carrier_code?: Maybe<Scalars['String']['output']>;
  partner_group_code?: Maybe<Scalars['String']['output']>;
  partner_group_division_name?: Maybe<Scalars['String']['output']>;
  partner_group_division_name_normalized?: Maybe<Scalars['String']['output']>;
  partner_group_name?: Maybe<Scalars['String']['output']>;
  pharmacy_Type?: Maybe<Scalars['String']['output']>;
  pharmacy_address_1?: Maybe<Scalars['String']['output']>;
  pharmacy_address_2?: Maybe<Scalars['String']['output']>;
  pharmacy_city?: Maybe<Scalars['String']['output']>;
  pharmacy_nabp?: Maybe<Scalars['String']['output']>;
  pharmacy_name?: Maybe<Scalars['String']['output']>;
  pharmacy_npi?: Maybe<Scalars['String']['output']>;
  pharmacy_phone?: Maybe<Scalars['String']['output']>;
  pharmacy_state?: Maybe<Scalars['String']['output']>;
  pharmacy_type_code?: Maybe<Scalars['Int']['output']>;
  pharmacy_zip?: Maybe<Scalars['String']['output']>;
  plan_code_name?: Maybe<Scalars['String']['output']>;
  primary_address_1?: Maybe<Scalars['String']['output']>;
  primary_address_2?: Maybe<Scalars['String']['output']>;
  primary_city?: Maybe<Scalars['String']['output']>;
  primary_date_of_birth?: Maybe<Scalars['Time']['output']>;
  primary_first_name?: Maybe<Scalars['String']['output']>;
  primary_gender?: Maybe<Scalars['String']['output']>;
  primary_last_name?: Maybe<Scalars['String']['output']>;
  primary_middle_name?: Maybe<Scalars['String']['output']>;
  primary_ssn?: Maybe<Scalars['String']['output']>;
  primary_state?: Maybe<Scalars['String']['output']>;
  primary_suffix?: Maybe<Scalars['String']['output']>;
  primary_zip?: Maybe<Scalars['String']['output']>;
  reversed_auth_number?: Maybe<Scalars['String']['output']>;
  reversed_processed_at?: Maybe<Scalars['Time']['output']>;
  reversed_started_at?: Maybe<Scalars['Time']['output']>;
};

export type ReportTypeListResponse = {
  __typename?: 'ReportTypeListResponse';
  results: Array<ReportTypeResponse>;
};

export type ReportTypeResponse = {
  __typename?: 'ReportTypeResponse';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ReportTypeSectionField = {
  __typename?: 'ReportTypeSectionField';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  samples: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ReportTypeSectionFieldsResponse = {
  __typename?: 'ReportTypeSectionFieldsResponse';
  results: Array<ReportTypeSectionField>;
};

export type ReprocessorBatch = Node & {
  __typename?: 'ReprocessorBatch';
  /**
   * The legacy batches in the "batch" table associated with this reprocessor batch,
   * including reversals, ordered by created_at DESC.
   */
  associatedLegacyBatches: Array<LegacyBatch>;
  batchSettings?: Maybe<BatchSettings>;
  claimSet?: Maybe<ClaimSet>;
  /**
   * The upload and processing status of all ClaimSet IFP files associated with this batch.
   * Use this to track whether uploaded claim set files have been validated, committed, or errored.
   * Ordered by created_at descending (most recent upload first).
   */
  claimSetUploadProgress: Array<ClaimSetUploadProgress>;
  createdAt: Scalars['Time']['output'];
  createdBy: Credential;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: ReprocessorBatchStatusEnum;
  updatedAt: Scalars['Time']['output'];
};

export type ReprocessorBatchActionInput = {
  includeReversals: Scalars['Boolean']['input'];
  reprocessorBatchId: Scalars['ID']['input'];
};

export type ReprocessorBatchConnection = {
  __typename?: 'ReprocessorBatchConnection';
  edges: Array<ReprocessorBatchEdge>;
  pageInfo: PageInfo;
};

export type ReprocessorBatchEdge = {
  __typename?: 'ReprocessorBatchEdge';
  cursor: Scalars['String']['output'];
  node: ReprocessorBatch;
};

export type ReprocessorBatchFilters = {
  createdBy?: InputMaybe<IdFilter>;
  dateCreated?: InputMaybe<TimeFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  status?: InputMaybe<ReprocessorBatchStatusEnum>;
};

export type ReprocessorBatchOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  createdBy?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  status?: InputMaybe<OrderDirectionEnum>;
  totalClaims?: InputMaybe<OrderDirectionEnum>;
};

export type ReprocessorBatchReverseAllClaimsInput = {
  reprocessorBatchId: Scalars['ID']['input'];
};

export enum ReprocessorBatchStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ReprocessorReport = {
  __typename?: 'ReprocessorReport';
  downloadLocation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: ReprocessorReportStatusEnum;
};

export enum ReprocessorReportStatusEnum {
  Error = 'ERROR',
  Pending = 'PENDING',
  Ready = 'READY'
}

export enum ReprocessorReportTypeEnum {
  AuthNumbers = 'AUTH_NUMBERS',
  /** @deprecated Removed from scope of work, will be deleted in a future release */
  CombinedPaidRejects = 'COMBINED_PAID_REJECTS',
  ImpactReport = 'IMPACT_REPORT',
  NotProcessed = 'NOT_PROCESSED',
  PaidClaimReport = 'PAID_CLAIM_REPORT',
  Rejected = 'REJECTED'
}

export type RequestConsentInput = {
  dependentPersonId: Scalars['ID']['input'];
};

export type RerunTransmissionJobInput = {
  force: Scalars['Boolean']['input'];
  groupUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Use group_uuids  */
  group_uuid?: InputMaybe<Scalars['ID']['input']>;
  run_at?: InputMaybe<Scalars['String']['input']>;
};

export type ResendConsentInput = {
  consentId: Scalars['ID']['input'];
};

export type ResendSent835sInput = {
  /** Array of IDs of the Sent835s to send again. */
  ids: Array<Scalars['ID']['input']>;
};

/** A resolved reference. id is the referenced value (UUID string or code); label is its display. */
export type ResolvedRef = {
  __typename?: 'ResolvedRef';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type Resource = {
  __typename?: 'Resource';
  type: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type Resources = {
  __typename?: 'Resources';
  group?: Maybe<Array<Scalars['ID']['output']>>;
  member?: Maybe<Array<Scalars['ID']['output']>>;
  partner?: Maybe<Array<Scalars['ID']['output']>>;
  type: Scalars['String']['output'];
};

export type Restriction = {
  __typename?: 'Restriction';
  /** Field name of the restriction, e.g. 'mewa_mail_order_restricted_yn' */
  name: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type ReversalClaimResponse = {
  __typename?: 'ReversalClaimResponse';
  claimType: ClaimTypeV2;
  claimUUID: Scalars['UUID']['output'];
};

export enum ReversalStatus {
  RevCompleted = 'REV_COMPLETED',
  RevFailed = 'REV_FAILED',
  RevInProgress = 'REV_IN_PROGRESS',
  RevNa = 'REV_NA',
  RevPending = 'REV_PENDING'
}

export type Role = {
  __typename?: 'Role';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RoleFilters = {
  activity?: InputMaybe<IdFilter>;
  activity_name?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
};

export type RoleList = {
  __typename?: 'RoleList';
  pagination?: Maybe<Pagination>;
  results: Array<Role>;
};

export type RoleOrder = {
  name?: InputMaybe<OrderDirectionEnum>;
};

export type RoleV2 = {
  __typename?: 'RoleV2';
  id: Scalars['ID']['output'];
  /** Managed by Tenant */
  isTenantBased: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
};

export type RowDetails = {
  __typename?: 'RowDetails';
  /** The errors encountered while validating */
  errors?: Maybe<Array<Maybe<RowErrors>>>;
  /** The valid drug list items */
  items?: Maybe<Array<Maybe<DrugListItemV2>>>;
  /** The IDs of the drug list item no-ops (exact match already exists in list) */
  noops?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** The IDs of the drug list item updates */
  updates?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type RowErrors = {
  __typename?: 'RowErrors';
  /** The drug name */
  drugName?: Maybe<Scalars['String']['output']>;
  /** The field where the error occurred */
  field?: Maybe<Scalars['String']['output']>;
  /** Describes the error */
  message: Scalars['String']['output'];
  /** The row number where the error occurred */
  rowNumber?: Maybe<Scalars['Int']['output']>;
  /** The drug value identifier GPI or NDC */
  value?: Maybe<Scalars['String']['output']>;
};

/** Input for running a plan test suite */
export type RunPlanTestSuiteInput = {
  groupID: Scalars['ID']['input'];
  planTestSuiteID: Scalars['ID']['input'];
  subGroupID: Scalars['ID']['input'];
};

/** Response from running a plan test suite */
export type RunPlanTestSuiteResponse = {
  __typename?: 'RunPlanTestSuiteResponse';
  inProgress: Scalars['String']['output'];
};

export enum RxOtcInd {
  /** P */
  OverTheCounterMultiple = 'OverTheCounterMultiple',
  /** O */
  OverTheCounterSingle = 'OverTheCounterSingle',
  /** S */
  RxSourceMultiple = 'RxSourceMultiple',
  /** R */
  RxSourceSingle = 'RxSourceSingle'
}

export type S3File = {
  __typename?: 'S3File';
  /** The Actor/Partner with which this S3File is associated. This S3File is the inbound file for this actor/partner. */
  actor?: Maybe<Partner>;
  /** A checksum generated from the file contents. */
  checksum?: Maybe<Scalars['String']['output']>;
  /** The type of checksum generation that was used. */
  checksum_type?: Maybe<Scalars['String']['output']>;
  /** The Connection specifying the inbound ingestion process that generates this file. */
  connection?: Maybe<Connection>;
  /** Time this record was created. */
  created_at?: Maybe<Scalars['Time']['output']>;
  /** Time this record was deleted. */
  deleted_at?: Maybe<Scalars['Time']['output']>;
  /** Presigned S3 URL to download the file. Valid for 15 minutes. */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** The total records which are failed. */
  failedRecords: Scalars['Int']['output'];
  /**
   * Type of file. This is an enum:
   *
   * unknown: we do now know what type of file this is
   * 835: an 835 file used in pharmacy remittance
   * nacha: a NACHA file containing bank transaction instructions
   */
  file_type: Scalars['String']['output'];
  /** Groups associated to the file */
  groups?: Maybe<Array<Maybe<Group>>>;
  /** ID of the S3File */
  id: Scalars['ID']['output'];
  /** The name of the file */
  name: Scalars['String']['output'];
  /** NormalizerLineStats from the meta of the normalizer job */
  normalizerLineStats?: Maybe<NormalizerLineStats>;
  /** Accum file type from connection config */
  s3FileAccumType?: Maybe<S3FileAccumType>;
  /** S3FileStatus from s3_file_status to check s3 file status for med transaction revert. */
  s3FileStatus?: Maybe<S3FileStatus>;
  /** AWS S3 Bucket where the file is stored */
  s3_bucket: Scalars['String']['output'];
  /** AWS S3 path where the file is stored. This is the "file path" without the file's name. */
  s3_path: Scalars['String']['output'];
  /** The size of the file in bytes. */
  size: Scalars['Int']['output'];
  /** The status will be Success or failed based on the associated jobs status. */
  status: Scalars['String']['output'];
  /** The total records which are successfully processed */
  successRecords: Scalars['Int']['output'];
  /** Indicates term by omission */
  tbo: Scalars['String']['output'];
  /** The total records present in that file */
  totalRecords: Scalars['Int']['output'];
  /** List of transmission jobs associated with this S3File. */
  transmission_jobs: TransmissionJobList;
  /** Time this record was updated. */
  updated_at?: Maybe<Scalars['Time']['output']>;
};


export type S3FileTransmissionJobsArgs = {
  order?: InputMaybe<Array<TransmissionJobOrder>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<TransmissionJobFilters>;
};

export type S3FileAccumType = {
  __typename?: 'S3FileAccumType';
  accum_file_type?: Maybe<Scalars['String']['output']>;
  accum_type?: Maybe<Scalars['String']['output']>;
};

export type S3FileFilters = {
  actor_id?: InputMaybe<IdFilter>;
  created_at?: InputMaybe<TimeFilter>;
  deleted_at?: InputMaybe<TimeFilter>;
  direction?: InputMaybe<StringFilter>;
  file_type?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  size?: InputMaybe<IntFilter>;
  updated_at?: InputMaybe<TimeFilter>;
};

export type S3FileLink = {
  __typename?: 'S3FileLink';
  /** ID of the S3File */
  id: Scalars['ID']['output'];
  /** Pre-authorized, time-limited download link for the S3File */
  url: Scalars['String']['output'];
};

export type S3FileLinkFilters = {
  id?: InputMaybe<IdFilter>;
};

export type S3FileList = {
  __typename?: 'S3FileList';
  pagination: Pagination;
  results: Array<S3File>;
};

export type S3FileOrder = {
  created_at?: InputMaybe<OrderDirectionEnum>;
  deleted_at?: InputMaybe<OrderDirectionEnum>;
  file_type?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  size?: InputMaybe<OrderDirectionEnum>;
  updated_at?: InputMaybe<OrderDirectionEnum>;
};

export type S3FileStatus = {
  __typename?: 'S3FileStatus';
  accum_file_type: AccumFileType;
  created_at: Scalars['Time']['output'];
  file_status: S3FileStatusName;
};

export enum S3FileStatusName {
  FailedToRevert = 'failed_to_revert',
  RevertInProgress = 'revert_in_progress',
  RevertSubmitted = 'revert_submitted',
  Reverted = 'reverted'
}

export type SdcAccumTransactions = {
  __typename?: 'SDCAccumTransactions';
  adjudicationDate: Scalars['Time']['output'];
  authId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  credentialId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incomingSdcId: Scalars['String']['output'];
  membershipId: Scalars['ID']['output'];
  sdcAmount: Scalars['Int']['output'];
};

export type SdcAccumTransactionsFilters = {
  incomingSdcId?: InputMaybe<StringFilter>;
  membershipId?: InputMaybe<IdFilter>;
};

export type SdcAccumTransactionsInput = {
  action: SdcActionEnum;
  adjudicationDate: Scalars['Time']['input'];
  effectiveAt?: InputMaybe<Scalars['Time']['input']>;
  id: Scalars['ID']['input'];
  incomingSdcId: Scalars['String']['input'];
  membershipId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  sdcAmount: Scalars['Int']['input'];
  sdcConfig?: InputMaybe<SdcConfig>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type SdcAccumTransactionsList = {
  __typename?: 'SDCAccumTransactionsList';
  pagination: Pagination;
  results: Array<SdcAccumTransactions>;
};

export type SdcAccumTransactionsOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
};

/** SDCAccumsStore holds the sdc information for the sdc of accumulator types */
export type SdcAccumsStore = {
  __typename?: 'SDCAccumsStore';
  /** The AllTime accumulator value for the member */
  allTime?: Maybe<Scalars['Int']['output']>;
  /** full amount per sdc id of the member */
  fullPlanPaidAmount: Scalars['Int']['output'];
  lakerSDCId: Scalars['String']['output'];
  /** full amount per sdc id of the member */
  medPlanPaidAmount: Scalars['Int']['output'];
  membershipId: Scalars['ID']['output'];
  /** full amount per sdc id of the member */
  rxPlanPaidAmount: Scalars['Int']['output'];
  /** The time the record was last updated. */
  updatedAt: Scalars['Time']['output'];
};

export type SdcAccumsStoreFilters = {
  effectiveAt?: InputMaybe<TimeFilter>;
  lakerSDCId?: InputMaybe<StringFilter>;
  membershipId: IdFilter;
};

export type SdcAccumsStoreInput = {
  accumulatorType: Scalars['String']['input'];
  effectiveAt?: InputMaybe<Scalars['Time']['input']>;
  fullPlanPaidAmount: Scalars['Int']['input'];
  lakerSDCId: Scalars['String']['input'];
  medPlanPaidAmount: Scalars['Int']['input'];
  membershipId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  rxPlanPaidAmount: Scalars['Int']['input'];
  sdcConfig?: InputMaybe<SdcConfig>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type SdcAccumsStoreList = {
  __typename?: 'SDCAccumsStoreList';
  results: Array<SdcAccumsStore>;
};

export type SdcAccumulation = {
  __typename?: 'SDCAccumulation';
  allTimeAmount: Scalars['Float']['output'];
  fullAmount: Scalars['Float']['output'];
  medAmount: Scalars['Float']['output'];
  rxAmount: Scalars['Float']['output'];
};

export enum SdcActionEnum {
  Add = 'ADD',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

/** SDCConfig holds the sdc config information for groups,plans */
export type SDCConfig = {
  __typename?: 'SDCConfig';
  benefitPlanId: Scalars['ID']['output'];
  groupId: Scalars['ID']['output'];
  incomingSdcId: Scalars['String']['output'];
  sdcConfigStatus?: Maybe<Scalars['String']['output']>;
  sdcIdLaker: Scalars['String']['output'];
  sdcName: Scalars['String']['output'];
  sdcPeriod: Scalars['String']['output'];
};

export type SdcConfigFilters = {
  membershipId: IdFilter;
};

export type SdcConfigList = {
  __typename?: 'SDCConfigList';
  results: Array<SDCConfig>;
};

export type SdcConnection = {
  __typename?: 'SDCConnection';
  edges: Array<SdcEdge>;
  pageInfo: PageInfo;
};

export type SdcCrossAccumConfig = {
  __typename?: 'SDCCrossAccumConfig';
  SDCID: Scalars['String']['output'];
  /**
   * SDCName is the human-readable Zebra SDC name for SDCID. Null on configs written before the
   * name was captured.
   */
  SDCName?: Maybe<Scalars['String']['output']>;
  accumulate: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Time']['output']>;
  crossAccumulator: Scalars['Boolean']['output'];
  effectiveFrom: Scalars['Time']['output'];
  effectiveTo?: Maybe<Scalars['Time']['output']>;
  id: Scalars['UUID']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type SdcCrossAccumConfigFilters = {
  id?: InputMaybe<IdFilter>;
  recordStatus?: InputMaybe<StringFilter>;
};

export type SdcCrossAccumConfigInput = {
  SDCID: Scalars['String']['input'];
  /**
   * SDCName is optional; when omitted an existing config keeps the name it already
   * has. There is deliberately no way to clear a name through this input, since an
   * absent field and an explicit null are indistinguishable here.
   */
  SDCName?: InputMaybe<Scalars['String']['input']>;
  accumulate: Scalars['String']['input'];
  crossAccumulator: Scalars['Boolean']['input'];
  /**
   * id is optional on the input but if known should be sent so the sdc cross accum config can be correctly updated
   * rather than a new one being created
   */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type SdcEdge = {
  __typename?: 'SDCEdge';
  cursor: Scalars['String']['output'];
  node: Sdcv2;
};

export type SdcFiltersV2 = {
  id?: InputMaybe<IdFilter>;
  sdcCode?: InputMaybe<StringFilter>;
  sdcName?: InputMaybe<StringFilter>;
};

export enum SdcOopCapInteraction {
  BothCapsMet = 'BOTH_CAPS_MET',
  EitherCapMet = 'EITHER_CAP_MET',
  GroupAlways = 'GROUP_ALWAYS',
  SdcAlways = 'SDC_ALWAYS'
}

export type SdcOrderV2 = {
  id?: InputMaybe<OrderDirectionEnum>;
  sdcName?: InputMaybe<OrderDirectionEnum>;
};

export enum SdcPeriodType {
  BenefitYear = 'BENEFIT_YEAR',
  CalendarMonth = 'CALENDAR_MONTH',
  CalendarYear = 'CALENDAR_YEAR',
  Lifetime = 'LIFETIME',
  Script = 'SCRIPT',
  XMonths = 'X_MONTHS'
}

export enum SdcSatisfactionType {
  CoverageEmbedded = 'COVERAGE_EMBEDDED',
  CoverageTypeDetermines = 'COVERAGE_TYPE_DETERMINES',
  FamilyOnly = 'FAMILY_ONLY',
  IndividualOnly = 'INDIVIDUAL_ONLY',
  LesserOfIndivOrFamily = 'LESSER_OF_INDIV_OR_FAMILY',
  Na = 'NA'
}

export type SdcTotals = {
  __typename?: 'SDCTotals';
  allTimeAmount: Scalars['Float']['output'];
  fullAmount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  medAmount: Scalars['Float']['output'];
  rxAmount: Scalars['Float']['output'];
};

/**
 * YTD totals for a single SDC resolved at every applicable scope of aggregation.
 * individual aggregates claims for one membership.
 * family aggregates claims across every membership on the subscription.
 */
export type SdcTotalsByScope = {
  __typename?: 'SDCTotalsByScope';
  /** @deprecated Use individual.allTimeAmount */
  allTimeAmount: Scalars['Float']['output'];
  family?: Maybe<SdcAccumulation>;
  /** @deprecated Use individual.fullAmount */
  fullAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  individual?: Maybe<SdcAccumulation>;
  /** @deprecated Use individual.medAmount */
  medAmount: Scalars['Float']['output'];
  /** @deprecated Use individual.rxAmount */
  rxAmount: Scalars['Float']['output'];
};

export type SdcTotalsByScopeConnection = {
  __typename?: 'SDCTotalsByScopeConnection';
  edges: Array<SdcTotalsByScopeEdge>;
  pageInfo: PageInfo;
};

export type SdcTotalsByScopeEdge = {
  __typename?: 'SDCTotalsByScopeEdge';
  cursor: Scalars['String']['output'];
  node: SdcTotalsByScope;
};

export type SdcTotalsByScopeFilters = {
  endDate: Scalars['Time']['input'];
  startDate: Scalars['Time']['input'];
};

export type SdcTotalsConnection = {
  __typename?: 'SDCTotalsConnection';
  edges: Array<SdcTotalsEdge>;
  pageInfo: PageInfo;
};

export type SdcTotalsEdge = {
  __typename?: 'SDCTotalsEdge';
  cursor: Scalars['String']['output'];
  node: SdcTotals;
};

export type SdcTotalsFilters = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  membershipUUID: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['Time']['input']>;
};

export enum SdcType {
  BenefitCap = 'BENEFIT_CAP',
  Deductible = 'DEDUCTIBLE',
  OutOfPocket = 'OUT_OF_POCKET'
}

export type Sdcv2 = {
  __typename?: 'SDCV2';
  afterCapCopayHandler?: Maybe<CopayHandler>;
  familyAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  individualAmount?: Maybe<Scalars['Float']['output']>;
  oopCapInteraction?: Maybe<SdcOopCapInteraction>;
  periodType?: Maybe<SdcPeriodType>;
  periodX?: Maybe<Scalars['Int']['output']>;
  rejectClaimAfterCapIsMet?: Maybe<Scalars['Boolean']['output']>;
  satisfactionType: SdcSatisfactionType;
  satisfactionTypeDescription: Scalars['String']['output'];
  sdcCode: Scalars['String']['output'];
  sdcName: Scalars['String']['output'];
  sdcType: SdcType;
  sdcTypeDescription: Scalars['String']['output'];
};

export type SdcValues = {
  __typename?: 'SDCValues';
  amount: Scalars['Cents']['output'];
  id: Scalars['ID']['output'];
  runningTotal: Scalars['Cents']['output'];
  sdcCode: Scalars['String']['output'];
};

export type SqsRequest = {
  __typename?: 'SQSRequest';
  createdAt: Scalars['Time']['output'];
  endDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  payeeName: Scalars['String']['output'];
  requestType: Scalars['String']['output'];
  sent835?: Maybe<Sent835>;
  startDate: Scalars['Time']['output'];
  status: Scalars['String']['output'];
  statusMessage: Scalars['String']['output'];
};

export type SqsRequestFilters = {
  createdAt?: InputMaybe<TimeFilter>;
  endDate?: InputMaybe<TimeFilter>;
  id?: InputMaybe<IdFilter>;
  payeeIds?: InputMaybe<StringFilter>;
  requestType?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<TimeFilter>;
  status?: InputMaybe<StringFilter>;
};

export type SqsRequestList = {
  __typename?: 'SQSRequestList';
  pagination: Pagination;
  results: Array<SqsRequest>;
};

export type SqsRequestOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  payeeName?: InputMaybe<OrderDirectionEnum>;
  requestType?: InputMaybe<OrderDirectionEnum>;
  status?: InputMaybe<OrderDirectionEnum>;
};

export enum SatisfactionType {
  CoverageEmbedded = 'COVERAGE_EMBEDDED',
  CoverageTypeDetermines = 'COVERAGE_TYPE_DETERMINES',
  FamilyOnly = 'FAMILY_ONLY',
  IndividualOnly = 'INDIVIDUAL_ONLY',
  LesserOfIndivOrFamily = 'LESSER_OF_INDIV_OR_FAMILY',
  Na = 'NA'
}

export type ScreeningIngredient = {
  __typename?: 'ScreeningIngredient';
  id: Scalars['ID']['output'];
  ingredientName: Scalars['String']['output'];
};

/** SDCConfig holds the configuration for the SDC */
export type SdcConfig = {
  incomingSDCID?: InputMaybe<Scalars['String']['input']>;
  sdcConfigStatus?: InputMaybe<Scalars['String']['input']>;
  sdcIDLaker?: InputMaybe<Scalars['String']['input']>;
  sdcPeriod?: InputMaybe<Scalars['String']['input']>;
};

export type SelectedTestCasesInput = {
  /** benefit plan ID */
  benefit_plan_id: Scalars['ID']['input'];
  /** List of selected test case ids ready to play */
  plan_test_case_ids: Array<Scalars['ID']['input']>;
};

export type SendClaimInput = {
  claimSource: Scalars['String']['input'];
  isTest: Scalars['Boolean']['input'];
  transaction: NcpdpTransactionInput;
};

export type SendClaimResponse = {
  __typename?: 'SendClaimResponse';
  claimUUID: Scalars['UUID']['output'];
};

/** Input for creating a demo Kafka event */
export type SendDemoEventInput = {
  /** The name/type of the demo event */
  eventName: Scalars['String']['input'];
  /** A descriptive message for the event */
  message: Scalars['String']['input'];
  /** The ID of the user triggering the event (used as partition key) */
  userId: Scalars['String']['input'];
};

/** Response from sending a demo event */
export type SendDemoEventResponse = {
  __typename?: 'SendDemoEventResponse';
  /** Optional error message if sending failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the event was successfully sent to Kafka */
  success: Scalars['Boolean']['output'];
  /** The topic the event was sent to */
  topic: Scalars['String']['output'];
  /** The user ID (partition key) used */
  userId: Scalars['String']['output'];
};

export type Sent835 = {
  __typename?: 'Sent835';
  /**
   * The ACH Trace Number is a unique 15 digit reference number used to track an ACH transfer.
   * It is prefixed with SmithRx's tax id number (eight digits). The remaining seven digits is a sequence number
   * that is incremented according to the number of records on the sent_835s table.
   */
  ach_trace_number: Scalars['String']['output'];
  /** Number of Cervey claims on this Sent835. */
  cervey_claim_count: Scalars['Int']['output'];
  /** Total number of claims on this Sent835. */
  claim_count: Scalars['Int']['output'];
  /** The time at which this Sent835 was created. */
  created_at: Scalars['Time']['output'];
  /** The time at which this Sent835 was deleted. */
  deleted_at?: Maybe<Scalars['Time']['output']>;
  /** The date for which this 835 accounting ends. */
  end_date: Scalars['Time']['output'];
  /** Assigned number originated and maintained by the sender. */
  group_control_number: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** A control number assigned by the interchange sender. */
  interchange_control_number: Scalars['String']['output'];
  /** Number of Laker claims on this Sent835. */
  laker_claim_count: Scalars['Int']['output'];
  /** ID of the nacha record to which this Sent835 is associated. */
  nacha_id?: Maybe<Scalars['ID']['output']>;
  /** ID of the payee record. */
  payee_id: Scalars['ID']['output'];
  /** Name of the payee. */
  payee_name: Scalars['String']['output'];
  /**
   * PLB is the "forward balance" at the time the sent_835 record was generated. It represents the amount of money in
   * cents owed to SmithRx from the payee. It is an accumulated total, so only the latest value is valid, if and only if
   * the sent_835 record has a status of `sent`. PLB is stored as a negative value, indicating it is an amount to be
   * owed to SmithRx.
   */
  plb: Scalars['Int']['output'];
  /** ID of the s3_file record file to which this Sent835 is associated. */
  s3_file_id?: Maybe<Scalars['ID']['output']>;
  /** The time at which this Sent835 was transferred to its payee destination. */
  sent_at?: Maybe<Scalars['Time']['output']>;
  /** The date for which this 835 accounting starts. */
  start_date: Scalars['Time']['output'];
  /**
   * The status of a Sent835 can be on of the following:
   *
   * generated: the 835 file has been created but not yet sent
   * sending: the 835 file is in the process of being sent
   * sent: the final state of an 835 that was successfully sent
   * deleted: if an 835 was generated but is not indenteded to be used or sent, it is deleted
   */
  status: Scalars['String']['output'];
  /** The amount to be remitted to the payee in cents. It should be a positive value. */
  total: Scalars['Int']['output'];
  /**
   * Identifying control number that must be unique within the transaction set functional group assigned by the
   * originator for a transaction set.
   */
  transaction_set_control_number: Scalars['String']['output'];
  /** The time at which this Sent835 was last updated. */
  updated_at?: Maybe<Scalars['Time']['output']>;
  /** Number of Zebra claims on this Sent835. */
  zebra_claim_count: Scalars['Int']['output'];
};

export type Sent835Filters = {
  ach_trace_number?: InputMaybe<StringFilter>;
  cervey_claim_count?: InputMaybe<IntFilter>;
  claim_count?: InputMaybe<IntFilter>;
  created_at?: InputMaybe<TimeFilter>;
  deleted_at?: InputMaybe<TimeFilter>;
  end_date?: InputMaybe<TimeFilter>;
  id?: InputMaybe<IdFilter>;
  laker_claim_count?: InputMaybe<IntFilter>;
  nacha_id?: InputMaybe<IdFilter>;
  payee_id?: InputMaybe<IdFilter>;
  payee_name?: InputMaybe<StringFilter>;
  pharmacy_state?: InputMaybe<StringFilter>;
  plb?: InputMaybe<IntFilter>;
  sent_at?: InputMaybe<TimeFilter>;
  start_date?: InputMaybe<TimeFilter>;
  status?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<TimeFilter>;
  zebra_claim_count?: InputMaybe<IntFilter>;
};

export type Sent835List = {
  __typename?: 'Sent835List';
  pagination: Pagination;
  results: Array<Sent835>;
};

export type Sent835Order = {
  ach_trace_number?: InputMaybe<OrderDirectionEnum>;
  cervey_claim_count?: InputMaybe<OrderDirectionEnum>;
  claim_count?: InputMaybe<OrderDirectionEnum>;
  created_at?: InputMaybe<OrderDirectionEnum>;
  deleted_at?: InputMaybe<OrderDirectionEnum>;
  end_date?: InputMaybe<OrderDirectionEnum>;
  id?: InputMaybe<OrderDirectionEnum>;
  laker_claim_count?: InputMaybe<OrderDirectionEnum>;
  nacha_id?: InputMaybe<OrderDirectionEnum>;
  payee_id?: InputMaybe<OrderDirectionEnum>;
  payee_name?: InputMaybe<OrderDirectionEnum>;
  plb?: InputMaybe<OrderDirectionEnum>;
  sent_at?: InputMaybe<OrderDirectionEnum>;
  start_date?: InputMaybe<OrderDirectionEnum>;
  status?: InputMaybe<OrderDirectionEnum>;
  updated_at?: InputMaybe<OrderDirectionEnum>;
  zebra_claim_count?: InputMaybe<OrderDirectionEnum>;
};

export type Sent835sClaimsMissed = {
  __typename?: 'Sent835sClaimsMissed';
  accountNumber: Scalars['String']['output'];
  authorizationNumber: Scalars['String']['output'];
  claimId: Scalars['String']['output'];
  fillProcessedAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  payeeName: Scalars['String']['output'];
  routingNumber: Scalars['String']['output'];
};

export type Sent835sToClaims = {
  __typename?: 'Sent835sToClaims';
  authorizationNumber: Scalars['String']['output'];
  claimId: Scalars['String']['output'];
  fillProcessedAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  remittedAmount: Scalars['String']['output'];
  totalBilled: Scalars['String']['output'];
};

export type Sent835sToClaimsFilters = {
  id?: InputMaybe<IdFilter>;
  sent_835s_id?: InputMaybe<IdFilter>;
};

export type Sent835sToClaimsList = {
  __typename?: 'Sent835sToClaimsList';
  pagination: Pagination;
  results: Array<Sent835sToClaims>;
};

export type Sent835sToClaimsMissedFilters = {
  endDate: TimeFilter;
  id?: InputMaybe<IdFilter>;
  payeeIds?: InputMaybe<StringFilter>;
  startDate: TimeFilter;
};

export type Sent835sToClaimsMissedList = {
  __typename?: 'Sent835sToClaimsMissedList';
  pagination: Pagination;
  results: Array<Sent835sClaimsMissed>;
};

export type Sent835sToClaimsOrder = {
  authorizationNumber?: InputMaybe<OrderDirectionEnum>;
  claimId?: InputMaybe<OrderDirectionEnum>;
  createdAt?: InputMaybe<OrderDirectionEnum>;
  payeeName?: InputMaybe<OrderDirectionEnum>;
};

export type ServiceCodeReason = {
  __typename?: 'ServiceCodeReason';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  serviceCode: Scalars['String']['output'];
};

export type Services = {
  __typename?: 'Services';
  auth?: Maybe<Scalars['Map']['output']>;
  manage?: Maybe<Scalars['Map']['output']>;
};

export type SignConsentInput = {
  agreedToTerms: Scalars['Boolean']['input'];
  consentId: Scalars['ID']['input'];
};

export enum SingleComboEnum {
  Combo = 'COMBO',
  Single = 'SINGLE'
}

/**
 * The drug the alternatives were resolved for, echoed back so the UI can title the
 * results without a second lookup.
 */
export type SourceDrug = {
  __typename?: 'SourceDrug';
  /**
   * Claims measures for the source drug's GPI. Null when DAS has no claims data
   * for this drug.
   */
  claimsAnalytics?: Maybe<ClaimsAnalytics>;
  /**
   * Drug class from GPI reference data. Null when the drug record could not be
   * resolved or a dependency failure prevented the lookup.
   */
  drugClass?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the source drug is covered by the requested formulary. Null when no
   * `formularyId` was supplied or when coverage could not be determined due to
   * a dependency failure. Distinct from `NON_FORMULARY`: a null status must not
   * be rendered as excluded from coverage.
   */
  formularyStatus?: Maybe<FormularyStatusEnum>;
  /**
   * Generic Product Identifier for the source drug. Null when the drug record
   * could not be resolved or a dependency was unavailable.
   */
  gpi?: Maybe<Scalars['String']['output']>;
  /**
   * Indications considered when resolving the alternatives. The filter dropdown
   * itself is populated by `drugIndications`, which runs first; this is what the
   * returned list was actually built from.
   */
  indications: Array<DrugIndication>;
  /** Label name of the source drug. Empty if the upstream record has no label. */
  label: Scalars['String']['output'];
  ndc: Scalars['String']['output'];
  /**
   * Number of NDCs that share this drug's GPI. Null when the GPI could not be
   * resolved or a dependency failure prevented the lookup.
   */
  ndcCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Whether prior authorization is required. Null when no `formularyId` was
   * supplied, when the source drug is not on the formulary, or when coverage
   * could not be determined.
   */
  paRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether step therapy is required. Null when no `formularyId` was supplied,
   * when the source drug is not on the formulary, or when coverage could not be
   * determined.
   */
  stRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Formulary tier. Null when the source drug is not on the formulary, when no
   * `formularyId` was supplied, or when coverage could not be determined.
   */
  tier?: Maybe<Scalars['Int']['output']>;
};

export type StateBasedRestrictions = {
  __typename?: 'StateBasedRestrictions';
  restrictions: Array<Restriction>;
  /** State abbreviation, e.g. 'CA' */
  state: Scalars['String']['output'];
};

export type StatusLogEntry = {
  __typename?: 'StatusLogEntry';
  /** Decision outcome (Cancel, Partially Approved, Denied, etc.) */
  decisionOutcome?: Maybe<Scalars['String']['output']>;
  /** Decision outcome description, including rejection reason. */
  decisionOutcomeDescription?: Maybe<Scalars['String']['output']>;
  /** The log entry's unique identifier */
  id: Scalars['ID']['output'];
  /** The status of the PA request */
  status: Scalars['String']['output'];
  /** The status category of the case */
  statusCategory: Scalars['String']['output'];
  /**
   * The status the member portal PA tracker displays for this entry. Null for states the tracker
   * doesn't surface. For PriorAuthorizationRequest.statusLog only; do not read it on Connect or MSS entries.
   */
  trackerStatus?: Maybe<PriorAuthTrackerStatus>;
  /** The timestamp of the status */
  updatedAt: Scalars['Time']['output'];
};

export type StepTherapyConnection = {
  __typename?: 'StepTherapyConnection';
  edges: Array<StepTherapyEdge>;
  pageInfo: PageInfo;
};

export type StepTherapyEdge = {
  __typename?: 'StepTherapyEdge';
  cursor: Scalars['String']['output'];
  node: StepTherapyV2;
};

export type StepTherapyLine = {
  __typename?: 'StepTherapyLine';
  RxOTCCode?: Maybe<RxOtcInd>;
  customDrugList?: Maybe<CustomDrugListV2>;
  daysUsed?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distinctDrugCount?: Maybe<Scalars['Int']['output']>;
  distinctDrugDigits?: Maybe<Scalars['Int']['output']>;
  dontApplyBeforeDate?: Maybe<Scalars['Time']['output']>;
  drugID?: Maybe<Scalars['String']['output']>;
  drugValue?: Maybe<DrugValue>;
  effectiveDate: Scalars['Time']['output'];
  expirationDate?: Maybe<Scalars['Time']['output']>;
  falseProcessRule?: Maybe<ProcessRule>;
  falseProcessRulePriority?: Maybe<Scalars['Int']['output']>;
  hxClaimsQuantityLessOrEqual?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<Scalars['Int']['output']>;
  monyCode: Array<MonyCode>;
  notAppRxLevelPaidDuringPeriod?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  periodType?: Maybe<PeriodType>;
  periodX?: Maybe<Scalars['Int']['output']>;
  rule?: Maybe<StepTherapyLineRuleType>;
  scriptTagMatchValue?: Maybe<Scalars['String']['output']>;
  trueProcessRule?: Maybe<ProcessRule>;
  trueProcessRulePriority?: Maybe<Scalars['Int']['output']>;
};

export type StepTherapyLineConnection = {
  __typename?: 'StepTherapyLineConnection';
  edges: Array<StepTherapyLineEdge>;
  pageInfo: PageInfo;
};

export type StepTherapyLineEdge = {
  __typename?: 'StepTherapyLineEdge';
  cursor: Scalars['String']['output'];
  node: StepTherapyLine;
};

export enum StepTherapyLineRuleType {
  /** 1 */
  HadPreviousLevelRuleType = 'HadPreviousLevelRuleType',
  /** 3 */
  HadPreviousTwoLevelsRuleType = 'HadPreviousTwoLevelsRuleType',
  /** 2 */
  HadSameLevelRuleType = 'HadSameLevelRuleType'
}

/**
 * One place a process rule is used through a step therapy: a single step therapy line
 * routing to the rule.
 */
export type StepTherapyRelatedProcessRule = Node & {
  __typename?: 'StepTherapyRelatedProcessRule';
  /**
   * Global ID of the step therapy line — unique per edge, and resolvable through
   * Query.node.
   */
  id: Scalars['ID']['output'];
  stepTherapy: StepTherapyV2;
  stepTherapyLine: StepTherapyLine;
};

export type StepTherapyRelatedProcessRuleConnection = {
  __typename?: 'StepTherapyRelatedProcessRuleConnection';
  /** Total matching step therapy lines, not distinct step therapies. */
  count: Scalars['Int']['output'];
  edges: Array<StepTherapyRelatedProcessRuleEdge>;
  /**
   * Bucket counts over the same rows this connection selects, grouped by `by`. Behaves
   * as PlanRelatedProcessRuleConnection.groups does: the aggregate covers the whole
   * filtered set, and the pagination arguments window the bucket list.
   */
  groups: GroupBucketConnection;
  pageInfo: PageInfo;
};


export type StepTherapyRelatedProcessRuleConnectionGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  by: StepTherapyRelatedProcessRuleGroupBy;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StepTherapyRelatedProcessRuleEdge = {
  __typename?: 'StepTherapyRelatedProcessRuleEdge';
  cursor: Scalars['String']['output'];
  node: StepTherapyRelatedProcessRule;
};

/** The rows to select. Every field is optional, and the ones that are set are ANDed. */
export type StepTherapyRelatedProcessRuleFilters = {
  /** Name of the process rule step_therapy_line.false_process_rule_uuid refers to */
  falseProcessRuleName?: InputMaybe<StringFilter>;
  /** step_therapy_line.description */
  stepTherapyLineDescription?: InputMaybe<StringFilter>;
  /** step_therapy_line.drug_value */
  stepTherapyLineDrugValue?: InputMaybe<StringFilter>;
  /** step_therapy_line.drug_id */
  stepTherapyLineValue?: InputMaybe<StringFilter>;
  /** step_therapy.name */
  stepTherapyName?: InputMaybe<StringFilter>;
  /** Name of the process rule step_therapy_line.true_process_rule_uuid refers to */
  trueProcessRuleName?: InputMaybe<StringFilter>;
};

/** One groupable column of the rule-to-step-therapy-line join. Mirrors StepTherapyRelatedProcessRuleFilters. */
export enum StepTherapyRelatedProcessRuleGroupBy {
  FalseProcessRuleName = 'FALSE_PROCESS_RULE_NAME',
  StepTherapyLineDescription = 'STEP_THERAPY_LINE_DESCRIPTION',
  StepTherapyLineDrugValue = 'STEP_THERAPY_LINE_DRUG_VALUE',
  StepTherapyLineValue = 'STEP_THERAPY_LINE_VALUE',
  StepTherapyName = 'STEP_THERAPY_NAME',
  TrueProcessRuleName = 'TRUE_PROCESS_RULE_NAME'
}

/**
 * The sort to apply. Set the direction on the one field to sort by; rows are sorted by
 * step therapy name ascending when nothing is set. If more than one field is set, the
 * first one listed here wins.
 */
export type StepTherapyRelatedProcessRuleOrder = {
  falseProcessRuleName?: InputMaybe<OrderDirectionEnum>;
  stepTherapyLineDescription?: InputMaybe<OrderDirectionEnum>;
  stepTherapyLineDrugValue?: InputMaybe<OrderDirectionEnum>;
  stepTherapyLineValue?: InputMaybe<OrderDirectionEnum>;
  stepTherapyName?: InputMaybe<OrderDirectionEnum>;
  trueProcessRuleName?: InputMaybe<OrderDirectionEnum>;
};

export type StepTherapyV2 = {
  __typename?: 'StepTherapyV2';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Plans this step therapy is used in, one edge per plan_to_step_therapy row. */
  usedInPlans: PlanRelatedStepTherapyConnection;
};


export type StepTherapyV2UsedInPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<PlanRelatedStepTherapyOrder>;
  where?: InputMaybe<PlanRelatedStepTherapyFilters>;
};

export type StringClaimInstruction = ClaimInstruction & {
  __typename?: 'StringClaimInstruction';
  field: MpaClaimInstructionField;
  id: Scalars['ID']['output'];
  isEmpty: Scalars['Boolean']['output'];
  stringValue: Scalars['String']['output'];
};

export type StringFilter = {
  /** Equal */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Case insensitive Like */
  ilike?: InputMaybe<Scalars['String']['input']>;
  /** In */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches rows where the column IS NULL (true) or IS NOT NULL (false) */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Like */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Not equal */
  ne?: InputMaybe<Scalars['String']['input']>;
  /** Not in */
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Right */
  right?: InputMaybe<Scalars['String']['input']>;
};

export type SubGroupFilters = {
  benefit_plan_id?: InputMaybe<IdFilter>;
  created_at?: InputMaybe<TimeFilter>;
  department_id?: InputMaybe<IdFilter>;
  effective_from?: InputMaybe<TimeFilter>;
  effective_to?: InputMaybe<TimeFilter>;
  name?: InputMaybe<StringFilter>;
  /** Filter by name OR plan_code.display_name */
  nameComposite?: InputMaybe<StringFilter>;
  plan_code_id?: InputMaybe<IdFilter>;
  plan_design_id?: InputMaybe<StringFilter>;
};

export type SubGroupListV2 = {
  __typename?: 'SubGroupListV2';
  /** @deprecated Use SubgroupConnection */
  pagination: Pagination;
  /** @deprecated Use SubgroupConnection */
  results?: Maybe<Array<PortalSubgroupDetail>>;
};

export type SubGroupOrder = {
  benefitStartDate?: InputMaybe<OrderDirectionEnum>;
  effectiveFrom?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  plan?: InputMaybe<OrderDirectionEnum>;
  terminationDate?: InputMaybe<OrderDirectionEnum>;
};

export type Subgroup = {
  currentBenefitStartDate?: Maybe<Scalars['Date']['output']>;
  currentTerminationDate?: Maybe<Scalars['Date']['output']>;
  details: Array<SubgroupDetail>;
  firstEffectiveDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  status: GroupStatus;
};

export type SubgroupConnection = {
  __typename?: 'SubgroupConnection';
  count: Scalars['Int']['output'];
  edges: Array<SubgroupEdge>;
  pageInfo: PageInfo;
};

export type SubgroupCreatorInput = {
  file: Scalars['String']['input'];
};

export type SubgroupDetail = {
  benefitStartDate?: Maybe<Scalars['Date']['output']>;
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  familyBenCap?: Maybe<Scalars['Cents']['output']>;
  familyDed?: Maybe<Scalars['Cents']['output']>;
  familyOop?: Maybe<Scalars['Cents']['output']>;
  id: Scalars['ID']['output'];
  individualBenCap?: Maybe<Scalars['Cents']['output']>;
  individualDed?: Maybe<Scalars['Cents']['output']>;
  individualOop?: Maybe<Scalars['Cents']['output']>;
  overridePlan?: Maybe<Plan>;
};

/**
 * A subgroup detail whose benefit-plan-derived fields will be rewritten: its
 * override plan is repointed at the new benefit plan's zebra plan, and its six
 * accumulator thresholds are re-derived from that plan's current accumulators.
 * Thresholds with no corresponding accumulator on the new plan are cleared.
 */
export type SubgroupDetailAccumResync = {
  __typename?: 'SubgroupDetailAccumResync';
  /** The benefit plan the detail's override plan and thresholds will be derived from. */
  newBenefitPlanId: Scalars['ID']['output'];
  /** The existing subgroup detail being resynced, with its current values. */
  subgroupDetail: ZebraSubgroupDetail;
};

export type SubgroupDetailConnection = {
  __typename?: 'SubgroupDetailConnection';
  count: Scalars['Int']['output'];
  edges: Array<SubgroupDetailEdge>;
  pageInfo: PageInfo;
};

export type SubgroupDetailCreation = {
  __typename?: 'SubgroupDetailCreation';
  /** Effective date of the detail */
  effectiveDate: Scalars['Date']['output'];
  /** Expiration date of the detail */
  expirationDate: Scalars['Date']['output'];
  /** The Zebra plan derived from the plan code's benefit plan */
  planOverride?: Maybe<Plan>;
};

export type SubgroupDetailEdge = {
  __typename?: 'SubgroupDetailEdge';
  cursor: Scalars['String']['output'];
  node: SubgroupDetail;
};

export type SubgroupDetailExpansion = {
  __typename?: 'SubgroupDetailExpansion';
  /** New effective date the detail would be expanded to */
  newEffectiveDate: Scalars['Date']['output'];
  /** New expiration date the detail would be expanded to */
  newExpirationDate: Scalars['Date']['output'];
  /** The existing subgroup detail being expanded */
  subgroupDetail: ZebraSubgroupDetail;
};

export type SubgroupDetailTruncation = {
  __typename?: 'SubgroupDetailTruncation';
  /** New effective date the detail would be truncated to. */
  newEffectiveDate: Scalars['Date']['output'];
  /** New expiration date the detail would be truncated to */
  newExpirationDate: Scalars['Date']['output'];
  /** The existing subgroup detail being truncated. */
  subgroupDetail: ZebraSubgroupDetail;
};

export type SubgroupEdge = {
  __typename?: 'SubgroupEdge';
  cursor: Scalars['String']['output'];
  node: Subgroup;
};

export type SubgroupFieldValidationError = {
  __typename?: 'SubgroupFieldValidationError';
  /** The name of the column where the error occurred. */
  column_name: Scalars['String']['output'];
  /** The value of the column where the error occurred. */
  column_value: Scalars['String']['output'];
  /** The error message. */
  error_message: Scalars['String']['output'];
  /** The line index in the CSV file where the error occurred. */
  line_number: Scalars['Int']['output'];
  /** The integer position on the line where the error occurred. */
  position: Scalars['Int']['output'];
  /** The type of record for which this line validation error occurred. */
  record_type: RecordType;
};

export type SubgroupFileValidationError = {
  __typename?: 'SubgroupFileValidationError';
  /** The error message. */
  error_message: Scalars['String']['output'];
};

export type SubgroupFilters = {
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  number?: InputMaybe<StringFilter>;
};

export type SubgroupKey = {
  groupCode: Scalars['String']['input'];
  subgroupCode: Scalars['String']['input'];
};

export type SubgroupLineValidationError = {
  __typename?: 'SubgroupLineValidationError';
  /** The error message. */
  error_message: Scalars['String']['output'];
  /** List of field validation errors */
  field_validation_errors: Array<SubgroupFieldValidationError>;
  /** The line index in the CSV file where the error occurred. */
  line_number: Scalars['Int']['output'];
  /** The text of the line where the error occurred. */
  line_text: Scalars['String']['output'];
  /** The type of record for which this line validation error occurred. */
  record_type: RecordType;
};

export type SubgroupOrder = {
  benefitStartDate?: InputMaybe<OrderDirectionEnum>;
  effectiveFrom?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  plan?: InputMaybe<OrderDirectionEnum>;
  terminationDate?: InputMaybe<OrderDirectionEnum>;
};

export type SubgroupScheduleImpact = {
  __typename?: 'SubgroupScheduleImpact';
  /** New detail that would be created for the new schedule */
  createdDetail?: Maybe<SubgroupDetailCreation>;
  /** Existing detail that would be expanded to bridge a gap, if any */
  expandedDetail?: Maybe<SubgroupDetailExpansion>;
  /** The synced subgroup impacted by the schedule change */
  subgroup: SyncedSubgroup;
};

export type SubgroupValidation = {
  __typename?: 'SubgroupValidation';
  /** Statistics on the creation process. */
  creation_stats: CreationStats;
  /** List of file validation errors */
  file_validation_errors: Array<SubgroupFileValidationError>;
  /** Is the file valid? */
  is_valid: Scalars['Boolean']['output'];
  /** List of line validation errors */
  line_validation_errors: Array<SubgroupLineValidationError>;
  /** Statistics on the validation process. */
  validation_stats: ValidationStats;
  /** Were entities created in the database? */
  was_created: Scalars['Boolean']['output'];
};

export type Summary = {
  __typename?: 'Summary';
  failed_test_count: Scalars['Int']['output'];
  passed_test_count: Scalars['Int']['output'];
  percentage_passed: Scalars['Int']['output'];
  test_case_count: Scalars['Int']['output'];
};

export type SuperNetwork = {
  __typename?: 'SuperNetwork';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type SuperNetworkFilter = {
  id?: InputMaybe<IdFilter>;
  userType?: InputMaybe<Scalars['String']['input']>;
};

export type SuperNetworkList = {
  __typename?: 'SuperNetworkList';
  pagination: Pagination;
  results: Array<SuperNetwork>;
};

export type SuperNetworkOrder = {
  code?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export enum SyncDestination {
  Laker = 'LAKER',
  Salesforce = 'SALESFORCE',
  Zes = 'ZES'
}

export type SyncFailure = {
  __typename?: 'SyncFailure';
  error: Scalars['String']['output'];
  membershipUUID: Scalars['ID']['output'];
};

export type SyncFillRuleLinesInput = {
  create: Array<CreateFillRuleLineInput>;
  delete: Array<Scalars['ID']['input']>;
  update: Array<UpdateFillRuleLineInput>;
};

export enum SyncJobPriority {
  High = 'HIGH',
  Normal = 'NORMAL'
}

export type SyncStepTherapyLinesInput = {
  create: Array<CreateStepTherapyLineInput>;
  delete: Array<Scalars['ID']['input']>;
  update: Array<UpdateStepTherapyLineInput>;
};

export type SyncedSubgroup = Subgroup & {
  __typename?: 'SyncedSubgroup';
  currentBenefitPlanOverride?: Maybe<Plan>;
  currentBenefitStartDate?: Maybe<Scalars['Date']['output']>;
  currentDepartment?: Maybe<Department>;
  currentPlanCode?: Maybe<PlanCodeV2>;
  currentTerminationDate?: Maybe<Scalars['Date']['output']>;
  /**
   * Data integrity warnings for this subgroup. Non-empty when underlying data
   * has issues that prevent some details from being displayed.
   */
  dataWarnings: Array<Scalars['String']['output']>;
  details: Array<SyncedSubgroupDetail>;
  firstEffectiveDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Indicates if this subgroup was auto-selected (used in plan test assignment context) */
  isAutoSelected?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  status: GroupStatus;
  zebraSubgroupId: Scalars['String']['output'];
};

export type SyncedSubgroupDetail = SubgroupDetail & {
  __typename?: 'SyncedSubgroupDetail';
  benCapSatisfactionType?: Maybe<SatisfactionType>;
  benefitStartDate?: Maybe<Scalars['Date']['output']>;
  dedSatisfactionType?: Maybe<SatisfactionType>;
  department?: Maybe<Department>;
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  familyBenCap?: Maybe<Scalars['Cents']['output']>;
  familyDed?: Maybe<Scalars['Cents']['output']>;
  familyOop?: Maybe<Scalars['Cents']['output']>;
  id: Scalars['ID']['output'];
  individualBenCap?: Maybe<Scalars['Cents']['output']>;
  individualDed?: Maybe<Scalars['Cents']['output']>;
  individualOop?: Maybe<Scalars['Cents']['output']>;
  naToDed: Scalars['Boolean']['output'];
  oopSatisfactionType?: Maybe<SatisfactionType>;
  overridePlan?: Maybe<Plan>;
  planCode?: Maybe<PlanCodeV2>;
  processRule?: Maybe<ProcessRule>;
  sdc?: Maybe<Sdcv2>;
};

export type TemplateExecutionInput = {
  groupId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
  subgroupId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export type TerminateConnectionValidityInput = {
  id: Scalars['ID']['input'];
};

export type TerminateConsentInput = {
  consentId: Scalars['ID']['input'];
};

export type Terminology = {
  __typename?: 'Terminology';
  created_at?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Time']['output']>;
};

export type TerminologyList = {
  __typename?: 'TerminologyList';
  pagination: Pagination;
  results?: Maybe<Array<Terminology>>;
};

export type TestCaseResult = {
  __typename?: 'TestCaseResult';
  actual_coinsurance?: Maybe<Scalars['Int']['output']>;
  actual_copay?: Maybe<Scalars['Float']['output']>;
  actual_coverage: CoverageEnum;
  created_at?: Maybe<Scalars['Time']['output']>;
  diff_notes?: Maybe<Scalars['String']['output']>;
  expected_coinsurance?: Maybe<Scalars['Int']['output']>;
  expected_copay?: Maybe<Scalars['Float']['output']>;
  expected_coverage: CoverageEnum;
  laker_copay_handler?: Maybe<Scalars['String']['output']>;
  laker_group_billed_amount?: Maybe<Scalars['String']['output']>;
  laker_rej_code?: Maybe<Scalars['String']['output']>;
  laker_rej_notes?: Maybe<Scalars['String']['output']>;
  laker_res_message?: Maybe<Scalars['String']['output']>;
  result: TestResultEnum;
};

export enum TestCaseTypeEnum {
  Custom = 'CUSTOM',
  Standard = 'STANDARD'
}

export type TestMember = {
  __typename?: 'TestMember';
  cardId?: Maybe<Scalars['String']['output']>;
  member_id: Scalars['ID']['output'];
  member_name: Scalars['String']['output'];
  personCode?: Maybe<Scalars['String']['output']>;
};

export type TestResult = {
  __typename?: 'TestResult';
  actual_coinsurance?: Maybe<Scalars['Int']['output']>;
  actual_copay?: Maybe<Scalars['Float']['output']>;
  actual_coverage: CoverageEnum;
  diff_notes?: Maybe<Scalars['String']['output']>;
  expected_coinsurance?: Maybe<Scalars['Int']['output']>;
  expected_copay?: Maybe<Scalars['Float']['output']>;
  expected_coverage: CoverageEnum;
  laker_copay_handler?: Maybe<Scalars['String']['output']>;
  laker_group_billed_amount?: Maybe<Scalars['String']['output']>;
  laker_rej_code?: Maybe<Scalars['String']['output']>;
  laker_rej_notes?: Maybe<Scalars['String']['output']>;
  laker_res_message?: Maybe<Scalars['String']['output']>;
  ndc: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  result: TestResultEnum;
  test_name: Scalars['String']['output'];
};

export enum TestResultEnum {
  Failed = 'FAILED',
  Passed = 'PASSED'
}

export type TestResultList = {
  __typename?: 'TestResultList';
  output_file_id: Scalars['ID']['output'];
  result: Array<TestResult>;
  summary: Summary;
};

export type TestRun = Node & {
  __typename?: 'TestRun';
  createdAt: Scalars['Time']['output'];
  createdBy: Credential;
  executions: Array<TestRunExecution>;
  holdUnitCostConstant: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ignoreAgeHandler: Scalars['Boolean']['output'];
  ignoreDiscontinuedNdcs: Scalars['Boolean']['output'];
  ignoreDispenseLimitHandler: Scalars['Boolean']['output'];
  ignoreMemberEligibilityEndDate: Scalars['Boolean']['output'];
  overrideRefillTooSoon: Scalars['Boolean']['output'];
  reverseAllClaims: Scalars['Boolean']['output'];
  testName: Scalars['String']['output'];
  testType: TestType;
  updatedAt: Scalars['Time']['output'];
};

export type TestRunConnection = {
  __typename?: 'TestRunConnection';
  edges: Array<TestRunEdge>;
  pageInfo: PageInfo;
};

export type TestRunEdge = {
  __typename?: 'TestRunEdge';
  cursor: Scalars['String']['output'];
  node: TestRun;
};

export type TestRunExecution = Node & {
  __typename?: 'TestRunExecution';
  adjudicationStatus: AdjudicationStatus;
  benefitPlan: BenefitPlan;
  createdAt: Scalars['Time']['output'];
  discardReason?: Maybe<Scalars['String']['output']>;
  errorCases: Scalars['Int']['output'];
  failedCases: Scalars['Int']['output'];
  group: Group;
  id: Scalars['ID']['output'];
  naCases: Scalars['Int']['output'];
  passedCases: Scalars['Int']['output'];
  reversalStatus: ReversalStatus;
  /** @deprecated Use subgroupV2 */
  subgroup: Subgroup;
  subgroupV2?: Maybe<Subgroup>;
  suite: PlanTestSuite;
  template?: Maybe<PlanTestSuite>;
  testRun: TestRun;
  totalCases: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
  validationStatus: ValidationStatus;
};

export type TestRunExecutionConnection = {
  __typename?: 'TestRunExecutionConnection';
  edges: Array<TestRunExecutionEdge>;
  pageInfo: PageInfo;
};

export type TestRunExecutionEdge = {
  __typename?: 'TestRunExecutionEdge';
  cursor: Scalars['String']['output'];
  node: TestRunExecution;
};

export type TestRunExecutionFilters = {
  adjudicationStatus?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<TimeFilter>;
  createdBy?: InputMaybe<IntFilter>;
  groupId?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  planId?: InputMaybe<IdFilter>;
  reversalStatus?: InputMaybe<StringFilter>;
  subgroupId?: InputMaybe<IdFilter>;
  suiteId?: InputMaybe<IdFilter>;
  templateId?: InputMaybe<IdFilter>;
  validationStatus?: InputMaybe<StringFilter>;
};

export type TestRunExecutionOrder = {
  adjudicationStatus?: InputMaybe<OrderDirectionEnum>;
  createdAt?: InputMaybe<OrderDirectionEnum>;
  failedCases?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
  passedCases?: InputMaybe<OrderDirectionEnum>;
  reversalStatus?: InputMaybe<OrderDirectionEnum>;
  totalCases?: InputMaybe<OrderDirectionEnum>;
  updatedAt?: InputMaybe<OrderDirectionEnum>;
  validationStatus?: InputMaybe<OrderDirectionEnum>;
};

export type TestRunFilters = {
  aggregateAdjudicationStatus?: InputMaybe<AggregateAdjudicationStatus>;
  createdAt?: InputMaybe<TimeFilter>;
  createdBy?: InputMaybe<IntFilter>;
  groupId?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  planId?: InputMaybe<IdFilter>;
  testName?: InputMaybe<StringFilter>;
  testType?: InputMaybe<StringFilter>;
};

export type TestRunOrder = {
  createdAt?: InputMaybe<OrderDirectionEnum>;
  testName?: InputMaybe<OrderDirectionEnum>;
  testType?: InputMaybe<OrderDirectionEnum>;
  updatedAt?: InputMaybe<OrderDirectionEnum>;
};

export enum TestType {
  /**
   * System-assigned to the run a TEMPLATE run spawns for plans with AI-generated
   * test cases. Output only: no create input accepts it.
   */
  Ai = 'AI',
  CsvUpload = 'CSV_UPLOAD',
  SingleClaimTest = 'SINGLE_CLAIM_TEST',
  Template = 'TEMPLATE'
}

export type Tier = {
  __typename?: 'Tier';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum TierBasis {
  /** 3 */
  Cost = 'COST',
  /** 1 */
  DaysSupply = 'DAYS_SUPPLY',
  /** 4 */
  IngDispTax = 'ING_DISP_TAX',
  /** 2 */
  Quantity = 'QUANTITY'
}

export type TimeFilter = {
  /** Equal */
  eq?: InputMaybe<Scalars['Time']['input']>;
  /** Greater than */
  gt?: InputMaybe<Scalars['Time']['input']>;
  /** Greater than or equal */
  gte?: InputMaybe<Scalars['Time']['input']>;
  /** Less than */
  lt?: InputMaybe<Scalars['Time']['input']>;
  /** Less than or equal */
  lte?: InputMaybe<Scalars['Time']['input']>;
  /** Not equal */
  ne?: InputMaybe<Scalars['Time']['input']>;
};

export type TimeRange = {
  __typename?: 'TimeRange';
  end?: Maybe<Scalars['Time']['output']>;
  start?: Maybe<Scalars['Time']['output']>;
};

export type TimelineDiscrepancies = {
  __typename?: 'TimelineDiscrepancies';
  hasDiscrepancy: Scalars['Boolean']['output'];
  matches: Array<TimelineRecordMatch>;
};

/** Common shape shared by all member timeline records. */
export type TimelineRecord = {
  effectiveDate: Scalars['Date']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
};

export type TimelineRecordInput =
  { cardholderToGroupTimeline: CardholderToGroupTimelineRecordInput; memberCOBTimeline?: never; memberEligibilityFlagTimeline?: never; memberEligibilityTimeline?: never; memberToSubgroupTimeline?: never; }
  |  { cardholderToGroupTimeline?: never; memberCOBTimeline: MemberCobTimelineRecordInput; memberEligibilityFlagTimeline?: never; memberEligibilityTimeline?: never; memberToSubgroupTimeline?: never; }
  |  { cardholderToGroupTimeline?: never; memberCOBTimeline?: never; memberEligibilityFlagTimeline: MemberEligibilityFlagTimelineRecordInput; memberEligibilityTimeline?: never; memberToSubgroupTimeline?: never; }
  |  { cardholderToGroupTimeline?: never; memberCOBTimeline?: never; memberEligibilityFlagTimeline?: never; memberEligibilityTimeline: MemberEligibilityTimelineRecordInput; memberToSubgroupTimeline?: never; }
  |  { cardholderToGroupTimeline?: never; memberCOBTimeline?: never; memberEligibilityFlagTimeline?: never; memberEligibilityTimeline?: never; memberToSubgroupTimeline: MemberToSubgroupTimelineRecordInput; };

export type TimelineRecordMatch = {
  __typename?: 'TimelineRecordMatch';
  matchType: TimelineRecordMatchType;
  portalId?: Maybe<Scalars['ID']['output']>;
  zebraId?: Maybe<Scalars['ID']['output']>;
};

export enum TimelineRecordMatchType {
  /**
   * An exact replica of the record exists in the linked system.
   * Relevant data is synced between the two records.
   */
  Exact = 'EXACT',
  /** The record is irrelevant for systems sync status. */
  Exempt = 'EXEMPT',
  /** The record is not synced to the linked system. */
  None = 'NONE'
}

export type TransactionConnection = {
  __typename?: 'TransactionConnection';
  csvDownloadURL?: Maybe<Scalars['String']['output']>;
  edges: Array<TransactionEdge>;
  pageInfo: PageInfo;
};

export type TransactionEdge = {
  __typename?: 'TransactionEdge';
  cursor: Scalars['String']['output'];
  node: Transactions;
};

export type TransactionFilters = {
  endDate: Scalars['Time']['input'];
  isSDC?: InputMaybe<Scalars['Boolean']['input']>;
  membershipUUID: Scalars['UUID']['input'];
  sdcId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Time']['input'];
};

/** TransactionTypeEnum represents the type of accumulator transaction, Med/Rx. */
export enum TransactionTypeEnum {
  Med = 'MED',
  Rx = 'RX'
}

export type Transactions = {
  __typename?: 'Transactions';
  addedBy?: Maybe<Scalars['String']['output']>;
  adjudicatorPersonCode: Scalars['Int']['output'];
  authorizationNumber?: Maybe<Scalars['String']['output']>;
  benefitTransactionType?: Maybe<Scalars['String']['output']>;
  cardId?: Maybe<Scalars['String']['output']>;
  claimStatus?: Maybe<Scalars['String']['output']>;
  claimsId?: Maybe<Scalars['UUID']['output']>;
  copay: Scalars['Cents']['output'];
  dateAdded?: Maybe<Scalars['Time']['output']>;
  daySupply?: Maybe<Scalars['Int']['output']>;
  deductible: Scalars['Cents']['output'];
  drugDescription?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  groupBilled: Scalars['Cents']['output'];
  groupNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  memberName?: Maybe<Scalars['String']['output']>;
  nabp?: Maybe<Scalars['String']['output']>;
  ndc?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outOfPocket: Scalars['Cents']['output'];
  paid: Scalars['Cents']['output'];
  prescriber?: Maybe<Scalars['String']['output']>;
  providerPersonCode: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  runningDeductible: Scalars['Cents']['output'];
  runningOutOfPocket: Scalars['Cents']['output'];
  rxNumber?: Maybe<Scalars['String']['output']>;
  sdcValues?: Maybe<Array<Maybe<SdcValues>>>;
  subGroup?: Maybe<Scalars['String']['output']>;
};

export type TransmissionFormat = {
  __typename?: 'TransmissionFormat';
  /** Configuration obj, schema varies */
  config: Scalars['Map']['output'];
  id: Scalars['ID']['output'];
  /** Modified date */
  last_modified?: Maybe<Scalars['Time']['output']>;
  /** User-defined name. */
  name: Scalars['String']['output'];
  /** S3 file id */
  s3_file_id?: Maybe<Scalars['ID']['output']>;
  /** A sample file to use against the config (in the case of incoming files) */
  sampleFile?: Maybe<Scalars['String']['output']>;
  /** Description of config structure/schema, i.e. 'paid_claim' */
  type: TransmissionFormatType;
};

export type TransmissionFormatDelimiter = {
  __typename?: 'TransmissionFormatDelimiter';
  /** This goes in the TransmissionFormat config.sections.column_delimiter */
  delimiter: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type TransmissionFormatFilters = {
  id?: InputMaybe<IdFilter>;
  /** Partial match filter (substring). */
  name?: InputMaybe<StringFilter>;
  /** Partial match filter (substring). */
  type?: InputMaybe<StringFilter>;
};

export type TransmissionFormatList = {
  __typename?: 'TransmissionFormatList';
  pagination: Pagination;
  results: Array<TransmissionFormat>;
};

export type TransmissionFormatOrder = {
  last_modified?: InputMaybe<OrderDirectionEnum>;
  name?: InputMaybe<OrderDirectionEnum>;
};

export type TransmissionFormatPreview = {
  __typename?: 'TransmissionFormatPreview';
  /** One entry for every line the config dropped, empty when it dropped none. */
  errors: Array<TransmissionFormatPreviewError>;
  /** The lines that survived the pipeline, in file order. */
  lines: Array<Scalars['Map']['output']>;
};

/** Why a line of the sample file is absent from a preview. */
export type TransmissionFormatPreviewError = {
  __typename?: 'TransmissionFormatPreviewError';
  /** The callback that threw. */
  callback?: Maybe<Scalars['String']['output']>;
  /** The transform field being computed when the failure happened. */
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  /**
   * Index of the parsed record, counting from 1. Differs from row for formats
   * where several file lines make up one record.
   */
  record?: Maybe<Scalars['Int']['output']>;
  /**
   * Line number in the sample file, counting from 1. Absent when the config
   * itself is unusable, because then no individual line is at fault.
   */
  row?: Maybe<Scalars['Int']['output']>;
  stage: PreviewStage;
};

export enum TransmissionFormatType {
  Accum = 'ACCUM',
  Card = 'CARD',
  CompositeReport = 'COMPOSITE_REPORT',
  Elig = 'ELIG',
  Eligibility = 'ELIGIBILITY',
  EligFlag = 'ELIG_FLAG',
  GatewayEligibility = 'GATEWAY_ELIGIBILITY',
  Lock = 'LOCK',
  PaidClaim = 'PAID_CLAIM',
  PaidClaimEligibilityAudit = 'PAID_CLAIM_ELIGIBILITY_AUDIT',
  SapProvider = 'SAP_PROVIDER'
}

export type TransmissionJob = {
  __typename?: 'TransmissionJob';
  /** JSON blob containing the configuration for a particular report. */
  config: Scalars['Map']['output'];
  /** Null for manually created jobs. */
  connection_id: Scalars['Int']['output'];
  /** Timestamp of record being written to the DB. */
  created_at: Scalars['Time']['output'];
  /**
   * Persons or actor that created this job.
   * Null for automatically generated jobs.
   */
  credential_id: Scalars['Int']['output'];
  /** Current status */
  current_status: TransmissionJobStatusValue;
  /** Current status message */
  current_status_message: Scalars['String']['output'];
  /** Time the job completed. Null if the status is running. */
  finished_at?: Maybe<Scalars['Time']['output']>;
  /** Group associated to the job */
  groups?: Maybe<Array<Maybe<Group>>>;
  /** Time ordered list of status change events. */
  history?: Maybe<TransmissionJobStatusList>;
  id: Scalars['ID']['output'];
  /**
   * Target location (i.e. an S3 bucket) to write transmission (report) content to.
   * s3://bucket/folder/file
   * sftp://hitrust.org/upload
   * http://other.mplace/folder
   */
  location: Scalars['String']['output'];
  /** Metadata about the job */
  meta: Scalars['Map']['output'];
  /** Processed by the system either forge or dredd */
  runAt: Scalars['String']['output'];
  /** S3 file processed by the job */
  s3_file?: Maybe<S3File>;
  /**
   * Time range for connection (automatic) based jobs to support contiguous, non-overlapping report generation.
   * i.e. ["2019-06-18 17:55:07","2019-06-19 17:55:07")
   */
  sequence_interval: Scalars['String']['output'];
  /** Enumerated type describing where this job originated. */
  source: TransmissionSource;
};


export type TransmissionJobHistoryArgs = {
  order?: InputMaybe<TransmissionJobStatusOrder>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<TransmissionJobStatusFilters>;
};

export type TransmissionJobFilters = {
  /** ID of the actor associated with the job. */
  actor_id?: InputMaybe<IdFilter>;
  /** Entity to list jobs for connection created (automatically scheduled) jobs. */
  connection_id?: InputMaybe<IdFilter>;
  /** Date and time the job was created. */
  created_at?: InputMaybe<TimeFilter>;
  /** Person/actor entity to list jobs for manually created jobs. */
  credential_id?: InputMaybe<IdFilter>;
  /** Current Status of the job - started/blocked/running/success/failed/skipped. */
  current_status?: InputMaybe<StringFilter>;
  /** File type of the S3 file associated with the job. */
  file_type?: InputMaybe<StringFilter>;
  /** ID of the group associated with the job. */
  group_id?: InputMaybe<IdFilter>;
  id?: InputMaybe<IdFilter>;
  /** Target location data is written to. */
  location?: InputMaybe<StringFilter>;
  /** Name of the job. */
  meta_name?: InputMaybe<StringFilter>;
  /** ID of the S3 file associated with the job. */
  s3_file_id?: InputMaybe<IdFilter>;
  /** Enumerated type CONNECTION/PORTAL. */
  source?: InputMaybe<StringFilter>;
};

export type TransmissionJobList = {
  __typename?: 'TransmissionJobList';
  pagination: Pagination;
  results: Array<TransmissionJob>;
};

export type TransmissionJobOrder = {
  created_at?: InputMaybe<OrderDirectionEnum>;
};

export type TransmissionJobStatus = {
  __typename?: 'TransmissionJobStatus';
  created_at: Scalars['Time']['output'];
  status: TransmissionJobStatusValue;
  status_message: Scalars['String']['output'];
};

export type TransmissionJobStatusFilters = {
  created_at?: InputMaybe<TimeFilter>;
};

export type TransmissionJobStatusList = {
  __typename?: 'TransmissionJobStatusList';
  pagination: Pagination;
  results: Array<TransmissionJobStatus>;
};

export type TransmissionJobStatusOrder = {
  created_at?: InputMaybe<OrderDirectionEnum>;
};

export enum TransmissionJobStatusValue {
  Blocked = 'BLOCKED',
  Error = 'ERROR',
  Failed = 'FAILED',
  NotificationSent = 'NOTIFICATION_SENT',
  PartialSuccess = 'PARTIAL_SUCCESS',
  Queued = 'QUEUED',
  Rerun = 'RERUN',
  Running = 'RUNNING',
  Skipped = 'SKIPPED',
  Started = 'STARTED',
  Success = 'SUCCESS'
}

export enum TransmissionJobType {
  PaidClaim = 'PAID_CLAIM',
  PartnerFile = 'PARTNER_FILE'
}

export enum TransmissionSource {
  Connection = 'CONNECTION',
  Portal = 'PORTAL'
}

export enum UnitType {
  /** 2 */
  DaysSupply = 'DAYS_SUPPLY',
  /** 1 */
  MetricQuantity = 'METRIC_QUANTITY',
  /** 3 */
  Prescriptions = 'PRESCRIPTIONS'
}

export type UniversalDocumentationCreate = {
  file: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UniversalDocumentationUpdate = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConnectionInput = {
  activation_date?: InputMaybe<Scalars['Time']['input']>;
  /** Person or organization tied to this connection. */
  actor_id: Scalars['ID']['input'];
  /**
   * Variable format configuration.
   * Wiki: https://smithrx.atlassian.net/wiki/spaces/EN/pages/530055376/Automated+Claims+Reporting
   * Outgoing+paid_claim: transmission/reports.PaidClaimConnectionParams
   */
  config: Scalars['Map']['input'];
  credentials_id?: InputMaybe<Scalars['Int']['input']>;
  /** When set cron_schedule describes when the next report should be generated. */
  cron_schedule: Scalars['String']['input'];
  deactivation_date?: InputMaybe<Scalars['Time']['input']>;
  deliverable_response_method?: InputMaybe<Scalars['String']['input']>;
  deliverable_type?: InputMaybe<Scalars['String']['input']>;
  direction: ConnectionDirection;
  id: Scalars['ID']['input'];
  implementation_project_uuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target or source location for file handling. Includes protocol, path, and filename.
   * i.e. s3://srx-staging-partner-sftp-hrzn.s3.us-west-2.amazonaws.com/paid_claim_report.csv
   */
  location: Scalars['String']['input'];
  /** Duration (in seconds) that a transmission can be blocked before alerts should be generated. */
  max_latency: Scalars['Int']['input'];
  /** Human readable name for this connection. */
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  /** Email notification configuration */
  notification_config?: InputMaybe<ConnectionNotificationConfigInput>;
  review_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  /** transmission_format record used to parse inbound or compose outbound file content. */
  transmission_format_id: Scalars['ID']['input'];
  type: ConnectionType;
};

export type UpdateCustomDrugListV2Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DrugListStatus>;
};

export type UpdateDefaultPlanInput = {
  benCapSatisfactionType?: InputMaybe<SatisfactionType>;
  dedSatisfactionType?: InputMaybe<SatisfactionType>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  familyBenCap?: InputMaybe<Scalars['Cents']['input']>;
  familyDed?: InputMaybe<Scalars['Cents']['input']>;
  familyOop?: InputMaybe<Scalars['Cents']['input']>;
  groupID?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  individualBenCap?: InputMaybe<Scalars['Cents']['input']>;
  individualDed?: InputMaybe<Scalars['Cents']['input']>;
  individualOop?: InputMaybe<Scalars['Cents']['input']>;
  oopSatisfactionType?: InputMaybe<SatisfactionType>;
  planID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDepartmentInput = {
  /** @deprecated Departments cannot be updated. Delete and recreate */
  code?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Departments cannot be updated. Delete and recreate */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDrugListItemInputV2 = {
  customDrugListId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  drugListItemId: Scalars['ID']['input'];
  effectiveAt?: InputMaybe<Scalars['Time']['input']>;
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  gpi?: InputMaybe<Scalars['String']['input']>;
  mony?: InputMaybe<Scalars['String']['input']>;
  ndc?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDrugListUploadInput = {
  /** The ID of the DrugListUpload to update */
  id: Scalars['ID']['input'];
  /** The upload name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The new status for the DrugListUpload */
  status?: InputMaybe<UploadStatus>;
};

export type UpdateFillRuleLineInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dontApplyBeforeDate?: InputMaybe<Scalars['Date']['input']>;
  drugID?: InputMaybe<Scalars['String']['input']>;
  drugValue?: InputMaybe<DrugValue>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  excludeMOClaims?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  hxClaimsQuantityLessOrEqual?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  level?: InputMaybe<Scalars['Int']['input']>;
  monyCode?: InputMaybe<Array<MonyCode>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  periodType?: InputMaybe<PeriodType>;
  periodX?: InputMaybe<Scalars['Int']['input']>;
  profileMatchOn?: InputMaybe<Scalars['Int']['input']>;
  rule?: InputMaybe<FillRuleLineRuleType>;
  rxOTCCode?: InputMaybe<RxOtcInd>;
  scriptTagMatchValue?: InputMaybe<Scalars['String']['input']>;
  trueProcessRuleID?: InputMaybe<Scalars['ID']['input']>;
  trueProcessRulePriority?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGroupDetailsInput = {
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  legalEntityName?: InputMaybe<Scalars['String']['input']>;
  legalStateOfJurisdiction?: InputMaybe<Scalars['String']['input']>;
  openEnrollmentEnd?: InputMaybe<Scalars['Time']['input']>;
  openEnrollmentStart?: InputMaybe<Scalars['Time']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  planRenewalDate?: InputMaybe<Scalars['Time']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupInput = {
  accumulateSeparately?: InputMaybe<Scalars['Boolean']['input']>;
  associatePartners?: InputMaybe<Array<InputMaybe<GroupToPartnerInput>>>;
  autoEnrollment?: InputMaybe<Scalars['Int']['input']>;
  benCapAction?: InputMaybe<Scalars['Int']['input']>;
  benefitPeriodMonths?: InputMaybe<Scalars['Int']['input']>;
  benefitRestart?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Use benefitStartDate */
  benefit_start_date?: InputMaybe<Scalars['Time']['input']>;
  bin?: InputMaybe<Scalars['String']['input']>;
  cardCarrierTemplate?: InputMaybe<Scalars['String']['input']>;
  cardEnvelopTemplate?: InputMaybe<Scalars['String']['input']>;
  cardTemplate?: InputMaybe<Scalars['String']['input']>;
  carrierCode?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use carrierCode */
  carrier_code?: InputMaybe<Scalars['String']['input']>;
  copayHandlerAfterCapId?: InputMaybe<Scalars['String']['input']>;
  copayHandlerMailId?: InputMaybe<Scalars['String']['input']>;
  daysSupply90ForceMailOrder?: InputMaybe<Scalars['Boolean']['input']>;
  deductibleNaAfterOOPCap?: InputMaybe<Scalars['Boolean']['input']>;
  designatedPharmacyComment?: InputMaybe<Scalars['String']['input']>;
  designatedPharmacyFror?: InputMaybe<DesignatedPharmacyFror>;
  designatedPharmacyHas340b?: InputMaybe<Scalars['Boolean']['input']>;
  designatedPharmacyHasCopayIncentive?: InputMaybe<Scalars['Boolean']['input']>;
  designatedPharmacyHasFror?: InputMaybe<Scalars['Boolean']['input']>;
  designatedPharmacyPoc?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<UpdateGroupDetailsInput>;
  disassociatePartners?: InputMaybe<Array<InputMaybe<GroupToPartnerInput>>>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Use effectiveDate */
  effective_date?: InputMaybe<Scalars['Time']['input']>;
  excludeAccums?: InputMaybe<Scalars['Boolean']['input']>;
  excludeDaw2?: InputMaybe<Scalars['Boolean']['input']>;
  excludeGenFromDed?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  extendFirstBenefitPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignatedPharmacy?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreHistory?: InputMaybe<Scalars['Boolean']['input']>;
  implementationPhase?: InputMaybe<GroupImplementationPhase>;
  /** @deprecated Use implementationPhase */
  implementation_phase?: InputMaybe<GroupImplementationPhase>;
  insuranceType?: InputMaybe<Scalars['String']['input']>;
  invoiceConfigUuidList?: InputMaybe<Array<Scalars['String']['input']>>;
  mailNetworkID?: InputMaybe<Scalars['String']['input']>;
  mailOrderType?: InputMaybe<Scalars['Int']['input']>;
  maxAllowedCostKey?: InputMaybe<Scalars['Cents']['input']>;
  maxAllowedCostMO?: InputMaybe<Scalars['Cents']['input']>;
  maxAllowedCostOL?: InputMaybe<Scalars['Cents']['input']>;
  maxAllowedCostSP?: InputMaybe<Scalars['Cents']['input']>;
  maxPrescriptions?: InputMaybe<Scalars['Int']['input']>;
  maxRevDaysOldKey?: InputMaybe<Scalars['Int']['input']>;
  maxRevDaysOldMO?: InputMaybe<Scalars['Int']['input']>;
  maxRevDaysOldOL?: InputMaybe<Scalars['Int']['input']>;
  maxRevDaysOldSP?: InputMaybe<Scalars['Int']['input']>;
  maxRxDaysOldKey?: InputMaybe<Scalars['Int']['input']>;
  maxRxDaysOldMO?: InputMaybe<Scalars['Int']['input']>;
  maxRxDaysOldOL?: InputMaybe<Scalars['Int']['input']>;
  maxRxDaysOldSP?: InputMaybe<Scalars['Int']['input']>;
  maxWrittenDaysOld?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pcLogic?: InputMaybe<Scalars['String']['input']>;
  pcn?: InputMaybe<Scalars['String']['input']>;
  predateAutoEnrollDays?: InputMaybe<Scalars['Int']['input']>;
  prescriberCheck?: InputMaybe<Scalars['Int']['input']>;
  prescriberListId?: InputMaybe<Scalars['String']['input']>;
  printCardOption?: InputMaybe<Scalars['String']['input']>;
  pushToSalesforce?: InputMaybe<Scalars['Boolean']['input']>;
  runOutDate?: InputMaybe<Scalars['Date']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  serviceNotes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  taxCalculation?: InputMaybe<Scalars['String']['input']>;
  terminationDays?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use expirationDate */
  termination_date?: InputMaybe<Scalars['Time']['input']>;
  testOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for updating a single IFPFile row's data and re-running validation. */
export type UpdateIfpFileRowInput = {
  rowData: Scalars['Map']['input'];
  rowID: Scalars['ID']['input'];
};

export type UpdateMpaClaimInstructionsV2Input = {
  /**
   * Full desired instruction set: a full-state replace. Fields present are set,
   * fields omitted are cleared. A duplicate field is rejected.
   */
  instructions: Array<ClaimInstructionValueInput>;
  mpaID: Scalars['UUID']['input'];
};

export type UpdateMpaProcessRuleInput = {
  /** MPA ID */
  mpaID: Scalars['UUID']['input'];
  /** MPA Process Rule Input to replace the mpa_process_rule entries with new entries */
  mpaProcessRuleInput: MpaProcessRuleInput;
};

export type UpdateMemberInput = {
  /** The member's address line 1 */
  address_1?: InputMaybe<Scalars['String']['input']>;
  /** The member's address line 2 */
  address_2?: InputMaybe<Scalars['String']['input']>;
  /** The member's city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Name of carrier */
  cob_carrier_name?: InputMaybe<Scalars['String']['input']>;
  /** Has COB coverage */
  cob_coverage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of COB Coverage */
  cob_coverage_type?: InputMaybe<MemberCobCoverageTypeEnum>;
  /** Date COB ends */
  cob_end?: InputMaybe<Scalars['Time']['input']>;
  /** Date COB starts */
  cob_start?: InputMaybe<Scalars['Time']['input']>;
  /** The member's country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The member's coverage end date */
  coverage_end?: InputMaybe<Scalars['Time']['input']>;
  /** The member's coverage level */
  coverage_level?: InputMaybe<MemberCoverageLevelEnum>;
  /** The member's coverage start date */
  coverage_start?: InputMaybe<Scalars['Time']['input']>;
  /** The member's date of birth */
  date_of_birth?: InputMaybe<Scalars['Time']['input']>;
  /** The date the member died. */
  death_date?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Whether the member is deceased.
   *
   * It need not be sent alongside `death_date`, which implies it. Sending it on its own is how
   * a death reported without its date is recorded. Sending false for a member who has a
   * `death_date` is rejected unless the same request clears the date, since a stored date
   * always means deceased.
   */
  deceased?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Department UUID to move the member to. Must already be a valid subgroup when combined with plan code ID
   * Not valid to change on a dependent.
   */
  department_id?: InputMaybe<Scalars['ID']['input']>;
  /** The member's email */
  email?: InputMaybe<Scalars['String']['input']>;
  /**
   * The member's emergency contact, whose three parts are stored as three columns and can be
   * edited one at a time. An empty string is how one is cleared.
   */
  emergency_contact_name?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_phone?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_relationship?: InputMaybe<Scalars['String']['input']>;
  /** The member's first name */
  first_name?: InputMaybe<Scalars['String']['input']>;
  /** The member's gender */
  gender?: InputMaybe<MemberGenderEnum>;
  /** add laker person code */
  laker_person_code?: InputMaybe<Scalars['ID']['input']>;
  /** The member's last name */
  last_name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The member's marital status, from the https://build.fhir.org/valueset-marital-status.html
   * value set.
   */
  marital_status?: InputMaybe<MemberMaritalStatusEnum>;
  /** The member's middle name */
  middle_name?: InputMaybe<Scalars['String']['input']>;
  /** add provider person code */
  person_code?: InputMaybe<Scalars['ID']['input']>;
  /** The member's alternative phone number */
  phone_alt?: InputMaybe<Scalars['String']['input']>;
  /** The member's cell phone number */
  phone_cell?: InputMaybe<Scalars['String']['input']>;
  /** The member's default phone number */
  phone_default?: InputMaybe<Scalars['String']['input']>;
  /** The member's home phone number */
  phone_home?: InputMaybe<Scalars['String']['input']>;
  /** The member's work phone number */
  phone_work?: InputMaybe<Scalars['String']['input']>;
  /**
   * Plan Code UUID to move the member to. Must already be a valid subgroup when combined with department ID.
   * Not valid to change on a dependent.
   */
  plan_code_id?: InputMaybe<Scalars['ID']['input']>;
  /** Profile address 1 line */
  profile_address_1?: InputMaybe<Scalars['String']['input']>;
  /** Profile address 2 line */
  profile_address_2?: InputMaybe<Scalars['String']['input']>;
  /** Profile address city */
  profile_city?: InputMaybe<Scalars['String']['input']>;
  /** Profile address country */
  profile_country?: InputMaybe<Scalars['String']['input']>;
  /** Profile cell phone */
  profile_phone_cell?: InputMaybe<Scalars['String']['input']>;
  /** Profile address state */
  profile_state?: InputMaybe<Scalars['String']['input']>;
  /** Profile address zip */
  profile_zip?: InputMaybe<Scalars['String']['input']>;
  /** The member's relationship to the subscriber */
  relationship_to_subscriber?: InputMaybe<MemberRelationshipEnum>;
  /** The member's social security number */
  ssn?: InputMaybe<Scalars['String']['input']>;
  /** The member's state */
  state?: InputMaybe<Scalars['String']['input']>;
  /** The member's suffix */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The member's title if any */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The member's zip code */
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMemberProfileInput = {
  /** member id */
  id: Scalars['ID']['input'];
  /** The member's cell phone number */
  phone_cell?: InputMaybe<Scalars['String']['input']>;
  /** The member's default phone number */
  phone_default?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePartnerInput = {
  account_holder?: InputMaybe<Scalars['Boolean']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  s3_bucket?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  useCarrierCode?: InputMaybe<Scalars['Boolean']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlanCobSettingsInput = {
  allowCOB: Scalars['Boolean']['input'];
  onlyPayPrimaryClaims: Scalars['Boolean']['input'];
  planID: Scalars['ID']['input'];
  planToCOBObjects: Array<PlanToCobInput>;
};

export type UpdatePlanCodeImpactAssessment = {
  __typename?: 'UpdatePlanCodeImpactAssessment';
  /**
   * Opaque token encoding the assessment state. Pass to groupUpdatePlanCode
   * to apply the assessed subgroup detail synchronization. If the
   * underlying data has changed since the assessment, the mutation fails.
   */
  assessmentToken: Scalars['String']['output'];
  /** Subgroups whose details would change as part of this plan code schedule modification. */
  impactedSubgroups: Array<UpdateSubgroupScheduleImpact>;
};

export type UpdatePlanCodeV2Input = {
  /**
   * Token from groupAssessUpdatePlanCodeImpact. Required whenever the
   * assessment reports any subgroup detail under truncatedDetails,
   * deletedDetails or resyncedDetails. When provided, applies subgroup detail
   * synchronization with the plan code update. If state has drifted since the
   * assessment, the mutation fails.
   */
  assessmentToken?: InputMaybe<Scalars['String']['input']>;
  benefitPlanId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use benefitPlanId instead */
  benefit_plan_id?: InputMaybe<Scalars['ID']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Use effectiveDate */
  effective_from?: InputMaybe<Scalars['Time']['input']>;
  /** @deprecated Use expirationDate */
  effective_to?: InputMaybe<Scalars['Time']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  recordID: Scalars['ID']['input'];
};

export type UpdatePlanDawInput = {
  dawSettings: Array<DawSettingInput>;
  excludeForOop: Scalars['Boolean']['input'];
  excludeFromDed: Scalars['Boolean']['input'];
  forceZero: Scalars['Boolean']['input'];
  planPayAfterOop: Scalars['Boolean']['input'];
  planUUID: Scalars['ID']['input'];
};

export type UpdatePlanHandlerInput = {
  benAfterCapCopayHandler?: InputMaybe<Scalars['ID']['input']>;
  defaultAgeHandler?: InputMaybe<Scalars['ID']['input']>;
  defaultBillCostHandler?: InputMaybe<Scalars['ID']['input']>;
  defaultCopayHandler?: InputMaybe<Scalars['ID']['input']>;
  defaultCostHandler?: InputMaybe<Scalars['ID']['input']>;
  defaultDispFeeHandler?: InputMaybe<Scalars['ID']['input']>;
  defaultDispLimitHandler?: InputMaybe<Scalars['ID']['input']>;
  defaultRefillHandler?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  oopAfterCapCopayHandler?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePlanTestSuiteInput = {
  /** Plan Test suite identifier */
  ID: Scalars['ID']['input'];
};

export type UpdateProcessRuleInput = {
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  id: Scalars['ID']['input'];
  processRuleLines?: InputMaybe<Array<ProcessRuleLineInput>>;
};

export type UpdateProcessRuleLineActionsInput = {
  addRegulatoryFee?: InputMaybe<Scalars['Float']['input']>;
  addSdc?: InputMaybe<Scalars['UUID']['input']>;
  ageHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  allowNegativePayments?: InputMaybe<Scalars['Boolean']['input']>;
  billCostHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  copayHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  costHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  deferMessage?: InputMaybe<Scalars['Boolean']['input']>;
  dispenseFeeHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  dispenseLimitHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** @deprecated Field is no longer used */
  excludeWithRejectCode?: InputMaybe<Scalars['String']['input']>;
  forceZeroTax?: InputMaybe<Scalars['Boolean']['input']>;
  ignore7571Reject?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreAccums?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreDateWrittenReject?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreGroupMaxDollar?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreInvalidPrescriber?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreOTCReject?: InputMaybe<Scalars['Boolean']['input']>;
  ignorePhysicianChecks?: InputMaybe<Scalars['Boolean']['input']>;
  ignorePrescriberRestrictions?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Inert: no adjudication rule reads it. Waive 9G with MARK_SCRIPT_TAG (MPA2) plus MAX_DAILY_DOSE and MAX_SCRIPT_QTY (ZEB-10634). */
  ignoreQuantityLimits?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreRepackReject?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreScriptTooOld?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreZeroCost?: InputMaybe<Scalars['Boolean']['input']>;
  incentiveFee?: InputMaybe<Scalars['Float']['input']>;
  limitOOP?: InputMaybe<Scalars['Float']['input']>;
  macUUID?: InputMaybe<Scalars['UUID']['input']>;
  maintenanceFlag?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  messageOnlyRts?: InputMaybe<Scalars['Boolean']['input']>;
  miscHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  naToBencap?: InputMaybe<Scalars['Boolean']['input']>;
  naToDeductible?: InputMaybe<Scalars['Boolean']['input']>;
  naToOop?: InputMaybe<Scalars['Boolean']['input']>;
  naToSdcBencap?: InputMaybe<Scalars['Boolean']['input']>;
  naToSdcDeductible?: InputMaybe<Scalars['Boolean']['input']>;
  naToSdcOop?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUseMessageIfHandlerUsed?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUseMessageIfReject?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUseMessageIfRejectAgainstLine?: InputMaybe<Scalars['Boolean']['input']>;
  oopLimitApplyDeductible?: InputMaybe<Scalars['Boolean']['input']>;
  otherAmtPaidFee?: InputMaybe<Scalars['Float']['input']>;
  overrideGroupMaxDollar?: InputMaybe<Scalars['Float']['input']>;
  overrideMACListID?: InputMaybe<Scalars['UUID']['input']>;
  overrideMACPrice?: InputMaybe<Scalars['Float']['input']>;
  pharmacyFee?: InputMaybe<Scalars['Float']['input']>;
  planPaysDaw?: InputMaybe<Scalars['Boolean']['input']>;
  preferredFlag?: InputMaybe<Scalars['Boolean']['input']>;
  processRuleLineID: Scalars['UUID']['input'];
  refillHandlerUUID?: InputMaybe<Scalars['UUID']['input']>;
  rejectCode?: InputMaybe<Scalars['String']['input']>;
  repackFlag?: InputMaybe<Scalars['Boolean']['input']>;
  return5452FValue?: InputMaybe<Scalars['String']['input']>;
  setScriptTag?: InputMaybe<Scalars['String']['input']>;
  setTier?: InputMaybe<Scalars['String']['input']>;
  skipDur?: InputMaybe<Scalars['Boolean']['input']>;
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
  treatAsMony?: InputMaybe<Scalars['String']['input']>;
  treatAsMonyCopay?: InputMaybe<Scalars['String']['input']>;
  treatAsMonyCostDispFee?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProcessRuleLineCriteriaInput = {
  applyOnlyIfCompound?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfDMR?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfDosageForm?: InputMaybe<Scalars['String']['input']>;
  applyOnlyIfEligibilityFlag?: InputMaybe<Scalars['UUID']['input']>;
  applyOnlyIfGroupOOPCapExceeded?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfOTC?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfPAPN?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfPAPN2?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfPAPN3?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfRepack?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfUMAC?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnlyIfWebPricing?: InputMaybe<Scalars['Boolean']['input']>;
  gpiMatchDigits?: InputMaybe<Scalars['Int']['input']>;
  historicGPIMatchDigits?: InputMaybe<Scalars['Int']['input']>;
  lookbackGroupStartDateOption?: InputMaybe<Scalars['Boolean']['input']>;
  matchAge?: InputMaybe<Scalars['String']['input']>;
  matchBrandCode?: InputMaybe<Scalars['String']['input']>;
  matchChainCode?: InputMaybe<Scalars['String']['input']>;
  matchDaysPriorSD?: InputMaybe<Scalars['Int']['input']>;
  matchDaysSupply?: InputMaybe<Scalars['String']['input']>;
  matchDxCode?: InputMaybe<Scalars['String']['input']>;
  matchDxCodeQual?: InputMaybe<Scalars['String']['input']>;
  matchFlex2?: InputMaybe<Scalars['String']['input']>;
  matchGender?: InputMaybe<Scalars['Int']['input']>;
  matchHistoricalDays?: InputMaybe<Scalars['Int']['input']>;
  matchLevelOfEffort?: InputMaybe<Scalars['String']['input']>;
  matchMemberState?: InputMaybe<Scalars['String']['input']>;
  matchOtherCoverageCode?: InputMaybe<Scalars['String']['input']>;
  matchPCN?: InputMaybe<Scalars['String']['input']>;
  matchPharmacy?: InputMaybe<Scalars['String']['input']>;
  matchPharmacyState?: InputMaybe<Scalars['String']['input']>;
  matchPharmacyType?: InputMaybe<Scalars['String']['input']>;
  matchPrescriber?: InputMaybe<Scalars['String']['input']>;
  matchRefillNumber?: InputMaybe<Scalars['String']['input']>;
  matchRouteOfAdmin?: InputMaybe<Scalars['String']['input']>;
  matchScriptTag?: InputMaybe<Scalars['String']['input']>;
  matchServiceID?: InputMaybe<Scalars['Int']['input']>;
  matchSubmissionClarificationCode?: InputMaybe<Scalars['String']['input']>;
  matchSubmittedBIN?: InputMaybe<Scalars['String']['input']>;
  matchSubmittedGroup?: InputMaybe<Scalars['String']['input']>;
  matchSubmittedPA?: InputMaybe<Scalars['String']['input']>;
  matchTier?: InputMaybe<Scalars['String']['input']>;
  mony?: InputMaybe<Scalars['String']['input']>;
  priorSDDays?: InputMaybe<Scalars['Int']['input']>;
  processRuleLineID: Scalars['UUID']['input'];
};

export type UpdateProcessRuleLineDetailsInput = {
  processRuleLineActions: UpdateProcessRuleLineActionsInput;
  processRuleLineCriteria: UpdateProcessRuleLineCriteriaInput;
};

export type UpdateProcessRuleLineDetailsResponse = {
  __typename?: 'UpdateProcessRuleLineDetailsResponse';
  processRuleLineActions?: Maybe<ProcessRuleLineActions>;
  processRuleLineCriteria?: Maybe<ProcessRuleLineCriteria>;
};

export type UpdateProcessRuleResponse = {
  __typename?: 'UpdateProcessRuleResponse';
  generalErrors?: Maybe<Array<Scalars['String']['output']>>;
  processRule?: Maybe<ProcessRule>;
  processRuleLineErrors?: Maybe<Array<ProcessRuleLineError>>;
  processRuleLines?: Maybe<Array<ProcessRuleLine>>;
  success: Scalars['Boolean']['output'];
};

export type UpdateRelationshipsForGroupInput = {
  /** The ID of the group for which partner_group records will be updated. */
  groupID: Scalars['ID']['input'];
  relationships: Array<PartnerGroupRelationship>;
};

export type UpdateSdcInput = {
  afterCapCopayHandlerID?: InputMaybe<Scalars['ID']['input']>;
  familyAmount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  individualAmount?: InputMaybe<Scalars['Float']['input']>;
  oopCapInteraction?: InputMaybe<SdcOopCapInteraction>;
  periodType?: InputMaybe<SdcPeriodType>;
  periodX?: InputMaybe<Scalars['Int']['input']>;
  rejectClaimAfterCapIsMet?: InputMaybe<Scalars['Boolean']['input']>;
  satisfactionType: SdcSatisfactionType;
  sdcCode: Scalars['String']['input'];
  sdcName: Scalars['String']['input'];
  sdcType: SdcType;
};

export type UpdateSent835sPlBsInput = {
  /** CSV file containing payee names and PLB amounts. */
  file: Scalars['Upload']['input'];
};

export type UpdateStepTherapyLineInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  drugID?: InputMaybe<Scalars['String']['input']>;
  drugValue?: InputMaybe<DrugValue>;
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  id: Scalars['ID']['input'];
  level?: InputMaybe<Scalars['Int']['input']>;
  monyCode?: InputMaybe<Array<MonyCode>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  stepTherapyID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSubGroupInput = {
  benefit_start_date?: InputMaybe<Scalars['Time']['input']>;
  effective_date?: InputMaybe<Scalars['Time']['input']>;
  id: Scalars['ID']['input'];
  termination_date?: InputMaybe<Scalars['Time']['input']>;
};

export type UpdateSubgroupDetailInput = {
  benCapSatisfactionType?: InputMaybe<SatisfactionType>;
  benefitStartDate?: InputMaybe<Scalars['Date']['input']>;
  dedSatisfactionType?: InputMaybe<SatisfactionType>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  familyBenCap?: InputMaybe<Scalars['Cents']['input']>;
  familyDed?: InputMaybe<Scalars['Cents']['input']>;
  familyOop?: InputMaybe<Scalars['Cents']['input']>;
  /** Zebra subgroup detail UUID */
  id: Scalars['ID']['input'];
  individualBenCap?: InputMaybe<Scalars['Cents']['input']>;
  individualDed?: InputMaybe<Scalars['Cents']['input']>;
  individualOop?: InputMaybe<Scalars['Cents']['input']>;
  naToDed?: InputMaybe<Scalars['Boolean']['input']>;
  oopSatisfactionType?: InputMaybe<SatisfactionType>;
  processRuleID?: InputMaybe<Scalars['String']['input']>;
  sdcID?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubgroupInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubgroupScheduleImpact = {
  __typename?: 'UpdateSubgroupScheduleImpact';
  /** Existing details that fall entirely in the cut-off region and will be deleted. */
  deletedDetails: Array<ZebraSubgroupDetail>;
  /** Existing details that would be expanded (only populated for expansion-direction modifications). */
  expandedDetails: Array<SubgroupDetailExpansion>;
  /**
   * Existing details whose override plan and accumulator thresholds will be
   * rewritten because the plan code's benefit plan changed. Only populated for
   * benefit plan modifications. A detail may appear here as well as under
   * expandedDetails or truncatedDetails when its dates move in the same update.
   */
  resyncedDetails: Array<SubgroupDetailAccumResync>;
  /** The synced subgroup impacted by the schedule modification. */
  subgroup: SyncedSubgroup;
  /** Whether deletion of these details will cascade-delete the subgroup itself (zero remaining details). */
  subgroupWillBeDeleted: Scalars['Boolean']['output'];
  /** Existing details that would be truncated to fit the new schedule range. */
  truncatedDetails: Array<SubgroupDetailTruncation>;
};

export type UpdateTestRunExecutionInput = {
  discardReason?: InputMaybe<Scalars['String']['input']>;
  testCaseResultUpdates?: InputMaybe<Array<BulkUpdateTestCaseResultsInput>>;
  testRunExecutionId: Scalars['ID']['input'];
  validationStatus?: InputMaybe<ValidationStatus>;
};

export type UpdateTransmissionFormatInput = {
  /** The configuration JSON for the format. */
  config: Scalars['Map']['input'];
  /** name of sample file */
  fileName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** User-facing format name. */
  name: Scalars['String']['input'];
  /** A sample file to use against the config */
  sampleFile?: InputMaybe<Scalars['String']['input']>;
  /** Type describes the structure/schema of config. */
  type: TransmissionFormatType;
};

export enum UpdateType {
  /** UpdateTypeCreateUpdate */
  CreateUpdate = 'create_update',
  /** UpdateTypeCreateUpdateDelete */
  CreateUpdateDelete = 'create_update_delete'
}

export enum UploadStatus {
  /** UploadStatusApproved */
  Approved = 'approved',
  /** UploadStatusCreated */
  Created = 'created',
  /** UploadStatusComplete */
  UploadComplete = 'upload_complete'
}

export type UpsertCobObjectLineInput = {
  calculation?: InputMaybe<CalculationType>;
  cobObjectID?: InputMaybe<Scalars['ID']['input']>;
  condition?: InputMaybe<Condition>;
  effectiveDate: Scalars['Date']['input'];
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  occCode?: InputMaybe<OccCode>;
  rejectWithCode?: InputMaybe<Scalars['String']['input']>;
  rejectWithMessage?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertCobObjectLinesPayload = {
  __typename?: 'UpsertCOBObjectLinesPayload';
  cobObjectLines: Array<CobObjectLine>;
};

export type UpsertDurProgramDetailsInput = {
  DURProgramDetails: Array<InputMaybe<DurProgramDetailInput>>;
  DURProgramID: Scalars['ID']['input'];
};

export type UpsertEligibilityTimelineInput = {
  dataSource: DataSourceEnum;
  memberId: Scalars['String']['input'];
  timelineInput: TimelineRecordInput;
};

export type UpsertMemberEligibilityFlagInput = {
  dataSource: DataSourceEnum;
  eligibilityFlag: MemberEligibilityFlagTimelineRecordInput;
  memberId: Scalars['String']['input'];
};

export type UpsertMiscHandlerDetailInput = {
  consecutive?: InputMaybe<Scalars['Boolean']['input']>;
  consecutiveDays?: InputMaybe<Scalars['Int']['input']>;
  dollarAction?: InputMaybe<DollarAction>;
  dollarPeriod?: InputMaybe<PeriodType>;
  dollarPeriodX?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ignoreCurrentScript?: InputMaybe<Scalars['Int']['input']>;
  matchDigits?: InputMaybe<Scalars['Int']['input']>;
  matchHandler?: InputMaybe<Scalars['Int']['input']>;
  matchHistGroup?: InputMaybe<Scalars['Int']['input']>;
  matchMony?: InputMaybe<MonyCode>;
  matchSelRange?: InputMaybe<Scalars['Int']['input']>;
  maxDollars?: InputMaybe<Scalars['Float']['input']>;
  miscHandlerID?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<MiscHandlerDetailType>;
  unitPeriod?: InputMaybe<PeriodType>;
  unitPeriodX?: InputMaybe<Scalars['Int']['input']>;
  unitType?: InputMaybe<UnitType>;
  units?: InputMaybe<Scalars['Float']['input']>;
};

export type UpsertMiscHandlerDetailsPayload = {
  __typename?: 'UpsertMiscHandlerDetailsPayload';
  miscHandlerDetails: Array<MiscHandlerDetail>;
};

export type UpsertPlanDurProgramInput = {
  durProgramID: Scalars['ID']['input'];
  effectiveDate: Scalars['Time']['input'];
  expirationDate?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  planID: Scalars['ID']['input'];
};

export type UpsertProcessRuleLineInput = {
  action?: InputMaybe<ProcessRuleLineInclusion>;
  description?: InputMaybe<Scalars['String']['input']>;
  drugType?: InputMaybe<DrugType>;
  drugValue?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  insertNetworkPMBefore?: InputMaybe<Scalars['Boolean']['input']>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  processRuleLineActions?: InputMaybe<ProcessRuleLineActionsInput>;
  processRuleLineCriteria?: InputMaybe<ProcessRuleLineCriteriaInput>;
  processRuleLineDynConds?: InputMaybe<Array<InputMaybe<ProcessRuleLineDynCondInput>>>;
};

export type UpsertProcessRuleLinesInput = {
  delete?: InputMaybe<Array<Scalars['UUID']['input']>>;
  processRuleId: Scalars['UUID']['input'];
  upsert?: InputMaybe<Array<UpsertProcessRuleLineInput>>;
};

export type UpsertStepTherapyLineInput = {
  daysUsed?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  distinctDrugCount?: InputMaybe<Scalars['Int']['input']>;
  distinctDrugDigits?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Date field that is used to limit how far back in history the adjudicator will look.
   * Consider renaming across step therapy to avoid confusion with effectiveAt and to align with graphql standards.
   */
  dontApplyBeforeDate?: InputMaybe<Scalars['Time']['input']>;
  drugID?: InputMaybe<Scalars['String']['input']>;
  drugValue?: InputMaybe<DrugValue>;
  effectiveAt: Scalars['Time']['input'];
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  falseProcessRuleID?: InputMaybe<Scalars['ID']['input']>;
  falseProcessRulePriority?: InputMaybe<Scalars['Int']['input']>;
  hxClaimsQuantityLessOrEqual?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  monyCode?: InputMaybe<Array<MonyCode>>;
  notAppRxLevelPaidDuringPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  periodType?: InputMaybe<PeriodType>;
  periodX?: InputMaybe<Scalars['Int']['input']>;
  rule?: InputMaybe<StepTherapyLineRuleType>;
  rxOTCCode?: InputMaybe<RxOtcInd>;
  scriptTagMatchValue?: InputMaybe<Scalars['String']['input']>;
  stepTherapyID: Scalars['ID']['input'];
  trueProcessRuleID?: InputMaybe<Scalars['ID']['input']>;
  trueProcessRulePriority?: InputMaybe<Scalars['Int']['input']>;
};

export type User = {
  __typename?: 'User';
  analyticsId: Scalars['ID']['output'];
  analyticsIsUserInternal: Scalars['Boolean']['output'];
  credentialId: Scalars['Int']['output'];
  parent?: Maybe<User>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  profile: Profile;
  resources: Resources;
  role: Scalars['String']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  services: Services;
  viewedTutorials?: Maybe<Array<ViewedTutorialKey>>;
};

export type ValidationError = Error & {
  __typename?: 'ValidationError';
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type ValidationStats = {
  __typename?: 'ValidationStats';
  /** The total number of error department rows in the file. */
  department_errors: Scalars['Int']['output'];
  /** The total number of department rows in the file. */
  department_lines: Scalars['Int']['output'];
  /** The total number of error plan code rows in the file. */
  plan_code_errors: Scalars['Int']['output'];
  /** The total number of plan code rows in the file. */
  plan_code_lines: Scalars['Int']['output'];
  /** The total number of error subgroup rows in the file. */
  subgroup_errors: Scalars['Int']['output'];
  /** The total number of subgroup rows in the file. */
  subgroup_lines: Scalars['Int']['output'];
  /** The total number of field errors in the file. */
  total_field_errors: Scalars['Int']['output'];
  /** The total number of error rows in the file. */
  total_line_errors: Scalars['Int']['output'];
  /** The total number of parseable rows in the file. */
  total_lines: Scalars['Int']['output'];
  /** The total number of unknown rows in the file. */
  total_unknown_lines: Scalars['Int']['output'];
};

export enum ValidationStatus {
  ValCompleted = 'VAL_COMPLETED',
  ValDiscarded = 'VAL_DISCARDED',
  ValInProgress = 'VAL_IN_PROGRESS',
  ValLocked = 'VAL_LOCKED',
  ValReady = 'VAL_READY'
}

export type Version = {
  __typename?: 'Version';
  git_commit: Scalars['String']['output'];
  /** Server version */
  version: Scalars['String']['output'];
};

/**
 * These values *MUST* be kept in sync with the `Tutorial` DB table.
 *
 * See this migration script for how to add new tutorials to the DB:
 * 000643_add_july_2024_member_walkthrough_tutorials.up.sql
 */
export enum ViewedTutorialKey {
  July_2024MemberWalkthrough_0IntroNewFeatures = 'JULY_2024_MEMBER_WALKTHROUGH_0_INTRO_NEW_FEATURES',
  July_2024MemberWalkthrough_1Notifications = 'JULY_2024_MEMBER_WALKTHROUGH_1_NOTIFICATIONS',
  July_2024MemberWalkthrough_2Fmm = 'JULY_2024_MEMBER_WALKTHROUGH_2_FMM',
  July_2024MemberWalkthrough_3MemberIdCard = 'JULY_2024_MEMBER_WALKTHROUGH_3_MEMBER_ID_CARD',
  July_2024MemberWalkthrough_4Prescriptions = 'JULY_2024_MEMBER_WALKTHROUGH_4_PRESCRIPTIONS',
  July_2024MemberWalkthrough_5PlanDetails = 'JULY_2024_MEMBER_WALKTHROUGH_5_PLAN_DETAILS',
  July_2024MemberWalkthrough_6VirtualAssistant = 'JULY_2024_MEMBER_WALKTHROUGH_6_VIRTUAL_ASSISTANT'
}

export enum WeekdayEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type WhatsMyCopay = {
  __typename?: 'WhatsMyCopay';
  copay?: Maybe<Scalars['Cents']['output']>;
  coverage?: Maybe<Scalars['String']['output']>;
  coverageChecks?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  hasFROR?: Maybe<Scalars['Boolean']['output']>;
  inNetwork?: Maybe<Scalars['Boolean']['output']>;
  isPreferredPharmacy?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  ndc: Scalars['String']['output'];
  pharmacy: Pharmacy;
  pharmacyType: Scalars['String']['output'];
  priorAuth?: Maybe<Scalars['Boolean']['output']>;
};

export type WhatsMyCopayInput = {
  daySupply: Scalars['Int']['input'];
  memberID: Scalars['String']['input'];
  ndc: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  radius?: InputMaybe<Scalars['Int']['input']>;
  userGeoLocation: Geolocation;
};

export type WhatsMyCopayList = {
  __typename?: 'WhatsMyCopayList';
  designated: Array<WhatsMyCopay>;
  mailOrder: Array<WhatsMyCopay>;
  preferred: Array<WhatsMyCopay>;
  results: Array<WhatsMyCopay>;
  retail: Array<WhatsMyCopay>;
};

export type WhatsMyCopayV2 = {
  __typename?: 'WhatsMyCopayV2';
  /** @deprecated Use pricing.patientPayAmount. */
  copay?: Maybe<Scalars['Cents']['output']>;
  coverage?: Maybe<Scalars['String']['output']>;
  coverageChecks?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  hasFROR?: Maybe<Scalars['Boolean']['output']>;
  inNetwork?: Maybe<Scalars['Boolean']['output']>;
  isPreferredPharmacy?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  ndc: Scalars['String']['output'];
  pharmacy: PharmacyV2;
  pharmacyType: Scalars['String']['output'];
  /** The adjudicator's pricing breakdown for this fill, in cents. Null when the result is not covered. */
  pricing?: Maybe<WhatsMyCopayV2Pricing>;
  priorAuth?: Maybe<Scalars['Boolean']['output']>;
  rejectCode?: Maybe<Scalars['String']['output']>;
};

export type WhatsMyCopayV2Connection = {
  __typename?: 'WhatsMyCopayV2Connection';
  edges: Array<WhatsMyCopayV2Edge>;
  pageInfo: PageInfo;
};

export type WhatsMyCopayV2Edge = {
  __typename?: 'WhatsMyCopayV2Edge';
  cursor: Scalars['String']['output'];
  node: WhatsMyCopayV2;
};

export type WhatsMyCopayV2Input = {
  bounds?: InputMaybe<Array<Geolocation>>;
  daySupply: Scalars['Int']['input'];
  location?: InputMaybe<Geolocation>;
  memberID: Scalars['String']['input'];
  ndc: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  radius?: InputMaybe<Scalars['Int']['input']>;
};

/** Pricing amounts the adjudicator calculated for a paid quote, in cents. Null when the result is not covered. */
export type WhatsMyCopayV2Pricing = {
  __typename?: 'WhatsMyCopayV2Pricing';
  /** Dispensing fee on the pharmacy pay side. Null when the adjudicator did not return this amount. */
  dispensingFee?: Maybe<Scalars['Cents']['output']>;
  /** Incentive fee applied to the claim. Null when the adjudicator did not return this amount. */
  incentiveFee?: Maybe<Scalars['Cents']['output']>;
  /** Ingredient cost on the pharmacy pay side. Null when the adjudicator did not return this amount. */
  ingredientCost?: Maybe<Scalars['Cents']['output']>;
  /** Other amount paid on the pharmacy pay side. Null when the adjudicator did not return this amount. */
  otherAmountPaid?: Maybe<Scalars['Cents']['output']>;
  /** Total patient responsibility; can include copay, coinsurance, deductible, patient tax, and DAW penalty. Equals copay. Null when the adjudicator did not return this amount. */
  patientPayAmount?: Maybe<Scalars['Cents']['output']>;
  /** Plan cost on the bill side. Null when the adjudicator did not return this amount. */
  planPayAmount?: Maybe<Scalars['Cents']['output']>;
  /** Regulatory fee or flat sales tax; excludes percentage tax. Null when the adjudicator did not return this amount. */
  taxAmount?: Maybe<Scalars['Cents']['output']>;
  /** Amount the pharmacy would be paid for this fill after patient and other-payer amounts. Null when the adjudicator did not return this amount. */
  totalAmountPaid?: Maybe<Scalars['Cents']['output']>;
};

/** An entity type that participates in where-used search. */
export enum WhereUsedEntityType {
  Cob = 'COB',
  CustomDrugList = 'CUSTOM_DRUG_LIST',
  DurProgram = 'DUR_PROGRAM',
  FillRule = 'FILL_RULE',
  PrescriberList = 'PRESCRIBER_LIST',
  ProcessRule = 'PROCESS_RULE',
  Sdc = 'SDC',
  StepTherapy = 'STEP_THERAPY'
}

export type WorkersComp = {
  __typename?: 'WorkersComp';
  adjuster_email?: Maybe<Scalars['String']['output']>;
  adjuster_name?: Maybe<Scalars['String']['output']>;
  body_part_codes?: Maybe<Array<BodyPartCode>>;
  carrier_naic?: Maybe<Scalars['String']['output']>;
  employer_identification_number?: Maybe<Scalars['String']['output']>;
  icd_codes?: Maybe<Array<IcdCode>>;
  injury_date?: Maybe<Scalars['Time']['output']>;
  insurer_taxpayer_id?: Maybe<Scalars['String']['output']>;
  jurisdiction_state?: Maybe<Scalars['String']['output']>;
  ncci_code?: Maybe<Scalars['String']['output']>;
  policy_effective_date?: Maybe<Scalars['Time']['output']>;
  policy_number?: Maybe<Scalars['String']['output']>;
  reporting_claim_number?: Maybe<Scalars['String']['output']>;
  surgery_date?: Maybe<Scalars['Time']['output']>;
};

export type ZebraCrossAccumulatorConfig = {
  __typename?: 'ZebraCrossAccumulatorConfig';
  benefitPlanId: Scalars['UUID']['output'];
  doesDeductiblePlanAccumulateRxOnly: Scalars['Int']['output'];
  doesOOPPlanAccumulateRxOnly: Scalars['Int']['output'];
  sendDeductible: Scalars['Int']['output'];
  sendOOP: Scalars['Int']['output'];
};

export type ZebraSdc = {
  __typename?: 'ZebraSDC';
  id: Scalars['ID']['output'];
  sdcCode: Scalars['String']['output'];
  sdcName: Scalars['String']['output'];
};

export type ZebraSubgroup = Subgroup & {
  __typename?: 'ZebraSubgroup';
  currentBenefitPlanOverride?: Maybe<Plan>;
  currentBenefitStartDate?: Maybe<Scalars['Date']['output']>;
  currentTerminationDate?: Maybe<Scalars['Date']['output']>;
  details: Array<ZebraSubgroupDetail>;
  firstEffectiveDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  status: GroupStatus;
};

export type ZebraSubgroupDetail = SubgroupDetail & {
  __typename?: 'ZebraSubgroupDetail';
  benCapSatisfactionType?: Maybe<SatisfactionType>;
  benefitStartDate?: Maybe<Scalars['Date']['output']>;
  dedSatisfactionType?: Maybe<SatisfactionType>;
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  familyBenCap?: Maybe<Scalars['Cents']['output']>;
  familyDed?: Maybe<Scalars['Cents']['output']>;
  familyOop?: Maybe<Scalars['Cents']['output']>;
  id: Scalars['ID']['output'];
  individualBenCap?: Maybe<Scalars['Cents']['output']>;
  individualDed?: Maybe<Scalars['Cents']['output']>;
  individualOop?: Maybe<Scalars['Cents']['output']>;
  naToDed: Scalars['Boolean']['output'];
  oopSatisfactionType?: Maybe<SatisfactionType>;
  overridePlan?: Maybe<Plan>;
};

export type ZebraTestCaseResult = {
  __typename?: 'ZebraTestCaseResult';
  actualCoinsurance?: Maybe<Scalars['Int']['output']>;
  actualCopay?: Maybe<Scalars['Float']['output']>;
  actualCoverage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  diffNotes?: Maybe<Scalars['String']['output']>;
  expectedCoinsurance?: Maybe<Scalars['Int']['output']>;
  expectedCopay?: Maybe<Scalars['Float']['output']>;
  expectedCoverage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issueCategory?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  testCaseID?: Maybe<Scalars['Int']['output']>;
  testRunExecutionID: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
  zebraCopayHandler?: Maybe<Scalars['String']['output']>;
  zebraGroupBilledAmount?: Maybe<Scalars['String']['output']>;
  zebraRejectCode?: Maybe<Scalars['String']['output']>;
  zebraRejectNotes?: Maybe<Scalars['String']['output']>;
  zebraResponseMessage?: Maybe<Scalars['String']['output']>;
};

export type AccountHolderOrder = {
  name?: InputMaybe<OrderDirectionEnum>;
};

export type UpdateTestCasesPrioritiesInput = {
  /** List of existing test case ids in new priority order */
  plan_test_case_ids: Array<Scalars['ID']['input']>;
  /** Priorities are being modified for specified plan test suite ID */
  plan_test_suite_id: Scalars['ID']['input'];
};

export type WhereUsedExportUrlInput = {
  searchByEntityType: WhereUsedEntityType;
  searchByUUID: Scalars['UUID']['input'];
};
